import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Base64: string;
  Date: string;
};

export type Arm = {
  __typename?: 'ARM';
  /** Refer: src/graphql/definitions/object/arm-assigned.graphql */
  assigned: ArmAssigned;
  blockedDays: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/preference.graphql */
  schedulePreferences: Array<Preference>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  user?: Maybe<User>;
};

export type ArmAssigned = {
  __typename?: 'ARMAssigned';
  /** Refer: src/graphql/definitions/object/user.graphql */
  by?: Maybe<User>;
  on: Scalars['String'];
};

export type ArmCommission = {
  __typename?: 'ARMCommission';
  /**
   * This actually mean claimable transactions, which means transactions that can be claimed for ARM transactions.
   * Refer: src/graphql/definitions/object/display-arm-commission-transaction.graphql
   */
  _transactions: Array<DisplayArmCommissionTransaction>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  arm?: Maybe<User>;
  /**
   * Refer: src/graphql/definitions/object/transaction.graphql
   * @deprecated Use `_transactions` instead.
   */
  transactions: Array<Transaction>;
  /** Refer: src/graphql/definitions/object/whitelist-item.graphql */
  whitelistItems: Array<WhitelistItem>;
};

export type ActiveBookingVerification = {
  __typename?: 'ActiveBookingVerification';
  /** Refer: src/graphql/definitions/object/booking-verification.graphql */
  bookingVerification: BookingVerification;
  /** Refer: src/graphql/definitions/object/project-unit-lock.graphql */
  unitLock: ProjectUnitLock;
};

export type ActivePeriod = {
  __typename?: 'ActivePeriod';
  endDateTime: Scalars['String'];
  startDateTime: Scalars['String'];
};

export type ActivePeriodHourMinute = {
  hour: Scalars['Int'];
  minute: Scalars['Int'];
};

export type ActivePeriodsDay = {
  /** Refer: src/graphql/definitions/input/active-periods-day-period.graphql */
  periods: Array<ActivePeriodsDayPeriod>;
};

export type ActivePeriodsDayPeriod = {
  /** Refer: src/graphql/definitions/input/active-period-hour-minute.graphql */
  closingTime: ActivePeriodHourMinute;
  /** Refer: src/graphql/definitions/input/active-period-hour-minute.graphql */
  openingTime: ActivePeriodHourMinute;
};

export type AddNew = {
  label: Scalars['String'];
  limit: Scalars['Int'];
};

export type AddNoteRequest = {
  content: Scalars['String'];
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /** ID of a transaction's loan */
  loanId?: InputMaybe<Scalars['String']>;
  /** Transaction ID */
  sequenceId?: InputMaybe<Scalars['String']>;
};

export enum AffixType {
  Infix = 'INFIX',
  Prefix = 'PREFIX',
  Suffix = 'SUFFIX'
}

/** IMPORTANT: Developer is treated similar to agency because they are also selling property */
export type Agency = {
  __typename?: 'Agency';
  address?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/agent.graphql */
  agents: Array<Agent>;
  /**
   * Refer: src/graphql/definitions/object/agency-contact.graphql
   * @deprecated use officeNum, email instead.
   */
  contacts?: Maybe<Array<AgencyContact>>;
  description?: Maybe<Scalars['String']>;
  /**
   * Only applicable for agency type 'DEVELOPER'
   * Refer: src/graphql/definitions/object/developer-dashboard-setting.graphql
   */
  developerDashboardSetting?: Maybe<DeveloperDashboardSetting>;
  email?: Maybe<Scalars['String']>;
  /**
   * This is a convenient shortcut that combines `name` and `registrationNum` together,
   * so that client do not need to keep joining both of these together manually.
   */
  fullName: Scalars['String'];
  /** Refer: src/graphql/definitions/object/gal-agency-group.graphql */
  galAgencyGroup?: Maybe<GalAgencyGroup>;
  hotline?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPreferredPartner?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use 'logoFile' instead */
  logo?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  logoFile?: Maybe<AttachedFile>;
  name: Scalars['String'];
  officeNum?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/agency.graphql */
  parent?: Maybe<Agency>;
  parentRegistrationNum?: Maybe<Scalars['String']>;
  registrationNum?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/agency.graphql */
  siblingAgencies?: Maybe<Array<Maybe<Agency>>>;
  /** Refer: src/graphql/definitions/object/agency-team.graphql */
  teams?: Maybe<Array<AgencyTeam>>;
  /** Refer: src/graphql/definitions/enum/agency-type.graphql */
  type: AgencyType;
};

export type AgencyContact = {
  __typename?: 'AgencyContact';
  email?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  officeNum?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/enum/agency-contact-type.graphql */
  type: AgencyContactType;
};

export enum AgencyContactType {
  Primary = 'primary',
  Secondary = 'secondary'
}

export type AgencyData = {
  __typename?: 'AgencyData';
  /** Refer: src/graphql/definitions/object/agency-sale-stat.graphql */
  salesStats: Array<AgencySaleStat>;
};

export type AgencyGroup = {
  __typename?: 'AgencyGroup';
  /** Refer: src/graphql/definitions/object/agency-group-child-agency.graphql */
  childAgencies: Array<AgencyGroupChildAgency>;
  /** Refer: src/graphql/definitions/object/agency-group-email.graphql */
  emails: Array<AgencyGroupEmail>;
  /** Refer: src/graphql/definitions/object/gal-agency-group.graphql */
  galAgencyGroup?: Maybe<GalAgencyGroup>;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/agency-group-parent-agency.graphql */
  parentAgency: AgencyGroupParentAgency;
  /** Refer: src/graphql/definitions/object/agency-group-pic.graphql */
  pics: Array<AgencyGroupPic>;
  /** Refer: src/graphql/definitions/object/project-agency-group.graphql */
  projectAgencyGroups: Array<ProjectAgencyGroup>;
};

export type AgencyGroupChildAgency = {
  __typename?: 'AgencyGroupChildAgency';
  /** Refer: src/graphql/definitions/object/agency.graphql */
  agency: Agency;
  id: Scalars['ID'];
};

export type AgencyGroupEmail = {
  __typename?: 'AgencyGroupEmail';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type AgencyGroupParentAgency = {
  __typename?: 'AgencyGroupParentAgency';
  /** Refer: src/graphql/definitions/object/agency.graphql */
  agency: Agency;
  id: Scalars['ID'];
};

export type AgencyGroupPic = {
  __typename?: 'AgencyGroupPic';
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  pic: User;
};

export type AgencySaleStat = {
  __typename?: 'AgencySaleStat';
  agencyName: Scalars['String'];
  /** Refer: src/graphql/definitions/object/agent-sale-stat.graphql */
  agentsSalesStats: Array<AgentSaleStat>;
  numberOfSales: Scalars['Float'];
};

export type AgencyTeam = {
  __typename?: 'AgencyTeam';
  /** Refer: src/graphql/definitions/object/agency.graphql */
  agency: Agency;
  /** Team code is actually the referral code of the team leader */
  code: Scalars['String'];
  /** Refer: src/graphql/definitions/object/agency-team-event.graphql */
  events: Array<AgencyTeamEvent>;
  id: Scalars['String'];
  /**
   * True if the requesting user is the team leader OR vice team leader of this team.
   * False otherwise.
   * This property is useful for Didian App to show/hide features that is exclusive to team manager(s).
   */
  isTeamManager: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/agency-team-join-requests.graphql */
  joinRequests: AgencyTeamJoinRequests;
  /**
   * Refer: src/graphql/definitions/object/join-team-request.graphql
   * @deprecated Use `joinRequests` instead.
   */
  joinTeamRequests: Array<JoinTeamRequest>;
  /**
   * Refer: src/graphql/definitions/object/agent.graphql
   * @deprecated Use `teamMembers` instead.
   */
  members: Array<Agent>;
  /** Number of all transactions made by members */
  numOfTransactions: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/agent.graphql */
  teamLead: Agent;
  /** Refer: src/graphql/definitions/object/agency-team-members.graphql */
  teamMembers: AgencyTeamMembers;
  /** Refer: src/graphql/definitions/object/vice-team-leader.graphql */
  viceTeamLeaders: Array<ViceTeamLeader>;
  /**
   * Refer: src/graphql/definitions/object/agent.graphql
   * @deprecated Use `viceTeamLeaders` instead.
   */
  viceTeamLeads: Array<Agent>;
};


export type AgencyTeamIsTeamManagerArgs = {
  projectId?: InputMaybe<Scalars['String']>;
};

export type AgencyTeamEvent = {
  __typename?: 'AgencyTeamEvent';
  description: Scalars['String'];
  on: Scalars['String'];
};

export type AgencyTeamJoinRequests = {
  __typename?: 'AgencyTeamJoinRequests';
  /** Refer: src/graphql/definitions/object/filtered-agency-team-join-requests.graphql */
  all: FilteredAgencyTeamJoinRequests;
  /** Refer: src/graphql/definitions/object/filtered-agency-team-join-requests.graphql */
  pending: FilteredAgencyTeamJoinRequests;
};

export type AgencyTeamMemberProjectWhitelistStatus = {
  __typename?: 'AgencyTeamMemberProjectWhitelistStatus';
  /** Refer: src/graphql/definitions/object/agent.graphql */
  member: Agent;
  /**
   * If this is undefined, it means that `member` is not whitelisted for this project (specified above).
   * Refer: src/graphql/definitions/object/whitelist-item.graphql
   */
  whitelist?: Maybe<WhitelistItem>;
};

export type AgencyTeamMembers = {
  __typename?: 'AgencyTeamMembers';
  /** Refer: src/graphql/definitions/object/agent.graphql */
  paginate: Array<Agent>;
  totalCount: Scalars['Int'];
};


export type AgencyTeamMembersPaginateArgs = {
  pagingOptions: PagingOptions;
};

export enum AgencyType {
  Developer = 'DEVELOPER',
  Realtor = 'REALTOR'
}

export type Agent = {
  __typename?: 'Agent';
  /** Refer: src/graphql/definitions/object/user-address.graphql */
  addresses?: Maybe<Array<UserAddress>>;
  /** Refer: src/graphql/definitions/object/user-agent-info.graphql */
  agentInfo: UserAgentInfo;
  /**
   * Refer: src/graphql/definitions/object/user-contact.graphql
   * @deprecated use mobileNum, email, emailIsVerified instead.
   */
  contacts?: Maybe<Array<UserContact>>;
  displayName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  emailIsVerified?: Maybe<Scalars['Boolean']>;
  fullName: Scalars['String'];
  id: Scalars['ID'];
  /**
   * True if this agent is same as the requesting user.
   * False or null otherwise.
   */
  isMe?: Maybe<Scalars['Boolean']>;
  mobileNum?: Maybe<Scalars['String']>;
  nric?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  nricCopiesBack: Array<UploadedFile>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  nricCopiesFront: Array<UploadedFile>;
  profilePicture?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/role.graphql */
  roles?: Maybe<Array<Role>>;
};

export type AgentCooperation = {
  __typename?: 'AgentCooperation';
  /** Refer: src/graphql/definitions/object/agent.graphql */
  buyerAgent: Agent;
  /** Refer: src/graphql/definitions/object/agent-cooperation-buyer.graphql */
  buyers: Array<AgentCooperationBuyer>;
  /** Refer: src/graphql/definitions/object/agent-cooperation-commission-fraction.graphql */
  commissionFraction: AgentCooperationCommissionFraction;
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  convertedBooking?: Maybe<Transaction>;
  createdOn: Scalars['String'];
  /** Refer: src/graphql/definitions/object/agent-cooperation-event.graphql */
  events: Array<AgentCooperationEvent>;
  id: Scalars['String'];
  /** Refer: src/graphql/definitions/object/project.graphql */
  parentProject: Project;
  /** Refer: src/graphql/definitions/object/schedule.graphql */
  schedule?: Maybe<Schedule>;
  /** Refer: src/graphql/definitions/object/agent.graphql */
  sellerAgent?: Maybe<Agent>;
  /** Refer: src/graphql/definitions/object/agency-team.graphql */
  sellerTeam: AgencyTeam;
  /** Refer: src/graphql/definitions/enum/agent-cooperation-status.graphql */
  status: AgentCooperationStatus;
  updatedOn: Scalars['String'];
};

export type AgentCooperationBuyer = {
  __typename?: 'AgentCooperationBuyer';
  mobileNum: Scalars['String'];
  name: Scalars['String'];
};

export type AgentCooperationCommissionFraction = {
  __typename?: 'AgentCooperationCommissionFraction';
  buyerAgent: Scalars['Float'];
  sellerAgent: Scalars['Float'];
};

export type AgentCooperationEvent = {
  __typename?: 'AgentCooperationEvent';
  createdOn: Scalars['String'];
  type: Scalars['String'];
};

export enum AgentCooperationStatus {
  Accepted = 'ACCEPTED',
  Attended = 'ATTENDED',
  Converted = 'CONVERTED',
  Created = 'CREATED',
  Expired = 'EXPIRED',
  Scheduled = 'SCHEDULED'
}

export type AgentLead = {
  __typename?: 'AgentLead';
  agencyName?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/schedule.graphql */
  appointments: Array<Schedule>;
  createdOn: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/whitelist-item.graphql */
  faceToFaceSessions: Array<WhitelistItem>;
  /** Refer: src/graphql/definitions/object/agent-lead-follow-up.graphql */
  followUps: Array<AgentLeadFollowUp>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  handleBy?: Maybe<User>;
  id: Scalars['String'];
  /** Refer: src/graphql/definitions/object/info-from-bovaea.graphql */
  infoFromBovaea?: Maybe<InfoFromBovaea>;
  mobileNum?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/project.graphql */
  projectsInterested: Array<Project>;
  /** Refer: src/graphql/definitions/object/agent-lead-remark.graphql */
  remarks: Array<AgentLeadRemark>;
  renTag?: Maybe<Scalars['String']>;
  signedUpOn?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  /** @deprecated use statusEnum instead. */
  status: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/derived-agent-lead-status.graphql */
  statusEnum: DerivedAgentLeadStatus;
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  type: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};


export type AgentLeadNameArgs = {
  includeDisplayName?: InputMaybe<Scalars['Boolean']>;
};

export type AgentLeadAppointment = {
  __typename?: 'AgentLeadAppointment';
  date: Scalars['String'];
  id: Scalars['String'];
  location: Scalars['String'];
  remark: Scalars['String'];
};

export type AgentLeadFollowUp = {
  __typename?: 'AgentLeadFollowUp';
  /** Refer: src/graphql/definitions/object/user.graphql */
  passedBy?: Maybe<User>;
  passedOn: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  passedTo?: Maybe<User>;
};

export type AgentLeadRemark = {
  __typename?: 'AgentLeadRemark';
  /** Refer: src/graphql/definitions/object/user.graphql */
  author?: Maybe<User>;
  content: Scalars['String'];
  createdOn: Scalars['String'];
};

export type AgentLeadSource = {
  remark?: InputMaybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/enum/source.graphql */
  type: Source;
};

export enum AgentLeadSources {
  ArmsInitiated = 'arms_initiated',
  DidianMarketplace = 'didian_marketplace',
  StarProperty = 'star_property'
}

export enum AgentLeadStatus {
  FutureProspect = 'future_prospect',
  NoActionRequired = 'no_action_required'
}

export type AgentSaleStat = {
  __typename?: 'AgentSaleStat';
  agentName: Scalars['String'];
  numberOfSales: Scalars['Float'];
  /** For testing purposes only */
  transactionIds: Array<Scalars['ID']>;
};

export type AgentSignupStats = {
  __typename?: 'AgentSignupStats';
  /** Week 0 means current week, week 1 means next week and so on. */
  week: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/weekly-signup-verification-stat.graphql */
  weeklySignupVerificationStats: Array<WeeklySignupVerificationStat>;
};

export type AgingInterval = {
  __typename?: 'AgingInterval';
  agingDayLowerBound: Scalars['Int'];
  agingDayUpperBound?: Maybe<Scalars['Int']>;
};

export enum AllFieldType {
  Boolean = 'BOOLEAN',
  File = 'FILE',
  Number = 'NUMBER',
  String = 'STRING',
  StringArray = 'STRING_ARRAY'
}

/**
 * Refer: src/graphql/definitions/object/app-screen-didian-support.graphql
 * Refer: src/graphql/definitions/object/app-screen-project.graphql
 * Refer: src/graphql/definitions/object/app-screen-project-detail.graphql
 * Refer: src/graphql/definitions/object/app-screen-project-unit.graphql
 * Refer: src/graphql/definitions/object/app-screen-booking-verification.graphql
 * Refer: src/graphql/definitions/object/app-screen-profile.graphql
 * Refer: src/graphql/definitions/object/app-screen-profile-team.graphql
 * Refer: src/graphql/definitions/object/app-screen-profile-referee-invite.graphql
 * Refer: src/graphql/definitions/object/app-screen-reward.graphql
 * Refer: src/graphql/definitions/object/app-screen-client-appointment.graphql
 * Refer: src/graphql/definitions/object/app-screen-client-facebook-lead.graphql
 * Refer: src/graphql/definitions/object/app-screen-client-sales.graphql
 */
export type AppScreen = AppScreenBookingVerification | AppScreenClientAppointment | AppScreenClientFacebookLead | AppScreenClientSales | AppScreenDidianSupport | AppScreenProfile | AppScreenProfileRefereeInvite | AppScreenProfileTeam | AppScreenProject | AppScreenProjectDetail | AppScreenProjectUnit | AppScreenReward;

export type AppScreenBookingVerification = {
  __typename?: 'AppScreenBookingVerification';
  bookingVerificationId: Scalars['ID'];
  childProjectId: Scalars['ID'];
  unitId: Scalars['ID'];
};

export type AppScreenClientAppointment = {
  __typename?: 'AppScreenClientAppointment';
  scheduleId: Scalars['ID'];
};

export type AppScreenClientFacebookLead = {
  __typename?: 'AppScreenClientFacebookLead';
  leadId: Scalars['ID'];
};

export type AppScreenClientSales = {
  __typename?: 'AppScreenClientSales';
  /** Refer: src/graphql/definitions/enum/app-screen-client-sales-focused-section.graphql */
  focusedSection?: Maybe<AppScreenClientSalesFocusedSection>;
  transactionId: Scalars['ID'];
};

export enum AppScreenClientSalesFocusedSection {
  Remark = 'REMARK'
}

export type AppScreenDidianSupport = {
  __typename?: 'AppScreenDidianSupport';
  messageSuggestions: Array<Scalars['String']>;
};

export type AppScreenProfile = {
  __typename?: 'AppScreenProfile';
  /** Refer: src/graphql/definitions/enum/app-screen-profile-focused-tab.graphql */
  focusedTab: AppScreenProfileFocusedTab;
};

export enum AppScreenProfileFocusedTab {
  Achievements = 'ACHIEVEMENTS',
  EStore = 'E_STORE',
  Team = 'TEAM'
}

export type AppScreenProfileRefereeInvite = {
  __typename?: 'AppScreenProfileRefereeInvite';
  dummy?: Maybe<Scalars['String']>;
};

export type AppScreenProfileTeam = {
  __typename?: 'AppScreenProfileTeam';
  focusedJoinTeamRequest?: Maybe<Scalars['ID']>;
};

export type AppScreenProject = {
  __typename?: 'AppScreenProject';
  dummy?: Maybe<Scalars['String']>;
};

export type AppScreenProjectDetail = {
  __typename?: 'AppScreenProjectDetail';
  /** Refer: src/graphql/definitions/enum/app-screen-project-detail-focused-section.graphql */
  focusedSection?: Maybe<AppScreenProjectDetailFocusedSection>;
  projectId: Scalars['ID'];
};

export enum AppScreenProjectDetailFocusedSection {
  MarketingMaterial = 'MARKETING_MATERIAL',
  SalesPackage = 'SALES_PACKAGE'
}

export type AppScreenProjectUnit = {
  __typename?: 'AppScreenProjectUnit';
  childProjectId: Scalars['ID'];
  unitId: Scalars['ID'];
};

export type AppScreenReward = {
  __typename?: 'AppScreenReward';
  dummy?: Maybe<Scalars['String']>;
};

export type ApplicablePeriod = {
  from: Scalars['String'];
  to: Scalars['String'];
};

export type AppointmentLetter = {
  __typename?: 'AppointmentLetter';
  /** Refer: src/graphql/definitions/object/agency.graphql */
  agency?: Maybe<Agency>;
  autoRenew: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/appointment-letter-cancelled-signed-version.graphql */
  cancelledSignedVersions: Array<AppointmentLetterCancelledSignedVersion>;
  /** Refer: src/graphql/definitions/object/project.graphql */
  childProject?: Maybe<Project>;
  commencementDate: Scalars['String'];
  /** Refer: src/graphql/definitions/object/appointment-letter-commission-tier.graphql */
  commissionTiers: Array<AppointmentLetterCommissionTier>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy?: Maybe<User>;
  createdOn: Scalars['String'];
  expiryDate: Scalars['String'];
  id: Scalars['String'];
  /** Refer: src/graphql/definitions/object/agency.graphql */
  otherAgencies: Array<Agency>;
  /** Refer: src/graphql/definitions/object/project.graphql */
  parentProject?: Maybe<Project>;
  /** Refer: src/graphql/definitions/object/appointment-letter-physical-copy-received-confirmed.graphql */
  physicalCopyReceivedConfirmed?: Maybe<AppointmentLetterPhysicalCopyReceivedConfirmed>;
  /** Refer: src/graphql/definitions/object/appointment-letter-rejected-signed-version.graphql */
  rejectedSignedVersions: Array<AppointmentLetterRejectedSignedVersion>;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  signedVersion?: Maybe<AttachedFile>;
  /** Refer: src/graphql/definitions/object/appointment-letter-signed-version-verified.graphql */
  signedVersionVerified?: Maybe<AppointmentLetterSignedVersionVerified>;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  template?: Maybe<AttachedFile>;
};

export type AppointmentLetterCancelledSignedVersion = {
  __typename?: 'AppointmentLetterCancelledSignedVersion';
  /** Refer: src/graphql/definitions/object/user.graphql */
  cancelledBy?: Maybe<User>;
  cancelledOn: Scalars['String'];
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  file?: Maybe<AttachedFile>;
  id: Scalars['String'];
};

export type AppointmentLetterCommissionTier = {
  __typename?: 'AppointmentLetterCommissionTier';
  lowerBoundaryInclusive: Scalars['Int'];
  percentage: Scalars['Float'];
};

export type AppointmentLetterPhysicalCopyReceivedConfirmed = {
  __typename?: 'AppointmentLetterPhysicalCopyReceivedConfirmed';
  /** Refer: src/graphql/definitions/object/user.graphql */
  by?: Maybe<User>;
  on?: Maybe<Scalars['String']>;
};

export type AppointmentLetterRejectedSignedVersion = {
  __typename?: 'AppointmentLetterRejectedSignedVersion';
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  file?: Maybe<AttachedFile>;
  id: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  rejectedBy?: Maybe<User>;
  rejectedOn?: Maybe<Scalars['String']>;
  rejectionDescription: Scalars['String'];
  rejectionTitle: Scalars['String'];
};

export type AppointmentLetterSignedVersionVerified = {
  __typename?: 'AppointmentLetterSignedVersionVerified';
  /** Refer: src/graphql/definitions/object/user.graphql */
  by?: Maybe<User>;
  on?: Maybe<Scalars['String']>;
};

export type AppointmentStat = {
  __typename?: 'AppointmentStat';
  /** Refer: src/graphql/definitions/object/user.graphql */
  arm?: Maybe<User>;
  numberOfAppointments: Scalars['Int'];
};

export type ArmPerformance = {
  __typename?: 'ArmPerformance';
  /** Refer: src/graphql/definitions/object/monthly-appointments-stat.graphql */
  monthlyAppointmentsStats: Array<MonthlyAppointmentsStat>;
  /** Refer: src/graphql/definitions/object/monthly-leads-assigned-stat.graphql */
  monthlyLeadsAssignedStats: Array<MonthlyLeadsAssignedStat>;
};

export type ArmSchedulePreference = {
  /** Refer: src/graphql/definitions/enum/day.graphql */
  day: Day;
  daySlotIndex: Scalars['Int'];
};

export enum AssignMode {
  Assign = 'assign',
  Unassign = 'unassign'
}

/** @deprecated(reason: "Use UploadedFile instead") */
export type AttachedFile = {
  __typename?: 'AttachedFile';
  _id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  attachedBy?: Maybe<User>;
  attachedOn?: Maybe<Scalars['String']>;
  fileSize: Scalars['Float'];
  /** @deprecated This is the same as signedURL, use _id instead */
  id: Scalars['String'];
  /** Refer: src/graphql/definitions/object/file-modification-history.graphql */
  modificationHistories: Array<FileModificationHistory>;
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  previewThumbnail?: Maybe<AttachedFile>;
  signedURL: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/uploaded-file-tag.graphql */
  tags: Array<UploadedFileTag>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  uploadedBy?: Maybe<User>;
  uploadedOn: Scalars['String'];
};

export type AttendeesLimit = {
  __typename?: 'AttendeesLimit';
  maximumNumber: Scalars['Int'];
  minimumNumber: Scalars['Int'];
};

export type AvailableSlot = {
  __typename?: 'AvailableSlot';
  /** Refer: src/graphql/definitions/object/user.graphql */
  armInCharge?: Maybe<User>;
  date: Scalars['String'];
  daySlotIndex: Scalars['Int'];
};

export type AvailableSlotsDay = {
  __typename?: 'AvailableSlotsDay';
  day: Scalars['String'];
  /** Refer: src/graphql/definitions/object/slot.graphql */
  slots: Array<Slot>;
};

export type AvailableUnit = {
  __typename?: 'AvailableUnit';
  id: Scalars['String'];
  unitNum: Scalars['String'];
};

export type Background = {
  id: Scalars['String'];
  signedURL: Scalars['String'];
};

export type Banker = {
  __typename?: 'Banker';
  /** Refer: src/graphql/definitions/object/user-address.graphql */
  addresses?: Maybe<Array<UserAddress>>;
  /** Refer: src/graphql/definitions/object/user-banker-info.graphql */
  bankerInfo?: Maybe<UserBankerInfo>;
  /**
   * Refer: src/graphql/definitions/object/user-contact.graphql
   * @deprecated use mobileNum, email, emailIsVerified instead.
   */
  contacts?: Maybe<Array<UserContact>>;
  displayName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  emailIsVerified?: Maybe<Scalars['Boolean']>;
  fullName: Scalars['String'];
  id: Scalars['ID'];
  mobileNum?: Maybe<Scalars['String']>;
  nric?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  nricCopiesBack: Array<UploadedFile>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  nricCopiesFront: Array<UploadedFile>;
};

export type BankerInfo = {
  __typename?: 'BankerInfo';
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  handlingTransactions: Array<Transaction>;
  /** Refer: src/graphql/definitions/object/banker.graphql */
  info: Banker;
};

export type Block = {
  __typename?: 'Block';
  amount: Scalars['Float'];
  createdOn: Scalars['String'];
  description: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  giver?: Maybe<User>;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  receiver?: Maybe<User>;
  /** Refer: src/graphql/definitions/object/reward.graphql */
  reward?: Maybe<Reward>;
};

export type BlockedDays = {
  /** dates in ISO format */
  days: Array<Scalars['String']>;
  projectId: Scalars['String'];
};

export type BookingDraftAgent = {
  __typename?: 'BookingDraftAgent';
  hasNextAgent?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  index: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  user?: Maybe<User>;
};

export type BookingDraftBuyer = {
  __typename?: 'BookingDraftBuyer';
  /** Refer: src/graphql/definitions/object/map-place.graphql */
  address?: Maybe<MapPlace>;
  addressDetails?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/map-place.graphql */
  companyAddress?: Maybe<MapPlace>;
  companyAddressDetails?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/enum/gender.graphql */
  gender?: Maybe<Gender>;
  grossMonthlyIncome?: Maybe<Scalars['Float']>;
  hasNextBuyer?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/enum/booking-draft-buyer-income-type.graphql */
  incomeType?: Maybe<BookingDraftBuyerIncomeType>;
  index: Scalars['Int'];
  industry?: Maybe<Scalars['String']>;
  isBumi?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/enum/marital-status.graphql */
  maritalStatus?: Maybe<MaritalStatus>;
  mobileNum?: Maybe<Scalars['String']>;
  nric?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  nricCopyBack?: Maybe<UploadedFile>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  nricCopyFront?: Maybe<UploadedFile>;
  occupation?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/enum/race.graphql */
  race?: Maybe<Race>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  signature?: Maybe<UploadedFile>;
};

export enum BookingDraftBuyerIncomeType {
  CommissionEarner = 'COMMISSION_EARNER',
  FixedIncome = 'FIXED_INCOME',
  SelfEmployed = 'SELF_EMPLOYED'
}

export type BookingDraftBuyerIndustry = {
  __typename?: 'BookingDraftBuyerIndustry';
  id: Scalars['ID'];
  industry: Scalars['String'];
};

export type BookingDraftBuyerOccupation = {
  __typename?: 'BookingDraftBuyerOccupation';
  id: Scalars['ID'];
  occupation: Scalars['String'];
};

export type BookingDraftBuyerOccupationList = {
  __typename?: 'BookingDraftBuyerOccupationList';
  group: Scalars['String'];
  /** Refer: src/graphql/definitions/object/booking-draft-buyer-occupation.graphql */
  occupations: Array<BookingDraftBuyerOccupation>;
};

export enum BookingDraftFinanceSource {
  Cash = 'CASH',
  CommercialBank = 'COMMERCIAL_BANK',
  CompanyStaffLoan = 'COMPANY_STAFF_LOAN',
  LppsaStaffLoan = 'LPPSA_STAFF_LOAN'
}

/**
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-finance-source.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-margin-of-finance.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-epf-contribution.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-banker-assignment-preference.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-payment-proof.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-first-time-home-buyer.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-repeat-buyer.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-how-do-you-know-about-us.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-custom-field.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-agent.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-summary.graphql
 */
export type BookingDraftNextPage = BookingDraftPageAgent | BookingDraftPageBankerAssignmentPreference | BookingDraftPageBuyer | BookingDraftPageCustomField | BookingDraftPageEpfContribution | BookingDraftPageFinanceSource | BookingDraftPageFirstTimeHomeBuyer | BookingDraftPageHowDoYouKnowAboutUs | BookingDraftPageMarginOfFinance | BookingDraftPagePaymentProof | BookingDraftPageRepeatBuyer | BookingDraftPageSummary;

export type BookingDraftPageAgent = {
  __typename?: 'BookingDraftPageAgent';
  /** Refer: src/graphql/definitions/object/booking-draft-agent.graphql */
  agent: BookingDraftAgent;
  /** Refer: src/graphql/definitions/union/booking-draft-page-agent-kind.graphql */
  kind: BookingDraftPageAgentKind;
};

export type BookingDraftPageAgentAddAgent = {
  __typename?: 'BookingDraftPageAgentAddAgent';
  currentNumberOfAgent: Scalars['Int'];
};

export type BookingDraftPageAgentHasNextAgent = {
  __typename?: 'BookingDraftPageAgentHasNextAgent';
  dummy?: Maybe<Scalars['String']>;
};

/**
 * Refer: src/graphql/definitions/object/booking-draft-page-agent-add-agent.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-agent-has-next-agent.graphql
 */
export type BookingDraftPageAgentKind = BookingDraftPageAgentAddAgent | BookingDraftPageAgentHasNextAgent;

export type BookingDraftPageBankerAssignmentPreference = {
  __typename?: 'BookingDraftPageBankerAssignmentPreference';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyer = {
  __typename?: 'BookingDraftPageBuyer';
  /** Refer: src/graphql/definitions/object/booking-draft-buyer.graphql */
  buyer: BookingDraftBuyer;
  /** Refer: src/graphql/definitions/union/booking-draft-page-buyer-kind.graphql */
  kind: BookingDraftPageBuyerKind;
};

export type BookingDraftPageBuyerAddressDetails = {
  __typename?: 'BookingDraftPageBuyerAddressDetails';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerAddressPlaceId = {
  __typename?: 'BookingDraftPageBuyerAddressPlaceId';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerCompanyAddressDetails = {
  __typename?: 'BookingDraftPageBuyerCompanyAddressDetails';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerCompanyAddressPlaceId = {
  __typename?: 'BookingDraftPageBuyerCompanyAddressPlaceId';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerCompanyName = {
  __typename?: 'BookingDraftPageBuyerCompanyName';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerEmail = {
  __typename?: 'BookingDraftPageBuyerEmail';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerFullName = {
  __typename?: 'BookingDraftPageBuyerFullName';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerGender = {
  __typename?: 'BookingDraftPageBuyerGender';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerGrossMonthlyIncome = {
  __typename?: 'BookingDraftPageBuyerGrossMonthlyIncome';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerHasNextBuyer = {
  __typename?: 'BookingDraftPageBuyerHasNextBuyer';
  currentNumberOfBuyer: Scalars['Int'];
};

export type BookingDraftPageBuyerIncomeType = {
  __typename?: 'BookingDraftPageBuyerIncomeType';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerIndustry = {
  __typename?: 'BookingDraftPageBuyerIndustry';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerIsBumi = {
  __typename?: 'BookingDraftPageBuyerIsBumi';
  dummy?: Maybe<Scalars['String']>;
};

/**
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-full-name.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-nric.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-gender.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-race.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-is-bumi.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-marital-status.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-address-place-id.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-address-details.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-email.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-mobile-num.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-gross-monthly-income.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-income-type.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-occupation.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-industry.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-company-name.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-company-address-place-id.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-company-address-details.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-nric-copy-front.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-nric-copy-back.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-signature.graphql
 * Refer: src/graphql/definitions/object/booking-draft-page-buyer-has-next-buyer.graphql
 */
export type BookingDraftPageBuyerKind = BookingDraftPageBuyerAddressDetails | BookingDraftPageBuyerAddressPlaceId | BookingDraftPageBuyerCompanyAddressDetails | BookingDraftPageBuyerCompanyAddressPlaceId | BookingDraftPageBuyerCompanyName | BookingDraftPageBuyerEmail | BookingDraftPageBuyerFullName | BookingDraftPageBuyerGender | BookingDraftPageBuyerGrossMonthlyIncome | BookingDraftPageBuyerHasNextBuyer | BookingDraftPageBuyerIncomeType | BookingDraftPageBuyerIndustry | BookingDraftPageBuyerIsBumi | BookingDraftPageBuyerMaritalStatus | BookingDraftPageBuyerMobileNum | BookingDraftPageBuyerNric | BookingDraftPageBuyerNricCopyBack | BookingDraftPageBuyerNricCopyFront | BookingDraftPageBuyerOccupation | BookingDraftPageBuyerRace | BookingDraftPageBuyerSignature;

export type BookingDraftPageBuyerMaritalStatus = {
  __typename?: 'BookingDraftPageBuyerMaritalStatus';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerMobileNum = {
  __typename?: 'BookingDraftPageBuyerMobileNum';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerNric = {
  __typename?: 'BookingDraftPageBuyerNric';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerNricCopyBack = {
  __typename?: 'BookingDraftPageBuyerNricCopyBack';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerNricCopyFront = {
  __typename?: 'BookingDraftPageBuyerNricCopyFront';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerOccupation = {
  __typename?: 'BookingDraftPageBuyerOccupation';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerRace = {
  __typename?: 'BookingDraftPageBuyerRace';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageBuyerSignature = {
  __typename?: 'BookingDraftPageBuyerSignature';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageCustomField = {
  __typename?: 'BookingDraftPageCustomField';
  /** Refer: src/graphql/definitions/union/postlaunch-form-custom-field.graphql */
  customField: PostlaunchFormCustomField;
};

export type BookingDraftPageEpfContribution = {
  __typename?: 'BookingDraftPageEpfContribution';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageFinanceSource = {
  __typename?: 'BookingDraftPageFinanceSource';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageFirstTimeHomeBuyer = {
  __typename?: 'BookingDraftPageFirstTimeHomeBuyer';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageHowDoYouKnowAboutUs = {
  __typename?: 'BookingDraftPageHowDoYouKnowAboutUs';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageMarginOfFinance = {
  __typename?: 'BookingDraftPageMarginOfFinance';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPagePaymentProof = {
  __typename?: 'BookingDraftPagePaymentProof';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageRepeatBuyer = {
  __typename?: 'BookingDraftPageRepeatBuyer';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingDraftPageSummary = {
  __typename?: 'BookingDraftPageSummary';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingFormField = {
  /** Refer: src/graphql/definitions/input/upload.graphql */
  files?: InputMaybe<Array<Upload>>;
  key?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<Scalars['String']>>;
};

export type BookingFormRequest = {
  /** Refer: src/graphql/definitions/input/booking-form-field.graphql */
  fields: Array<BookingFormField>;
  printHardcopy?: InputMaybe<Scalars['Boolean']>;
  sendEmail?: InputMaybe<Scalars['Boolean']>;
};

export type BookingStep = {
  __typename?: 'BookingStep';
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  files?: Maybe<Array<AttachedFile>>;
  steps?: Maybe<Array<Scalars['String']>>;
};

export type BookingVerification = {
  __typename?: 'BookingVerification';
  /** Refer: src/graphql/definitions/object/user.graphql */
  agent: User;
  /** Refer: src/graphql/definitions/object/booking-verification-buyer.graphql */
  buyers: Array<BookingVerificationBuyer>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/union/booking-verification-document-collection-method.graphql */
  documentCollectionMethod?: Maybe<BookingVerificationDocumentCollectionMethod>;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/parent-project.graphql */
  parentProject: ParentProject;
  refNo: Scalars['String'];
  /** Refer: src/graphql/definitions/union/transaction-source-of-finance.graphql */
  sourceOfFinance?: Maybe<TransactionSourceOfFinance>;
  /** Refer: src/graphql/definitions/union/booking-verification-status.graphql */
  status: BookingVerificationStatus;
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  unit?: Maybe<ProjectUnit>;
  verificationLink: Scalars['String'];
};

export type BookingVerificationBuyer = {
  __typename?: 'BookingVerificationBuyer';
  /** Refer: src/graphql/definitions/union/transaction-buyer-income-type.graphql */
  _incomeType: TransactionBuyerIncomeType;
  fullName: Scalars['String'];
  grossIncome: Scalars['Float'];
  id: Scalars['ID'];
  incomeType: Scalars['String'];
  mobileNum: Scalars['String'];
  nric: Scalars['String'];
  /**
   * Refer: src/graphql/definitions/object/uploaded-file.graphql
   * @deprecated Use `nricCopiesFront` and `nricCopiesBack` instead
   */
  nricCopies: Array<UploadedFile>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  nricCopiesBack: Array<UploadedFile>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  nricCopiesFront: Array<UploadedFile>;
  /** Refer: src/graphql/definitions/object/buyer.graphql */
  relatedTransactionBuyer?: Maybe<Buyer>;
  /** Refer: src/graphql/definitions/object/booking-verification.graphql */
  verification: BookingVerification;
  /**
   * If defined means buyer already verified and gave consent.
   * Refer: src/graphql/definitions/object/booking-verification-buyer-verified.graphql
   */
  verified?: Maybe<BookingVerificationBuyerVerified>;
};

export type BookingVerificationBuyerVerified = {
  __typename?: 'BookingVerificationBuyerVerified';
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
};

/**
 * Refer: src/graphql/definitions/object/booking-verification-document-collection-method-express.graphql
 * Refer: src/graphql/definitions/object/booking-verification-document-collection-method-manual.graphql
 */
export type BookingVerificationDocumentCollectionMethod = BookingVerificationDocumentCollectionMethodExpress | BookingVerificationDocumentCollectionMethodManual;

export type BookingVerificationDocumentCollectionMethodExpress = {
  __typename?: 'BookingVerificationDocumentCollectionMethodExpress';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingVerificationDocumentCollectionMethodManual = {
  __typename?: 'BookingVerificationDocumentCollectionMethodManual';
  dummy?: Maybe<Scalars['String']>;
};

/**
 * Refer: src/graphql/definitions/object/booking-verification-status-pending-verification.graphql
 * Refer: src/graphql/definitions/object/booking-verification-status-pending-booking.graphql
 * Refer: src/graphql/definitions/object/booking-verification-status-booked.graphql
 * Refer: src/graphql/definitions/object/booking-verification-status-pending-documents.graphql
 * Refer: src/graphql/definitions/object/booking-verification-status-document-submitted.graphql
 */
export type BookingVerificationStatus = BookingVerificationStatusBooked | BookingVerificationStatusDocumentSubmitted | BookingVerificationStatusPendingBooking | BookingVerificationStatusPendingDocuments | BookingVerificationStatusPendingVerification;

export type BookingVerificationStatusBooked = {
  __typename?: 'BookingVerificationStatusBooked';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingVerificationStatusDocumentSubmitted = {
  __typename?: 'BookingVerificationStatusDocumentSubmitted';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingVerificationStatusPendingBooking = {
  __typename?: 'BookingVerificationStatusPendingBooking';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingVerificationStatusPendingDocuments = {
  __typename?: 'BookingVerificationStatusPendingDocuments';
  dummy?: Maybe<Scalars['String']>;
};

export type BookingVerificationStatusPendingVerification = {
  __typename?: 'BookingVerificationStatusPendingVerification';
  dummy?: Maybe<Scalars['String']>;
};

export type Buyer = {
  __typename?: 'Buyer';
  /** Refer: src/graphql/definitions/object/map-place.graphql */
  address?: Maybe<MapPlace>;
  addressDetails?: Maybe<Scalars['String']>;
  /**
   * Refer: src/graphql/definitions/object/user-address.graphql
   * @deprecated use nric_ or corr_ address properties
   */
  addresses?: Maybe<Array<UserAddress>>;
  /**
   * Refer: src/graphql/definitions/object/user-buyer-info.graphql
   * @deprecated Postgres buyer not longer has this property
   */
  buyerInfo?: Maybe<UserBuyerInfo>;
  citizenship: Scalars['String'];
  /** Refer: src/graphql/definitions/object/map-place.graphql */
  companyAddress?: Maybe<MapPlace>;
  companyAddressDetails?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  /**
   * Refer: src/graphql/definitions/object/user-contact.graphql
   * @deprecated use mobileNum, email, emailIsVerified instead.
   */
  contacts?: Maybe<Array<UserContact>>;
  /** Refer: src/graphql/definitions/object/transaction-buyer-address.graphql */
  corrAddress?: Maybe<TransactionBuyerAddress>;
  /**
   * A CTOS report might consists of multiple CCRIS profiles according CTOS team.
   * However, we will still combine multiple CCRIS profiles in one response.
   * Refer: src/graphql/definitions/object/ctos-credit-report.graphql
   */
  ctosReport?: Maybe<CtosCreditReport>;
  /** @deprecated Postgres buyer not longer has this property */
  displayName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  /** @deprecated Postgres buyer not longer has this property */
  emailIsVerified?: Maybe<Scalars['Boolean']>;
  employerAddress: Scalars['String'];
  employerName: Scalars['String'];
  exactMonthlyIncome?: Maybe<Scalars['Float']>;
  /** Refer: src/graphql/definitions/object/transaction-buyer-file.graphql */
  files: Array<TransactionBuyerFile>;
  fullName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  houseNum: Scalars['String'];
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/enum/booking-draft-buyer-income-type.graphql */
  incomeType?: Maybe<BookingDraftBuyerIncomeType>;
  industry?: Maybe<Scalars['String']>;
  isBumi?: Maybe<Scalars['Boolean']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  maritalStatus: Scalars['String'];
  mobileNum?: Maybe<Scalars['String']>;
  monthlyIncome: Scalars['String'];
  nric?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/transaction-buyer-address.graphql */
  nricAddress?: Maybe<TransactionBuyerAddress>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  nricCopiesBack: Array<UploadedFile>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  nricCopiesFront: Array<UploadedFile>;
  occupation: Scalars['String'];
  officeNum: Scalars['String'];
  /** @deprecated Postgres buyer not longer has this property */
  profilePicture?: Maybe<Scalars['String']>;
  race: Scalars['String'];
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  signature?: Maybe<UploadedFile>;
};

export type BuyerAddress = {
  city: Scalars['String'];
  country: Scalars['String'];
  postCode: Scalars['String'];
  state: Scalars['String'];
  streetName: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/user-address-type.graphql */
  type: UserAddressType;
};

export type BuyerAddressHeatmap = {
  __typename?: 'BuyerAddressHeatmap';
  /** Refer: src/graphql/definitions/object/coordinate.graphql */
  coordinates: Array<Coordinate>;
};

export type BuyerConsentFlowSettingDisabled = {
  __typename?: 'BuyerConsentFlowSettingDisabled';
  dummy?: Maybe<Scalars['String']>;
};

export type BuyerConsentFlowSettingEnabledBlocking = {
  __typename?: 'BuyerConsentFlowSettingEnabledBlocking';
  dummy?: Maybe<Scalars['String']>;
};

export type BuyerConsentFlowSettingEnabledNonBlocking = {
  __typename?: 'BuyerConsentFlowSettingEnabledNonBlocking';
  dummy?: Maybe<Scalars['String']>;
};

export type BuyerDemographicData = {
  __typename?: 'BuyerDemographicData';
  /** Refer: src/graphql/definitions/object/by-age.graphql */
  byAge: Array<ByAge>;
  /** Refer: src/graphql/definitions/object/by-first-time-home-buyer.graphql */
  byFirstTimeHomeBuyer: Array<ByFirstTimeHomeBuyer>;
  /** Refer: src/graphql/definitions/object/by-gender.graphql */
  byGender: Array<ByGender>;
  /** Refer: src/graphql/definitions/object/by-location.graphql */
  byLocation: Array<ByLocation>;
  /** Refer: src/graphql/definitions/object/by-monthly-income.graphql */
  byMonthlyIncome: Array<ByMonthlyIncome>;
  /** Refer: src/graphql/definitions/object/by-occupation.graphql */
  byOccupation: Array<ByOccupation>;
  /** Refer: src/graphql/definitions/object/by-race.graphql */
  byRace: Array<ByRace>;
};

export type BuyerLead = {
  __typename?: 'BuyerLead';
  /** Passed in by the source platform */
  advertisementId: Scalars['String'];
  /** Passed in by the source platform */
  advertisementName: Scalars['String'];
  /**
   * This one means the related buyer lead distribution that is stored in our database
   * Refer: src/graphql/definitions/object/buyer-lead-distribution.graphql
   */
  buyerLeadDistribution?: Maybe<BuyerLeadDistribution>;
  /** Passed in by the source platform */
  campaignId: Scalars['String'];
  /** Passed in by the source platform */
  campaignName: Scalars['String'];
  createdOn: Scalars['String'];
  currentSecondaryStatus?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/enum/buyer-lead-status.graphql */
  currentStatus: BuyerLeadStatus;
  email: Scalars['String'];
  errors: Array<Scalars['String']>;
  fullName: Scalars['String'];
  id: Scalars['String'];
  leadId: Scalars['String'];
  mobileNum: Scalars['String'];
  platform: Scalars['String'];
  /** Refer: src/graphql/definitions/object/agent.graphql */
  receivingAgent?: Maybe<Agent>;
  /** Refer: src/graphql/definitions/object/recorded-buyer-lead-status.graphql */
  recordedStatuses: Array<RecordedBuyerLeadStatus>;
  /** Refer: src/graphql/definitions/object/buyer.graphql */
  relatedBuyers: Array<Buyer>;
  /**
   * Refer: src/graphql/definitions/object/user.graphql
   * @deprecated use relatedBuyers instead.
   */
  relatedUsers: Array<User>;
  /** Refer: src/graphql/definitions/object/buyer-lead-remark.graphql */
  remarks: Array<BuyerLeadRemark>;
  /** Refer: src/graphql/definitions/object/schedule.graphql */
  schedules: Array<Schedule>;
  /** Refer: src/graphql/definitions/object/buyer-lead-status-event.graphql */
  statusEvents: Array<BuyerLeadStatusEvent>;
  /**
   * - List of converted transactions
   * - Converted means that this buyer lead has a matching transaction made by the receivingAgent
   * - We match buyer lead with buyer using mobile number
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  transactions: Array<Transaction>;
};

export type BuyerLeadCampaign = {
  __typename?: 'BuyerLeadCampaign';
  /** Refer: src/graphql/definitions/object/buyer-lead-campaign-advertisement.graphql */
  advertisements: Array<BuyerLeadCampaignAdvertisement>;
  campaignId: Scalars['String'];
  campaignName: Scalars['String'];
  platform: Scalars['String'];
};

export type BuyerLeadCampaignAdvertisement = {
  __typename?: 'BuyerLeadCampaignAdvertisement';
  advertisementId: Scalars['String'];
  advertisementName: Scalars['String'];
};

export type BuyerLeadDistribution = {
  __typename?: 'BuyerLeadDistribution';
  advertisementIds: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  beneficiaryAgents: Array<User>;
  /** Refer: src/graphql/definitions/object/buyer-lead.graphql */
  buyerLeads: Array<BuyerLead>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn?: Maybe<Scalars['String']>;
  dedup: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/enum/buyer-lead-distribution-distribution-mechanism.graphql */
  distributionMechanism: BuyerLeadDistributionDistributionMechanism;
  id: Scalars['String'];
  /** Refer: src/graphql/definitions/object/project.graphql */
  parentProject: Project;
};

export enum BuyerLeadDistributionDistributionMechanism {
  PrioritizeAgentWhoWaitedLongest = 'PRIORITIZE_AGENT_WHO_WAITED_LONGEST',
  PrioritizeAgentWithLeastBuyerLead = 'PRIORITIZE_AGENT_WITH_LEAST_BUYER_LEAD'
}

export enum BuyerLeadPrimaryStatus {
  Disqualified = 'DISQUALIFIED',
  FollowUpRequired = 'FOLLOW_UP_REQUIRED',
  NewProspect = 'NEW_PROSPECT'
}

export type BuyerLeadRemark = {
  __typename?: 'BuyerLeadRemark';
  /** This represents the content of the latest version of this remark. */
  currentContent: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  deletedBy?: Maybe<User>;
  deletedOn?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastUpdatedOn: Scalars['String'];
  /** Refer: src/graphql/definitions/object/buyer-lead-remark-version.graphql */
  versions: Array<BuyerLeadRemarkVersion>;
};

export type BuyerLeadRemarkVersion = {
  __typename?: 'BuyerLeadRemarkVersion';
  content: Scalars['String'];
  id: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  recordedBy: User;
  recordedOn: Scalars['String'];
};

export enum BuyerLeadStatus {
  AppointmentScheduled = 'APPOINTMENT_SCHEDULED',
  Converted = 'CONVERTED',
  Disqualified = 'DISQUALIFIED',
  FollowUpRequired = 'FOLLOW_UP_REQUIRED',
  NewProspect = 'NEW_PROSPECT'
}

export type BuyerLeadStatusEvent = {
  __typename?: 'BuyerLeadStatusEvent';
  /**
   * If undefined means that this event is auto-generated
   * Refer: src/graphql/definitions/object/user.graphql
   */
  recordedBy?: Maybe<User>;
  recordedOn: Scalars['String'];
  secondaryStatus?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/enum/buyer-lead-status.graphql */
  status: BuyerLeadStatus;
};

export type BuyerPortalAuthenticated = {
  __typename?: 'BuyerPortalAuthenticated';
  /** Refer: src/graphql/definitions/object/booking-verification.graphql */
  displayBookingVerification: BookingVerification;
  /** Refer: src/graphql/definitions/object/booking-verification-buyer.graphql */
  displayBookingVerificationBuyer: BookingVerificationBuyer;
  /** Refer: src/graphql/definitions/object/financer.graphql */
  displaySuggestedBanks: Array<Financer>;
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  displayTransaction: Transaction;
};


export type BuyerPortalAuthenticatedDisplayBookingVerificationArgs = {
  refNo: Scalars['String'];
};


export type BuyerPortalAuthenticatedDisplayBookingVerificationBuyerArgs = {
  id: Scalars['ID'];
};


export type BuyerPortalAuthenticatedDisplaySuggestedBanksArgs = {
  bookingVerificationRefNo: Scalars['String'];
};


export type BuyerPortalAuthenticatedDisplayTransactionArgs = {
  bookingVerificationRefNo: Scalars['String'];
};

export type BuyerPortalMutationAuthenticated = {
  __typename?: 'BuyerPortalMutationAuthenticated';
  /** Refer: src/graphql/definitions/object/postlaunch-transaction.graphql */
  confirmDocumentSubmission: PostlaunchTransaction;
  /** Refer: src/graphql/definitions/object/transaction-buyer-file.graphql */
  removeDocuments: Array<TransactionBuyerFile>;
  /** Refer: src/graphql/definitions/object/transaction-buyer-file.graphql */
  uploadDocuments: Array<TransactionBuyerFile>;
  /** Refer: src/graphql/definitions/object/booking-verification-buyer-verified.graphql */
  verifyBooking: BookingVerificationBuyerVerified;
};


export type BuyerPortalMutationAuthenticatedConfirmDocumentSubmissionArgs = {
  bookingVerificationId: Scalars['ID'];
};


export type BuyerPortalMutationAuthenticatedRemoveDocumentsArgs = {
  transactionBuyerFileIds: Array<Scalars['ID']>;
};


export type BuyerPortalMutationAuthenticatedUploadDocumentsArgs = {
  bookingVerificationBuyerId: Scalars['ID'];
  files: Array<InputTaggedUpload>;
};


export type BuyerPortalMutationAuthenticatedVerifyBookingArgs = {
  bookingVerificationBuyerId: Scalars['ID'];
  documentCollectionMethod?: InputMaybe<InputVerifyBookingDocumentCollectionMethod>;
  waitBackgroundTasks?: InputMaybe<Scalars['Boolean']>;
};

export type BuyerPortalPublic = {
  __typename?: 'BuyerPortalPublic';
  /** Refer: src/graphql/definitions/object/buyer-portal-public-booking-verification.graphql */
  displayBookingVerification: BuyerPortalPublicBookingVerification;
};


export type BuyerPortalPublicDisplayBookingVerificationArgs = {
  refNo: Scalars['String'];
};

export type BuyerPortalPublicBookingVerification = {
  __typename?: 'BuyerPortalPublicBookingVerification';
  /** Refer: src/graphql/definitions/object/buyer-portal-public-booking-verification-agent.graphql */
  agent: BuyerPortalPublicBookingVerificationAgent;
  /** Refer: src/graphql/definitions/object/buyer-portal-public-booking-verification-buyer.graphql */
  buyers: Array<BuyerPortalPublicBookingVerificationBuyer>;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/buyer-portal-public-booking-verification-parent-project.graphql */
  parentProject: BuyerPortalPublicBookingVerificationParentProject;
  /** Refer: src/graphql/definitions/object/buyer-portal-public-booking-verification-unit.graphql */
  unit?: Maybe<BuyerPortalPublicBookingVerificationUnit>;
};

export type BuyerPortalPublicBookingVerificationAgent = {
  __typename?: 'BuyerPortalPublicBookingVerificationAgent';
  /** Refer: src/graphql/definitions/object/buyer-portal-public-booking-verification-agent-agency.graphql */
  agency: BuyerPortalPublicBookingVerificationAgentAgency;
};

export type BuyerPortalPublicBookingVerificationAgentAgency = {
  __typename?: 'BuyerPortalPublicBookingVerificationAgentAgency';
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  logoFile?: Maybe<AttachedFile>;
  name: Scalars['String'];
};

export type BuyerPortalPublicBookingVerificationBuyer = {
  __typename?: 'BuyerPortalPublicBookingVerificationBuyer';
  fullName: Scalars['String'];
  id: Scalars['ID'];
  mobileNum: Scalars['String'];
};

export type BuyerPortalPublicBookingVerificationParentProject = {
  __typename?: 'BuyerPortalPublicBookingVerificationParentProject';
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  coverImageFiles: Array<AttachedFile>;
  /** Refer: src/graphql/definitions/object/buyer-portal-public-booking-verification-parent-project-developer.graphql */
  developer?: Maybe<BuyerPortalPublicBookingVerificationParentProjectDeveloper>;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  logoFile?: Maybe<AttachedFile>;
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/union/buyer-portal-public-booking-verification-parent-project-unit-layout-type.graphql */
  unitLayoutType?: Maybe<BuyerPortalPublicBookingVerificationParentProjectUnitLayoutType>;
};

export type BuyerPortalPublicBookingVerificationParentProjectDeveloper = {
  __typename?: 'BuyerPortalPublicBookingVerificationParentProjectDeveloper';
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  logoFile?: Maybe<AttachedFile>;
  name: Scalars['String'];
};

export type BuyerPortalPublicBookingVerificationParentProjectUnitLayoutHighrise = {
  __typename?: 'BuyerPortalPublicBookingVerificationParentProjectUnitLayoutHighrise';
  dummy?: Maybe<Scalars['String']>;
};

export type BuyerPortalPublicBookingVerificationParentProjectUnitLayoutLanded = {
  __typename?: 'BuyerPortalPublicBookingVerificationParentProjectUnitLayoutLanded';
  dummy?: Maybe<Scalars['String']>;
};

/**
 * Refer: src/graphql/definitions/object/buyer-portal-public-booking-verification-parent-project-unit-layout-highrise.graphql
 * Refer: src/graphql/definitions/object/buyer-portal-public-booking-verification-parent-project-unit-layout-landed.graphql
 */
export type BuyerPortalPublicBookingVerificationParentProjectUnitLayoutType = BuyerPortalPublicBookingVerificationParentProjectUnitLayoutHighrise | BuyerPortalPublicBookingVerificationParentProjectUnitLayoutLanded;

export type BuyerPortalPublicBookingVerificationUnit = {
  __typename?: 'BuyerPortalPublicBookingVerificationUnit';
  floorPlan?: Maybe<Scalars['String']>;
  landSize?: Maybe<Scalars['String']>;
  noOfBathrooms?: Maybe<Scalars['String']>;
  noOfBedrooms?: Maybe<Scalars['String']>;
  noOfCarParks?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  unitNum: Scalars['String'];
  unitSize?: Maybe<Scalars['String']>;
};

export type ByAge = {
  __typename?: 'ByAge';
  ageGroup: Scalars['String'];
  numberOfBuyers: Scalars['Int'];
};

export type ByFirstTimeHomeBuyer = {
  __typename?: 'ByFirstTimeHomeBuyer';
  firstTimeHomeBuyer: Scalars['String'];
  numberOfBuyers: Scalars['Int'];
};

export type ByGender = {
  __typename?: 'ByGender';
  gender: Scalars['String'];
  numberOfBuyers: Scalars['Int'];
};

export type ByLocation = {
  __typename?: 'ByLocation';
  location: Scalars['String'];
  numberOfBuyers: Scalars['Int'];
};

export type ByMonthlyIncome = {
  __typename?: 'ByMonthlyIncome';
  monthlyIncome: Scalars['String'];
  numberOfBuyers: Scalars['Int'];
};

export type ByOccupation = {
  __typename?: 'ByOccupation';
  numberOfBuyers: Scalars['Int'];
  occupation: Scalars['String'];
};

export type ByRace = {
  __typename?: 'ByRace';
  numberOfBuyers: Scalars['Int'];
  race: Scalars['String'];
};

export type Cancelled = {
  __typename?: 'Cancelled';
  /** Refer: src/graphql/definitions/enum/cancelled-by.graphql */
  by: CancelledBy;
  on: Scalars['String'];
};

export enum CancelledBy {
  Agent = 'agent',
  Arm = 'arm',
  ThirdParty = 'third_party'
}

export type CategorizedProjects = {
  __typename?: 'CategorizedProjects';
  /** Refer: src/graphql/definitions/object/simplified-project-category.graphql */
  categories: Array<SimplifiedProjectCategory>;
  isAgentVerified: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/project.graphql */
  projects: Array<Project>;
};

export enum CategoryType {
  Array = 'ARRAY',
  Field = 'FIELD',
  File = 'FILE',
  Function = 'FUNCTION',
  Value = 'VALUE'
}

export enum CategoryType_NonValue {
  Array = 'ARRAY',
  Field = 'FIELD',
  File = 'FILE',
  Function = 'FUNCTION'
}

export enum CategoryType_Value {
  Value = 'VALUE'
}

export type ChildProject = {
  __typename?: 'ChildProject';
  /** Refer: src/graphql/definitions/object/project-agency-kind.graphql */
  agencyKinds: Array<ProjectAgencyKind>;
  /** Refer: src/graphql/definitions/object/project-arm-commission-settings.graphql */
  armCommissionSettings?: Maybe<ProjectArmCommissionSettings>;
  bookingFee?: Maybe<Scalars['Float']>;
  /** Refer: src/graphql/definitions/union/project-buyer-consent-flow-setting.graphql */
  buyerConsentFlowSetting: ProjectBuyerConsentFlowSetting;
  /** Refer: src/graphql/definitions/object/project-commission-settings.graphql */
  commissionSettings?: Maybe<Array<ProjectCommissionSettings>>;
  /** Refer: src/graphql/definitions/object/project-developer-commission-setting.graphql */
  developerCommissionSetting: ProjectDeveloperCommissionSetting;
  /** Refer: src/graphql/definitions/object/project-discount.graphql */
  discounts: Array<ProjectDiscount>;
  /**
   * Refer: src/graphql/definitions/union/project-discount-enum.graphql
   * @deprecated Use `discounts` instead
   */
  discountsEnum: Array<ProjectDiscountEnum>;
  /** Refer: src/graphql/definitions/object/project-entitlement.graphql */
  entitlements: Array<ProjectEntitlement>;
  /** Refer: src/graphql/definitions/object/expression-setting-instruction.graphql */
  expressionSettingInstruction: ExpressionSettingInstruction;
  /**
   * This will include the parent name if the parant name is different from this
   * project name.
   */
  fullName: Scalars['String'];
  /** Refer: src/graphql/definitions/object/project-gross-price-range.graphql */
  grossPriceRange: ProjectGrossPriceRange;
  id: Scalars['ID'];
  launchedOn?: Maybe<Scalars['Date']>;
  name: Scalars['String'];
  newPostlaunchForm?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/object/parent-project.graphql */
  parent: ParentProject;
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  postLaunchTransactions: Array<Transaction>;
  /** Refer: src/graphql/definitions/object/project-agency-kind.graphql */
  projectAgencyKinds: Array<ProjectAgencyKind>;
  /** Refer: src/graphql/definitions/enum/project-type.graphql */
  projectType: ProjectType;
  /** Default project unit lock duration for agent in minutes */
  projectUnitLockDuration: Scalars['Int'];
  /**
   * If undefined, it means this project does not have an active scraper.
   * Note: A project might have scraper but not activated due to some reasons.
   * Refer: src/graphql/definitions/object/scraper-stats.graphql
   */
  scraperStats?: Maybe<ScraperStats>;
  shouldRefreshPriceChart: Scalars['Boolean'];
  status?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/union/project-unit-layout.graphql */
  unitLayout?: Maybe<ProjectUnitLayout>;
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  units: Array<ProjectUnit>;
};


export type ChildProjectEntitlementsArgs = {
  displayOnPriceChart?: InputMaybe<Scalars['Boolean']>;
};

export type Color = {
  __typename?: 'Color';
  alpha: Scalars['Float'];
  blue: Scalars['Float'];
  green: Scalars['Float'];
  red: Scalars['Float'];
};

export type ColumnFilter = {
  columnName: Scalars['String'];
  includedValues: Array<Scalars['String']>;
};

export type ColumnSearch = {
  columnName: Scalars['String'];
  searchString: Scalars['String'];
};

export type ColumnSort = {
  columnName: Scalars['String'];
  /**
   * Should be either 'ASCENDING' or 'DESCENDING'.
   * Why is this property not made into an enum?
   * This is to ease development on frontend, especially when using code generators.
   */
  order: Scalars['String'];
};

export type ColumnUniqueValue = {
  __typename?: 'ColumnUniqueValue';
  count: Scalars['Int'];
  value: Scalars['String'];
};

export type CommissionPaymentDelayReason = {
  __typename?: 'CommissionPaymentDelayReason';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['String'];
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/transaction-commission-invoice.graphql */
  invoice: TransactionCommissionInvoice;
  reason: Scalars['String'];
};

export type Coordinate = {
  __typename?: 'Coordinate';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export enum CreatedBy {
  Agent = 'agent',
  Arm = 'arm',
  ThirdParty = 'third_party'
}

export type Creation = {
  fieldName: Scalars['String'];
};

export type CronJob = {
  __typename?: 'CronJob';
  /**
   * Purpose: Copy projects data from Mongo to Postgres so that we can build
   * analytics related to project on Holistics.
   */
  copyMongoProjectsToPostgres: Scalars['Boolean'];
  /**
   * Purpose: To search through all mispaid transactions, and perform correction.
   *   Mispaid means that the total payable amount has been changed, but invoice
   *   requests have been sent for all commission portions of the transaction.
   *   If a transaction is mispaid, there are 3 possible scenarios:
   *   1. The invoice of the invoice request of the last commission portion of the transaction has not been verified yet:
   *         - Void the invoice request
   *   2. Otherwise:
   *     2.1 The transaction is applicable for retrospective commission:
   *         - Add Retrospective commission portion
   *     2.2 Otherwise:
   *         - Add Balance commission portion
   */
  findMispaidTransactions: Scalars['Boolean'];
  /**
   * Purpose: To search through all the fully paid transactions and find out
   *   which transactions are applicable for retrospective commission.
   * @deprecated Use `findMispaidTransactions` instead.
   */
  findRetrospectiveCommissionApplicableTransactions: Scalars['Boolean'];
  /** Purpose: Insert new projects from KPKT Teduh into our system */
  insertKpktProjects: Scalars['Boolean'];
  /** Purpose: Insert new agencies from BOVAEA website */
  insertNewAgencies: Scalars['Boolean'];
  /**
   * Purpose: To remind SM team if they forget to pull financial reports for some
   * postlaunch transactions
   * @deprecated Not used anymore since we have already migrated to CTOS.
   */
  remindFinancialReportPulling: Scalars['Boolean'];
  /** Purpose: To remind agency PICs regarding pending invoices. */
  remindPendingInvoice: Scalars['Boolean'];
  /** Purpose: Remind PICs to sign GALs and agree to TNCs */
  remindSignGalAndTnc: Scalars['Boolean'];
  /** Purpose: Give rewards to user that has achieve E-store related missions. */
  rewardEstoreMissions: Scalars['Boolean'];
  /**
   * Purpose: Scrape Whopay financial reports for projects that has
   * `scrapeFinancialReports` property setup
   * Note: Currently, this cron job will only work for prelaunch projects
   */
  scrapeFinancialReports: Scalars['Boolean'];
  /** Purpose: Update the all the cached derived buyer leads */
  updateAllCachedBuyerLeads: Scalars['Boolean'];
  /**
   * Purpose: update the paid amount for each developer commission invoice transaction
   * @deprecated Use `updateTransactionDeveloperCommission` instead.
   */
  updateDeveloperCommissionTransactionPaidAmount: Scalars['Boolean'];
  /** Purpose: Insert new agencies and agents into HubSpot from BOVAEA website */
  updateHubSpotAgents: Scalars['Boolean'];
  /** Purpose: Insert new projects into HubSpot from our system */
  updateHubSpotProjects: Scalars['Boolean'];
  updateMindcraftLoanPredictionResults: Scalars['Boolean'];
  /**
   * Purpose: Update the developer commission payable amount for each transaction.
   * This is required for analytics on Holistics.
   */
  updateTransactionDeveloperCommission: Scalars['Boolean'];
  /**
   * Purpose: Update the cached data e.g. nett price, developer payable amount for each transaction.
   * This is required for analytics on Holistics.
   */
  updateTransactionsCachedData: Scalars['Boolean'];
};

export type CsvColumn = {
  __typename?: 'CsvColumn';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CtosCreditReport = {
  __typename?: 'CtosCreditReport';
  /** Refer: src/graphql/definitions/object/ctos-credit-report-applicant.graphql */
  applicant: CtosCreditReportApplicant;
  createdOn: Scalars['String'];
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  file?: Maybe<UploadedFile>;
  id: Scalars['ID'];
  refNo: Scalars['String'];
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  relatedTransactions: Array<Transaction>;
};


export type CtosCreditReportRelatedTransactionsArgs = {
  parentProjectId?: InputMaybe<Scalars['ID']>;
};

export type CtosCreditReportApplicant = {
  __typename?: 'CtosCreditReportApplicant';
  fullName: Scalars['String'];
  mobileNum: Scalars['String'];
  nric: Scalars['String'];
};

export type CustomField = {
  __typename?: 'CustomField';
  fieldName: Scalars['String'];
  fieldValue: Scalars['String'];
};

export type CustomerScheduleWeeklyStat = {
  __typename?: 'CustomerScheduleWeeklyStat';
  count: Scalars['Int'];
  /** @deprecated Use `dateStart` instead */
  date: Scalars['Date'];
  dateEnd: Scalars['Date'];
  dateStart: Scalars['Date'];
  hourEnd: Scalars['Int'];
  hourStart: Scalars['Int'];
  minuteEnd: Scalars['Int'];
  minuteStart: Scalars['Int'];
};

export enum DateType {
  Book = 'BOOK',
  Cancel = 'CANCEL',
  Complete = 'COMPLETE'
}

export enum Day {
  Friday = 'Friday',
  Monday = 'Monday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Thursday = 'Thursday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday'
}

export type DdnAgent = {
  __typename?: 'DdnAgent';
  /** Currently, this is the same as the user's referral code. */
  invitationCode: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  user: User;
};

export type DdnApplicant = {
  __typename?: 'DdnApplicant';
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  bankStatements: Array<UploadedFile>;
  correspondenceAddress?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  eaForms: Array<UploadedFile>;
  email?: Maybe<Scalars['String']>;
  employerName?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  epfStatements: Array<UploadedFile>;
  fullName?: Maybe<Scalars['String']>;
  grossMonthlyIncome?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  mobileNum?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  nric?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  nricBackCopy?: Maybe<UploadedFile>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  nricFrontCopy?: Maybe<UploadedFile>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  payslips: Array<UploadedFile>;
  race?: Maybe<Scalars['String']>;
};

export type DdnApplication = {
  __typename?: 'DdnApplication';
  /** Refer: src/graphql/definitions/object/ddn-booking.graphql */
  activeBooking?: Maybe<DdnBooking>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  agent: User;
  /** Refer: src/graphql/definitions/object/ddn-coapplicant.graphql */
  coapplicants: Array<DdnCoapplicant>;
  createdOn: Scalars['Date'];
  expectedCoapplicantCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/ddn-applicant.graphql */
  mainApplicant: DdnApplicant;
};

export type DdnAppreciationRate = {
  __typename?: 'DdnAppreciationRate';
  updatedOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/ddn-appreciation-rate-value.graphql */
  values: Array<DdnAppreciationRateValue>;
};

export type DdnAppreciationRateValue = {
  __typename?: 'DdnAppreciationRateValue';
  appreciationRate: Scalars['Float'];
  year: Scalars['Int'];
};

export type DdnBooking = {
  __typename?: 'DdnBooking';
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  application: DdnApplication;
  /** Refer: src/graphql/definitions/object/ddn-booking-confirmation.graphql */
  confirmation?: Maybe<DdnBookingConfirmation>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/ddn-property.graphql */
  property: DdnProperty;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  rentOfferLetterDraft: UploadedFile;
};

export type DdnBookingConfirmation = {
  __typename?: 'DdnBookingConfirmation';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  mainApplicantSignature: UploadedFile;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  rentOfferLetter: UploadedFile;
};

export type DdnBuyer = {
  __typename?: 'DdnBuyer';
  /** Refer: src/graphql/definitions/object/user.graphql */
  user: User;
};

export type DdnCalculationVariables = {
  __typename?: 'DdnCalculationVariables';
  /** Refer: src/graphql/definitions/object/ddn-appreciation-rate.graphql */
  appreciationRate?: Maybe<DdnAppreciationRate>;
  /** Refer: src/graphql/definitions/object/ddn-credit-point-percentage.graphql */
  creditPointPercentage?: Maybe<DdnCreditPointPercentage>;
  /** Refer: src/graphql/definitions/object/ddn-interest-rate.graphql */
  interestRate?: Maybe<DdnInterestRate>;
  /** Refer: src/graphql/definitions/object/ddn-monthly-payment-multiplier.graphql */
  monthlyPaymentMultiplier?: Maybe<DdnMonthlyPaymentMultiplier>;
};

export type DdnCoapplicant = {
  __typename?: 'DdnCoapplicant';
  /** Refer: src/graphql/definitions/object/ddn-applicant.graphql */
  applicant: DdnApplicant;
  id: Scalars['ID'];
  /** Relationship with main applicant. */
  relationship: Scalars['String'];
};

export type DdnCreditPointPercentage = {
  __typename?: 'DdnCreditPointPercentage';
  updatedOn: Scalars['Date'];
  value: Scalars['Float'];
};

export type DdnEnableOnApp = {
  __typename?: 'DdnEnableOnApp';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
};

export type DdnInquiry = {
  __typename?: 'DdnInquiry';
  createdOn: Scalars['Date'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  remarks: Scalars['String'];
};

export type DdnInterestRate = {
  __typename?: 'DdnInterestRate';
  updatedOn: Scalars['Date'];
  value: Scalars['Float'];
};

export type DdnMonthlyPaymentMultiplier = {
  __typename?: 'DdnMonthlyPaymentMultiplier';
  updatedOn: Scalars['Date'];
  value: Scalars['Float'];
};

export type DdnPortal = {
  __typename?: 'DdnPortal';
  /** Refer: src/graphql/definitions/object/ddn-portal-agent.graphql */
  agent: DdnPortalAgent;
  /** Refer: src/graphql/definitions/object/ddn-portal-buyer.graphql */
  buyer: DdnPortalBuyer;
};

export type DdnPortalAgent = {
  __typename?: 'DdnPortalAgent';
  /**
   * List of fields to view the applications that were created using the agent's
   * invitation code.
   * Refer: src/graphql/definitions/object/ddn-portal-agent-application.graphql
   */
  application: DdnPortalAgentApplication;
  /**
   * List of fields to view the listings created by the requesting agent.
   * Refer: src/graphql/definitions/object/ddn-portal-agent-property.graphql
   */
  property: DdnPortalAgentProperty;
};

export type DdnPortalAgentApplication = {
  __typename?: 'DdnPortalAgentApplication';
  /** Refer: src/graphql/definitions/object/ddn-portal-agent-application-find-many.graphql */
  findMany: DdnPortalAgentApplicationFindMany;
};

export type DdnPortalAgentApplicationFindMany = {
  __typename?: 'DdnPortalAgentApplicationFindMany';
  /**
   * Applications that are bookable.
   * Refer: src/graphql/definitions/object/filtered-ddn-applications.graphql
   */
  bookable: FilteredDdnApplications;
};


export type DdnPortalAgentApplicationFindManyBookableArgs = {
  search?: InputMaybe<Scalars['String']>;
};

export type DdnPortalAgentProperty = {
  __typename?: 'DdnPortalAgentProperty';
  /** Refer: src/graphql/definitions/object/ddn-portal-agent-property-find-many.graphql */
  findMany: DdnPortalAgentPropertyFindMany;
  /** Refer: src/graphql/definitions/object/ddn-portal-agent-property-find-one.graphql */
  findOne: DdnPortalAgentPropertyFindOne;
};

export type DdnPortalAgentPropertyFindMany = {
  __typename?: 'DdnPortalAgentPropertyFindMany';
  /** Refer: src/graphql/definitions/object/filtered-ddn-properties.graphql */
  all: FilteredDdnProperties;
  /**
   * Properties that are approved and not linked to any active bookings.
   * Doc: https://app.nuclino.com/Didian/Product/property-approved-b1ce9359-8fad-41b2-bede-08f55fd97d27
   * Refer: src/graphql/definitions/object/filtered-ddn-properties.graphql
   */
  approved: FilteredDdnProperties;
  /** Refer: src/graphql/definitions/object/filtered-ddn-properties.graphql */
  complete: FilteredDdnProperties;
  /**
   * Get the incomplete property listings of this agent.
   * Doc: https://app.nuclino.com/Didian/Product/Statuses-7517c22d-88a2-41c4-8c78-fae811dac25b
   * Refer: src/graphql/definitions/object/filtered-ddn-properties.graphql
   */
  incomplete: FilteredDdnProperties;
};


export type DdnPortalAgentPropertyFindManyApprovedArgs = {
  search?: InputMaybe<Scalars['String']>;
};

export type DdnPortalAgentPropertyFindOne = {
  __typename?: 'DdnPortalAgentPropertyFindOne';
  /** Refer: src/graphql/definitions/object/ddn-property.graphql */
  byId: DdnProperty;
};


export type DdnPortalAgentPropertyFindOneByIdArgs = {
  id: Scalars['ID'];
};

export type DdnPortalBuyer = {
  __typename?: 'DdnPortalBuyer';
  /** Refer: src/graphql/definitions/object/ddn-portal-buyer-application.graphql */
  application: DdnPortalBuyerApplication;
  /** Refer: src/graphql/definitions/object/ddn-portal-buyer-booking.graphql */
  booking: DdnPortalBuyerBooking;
};

export type DdnPortalBuyerApplication = {
  __typename?: 'DdnPortalBuyerApplication';
  /** Refer: src/graphql/definitions/object/ddn-portal-buyer-application-find-many.graphql */
  findMany: DdnPortalBuyerApplicationFindMany;
  /** Refer: src/graphql/definitions/object/ddn-portal-buyer-application-find-one.graphql */
  findOne: DdnPortalBuyerApplicationFindOne;
};

export type DdnPortalBuyerApplicationFindMany = {
  __typename?: 'DdnPortalBuyerApplicationFindMany';
  /** Refer: src/graphql/definitions/object/filtered-ddn-applications.graphql */
  all: FilteredDdnApplications;
};

export type DdnPortalBuyerApplicationFindOne = {
  __typename?: 'DdnPortalBuyerApplicationFindOne';
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  byId: DdnApplication;
};


export type DdnPortalBuyerApplicationFindOneByIdArgs = {
  id: Scalars['ID'];
};

export type DdnPortalBuyerBooking = {
  __typename?: 'DdnPortalBuyerBooking';
  /** Refer: src/graphql/definitions/object/ddn-booking.graphql */
  active?: Maybe<DdnBooking>;
};

export type DdnPortalMutation = {
  __typename?: 'DdnPortalMutation';
  /** Refer: src/graphql/definitions/object/ddn-portal-mutation-agent.graphql */
  agent: DdnPortalMutationAgent;
  /** Refer: src/graphql/definitions/object/ddn-portal-mutation-buyer.graphql */
  buyer: DdnPortalMutationBuyer;
};

export type DdnPortalMutationAgent = {
  __typename?: 'DdnPortalMutationAgent';
  /** Refer: src/graphql/definitions/object/ddn-booking.graphql */
  bookProperty: DdnBooking;
  /** Refer: src/graphql/definitions/object/ddn-booking.graphql */
  cancelBooking: DdnBooking;
  /** Refer: src/graphql/definitions/object/ddn-enable-on-app.graphql */
  enableDdnOnApp: DdnEnableOnApp;
  /** Refer: src/graphql/definitions/object/ddn-portal-mutation-agent-property.graphql */
  property: DdnPortalMutationAgentProperty;
};


export type DdnPortalMutationAgentBookPropertyArgs = {
  applicationId: Scalars['ID'];
  date?: InputMaybe<Scalars['Date']>;
  propertyId: Scalars['ID'];
};


export type DdnPortalMutationAgentCancelBookingArgs = {
  id: Scalars['ID'];
};

export type DdnPortalMutationAgentProperty = {
  __typename?: 'DdnPortalMutationAgentProperty';
  /** Refer: src/graphql/definitions/object/ddn-property.graphql */
  create: DdnProperty;
  /** Refer: src/graphql/definitions/object/ddn-property.graphql */
  delete: DdnProperty;
  /** Refer: src/graphql/definitions/object/ddn-portal-mutation-agent-property-update.graphql */
  update: DdnPortalMutationAgentPropertyUpdate;
};


export type DdnPortalMutationAgentPropertyCreateArgs = {
  address: Scalars['String'];
  coordinate?: InputMaybe<InputCoordinate>;
  date?: InputMaybe<Scalars['Date']>;
};


export type DdnPortalMutationAgentPropertyDeleteArgs = {
  id: Scalars['ID'];
};


export type DdnPortalMutationAgentPropertyUpdateArgs = {
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  waitBackgroundTasks?: InputMaybe<Scalars['Boolean']>;
};

export type DdnPortalMutationAgentPropertyUpdate = {
  __typename?: 'DdnPortalMutationAgentPropertyUpdate';
  /** Refer: src/graphql/definitions/object/ddn-property.graphql */
  bathroomCount: DdnProperty;
  /** Refer: src/graphql/definitions/object/ddn-property.graphql */
  bedroomCount: DdnProperty;
  /** Refer: src/graphql/definitions/object/ddn-property.graphql */
  builtUpSize: DdnProperty;
  /** Refer: src/graphql/definitions/object/manage-array-upload.graphql */
  coverImages: ManageArrayUpload;
  /** Refer: src/graphql/definitions/object/ddn-property.graphql */
  landSize: DdnProperty;
  /**
   * Lowest price owner is willing to sell at.
   * Refer: src/graphql/definitions/object/ddn-property.graphql
   */
  price: DdnProperty;
  /** Refer: src/graphql/definitions/object/ddn-property.graphql */
  renovated: DdnProperty;
  /** Refer: src/graphql/definitions/object/manage-array-upload.graphql */
  renovatedPartImages: ManageArrayUpload;
  /** Refer: src/graphql/definitions/object/ddn-property.graphql */
  storeyCount: DdnProperty;
};


export type DdnPortalMutationAgentPropertyUpdateBathroomCountArgs = {
  value: Scalars['Int'];
};


export type DdnPortalMutationAgentPropertyUpdateBedroomCountArgs = {
  value: Scalars['Int'];
};


export type DdnPortalMutationAgentPropertyUpdateBuiltUpSizeArgs = {
  value: Scalars['Float'];
};


export type DdnPortalMutationAgentPropertyUpdateLandSizeArgs = {
  length: Scalars['Float'];
  width: Scalars['Float'];
};


export type DdnPortalMutationAgentPropertyUpdatePriceArgs = {
  value: Scalars['Float'];
};


export type DdnPortalMutationAgentPropertyUpdateRenovatedArgs = {
  value: Scalars['Boolean'];
};


export type DdnPortalMutationAgentPropertyUpdateStoreyCountArgs = {
  value: Scalars['Float'];
};

export type DdnPortalMutationBuyer = {
  __typename?: 'DdnPortalMutationBuyer';
  /** Refer: src/graphql/definitions/object/ddn-portal-mutation-buyer-application.graphql */
  application: DdnPortalMutationBuyerApplication;
  /** Refer: src/graphql/definitions/object/ddn-booking.graphql */
  confirmBooking: DdnBooking;
};


export type DdnPortalMutationBuyerConfirmBookingArgs = {
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  mainApplicantSignature: Upload;
};

export type DdnPortalMutationBuyerApplication = {
  __typename?: 'DdnPortalMutationBuyerApplication';
  requestEstimatedBudget: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/ddn-portal-mutation-buyer-application-update.graphql */
  update: DdnPortalMutationBuyerApplicationUpdate;
};


export type DdnPortalMutationBuyerApplicationRequestEstimatedBudgetArgs = {
  id: Scalars['ID'];
  waitBackgroundTasks?: InputMaybe<Scalars['Boolean']>;
};


export type DdnPortalMutationBuyerApplicationUpdateArgs = {
  id: Scalars['ID'];
};

export type DdnPortalMutationBuyerApplicationUpdate = {
  __typename?: 'DdnPortalMutationBuyerApplicationUpdate';
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  addCoapplicant: DdnApplication;
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  removeCoapplicant: DdnApplication;
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  setExpectedCoapplicantCount: DdnApplication;
  /** Refer: src/graphql/definitions/object/ddn-portal-mutation-buyer-application-update-coapplicant.graphql */
  updateCoapplicant: DdnPortalMutationBuyerApplicationUpdateCoapplicant;
  /** Refer: src/graphql/definitions/object/ddn-portal-mutation-buyer-application-update-applicant.graphql */
  updateMainApplicant: DdnPortalMutationBuyerApplicationUpdateApplicant;
};


export type DdnPortalMutationBuyerApplicationUpdateAddCoapplicantArgs = {
  relationship: Scalars['String'];
};


export type DdnPortalMutationBuyerApplicationUpdateRemoveCoapplicantArgs = {
  id: Scalars['ID'];
};


export type DdnPortalMutationBuyerApplicationUpdateSetExpectedCoapplicantCountArgs = {
  value: Scalars['Int'];
};


export type DdnPortalMutationBuyerApplicationUpdateUpdateCoapplicantArgs = {
  id: Scalars['ID'];
};

export type DdnPortalMutationBuyerApplicationUpdateApplicant = {
  __typename?: 'DdnPortalMutationBuyerApplicationUpdateApplicant';
  /** Refer: src/graphql/definitions/object/manage-array-upload.graphql */
  bankStatements: ManageArrayUpload;
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  correspondenceAddress: DdnApplication;
  /** Refer: src/graphql/definitions/object/manage-array-upload.graphql */
  eaForms: ManageArrayUpload;
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  email: DdnApplication;
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  employerName: DdnApplication;
  /** Refer: src/graphql/definitions/object/manage-array-upload.graphql */
  epfStatements: ManageArrayUpload;
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  fullName: DdnApplication;
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  grossMonthlyIncome: DdnApplication;
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  mobileNum: DdnApplication;
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  nationality: DdnApplication;
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  nric: DdnApplication;
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  nricBackCopy: DdnApplication;
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  nricFrontCopy: DdnApplication;
  /** Refer: src/graphql/definitions/object/manage-array-upload.graphql */
  payslips: ManageArrayUpload;
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  race: DdnApplication;
};


export type DdnPortalMutationBuyerApplicationUpdateApplicantCorrespondenceAddressArgs = {
  value: Scalars['String'];
};


export type DdnPortalMutationBuyerApplicationUpdateApplicantEmailArgs = {
  value: Scalars['String'];
};


export type DdnPortalMutationBuyerApplicationUpdateApplicantEmployerNameArgs = {
  value: Scalars['String'];
};


export type DdnPortalMutationBuyerApplicationUpdateApplicantFullNameArgs = {
  value: Scalars['String'];
};


export type DdnPortalMutationBuyerApplicationUpdateApplicantGrossMonthlyIncomeArgs = {
  value: Scalars['Float'];
};


export type DdnPortalMutationBuyerApplicationUpdateApplicantMobileNumArgs = {
  value: Scalars['String'];
};


export type DdnPortalMutationBuyerApplicationUpdateApplicantNationalityArgs = {
  value: Scalars['String'];
};


export type DdnPortalMutationBuyerApplicationUpdateApplicantNricArgs = {
  value: Scalars['String'];
};


export type DdnPortalMutationBuyerApplicationUpdateApplicantNricBackCopyArgs = {
  value: Upload;
};


export type DdnPortalMutationBuyerApplicationUpdateApplicantNricFrontCopyArgs = {
  value: Upload;
};


export type DdnPortalMutationBuyerApplicationUpdateApplicantRaceArgs = {
  value: Scalars['String'];
};

export type DdnPortalMutationBuyerApplicationUpdateCoapplicant = {
  __typename?: 'DdnPortalMutationBuyerApplicationUpdateCoapplicant';
  /** Refer: src/graphql/definitions/object/ddn-portal-mutation-buyer-application-update-applicant.graphql */
  applicant: DdnPortalMutationBuyerApplicationUpdateApplicant;
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  relationship: DdnApplication;
};


export type DdnPortalMutationBuyerApplicationUpdateCoapplicantRelationshipArgs = {
  value: Scalars['String'];
};

export type DdnPortalPublic = {
  __typename?: 'DdnPortalPublic';
  /**
   * For buyer to create a DDN Application draft.
   * Note: the mobile number of the buyer should be obtained via the Firebase
   * Auth Token.
   * Refer: src/graphql/definitions/object/ddn-application.graphql
   */
  createDdnApplicationDraft: DdnApplication;
  /** Refer: src/graphql/definitions/object/ddn-inquiry.graphql */
  getSubmittedInquiry?: Maybe<DdnInquiry>;
  /**
   * For frontend client to tell if the requesting user is an agent or/and a
   * buyer on DDN.
   * If null is returned, it means that the user only have a
   * `user` object on Firebase but do not have a corresponding
   * `user` object in our database.
   * If not null, then the requesting user has a `user` object in
   * our database.
   * Refer: src/graphql/definitions/object/ddn-user-role.graphql
   */
  getUserRole?: Maybe<DdnUserRole>;
  /**
   * This is for wild users, either they are buyers who landed on Didian Now page
   * without any agent's invitation code, or they are agents who have not
   * registered on Didian App yet.
   */
  submitInquiry: Scalars['Boolean'];
};


export type DdnPortalPublicCreateDdnApplicationDraftArgs = {
  invitationCode: Scalars['String'];
};


export type DdnPortalPublicSubmitInquiryArgs = {
  email: Scalars['String'];
  fullName: Scalars['String'];
  remarks: Scalars['String'];
};

export type DdnProperty = {
  __typename?: 'DdnProperty';
  /** Refer: src/graphql/definitions/object/ddn-booking.graphql */
  activeBooking?: Maybe<DdnBooking>;
  address: Scalars['String'];
  bathroomCount?: Maybe<Scalars['Int']>;
  bedroomCount?: Maybe<Scalars['Int']>;
  builtUpSize?: Maybe<Scalars['Float']>;
  /**
   * If undefined means the property is not completed yet i.e. some of the
   * property's details are missing
   * Refer: src/graphql/definitions/object/ddn-property-completion.graphql
   */
  completion?: Maybe<DdnPropertyCompletion>;
  /** Refer: src/graphql/definitions/object/ddn-property-coordinate.graphql */
  coordinate?: Maybe<DdnPropertyCoordinate>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  coverImages?: Maybe<Array<UploadedFile>>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/ddn-property-land-size.graphql */
  landSize?: Maybe<DdnPropertyLandSize>;
  price?: Maybe<Scalars['Float']>;
  renovated?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  renovatedPartImages?: Maybe<Array<UploadedFile>>;
  /**
   * This is float but not integer because some property can have 2.5 storeys,
   * which indicate that the 3rd floor might be an attice (partial storey).
   */
  storeyCount?: Maybe<Scalars['Float']>;
};

export type DdnPropertyCompletion = {
  __typename?: 'DdnPropertyCompletion';
  /** Refer: src/graphql/definitions/union/ddn-property-completion-approval-status.graphql */
  approvalStatus?: Maybe<DdnPropertyCompletionApprovalStatus>;
  createdOn: Scalars['Date'];
};

/**
 * Refer: src/graphql/definitions/object/ddn-property-completion-approval-status-approved.graphql
 * Refer: src/graphql/definitions/object/ddn-property-completion-approval-status-rejected.graphql
 */
export type DdnPropertyCompletionApprovalStatus = DdnPropertyCompletionApprovalStatusApproved | DdnPropertyCompletionApprovalStatusRejected;

export type DdnPropertyCompletionApprovalStatusApproved = {
  __typename?: 'DdnPropertyCompletionApprovalStatusApproved';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/email.graphql */
  email?: Maybe<Email>;
};

export type DdnPropertyCompletionApprovalStatusRejected = {
  __typename?: 'DdnPropertyCompletionApprovalStatusRejected';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/email.graphql */
  email?: Maybe<Email>;
  reason: Scalars['String'];
};

export type DdnPropertyCoordinate = {
  __typename?: 'DdnPropertyCoordinate';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type DdnPropertyLandSize = {
  __typename?: 'DdnPropertyLandSize';
  /** In terms of square feet (sqft.) */
  length: Scalars['Float'];
  /** In terms of square feet (sqft.) */
  width: Scalars['Float'];
};

export type DdnPublic = {
  __typename?: 'DdnPublic';
  /** Refer: src/graphql/definitions/object/ddn-calculation-variables.graphql */
  calculationVariables: DdnCalculationVariables;
};

export type DdnUserRole = {
  __typename?: 'DdnUserRole';
  /**
   * If not null, then the user is an agent on DDN.
   * Refer: src/graphql/definitions/object/ddn-agent.graphql
   */
  agent?: Maybe<DdnAgent>;
  /**
   * If not null, then the user is a buyer on DDN.
   * Refer: src/graphql/definitions/object/ddn-buyer.graphql
   */
  buyer?: Maybe<DdnBuyer>;
};

/**
 * Refer: src/graphql/definitions/object/delete-service-fee-bill-success.graphql
 * Refer: src/graphql/definitions/object/delete-service-fee-bill-failure-dependency-issue.graphql
 */
export type DeleteServiceFeeBill = DeleteServiceFeeBillFailureDependencyIssue | DeleteServiceFeeBillSuccess;

export type DeleteServiceFeeBillFailureDependencyIssue = {
  __typename?: 'DeleteServiceFeeBillFailureDependencyIssue';
  /**
   * Items that are dependent on this bill.
   * Refer: src/graphql/definitions/object/service-fee-bill-item-grouped-by-bill.graphql
   */
  dependants: Array<ServiceFeeBillItemGroupedByBill>;
};

export type DeleteServiceFeeBillSuccess = {
  __typename?: 'DeleteServiceFeeBillSuccess';
  dummy?: Maybe<Scalars['Boolean']>;
};

export type Deletion = {
  fieldName: Scalars['String'];
};

export enum DerivedAgentLeadStatus {
  AppointmentScheduled = 'APPOINTMENT_SCHEDULED',
  FollowUpRequiredEngagementRequired = 'FOLLOW_UP_REQUIRED_ENGAGEMENT_REQUIRED',
  FollowUpRequiredScheduleConfirmationNeeded = 'FOLLOW_UP_REQUIRED_SCHEDULE_CONFIRMATION_NEEDED',
  FutureProspect = 'FUTURE_PROSPECT',
  NoActionRequired = 'NO_ACTION_REQUIRED',
  /**
   * This means agent lead who has submitted interest for a project but they are
   * not whitelisted for that project yet.
   */
  RegisteredInterest = 'REGISTERED_INTEREST',
  Whitelisted = 'WHITELISTED'
}

export type DetailedBuyerLeadStatus = {
  __typename?: 'DetailedBuyerLeadStatus';
  /** Refer: src/graphql/definitions/enum/buyer-lead-status.graphql */
  primaryStatus?: Maybe<BuyerLeadStatus>;
  secondaryStatuses: Array<Scalars['String']>;
};

export type DeveloperCommissionBatch = {
  __typename?: 'DeveloperCommissionBatch';
  /** @deprecated Use `id` instead. */
  _id: Scalars['String'];
  id: Scalars['ID'];
  paidOn: Scalars['String'];
  sstInclusive: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/developer-commission-stage.graphql */
  stage?: Maybe<DeveloperCommissionStage>;
  totalPaidAmount: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/filtered-developer-commission-batch-transactions.graphql */
  transactions: FilteredDeveloperCommissionBatchTransactions;
  /** Refer: src/graphql/definitions/union/developer-commission-batch-variant.graphql */
  variant: DeveloperCommissionBatchVariant;
};


export type DeveloperCommissionBatchTransactionsArgs = {
  search?: InputMaybe<Scalars['String']>;
};

/** This can also be read as `TransactionDeveloperCommissionBatch`. */
export type DeveloperCommissionBatchTransaction = {
  __typename?: 'DeveloperCommissionBatchTransaction';
  /** Refer: src/graphql/definitions/object/developer-commission-batch.graphql */
  batch: DeveloperCommissionBatch;
  paidAmount: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/postlaunch-transaction.graphql */
  transaction: PostlaunchTransaction;
};

/**
 * Refer: src/graphql/definitions/object/developer-commission-batch-variant-fixed-amount.graphql
 * Refer: src/graphql/definitions/object/developer-commission-batch-variant-percentage.graphql
 * Refer: src/graphql/definitions/object/developer-commission-batch-variant-expression.graphql
 */
export type DeveloperCommissionBatchVariant = DeveloperCommissionBatchVariantExpression | DeveloperCommissionBatchVariantFixedAmount | DeveloperCommissionBatchVariantPercentage;

export type DeveloperCommissionBatchVariantExpression = {
  __typename?: 'DeveloperCommissionBatchVariantExpression';
  expression: Scalars['String'];
};

export type DeveloperCommissionBatchVariantFixedAmount = {
  __typename?: 'DeveloperCommissionBatchVariantFixedAmount';
  fixedAmount: Scalars['Float'];
};

export type DeveloperCommissionBatchVariantPercentage = {
  __typename?: 'DeveloperCommissionBatchVariantPercentage';
  /** 0 - 100 */
  percentage: Scalars['Float'];
};

export type DeveloperCommissionInvoice = {
  __typename?: 'DeveloperCommissionInvoice';
  id: Scalars['ID'];
  invoiceId: Scalars['String'];
  issuedOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/developer-commission-receipt.graphql */
  receipts: Array<DeveloperCommissionReceipt>;
  /** Refer: src/graphql/definitions/object/filtered-developer-commission-transactions.graphql */
  transactions: FilteredDeveloperCommissionTransactions;
};

export type DeveloperCommissionReceipt = {
  __typename?: 'DeveloperCommissionReceipt';
  id: Scalars['ID'];
  paidOn: Scalars['Date'];
  receiptId: Scalars['String'];
  /** Refer: src/graphql/definitions/object/filtered-developer-commission-transactions.graphql */
  transactions: FilteredDeveloperCommissionTransactions;
};

export type DeveloperCommissionSettingPeriod = {
  __typename?: 'DeveloperCommissionSettingPeriod';
  commencementDate?: Maybe<Scalars['Date']>;
  expiryDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  projectUnits: Array<ProjectUnit>;
  sstInclusive: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/developer-commission-setting-period-stage.graphql */
  stages: Array<DeveloperCommissionSettingPeriodStage>;
};

export type DeveloperCommissionSettingPeriodStage = {
  __typename?: 'DeveloperCommissionSettingPeriodStage';
  expression: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/object/developer-commission-setting-period.graphql */
  period: DeveloperCommissionSettingPeriod;
};

export type DeveloperCommissionStage = {
  __typename?: 'DeveloperCommissionStage';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
  index: Scalars['Int'];
  name: Scalars['String'];
};

export type DeveloperCommissionTransaction = {
  __typename?: 'DeveloperCommissionTransaction';
  /**
   * For testing purpose only.
   * @deprecated Use `paidAmount` instead
   */
  cachedPaidAmount?: Maybe<Scalars['Float']>;
  /** For testing purpose only. */
  cachedPayableAmount?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  /** Actual amount paid by developer. */
  paidAmount: Scalars['Float'];
  /**
   * Expected paid amount from developer (calculated based on the settings
   * provided by Finance Team on Dashboard)
   */
  payableAmount: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/developer-commission-setting-period-stage.graphql */
  stage: DeveloperCommissionSettingPeriodStage;
  /** Refer: src/graphql/definitions/object/postlaunch-transaction.graphql */
  transaction: PostlaunchTransaction;
};

export type DeveloperCommissionTransactionCsvUploadAttempt = {
  __typename?: 'DeveloperCommissionTransactionCsvUploadAttempt';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  done: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/developer-commission-transaction-csv-upload-attempt-row.graphql */
  rows: Array<DeveloperCommissionTransactionCsvUploadAttemptRow>;
  totalRowsCount: Scalars['Int'];
};

export type DeveloperCommissionTransactionCsvUploadAttemptRow = {
  __typename?: 'DeveloperCommissionTransactionCsvUploadAttemptRow';
  childProjectName?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  invoiceId?: Maybe<Scalars['String']>;
  orId?: Maybe<Scalars['String']>;
  paidAmount?: Maybe<Scalars['Float']>;
  parentProjectName?: Maybe<Scalars['String']>;
  rowIndex: Scalars['Int'];
  stage?: Maybe<Scalars['String']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type DeveloperDashboard = {
  __typename?: 'DeveloperDashboard';
  /** Refer: src/graphql/definitions/object/buyer-address-heatmap.graphql */
  buyerAddressHeatmap: BuyerAddressHeatmap;
  /** Refer: src/graphql/definitions/object/buyer-demographic-data.graphql */
  buyerDemographics: BuyerDemographicData;
  /** Returns true if the requesting user can view Agency Commission pages on the Developer Dashboard. */
  canViewAgencyCommission: Scalars['Boolean'];
  /** Returns true if the requesting user can view Analytics pages on the Developer Dashboard. */
  canViewAnalytics: Scalars['Boolean'];
  /** Returns true if the requesting user can view Appointments pages on the Developer Dashboard. */
  canViewAppointments: Scalars['Boolean'];
  /** Returns true if the requesting user can view Price Chart pages on the Developer Dashboard. */
  canViewPriceChart: Scalars['Boolean'];
  /** Returns true if the requesting user can view Sales pages on the Developer Dashboard. */
  canViewSales: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/developer-dashboard-core-metrics.graphql */
  coreMetrics: DeveloperDashboardCoreMetrics;
  /**
   * This has been modified to become more general,
   * it can handle not only weekly sales summary, but also of monthly, yearly etc.
   * Refer: src/graphql/definitions/object/customer-schedule-weekly-stat.graphql
   */
  customerScheduleWeeklyStats: Array<CustomerScheduleWeeklyStat>;
  /** Refer: src/graphql/definitions/object/developer-dashboard-display-agency-commission.graphql */
  displayAgencyCommission: DeveloperDashboardDisplayAgencyCommission;
  /** Refer: src/graphql/definitions/object/developer-dashboard-display-project-unit.graphql */
  displayProjectUnit: DeveloperDashboardDisplayProjectUnit;
  /** Refer: src/graphql/definitions/object/filtered-parent-projects.graphql */
  displayProjects: FilteredParentProjects;
  /** Refer: src/graphql/definitions/object/developer-dashboard-display-transaction.graphql */
  displayTransaction: DeveloperDashboardDisplayTransaction;
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction.graphql */
  displayTransactionById: DeveloperDashboardTransaction;
  /** Refer: src/graphql/definitions/object/developer-dashboard-postlaunch-cancellation.graphql */
  postlaunchCancellation: DeveloperDashboardPostlaunchCancellation;
  /** Refer: src/graphql/definitions/object/developer-dashboard-prelaunch.graphql */
  prelaunch: DeveloperDashboardPrelaunch;
  /** Refer: src/graphql/definitions/object/project-sales-summary-by-unit-type.graphql */
  salesSummaryByUnitType: ProjectSalesSummaryByUnitType;
  /**
   * Refer: src/graphql/definitions/object/developer-dashboard-setting.graphql
   * @deprecated We cannot return the setting per the developer of the user, because users with the `canViewAllProjectsOnDeveloperDashboard` permission can access projects from different developers.
   */
  setting: DeveloperDashboardSetting;
  /**
   * This breakdowns by unit types, it's not mentioned in the name because
   * I'm short-sigthedly assuming that it's always by unit types.
   * Refer: src/graphql/definitions/object/developer-dashboard-transaction-status-breakdown.graphql
   */
  transactionStatusBreakdown: DeveloperDashboardTransactionStatusBreakdown;
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-status-breakdown-by-aging-interval.graphql */
  transactionStatusBreakdownByAgingInterval: DeveloperDashboardTransactionStatusBreakdownByAgingInterval;
  /** Refer: src/graphql/definitions/union/project-unit-layout.graphql */
  unitLayout?: Maybe<ProjectUnitLayout>;
  /**
   * This has been modified to become more general,
   * it can handle not only weekly sales summary, but also of monthly, yearly etc.
   * Refer: src/graphql/definitions/object/developer-dashboard-weekly-sales-summary.graphql
   */
  weeklySalesSummary: DeveloperDashboardWeeklySalesSummary;
};


export type DeveloperDashboardBuyerAddressHeatmapArgs = {
  launchStatus: LaunchStatus;
  parentProjectId: Scalars['ID'];
};


export type DeveloperDashboardBuyerDemographicsArgs = {
  launchStatus: LaunchStatus;
  parentProjectId: Scalars['ID'];
};


export type DeveloperDashboardCoreMetricsArgs = {
  parentProjectId: Scalars['ID'];
};


export type DeveloperDashboardCustomerScheduleWeeklyStatsArgs = {
  columnCount?: InputMaybe<Scalars['Int']>;
  parentProjectId: Scalars['ID'];
  relativeDate: Scalars['Date'];
  timeUnit?: InputMaybe<TimeUnit>;
};


export type DeveloperDashboardDisplayProjectsArgs = {
  developerId?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
};


export type DeveloperDashboardDisplayTransactionArgs = {
  parentProjectIds: Array<Scalars['ID']>;
};


export type DeveloperDashboardDisplayTransactionByIdArgs = {
  id: Scalars['ID'];
};


export type DeveloperDashboardPostlaunchCancellationArgs = {
  parentProjectId: Scalars['ID'];
};


export type DeveloperDashboardPrelaunchArgs = {
  parentProjectId: Scalars['ID'];
  relativeDate?: InputMaybe<Scalars['Date']>;
};


export type DeveloperDashboardSalesSummaryByUnitTypeArgs = {
  parentProjectId: Scalars['ID'];
};


export type DeveloperDashboardTransactionStatusBreakdownArgs = {
  parentProjectId: Scalars['ID'];
};


export type DeveloperDashboardTransactionStatusBreakdownByAgingIntervalArgs = {
  daysPerInterval: Scalars['Int'];
  parentProjectId: Scalars['ID'];
  relativeDate?: InputMaybe<Scalars['Date']>;
};


export type DeveloperDashboardUnitLayoutArgs = {
  childProjectId: Scalars['ID'];
};


export type DeveloperDashboardWeeklySalesSummaryArgs = {
  columnCount?: InputMaybe<Scalars['Int']>;
  date: Scalars['Date'];
  parentProjectId: Scalars['ID'];
  timeUnit?: InputMaybe<TimeUnit>;
};

export type DeveloperDashboardAgency = {
  __typename?: 'DeveloperDashboardAgency';
  fullName: Scalars['String'];
  id: Scalars['ID'];
};

export type DeveloperDashboardChildProject = {
  __typename?: 'DeveloperDashboardChildProject';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/object/developer-dashboard-parent-project.graphql */
  parentProject: DeveloperDashboardParentProject;
};

export type DeveloperDashboardCoreMetrics = {
  __typename?: 'DeveloperDashboardCoreMetrics';
  /** 0-100 */
  percentageBooked: Scalars['Float'];
  /** 0-100 */
  percentageSold: Scalars['Float'];
  /** Based on SPA/LA signings. */
  totalGdvSold: Scalars['Float'];
  totalUnitsSold: Scalars['Int'];
};

export type DeveloperDashboardDisplayAgencyCommission = {
  __typename?: 'DeveloperDashboardDisplayAgencyCommission';
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-commission-invoice.graphql */
  invoice: DeveloperDashboardTransactionCommissionInvoice;
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-commission-invoice-request.graphql */
  invoiceRequest: DeveloperDashboardTransactionCommissionInvoiceRequest;
  /** Refer: src/graphql/definitions/object/filtered-developer-dashboard-transaction-commission-invoices.graphql */
  invoices: FilteredDeveloperDashboardTransactionCommissionInvoices;
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-commission-payment-slip.graphql */
  paymentSlip: DeveloperDashboardTransactionCommissionPaymentSlip;
  /** Refer: src/graphql/definitions/object/filtered-developer-dashboard-transaction-commission-payment-slips.graphql */
  paymentSlips: FilteredDeveloperDashboardTransactionCommissionPaymentSlips;
  /** Refer: src/graphql/definitions/object/filtered-developer-dashboard-transaction-commission-invoice-requests.graphql */
  pendingInvoiceInvoiceRequests: FilteredDeveloperDashboardTransactionCommissionInvoiceRequests;
};


export type DeveloperDashboardDisplayAgencyCommissionInvoiceArgs = {
  id: Scalars['ID'];
};


export type DeveloperDashboardDisplayAgencyCommissionInvoiceRequestArgs = {
  id: Scalars['ID'];
};


export type DeveloperDashboardDisplayAgencyCommissionInvoicesArgs = {
  type?: InputMaybe<TransactionCommissionInvoiceType>;
};


export type DeveloperDashboardDisplayAgencyCommissionPaymentSlipArgs = {
  id: Scalars['ID'];
};


export type DeveloperDashboardDisplayAgencyCommissionPaymentSlipsArgs = {
  voided?: InputMaybe<Scalars['Boolean']>;
};

export type DeveloperDashboardDisplayProjectUnit = {
  __typename?: 'DeveloperDashboardDisplayProjectUnit';
  /** Refer: src/graphql/definitions/object/developer-dashboard-project-unit.graphql */
  byId: DeveloperDashboardProjectUnit;
};


export type DeveloperDashboardDisplayProjectUnitByIdArgs = {
  id: Scalars['ID'];
};

export type DeveloperDashboardDisplayTransaction = {
  __typename?: 'DeveloperDashboardDisplayTransaction';
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  downloadCsv: UploadedFile;
  /** Refer: src/graphql/definitions/object/filtered-developer-dashboard-transactions.graphql */
  filter: FilteredDeveloperDashboardTransactions;
  /** Refer: src/graphql/definitions/object/developer-dashboard-display-transaction-filters.graphql */
  filters: DeveloperDashboardDisplayTransactionFilters;
  /**
   * Refer: src/graphql/definitions/object/filtered-developer-dashboard-transactions.graphql
   * @deprecated Use `filter` instead, because it only has one argument which is easier to work with for frontends.
   */
  list: FilteredDeveloperDashboardTransactions;
};


export type DeveloperDashboardDisplayTransactionDownloadCsvArgs = {
  input: DeveloperDashboardFilterTransactionsInput;
};


export type DeveloperDashboardDisplayTransactionFilterArgs = {
  input: DeveloperDashboardFilterTransactionsInput;
};


export type DeveloperDashboardDisplayTransactionListArgs = {
  agingDayLowerBound?: InputMaybe<Scalars['Int']>;
  agingDayType: TransactionAgingDayType;
  agingDayUpperBound?: InputMaybe<Scalars['Int']>;
  dateLowerBound?: InputMaybe<Scalars['Date']>;
  dateType: DateType;
  dateUpperBound?: InputMaybe<Scalars['Date']>;
  relativeDate?: InputMaybe<Scalars['Date']>;
  search: Scalars['String'];
  statuses: Array<InputTransactionStatus>;
  unitTypes: Array<Scalars['String']>;
};

export type DeveloperDashboardDisplayTransactionFilters = {
  __typename?: 'DeveloperDashboardDisplayTransactionFilters';
  /** Refer: src/graphql/definitions/object/transaction-status.graphql */
  statuses: Array<TransactionStatus>;
  unitTypes: Array<Scalars['String']>;
};

export type DeveloperDashboardFilterTransactionsInput = {
  agingDayLowerBound?: InputMaybe<Scalars['Int']>;
  /** Refer: src/graphql/definitions/enum/transaction-aging-day-type.graphql */
  agingDayType: TransactionAgingDayType;
  agingDayUpperBound?: InputMaybe<Scalars['Int']>;
  dateLowerBound?: InputMaybe<Scalars['Date']>;
  /** Refer: src/graphql/definitions/enum/date-type.graphql */
  dateType: DateType;
  dateUpperBound?: InputMaybe<Scalars['Date']>;
  /** For testing purpose only. */
  relativeDate?: InputMaybe<Scalars['Date']>;
  search: Scalars['String'];
  /** Refer: src/graphql/definitions/input/input-transaction-status.graphql */
  statuses: Array<InputTransactionStatus>;
  unitTypes: Array<Scalars['String']>;
};

export type DeveloperDashboardMutation = {
  __typename?: 'DeveloperDashboardMutation';
  /** Refer: src/graphql/definitions/object/developer-dashboard-mutation-manage-agency-commission.graphql */
  manageAgencyCommission: DeveloperDashboardMutationManageAgencyCommission;
};

export type DeveloperDashboardMutationManageAgencyCommission = {
  __typename?: 'DeveloperDashboardMutationManageAgencyCommission';
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-commission-invoice.graphql */
  rejectInvoice: DeveloperDashboardTransactionCommissionInvoice;
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-commission-payment-slip.graphql */
  uploadPaymentSlip: DeveloperDashboardTransactionCommissionPaymentSlip;
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-commission-invoice.graphql */
  verifyInvoice: DeveloperDashboardTransactionCommissionInvoice;
};


export type DeveloperDashboardMutationManageAgencyCommissionRejectInvoiceArgs = {
  id: Scalars['ID'];
  reason: Scalars['String'];
};


export type DeveloperDashboardMutationManageAgencyCommissionUploadPaymentSlipArgs = {
  invoiceIds: Array<Scalars['ID']>;
  paymentSlipFile: Upload;
};


export type DeveloperDashboardMutationManageAgencyCommissionVerifyInvoiceArgs = {
  id: Scalars['ID'];
};

export type DeveloperDashboardParentProject = {
  __typename?: 'DeveloperDashboardParentProject';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DeveloperDashboardPostlaunchCancellation = {
  __typename?: 'DeveloperDashboardPostlaunchCancellation';
  /** Refer: src/graphql/definitions/object/filtered-developer-dashboard-postlaunch-cancellation-reasons.graphql */
  reasons: FilteredDeveloperDashboardPostlaunchCancellationReasons;
  total: Scalars['Int'];
  totalLastWeek: Scalars['Int'];
};

export type DeveloperDashboardPostlaunchCancellationReason = {
  __typename?: 'DeveloperDashboardPostlaunchCancellationReason';
  count: Scalars['Int'];
  percentage: Scalars['Float'];
  reason: Scalars['String'];
};

export type DeveloperDashboardPrelaunch = {
  __typename?: 'DeveloperDashboardPrelaunch';
  /** Refer: src/graphql/definitions/object/filtered-developer-dashboard-prelaunch-cancellation-reasons.graphql */
  cancellationReasons: FilteredDeveloperDashboardPrelaunchCancellationReasons;
  /** Refer: src/graphql/definitions/object/parent-project.graphql */
  parentProject: ParentProject;
  /** Refer: src/graphql/definitions/object/developer-dashboard-prelaunch-stats.graphql */
  stats: DeveloperDashboardPrelaunchStats;
  /** Refer: src/graphql/definitions/object/filtered-developer-dashboard-prelaunch-stats-by-unit-type.graphql */
  statsByUnitType: FilteredDeveloperDashboardPrelaunchStatsByUnitType;
};


export type DeveloperDashboardPrelaunchCancellationReasonsArgs = {
  unitType?: InputMaybe<Scalars['String']>;
};

export type DeveloperDashboardPrelaunchCancellationReason = {
  __typename?: 'DeveloperDashboardPrelaunchCancellationReason';
  count: Scalars['Int'];
  percentage: Scalars['Float'];
  reason: Scalars['String'];
};

export type DeveloperDashboardPrelaunchStats = {
  __typename?: 'DeveloperDashboardPrelaunchStats';
  availableUnits: Scalars['Int'];
  cancellationsThisWeek: Scalars['Int'];
  cancellationsTotal: Scalars['Int'];
  convertedThisWeek: Scalars['Int'];
  convertedTotal: Scalars['Int'];
  demand: Scalars['Int'];
  registeredThisWeek: Scalars['Int'];
  registeredTotal: Scalars['Int'];
};

export type DeveloperDashboardPrelaunchStatsByUnitType = {
  __typename?: 'DeveloperDashboardPrelaunchStatsByUnitType';
  /** Refer: src/graphql/definitions/object/developer-dashboard-prelaunch-stats.graphql */
  stats: DeveloperDashboardPrelaunchStats;
  unitType: Scalars['String'];
};

export type DeveloperDashboardProjectUnit = {
  __typename?: 'DeveloperDashboardProjectUnit';
  /** Refer: src/graphql/definitions/object/developer-dashboard-child-project.graphql */
  childProject: DeveloperDashboardChildProject;
  grossPrice: Scalars['Float'];
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction.graphql */
  transactions: Array<DeveloperDashboardTransaction>;
  type: Scalars['String'];
  unitNum: Scalars['String'];
  /** Refer: src/graphql/definitions/object/project-unit-mix.graphql */
  unitType?: Maybe<ProjectUnitMix>;
  view?: Maybe<Scalars['String']>;
};

export type DeveloperDashboardSetting = {
  __typename?: 'DeveloperDashboardSetting';
  showTransactionAgency: Scalars['Boolean'];
};

/**
 * This specifically means post-launch transaction.
 *
 * Prelaunch transaction should be named using another term that does not includes
 * the word "transaction", for example, "prelaunch booking".
 */
export type DeveloperDashboardTransaction = {
  __typename?: 'DeveloperDashboardTransaction';
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-activity-log.graphql */
  activityLogs: Array<DeveloperDashboardTransactionActivityLog>;
  /**
   * This is nullable if the developer does not have permission to view the agencies of transaction.
   * Refer: src/graphql/definitions/object/developer-dashboard-agency.graphql
   */
  agencies?: Maybe<Array<DeveloperDashboardAgency>>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  agentUploadedFiles: Array<UploadedFile>;
  /**
   * Refer: src/graphql/definitions/object/developer-dashboard-transaction-agent.graphql
   * @deprecated This will always return empty for now, use `agencies` instead
   */
  agents: Array<DeveloperDashboardTransactionAgent>;
  /**
   * This is also know as the Turnaround Time (TAT) for the transaction.
   * It is measured from the booking date until the completion date or the current
   * date if the transaction is not completed yet.
   */
  agingDay: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-buyer.graphql */
  buyers: Array<DeveloperDashboardTransactionBuyer>;
  cancelledOn?: Maybe<Scalars['Date']>;
  completedOn?: Maybe<Scalars['Date']>;
  createdOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/union/developer-dashboard-transaction-finance-source.graphql */
  financeSource: DeveloperDashboardTransactionFinanceSource;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-la-document.graphql */
  laDocument?: Maybe<DeveloperDashboardTransactionLaDocument>;
  /** Refer: src/graphql/definitions/object/nett-price-result.graphql */
  nettPriceResult: NettPriceResult;
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-spa-document.graphql */
  spaDocument?: Maybe<DeveloperDashboardTransactionSpaDocument>;
  /** Refer: src/graphql/definitions/object/transaction-status.graphql */
  status: TransactionStatus;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  systemGeneratedFiles: Array<UploadedFile>;
  /** Refer: src/graphql/definitions/object/developer-dashboard-project-unit.graphql */
  unit: DeveloperDashboardProjectUnit;
  unitGrossPrice: Scalars['Float'];
  updatedOn: Scalars['Date'];
};

export type DeveloperDashboardTransactionActivityLog = {
  __typename?: 'DeveloperDashboardTransactionActivityLog';
  author: Scalars['String'];
  content: Scalars['String'];
  createdOn: Scalars['Date'];
};

export type DeveloperDashboardTransactionAgent = {
  __typename?: 'DeveloperDashboardTransactionAgent';
  /** Refer: src/graphql/definitions/object/developer-dashboard-agency.graphql */
  agency: DeveloperDashboardAgency;
};

export type DeveloperDashboardTransactionBuyer = {
  __typename?: 'DeveloperDashboardTransactionBuyer';
  corrCity?: Maybe<Scalars['String']>;
  corrCountry?: Maybe<Scalars['String']>;
  corrPostCode?: Maybe<Scalars['String']>;
  corrState?: Maybe<Scalars['String']>;
  corrStreetName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mobileNum?: Maybe<Scalars['String']>;
  monthlyIncome?: Maybe<Scalars['String']>;
  nric: Scalars['String'];
  occupation?: Maybe<Scalars['String']>;
  race?: Maybe<Scalars['String']>;
};

export type DeveloperDashboardTransactionCommissionInvoice = {
  __typename?: 'DeveloperDashboardTransactionCommissionInvoice';
  /** Refer: src/graphql/definitions/object/commission-payment-delay-reason.graphql */
  commissionPaymentDelayReason?: Maybe<CommissionPaymentDelayReason>;
  createdOn: Scalars['String'];
  /**
   * Only PIC of this invoice or user with special permission can query this property.
   * Refer: src/graphql/definitions/object/uploaded-file.graphql
   */
  file?: Maybe<UploadedFile>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invalidatedBy?: Maybe<Scalars['String']>;
  invalidatedOn?: Maybe<Scalars['Date']>;
  invalidatedReason?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-commission-invoice-request.graphql */
  invoiceRequests: Array<DeveloperDashboardTransactionCommissionInvoiceRequest>;
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-commission-payment-slip.graphql */
  paymentSlip?: Maybe<DeveloperDashboardTransactionCommissionPaymentSlip>;
  totalPayableAmount: Scalars['Float'];
  /** Refer: src/graphql/definitions/enum/transaction-commission-invoice-type.graphql */
  type: TransactionCommissionInvoiceType;
  verifiedBy?: Maybe<Scalars['String']>;
  verifiedOn?: Maybe<Scalars['Date']>;
};

export type DeveloperDashboardTransactionCommissionInvoiceRequest = {
  __typename?: 'DeveloperDashboardTransactionCommissionInvoiceRequest';
  /** Refer: src/graphql/definitions/object/developer-dashboard-agency.graphql */
  agency: DeveloperDashboardAgency;
  commissionType: Scalars['String'];
  createdOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/email-content.graphql */
  emailContent?: Maybe<EmailContent>;
  humanReadableId: Scalars['ID'];
  id: Scalars['ID'];
  payableAmount: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction.graphql */
  transaction: DeveloperDashboardTransaction;
};

export type DeveloperDashboardTransactionCommissionPaymentSlip = {
  __typename?: 'DeveloperDashboardTransactionCommissionPaymentSlip';
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-commission-payment-slip.graphql */
  additionalPaymentSlips: Array<DeveloperDashboardTransactionCommissionPaymentSlip>;
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-commission-invoice.graphql */
  commissionInvoices: Array<DeveloperDashboardTransactionCommissionInvoice>;
  createdOn: Scalars['String'];
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  file: UploadedFile;
  generatedFilename: Scalars['String'];
  id: Scalars['ID'];
  originalFilename: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  voidedBy?: Maybe<User>;
  voidedOn?: Maybe<Scalars['String']>;
};

export type DeveloperDashboardTransactionDocumentSigningDate = {
  __typename?: 'DeveloperDashboardTransactionDocumentSigningDate';
  confirmedOn?: Maybe<Scalars['Date']>;
  createdOn: Scalars['Date'];
  signingDate: Scalars['Date'];
};

/**
 * Refer: src/graphql/definitions/object/developer-dashboard-transaction-finance-source-loan.graphql
 * Refer: src/graphql/definitions/object/developer-dashboard-transaction-finance-source-cash.graphql
 * Refer: src/graphql/definitions/object/developer-dashboard-transaction-finance-source-undecided.graphql
 */
export type DeveloperDashboardTransactionFinanceSource = DeveloperDashboardTransactionFinanceSourceCash | DeveloperDashboardTransactionFinanceSourceLoan | DeveloperDashboardTransactionFinanceSourceUndecided;

export type DeveloperDashboardTransactionFinanceSourceCash = {
  __typename?: 'DeveloperDashboardTransactionFinanceSourceCash';
  dummy?: Maybe<Scalars['String']>;
};

export type DeveloperDashboardTransactionFinanceSourceLoan = {
  __typename?: 'DeveloperDashboardTransactionFinanceSourceLoan';
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-loan-application.graphql */
  loanApplications: Array<DeveloperDashboardTransactionLoanApplication>;
};

export type DeveloperDashboardTransactionFinanceSourceUndecided = {
  __typename?: 'DeveloperDashboardTransactionFinanceSourceUndecided';
  dummy?: Maybe<Scalars['String']>;
};

export type DeveloperDashboardTransactionLaDocument = {
  __typename?: 'DeveloperDashboardTransactionLaDocument';
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-lawyer.graphql */
  lawyer?: Maybe<DeveloperDashboardTransactionLawyer>;
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-document-signing-date.graphql */
  signingDate?: Maybe<DeveloperDashboardTransactionDocumentSigningDate>;
};

export type DeveloperDashboardTransactionLawyer = {
  __typename?: 'DeveloperDashboardTransactionLawyer';
  lawyerFirm: Scalars['String'];
  personInCharge: Scalars['String'];
};

export type DeveloperDashboardTransactionLoanApplication = {
  __typename?: 'DeveloperDashboardTransactionLoanApplication';
  bankName: Scalars['String'];
  bankerName: Scalars['String'];
  createdOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/union/transaction-loan-application-status.graphql */
  status: TransactionLoanApplicationStatus;
};

export type DeveloperDashboardTransactionSpaDocument = {
  __typename?: 'DeveloperDashboardTransactionSpaDocument';
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-lawyer.graphql */
  lawyer?: Maybe<DeveloperDashboardTransactionLawyer>;
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-document-signing-date.graphql */
  signingDate?: Maybe<DeveloperDashboardTransactionDocumentSigningDate>;
};

export type DeveloperDashboardTransactionStatusBreakdown = {
  __typename?: 'DeveloperDashboardTransactionStatusBreakdown';
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-status-breakdown-row.graphql */
  rows: Array<DeveloperDashboardTransactionStatusBreakdownRow>;
  unitTypes: Array<Scalars['String']>;
};

export type DeveloperDashboardTransactionStatusBreakdownByAgingInterval = {
  __typename?: 'DeveloperDashboardTransactionStatusBreakdownByAgingInterval';
  /** Refer: src/graphql/definitions/object/aging-interval.graphql */
  agingIntervals: Array<AgingInterval>;
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-status-breakdown-by-aging-interval-row.graphql */
  rows: Array<DeveloperDashboardTransactionStatusBreakdownByAgingIntervalRow>;
};

export type DeveloperDashboardTransactionStatusBreakdownByAgingIntervalRow = {
  __typename?: 'DeveloperDashboardTransactionStatusBreakdownByAgingIntervalRow';
  /** Refer: src/graphql/definitions/enum/transaction-cancellation-status.graphql */
  cancellationStatus: TransactionCancellationStatus;
  count: Scalars['Int'];
  countByAgingInterval: Array<Scalars['Int']>;
  /** Refer: src/graphql/definitions/enum/transaction-financial-status.graphql */
  financialStatus: TransactionFinancialStatus;
  /** Refer: src/graphql/definitions/enum/transaction-spa-status.graphql */
  spaStatus: TransactionSpaStatus;
};

export type DeveloperDashboardTransactionStatusBreakdownRow = {
  __typename?: 'DeveloperDashboardTransactionStatusBreakdownRow';
  /** Refer: src/graphql/definitions/enum/transaction-cancellation-status.graphql */
  cancellationStatus: TransactionCancellationStatus;
  count: Scalars['Int'];
  countByUnitType: Array<Scalars['Int']>;
  /** Refer: src/graphql/definitions/enum/transaction-financial-status.graphql */
  financialStatus: TransactionFinancialStatus;
  /** Refer: src/graphql/definitions/enum/transaction-spa-status.graphql */
  spaStatus: TransactionSpaStatus;
};

export type DeveloperDashboardWeeklySalesSummary = {
  __typename?: 'DeveloperDashboardWeeklySalesSummary';
  /** Refer: src/graphql/definitions/object/developer-dashboard-weekly-sales-summary-week.graphql */
  weeks: Array<DeveloperDashboardWeeklySalesSummaryWeek>;
};

export type DeveloperDashboardWeeklySalesSummaryRowStatus = {
  __typename?: 'DeveloperDashboardWeeklySalesSummaryRowStatus';
  count: Scalars['Int'];
  unitGrossPrice: Scalars['Float'];
};

export type DeveloperDashboardWeeklySalesSummaryWeek = {
  __typename?: 'DeveloperDashboardWeeklySalesSummaryWeek';
  /** Refer: src/graphql/definitions/object/developer-dashboard-weekly-sales-summary-row-status.graphql */
  cancellationConfirmed: DeveloperDashboardWeeklySalesSummaryRowStatus;
  endDate: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/developer-dashboard-weekly-sales-summary-row-status.graphql */
  newBooking: DeveloperDashboardWeeklySalesSummaryRowStatus;
  /**
   * SPA & LA Signed
   * or
   * SPA Signed & Cash
   * Refer: src/graphql/definitions/object/developer-dashboard-weekly-sales-summary-row-status.graphql
   */
  spalaSigningCompleted: DeveloperDashboardWeeklySalesSummaryRowStatus;
  startDate: Scalars['Date'];
};

export type DeveloperDetail = {
  address: Scalars['String'];
  hotline: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
  officeNum: Scalars['String'];
};

export type DeveloperDisplayTransactionResult = {
  __typename?: 'DeveloperDisplayTransactionResult';
  /** Refer: src/graphql/definitions/object/developer-transaction-view.graphql */
  transactions: Array<DeveloperTransactionView>;
};

export type DeveloperTransactionView = {
  __typename?: 'DeveloperTransactionView';
  /** Refer: src/graphql/definitions/object/developer-transaction-view-booked-by.graphql */
  bookedBy: DeveloperTransactionViewBookedBy;
  bookedOn?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/developer-transaction-view-booking-form.graphql */
  bookingForm?: Maybe<DeveloperTransactionViewBookingForm>;
  buyerNames: Array<Scalars['String']>;
  id: Scalars['String'];
  launchingSequence?: Maybe<Scalars['String']>;
  projectName: Scalars['String'];
  status: Scalars['String'];
  unitNum?: Maybe<Scalars['String']>;
};

export type DeveloperTransactionViewBookedBy = {
  __typename?: 'DeveloperTransactionViewBookedBy';
  name?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/enum/developer-transaction-view-booked-by-type.graphql */
  type: DeveloperTransactionViewBookedByType;
};

export enum DeveloperTransactionViewBookedByType {
  DeveloperStaff = 'developer_staff',
  Didian = 'didian'
}

export type DeveloperTransactionViewBookingForm = {
  __typename?: 'DeveloperTransactionViewBookingForm';
  name: Scalars['String'];
  signedURL: Scalars['String'];
};

export type DevelopmentValue = {
  __typename?: 'DevelopmentValue';
  /** Gross Development Value = Sum of gross selling price of units booked on that week */
  gdv: Scalars['Float'];
  /** Nett Development Value = Sum of net selling price of units booked on that week */
  ndv: Scalars['Float'];
  /** Number of new sales */
  newSales: Scalars['Float'];
  /** 0 means current week, 1 means last week, 2 means last last week, and so and so forth. */
  week: Scalars['Int'];
};

export type Discount = {
  __typename?: 'Discount';
  amount: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/project-discount-dependency.graphql */
  dependsOn?: Maybe<ProjectDiscountDependency>;
  id: Scalars['String'];
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/transaction-price-type.graphql */
  remainingAmountPriceType?: Maybe<TransactionPriceType>;
  selected: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/enum/project-discount-type.graphql */
  type: ProjectDiscountType;
};

export type DiscountDependency = {
  discountId?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export enum DiscountStatus {
  Active = 'active',
  Discontinued = 'discontinued'
}

export type DiscountToggleKeyValue = {
  key: Scalars['String'];
  values: Array<Scalars['String']>;
};

export enum DiscountType {
  Entitlement = 'entitlement',
  Expression = 'expression',
  FixedAmount = 'fixedAmount',
  Percentage = 'percentage'
}

export type DisplayAgencyGroup = {
  __typename?: 'DisplayAgencyGroup';
  /** Refer: src/graphql/definitions/object/agency-group.graphql */
  findOne: AgencyGroup;
  /**
   * Search agency groups by parent agency name or registration number.
   * Refer: src/graphql/definitions/object/filtered-agency-groups.graphql
   */
  search: FilteredAgencyGroups;
};


export type DisplayAgencyGroupFindOneArgs = {
  id: Scalars['ID'];
};


export type DisplayAgencyGroupSearchArgs = {
  search: Scalars['String'];
  type: DisplayAgencyGroupSearchType;
};

export enum DisplayAgencyGroupSearchType {
  AgencyGroupOfGalAgencyGroup = 'AGENCY_GROUP_OF_GAL_AGENCY_GROUP'
}

export type DisplayAgencyTeam = {
  __typename?: 'DisplayAgencyTeam';
  /**
   * For displaying team's transaction agents that are not under the team members' current agency team.
   * These transaction agents were either created before the team member joined any team
   * OR
   * they were created in the team members' previous teams.
   * Refer: src/graphql/definitions/object/filtered-transaction-agents.graphql
   */
  displayMemberNonTeamTransactionAgents: FilteredTransactionAgents;
  /**
   * For displaying all the transaction agents under an agency team.
   * Refer: src/graphql/definitions/object/filtered-transaction-agents.graphql
   */
  displayTeamTransactionAgents: FilteredTransactionAgents;
};


export type DisplayAgencyTeamDisplayMemberNonTeamTransactionAgentsArgs = {
  search: Scalars['String'];
  teamId: Scalars['ID'];
};


export type DisplayAgencyTeamDisplayTeamTransactionAgentsArgs = {
  search: Scalars['String'];
  teamId: Scalars['ID'];
};

export type DisplayAgencyTeamMember = {
  __typename?: 'DisplayAgencyTeamMember';
  /**
   * This returns all the team members and whether or not they are whitelisted for
   * `parentProjectId`.
   * Refer: src/graphql/definitions/object/filtered-agency-team-member-project-whitelist-statuses.graphql
   */
  projectWhitelistStatuses: FilteredAgencyTeamMemberProjectWhitelistStatuses;
  /** Refer: src/graphql/definitions/object/agency-team-members.graphql */
  whitelistedMembers: AgencyTeamMembers;
};


export type DisplayAgencyTeamMemberProjectWhitelistStatusesArgs = {
  parentProjectId: Scalars['ID'];
};


export type DisplayAgencyTeamMemberWhitelistedMembersArgs = {
  parentProjectId: Scalars['ID'];
};

export type DisplayAgencyTeamProjectInquiry = {
  __typename?: 'DisplayAgencyTeamProjectInquiry';
  /** Refer: src/graphql/definitions/object/filtered-project-inquiries.graphql */
  searchProjectInquiries: FilteredProjectInquiries;
};


export type DisplayAgencyTeamProjectInquirySearchProjectInquiriesArgs = {
  parentProjectIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type DisplayAgentResult = {
  __typename?: 'DisplayAgentResult';
  /** Refer: src/graphql/definitions/object/agent.graphql */
  agent: Agent;
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  transactions: Array<Transaction>;
  /** Refer: src/graphql/definitions/object/project.graphql */
  whitelistedProjects: Array<Project>;
};

export type DisplayArmCommissionTransaction = {
  __typename?: 'DisplayArmCommissionTransaction';
  /** Refer: src/graphql/definitions/object/display-arm-commission-transaction-agent.graphql */
  agents: Array<DisplayArmCommissionTransactionAgent>;
  bookedOn?: Maybe<Scalars['String']>;
  childProjectId: Scalars['String'];
  childProjectName: Scalars['String'];
  currentPeriodTotalSales: Scalars['Int'];
  id: Scalars['String'];
  laSignedOn?: Maybe<Scalars['String']>;
  parentProjectId: Scalars['String'];
  parentProjectName: Scalars['String'];
  spaSignedOn?: Maybe<Scalars['String']>;
  tierFromInclusive?: Maybe<Scalars['Float']>;
  tierId?: Maybe<Scalars['String']>;
  tierPercentage?: Maybe<Scalars['Float']>;
  tierToInclusive?: Maybe<Scalars['Float']>;
  unitNum: Scalars['String'];
};

export type DisplayArmCommissionTransactionAgent = {
  __typename?: 'DisplayArmCommissionTransactionAgent';
  actualClaimableCommissionAmount: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/agency.graphql */
  agency?: Maybe<Agency>;
  agencyId: Scalars['String'];
  agencyName: Scalars['String'];
  agencyType?: Maybe<Scalars['String']>;
  agentId: Scalars['String'];
  fullName: Scalars['String'];
  maxClaimableCommissionAmount: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/display-arm-commission-transaction-agent-pooled-to.graphql */
  pooledTo: Array<DisplayArmCommissionTransactionAgentPooledTo>;
  previouslyPaidAmount?: Maybe<Scalars['Float']>;
  whitelistItemId: Scalars['String'];
  whitelistedByFullname: Scalars['String'];
  whitelistedById: Scalars['String'];
  whitelistedOn: Scalars['String'];
};

export type DisplayArmCommissionTransactionAgentPooledTo = {
  __typename?: 'DisplayArmCommissionTransactionAgentPooledTo';
  fullName: Scalars['String'];
  id: Scalars['String'];
};

export type DisplayAvailableTimeSlotsResult = {
  __typename?: 'DisplayAvailableTimeSlotsResult';
  /** Refer: src/graphql/definitions/object/available-slot.graphql */
  availableSlots: Array<AvailableSlot>;
  /** Refer: src/graphql/definitions/object/available-slots-day.graphql */
  availableSlotsGroupByDate: Array<AvailableSlotsDay>;
  /** Refer: src/graphql/definitions/object/schedule-config.graphql */
  scheduleConfig: ScheduleConfig;
};

export type DisplayBanker = {
  __typename?: 'DisplayBanker';
  /** Refer: src/graphql/definitions/object/filtered-bankers.graphql */
  search: FilteredBankers;
};


export type DisplayBankerSearchArgs = {
  financerId?: InputMaybe<Scalars['ID']>;
  parentProjectId?: InputMaybe<Scalars['ID']>;
  search: Scalars['String'];
  transactionId?: InputMaybe<Scalars['ID']>;
};

export enum DisplayBookingFormMode {
  Postlaunch = 'postlaunch',
  Prelaunch = 'prelaunch'
}

export type DisplayBookingVerification = {
  __typename?: 'DisplayBookingVerification';
  /** Refer: src/graphql/definitions/object/booking-verification.graphql */
  findOne: BookingVerification;
};


export type DisplayBookingVerificationFindOneArgs = {
  id: Scalars['ID'];
};

export type DisplayBovaeaDetailResponse = {
  __typename?: 'DisplayBovaeaDetailResponse';
  /** Refer: src/graphql/definitions/object/agency.graphql */
  agency?: Maybe<Agency>;
  displayName?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  mobileNum?: Maybe<Scalars['String']>;
  nric?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
};

export type DisplayBuyerLeadStatsResponse = {
  __typename?: 'DisplayBuyerLeadStatsResponse';
  /** Refer: src/graphql/definitions/object/display-buyer-lead-stats-response-project.graphql */
  byProjects: Array<DisplayBuyerLeadStatsResponseProject>;
};

export type DisplayBuyerLeadStatsResponseProject = {
  __typename?: 'DisplayBuyerLeadStatsResponseProject';
  /** Refer: src/graphql/definitions/object/display-buyer-lead-stats-response-project-agency-team.graphql */
  byAgencyTeams: Array<DisplayBuyerLeadStatsResponseProjectAgencyTeam>;
  /** Refer: src/graphql/definitions/object/project.graphql */
  project: Project;
};

export type DisplayBuyerLeadStatsResponseProjectAgencyTeam = {
  __typename?: 'DisplayBuyerLeadStatsResponseProjectAgencyTeam';
  /** Refer: src/graphql/definitions/object/display-buyer-lead-stats-response-project-agency-team-agent.graphql */
  byAgents: Array<DisplayBuyerLeadStatsResponseProjectAgencyTeamAgent>;
  /** Refer: src/graphql/definitions/object/agency-team.graphql */
  team?: Maybe<AgencyTeam>;
};

export type DisplayBuyerLeadStatsResponseProjectAgencyTeamAgent = {
  __typename?: 'DisplayBuyerLeadStatsResponseProjectAgencyTeamAgent';
  /** Refer: src/graphql/definitions/object/user.graphql */
  agent?: Maybe<User>;
  appointmentScheduled: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  bookingCollected: Array<Transaction>;
  disqualified: Scalars['Int'];
  followUpRequired: Scalars['Int'];
  leadsReceived: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  spaSigned: Array<Transaction>;
};

export type DisplayBuyerLeadsResponse = {
  __typename?: 'DisplayBuyerLeadsResponse';
  count: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/buyer-lead.graphql */
  items: Array<BuyerLead>;
};

export type DisplayChildProject = {
  __typename?: 'DisplayChildProject';
  /** Refer: src/graphql/definitions/object/child-project.graphql */
  findById: ChildProject;
  /** Refer: src/graphql/definitions/object/filtered-child-projects.graphql */
  search: FilteredChildProjects;
};


export type DisplayChildProjectFindByIdArgs = {
  id: Scalars['ID'];
};


export type DisplayChildProjectSearchArgs = {
  search: Scalars['String'];
};

export type DisplayCommonUtility = {
  __typename?: 'DisplayCommonUtility';
  loanRejectionReasons: Array<Scalars['String']>;
};

export type DisplayCustomerScheduleTimeslotsResponse = {
  __typename?: 'DisplayCustomerScheduleTimeslotsResponse';
  /** Refer: src/graphql/definitions/object/display-customer-schedule-timeslots-response-slot.graphql */
  blockedSlots: Array<DisplayCustomerScheduleTimeslotsResponseSlot>;
  /** Refer: src/graphql/definitions/object/display-customer-schedule-timeslots-response-slot.graphql */
  slots: Array<DisplayCustomerScheduleTimeslotsResponseSlot>;
};

export type DisplayCustomerScheduleTimeslotsResponseSlot = {
  __typename?: 'DisplayCustomerScheduleTimeslotsResponseSlot';
  endDatetime: Scalars['String'];
  startDatetime: Scalars['String'];
};

export type DisplayDdnProperty = {
  __typename?: 'DisplayDdnProperty';
  /** Refer: src/graphql/definitions/object/display-ddn-property-find-many.graphql */
  findMany: DisplayDdnPropertyFindMany;
  /** Refer: src/graphql/definitions/object/display-ddn-property-find-one.graphql */
  findOne: DisplayDdnPropertyFindOne;
};

export type DisplayDdnPropertyFindMany = {
  __typename?: 'DisplayDdnPropertyFindMany';
  /** Refer: src/graphql/definitions/object/display-ddn-property-find-many-by-status.graphql */
  byStatus: DisplayDdnPropertyFindManyByStatus;
};

export type DisplayDdnPropertyFindManyByStatus = {
  __typename?: 'DisplayDdnPropertyFindManyByStatus';
  /** Refer: src/graphql/definitions/object/filtered-ddn-properties.graphql */
  approved: FilteredDdnProperties;
  /** Refer: src/graphql/definitions/object/filtered-ddn-properties.graphql */
  incomplete: FilteredDdnProperties;
  /** Refer: src/graphql/definitions/object/filtered-ddn-properties.graphql */
  pendingVerification: FilteredDdnProperties;
  /** Refer: src/graphql/definitions/object/filtered-ddn-properties.graphql */
  rejected: FilteredDdnProperties;
};

export type DisplayDdnPropertyFindOne = {
  __typename?: 'DisplayDdnPropertyFindOne';
  /** Refer: src/graphql/definitions/object/ddn-property.graphql */
  byId: DdnProperty;
};


export type DisplayDdnPropertyFindOneByIdArgs = {
  id: Scalars['ID'];
};

export type DisplayDeveloperCommission = {
  __typename?: 'DisplayDeveloperCommission';
  /** Refer: src/graphql/definitions/object/display-developer-commission-batch.graphql */
  batch: DisplayDeveloperCommissionBatch;
  /** Refer: src/graphql/definitions/object/display-full-comm-ready-transaction.graphql */
  fullCommReadyTransaction: DisplayFullCommReadyTransaction;
  /** Refer: src/graphql/definitions/object/display-developer-commission-invoice.graphql */
  invoice: DisplayDeveloperCommissionInvoice;
  /** Refer: src/graphql/definitions/object/developer-commission-transaction-csv-upload-attempt.graphql */
  latestTransactionCsvUploadAttempt?: Maybe<DeveloperCommissionTransactionCsvUploadAttempt>;
  /** Refer: src/graphql/definitions/object/display-developer-commission-receipt.graphql */
  receipt: DisplayDeveloperCommissionReceipt;
  /** Refer: src/graphql/definitions/object/display-developer-commission-signed-transaction.graphql */
  signedTransaction: DisplayDeveloperCommissionSignedTransaction;
  /** Refer: src/graphql/definitions/object/display-developer-commission-stage.graphql */
  stage: DisplayDeveloperCommissionStage;
};


export type DisplayDeveloperCommissionLatestTransactionCsvUploadAttemptArgs = {
  hasError?: InputMaybe<Scalars['Boolean']>;
};

export type DisplayDeveloperCommissionBatch = {
  __typename?: 'DisplayDeveloperCommissionBatch';
  /** Refer: src/graphql/definitions/object/developer-commission-batch.graphql */
  findById: DeveloperCommissionBatch;
  /** Refer: src/graphql/definitions/object/filtered-developer-commission-batches.graphql */
  findByParentProjectId: FilteredDeveloperCommissionBatches;
};


export type DisplayDeveloperCommissionBatchFindByIdArgs = {
  id: Scalars['ID'];
};


export type DisplayDeveloperCommissionBatchFindByParentProjectIdArgs = {
  parentProjectId: Scalars['ID'];
};

export type DisplayDeveloperCommissionInvoice = {
  __typename?: 'DisplayDeveloperCommissionInvoice';
  /** Refer: src/graphql/definitions/object/developer-commission-invoice.graphql */
  findById: DeveloperCommissionInvoice;
  /** Refer: src/graphql/definitions/object/filtered-developer-commission-invoices.graphql */
  getAll: FilteredDeveloperCommissionInvoices;
};


export type DisplayDeveloperCommissionInvoiceFindByIdArgs = {
  id: Scalars['ID'];
};

export type DisplayDeveloperCommissionReceipt = {
  __typename?: 'DisplayDeveloperCommissionReceipt';
  /** Refer: src/graphql/definitions/object/developer-commission-receipt.graphql */
  findById: DeveloperCommissionReceipt;
  /** Refer: src/graphql/definitions/object/filtered-developer-commission-receipts.graphql */
  getAll: FilteredDeveloperCommissionReceipts;
};


export type DisplayDeveloperCommissionReceiptFindByIdArgs = {
  id: Scalars['ID'];
};

export type DisplayDeveloperCommissionSignedTransaction = {
  __typename?: 'DisplayDeveloperCommissionSignedTransaction';
  /** Refer: src/graphql/definitions/object/filtered-postlaunch-transactions.graphql */
  filter: FilteredPostlaunchTransactions;
  /** Refer: src/graphql/definitions/object/postlaunch-transaction.graphql */
  findById: PostlaunchTransaction;
  /** Refer: src/graphql/definitions/object/filtered-postlaunch-transactions.graphql */
  search: FilteredPostlaunchTransactions;
};


export type DisplayDeveloperCommissionSignedTransactionFilterArgs = {
  filteredByTransactionIds?: InputMaybe<Array<Scalars['ID']>>;
  parentProjectId: Scalars['ID'];
};


export type DisplayDeveloperCommissionSignedTransactionFindByIdArgs = {
  id: Scalars['ID'];
};


export type DisplayDeveloperCommissionSignedTransactionSearchArgs = {
  developerCommissionBatch?: InputMaybe<InputSearchByDeveloperCommissionBatch>;
  parentProjectId: Scalars['ID'];
  search: Scalars['String'];
};

export type DisplayDeveloperCommissionStage = {
  __typename?: 'DisplayDeveloperCommissionStage';
  /** Refer: src/graphql/definitions/object/developer-commission-stage.graphql */
  findById: DeveloperCommissionStage;
  /** Refer: src/graphql/definitions/object/filtered-developer-commission-stages.graphql */
  search: FilteredDeveloperCommissionStages;
};


export type DisplayDeveloperCommissionStageFindByIdArgs = {
  id: Scalars['ID'];
};


export type DisplayDeveloperCommissionStageSearchArgs = {
  parentProjectId: Scalars['ID'];
  search: Scalars['String'];
};

export type DisplayEstoreProjectTeaserFeatures = {
  __typename?: 'DisplayEstoreProjectTeaserFeatures';
  /** Refer: src/graphql/definitions/object/filtered-estore-project-teaser-features.graphql */
  search: FilteredEstoreProjectTeaserFeatures;
};


export type DisplayEstoreProjectTeaserFeaturesSearchArgs = {
  search: Scalars['String'];
};

export type DisplayFinancer = {
  __typename?: 'DisplayFinancer';
  /** Refer: src/graphql/definitions/object/project-financer.graphql */
  displayByProject: Array<ProjectFinancer>;
  /**
   * Search loan lenders  by name or mobile number.
   * Refer: src/graphql/definitions/object/filtered-financers.graphql
   */
  searchFinancers: FilteredFinancers;
};


export type DisplayFinancerDisplayByProjectArgs = {
  parentProjectId?: InputMaybe<Scalars['ID']>;
  transactionId?: InputMaybe<Scalars['ID']>;
};


export type DisplayFinancerSearchFinancersArgs = {
  search: Scalars['String'];
  type?: InputMaybe<FinancerType>;
};

export type DisplayFinancialReport = {
  __typename?: 'DisplayFinancialReport';
  /** Refer: src/graphql/definitions/union/financial-report.graphql */
  findOne: FinancialReport;
  /**
   * For user to preview the request to be sent to the WhoPay when requesting
   * financial report.
   * Refer: src/graphql/definitions/object/transaction-who-pay-preview.graphql
   */
  previewTransactionWhoPay: TransactionWhoPayPreview;
};


export type DisplayFinancialReportFindOneArgs = {
  id: Scalars['ID'];
};


export type DisplayFinancialReportPreviewTransactionWhoPayArgs = {
  transactionId: Scalars['String'];
};

export type DisplayFullCommReadyTransaction = {
  __typename?: 'DisplayFullCommReadyTransaction';
  /** Refer: src/graphql/definitions/object/filtered-full-comm-ready-transactions.graphql */
  findByParentProject: FilteredFullCommReadyTransactions;
  /**
   * Returns parent projects that has at least one [full comm ready transaction].
   * Refer: src/graphql/definitions/object/filtered-full-comm-ready-transaction-parent-projects.graphql
   */
  parentProjects: FilteredFullCommReadyTransactionParentProjects;
};


export type DisplayFullCommReadyTransactionFindByParentProjectArgs = {
  parentProjectId: Scalars['ID'];
};


export type DisplayFullCommReadyTransactionParentProjectsArgs = {
  search: Scalars['String'];
};

export type DisplayGalAgencyGroup = {
  __typename?: 'DisplayGalAgencyGroup';
  /** Refer: src/graphql/definitions/object/gal-agency-group.graphql */
  findOne: GalAgencyGroup;
  /**
   * Search GAL agency group by parent agency's name OR registration number.
   * Refer: src/graphql/definitions/object/filtered-gal-agency-groups.graphql
   */
  search: FilteredGalAgencyGroups;
  /** Refer: src/graphql/definitions/object/table.graphql */
  table: Table;
};


export type DisplayGalAgencyGroupFindOneArgs = {
  id: Scalars['ID'];
};


export type DisplayGalAgencyGroupSearchArgs = {
  search: Scalars['String'];
};

export type DisplayGalSignedCopy = {
  __typename?: 'DisplayGalSignedCopy';
  /** Refer: src/graphql/definitions/object/gal-signed-copy.graphql */
  findOne: GalSignedCopy;
  /** Refer: src/graphql/definitions/object/table.graphql */
  table: Table;
};


export type DisplayGalSignedCopyFindOneArgs = {
  id: Scalars['ID'];
};

export type DisplayGalTemplate = {
  __typename?: 'DisplayGalTemplate';
  /** Refer: src/graphql/definitions/object/document-template-variable.graphql */
  availableTemplateVariables: Array<DocumentTemplateVariable>;
  /** Refer: src/graphql/definitions/object/filtered-gal-templates.graphql */
  findMany: FilteredGalTemplates;
  /** Refer: src/graphql/definitions/object/gal-template.graphql */
  findOne: GalTemplate;
  /**
   * This returns the latest undeleted GAL template.
   * Refer: src/graphql/definitions/object/gal-template.graphql
   */
  latestGalTemplate?: Maybe<GalTemplate>;
  previewGeneratedGal: Scalars['Base64'];
  /** Refer: src/graphql/definitions/object/table.graphql */
  table: Table;
};


export type DisplayGalTemplateFindOneArgs = {
  id: Scalars['ID'];
};


export type DisplayGalTemplatePreviewGeneratedGalArgs = {
  galAgencyGroupId: Scalars['ID'];
  template: Scalars['String'];
};

export type DisplayKpktProjects = {
  __typename?: 'DisplayKpktProjects';
  /** Refer: src/graphql/definitions/object/kpkt-project.graphql */
  byId: KpktProject;
  /** Refer: src/graphql/definitions/object/display-kpkt-projects-on-map.graphql */
  onMap: DisplayKpktProjectsOnMap;
};


export type DisplayKpktProjectsByIdArgs = {
  id: Scalars['ID'];
};


export type DisplayKpktProjectsOnMapArgs = {
  bounds: DisplayKpktProjectsBounds;
  startDateFilter?: InputMaybe<DisplayKpktProjectsBoundsStartDateFilter>;
  zoom: Scalars['Float'];
};

export type DisplayKpktProjectsBounds = {
  /** Refer: src/graphql/definitions/input/display-kpkt-projects-bounds-coordinate.graphql */
  northEast: DisplayKpktProjectsBoundsCoordinate;
  /** Refer: src/graphql/definitions/input/display-kpkt-projects-bounds-coordinate.graphql */
  southWest: DisplayKpktProjectsBoundsCoordinate;
};

export type DisplayKpktProjectsBoundsCoordinate = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type DisplayKpktProjectsBoundsStartDateFilter = {
  minimumDate?: InputMaybe<Scalars['Date']>;
};

export type DisplayKpktProjectsOnMap = {
  __typename?: 'DisplayKpktProjectsOnMap';
  /** Refer: src/graphql/definitions/union/project-map-marker.graphql */
  cluster: Array<ProjectMapMarker>;
  totalCount: Scalars['Int'];
};

export type DisplayMapPlace = {
  __typename?: 'DisplayMapPlace';
  /** Refer: src/graphql/definitions/object/map-place.graphql */
  search: Array<MapPlace>;
};


export type DisplayMapPlaceSearchArgs = {
  search: Scalars['String'];
};

export type DisplayParentProject = {
  __typename?: 'DisplayParentProject';
  /** Refer: src/graphql/definitions/object/parent-project.graphql */
  findById: ParentProject;
  /** Refer: src/graphql/definitions/object/filtered-parent-projects.graphql */
  search: FilteredParentProjects;
};


export type DisplayParentProjectFindByIdArgs = {
  id: Scalars['ID'];
};


export type DisplayParentProjectSearchArgs = {
  search: Scalars['String'];
};

export type DisplayPaymentPortalDataResponse = {
  __typename?: 'DisplayPaymentPortalDataResponse';
  /** Refer: src/graphql/definitions/object/appointment-letter.graphql */
  appointmentLetters: Array<AppointmentLetter>;
  expiryDate: Scalars['String'];
  /** Refer: src/graphql/definitions/object/transaction-commission-invoice-request.graphql */
  invoiceRequests: Array<TransactionCommissionInvoiceRequest>;
  /** Refer: src/graphql/definitions/object/transaction-commission-invoice.graphql */
  invoices: Array<TransactionCommissionInvoice>;
  /** Refer: src/graphql/definitions/object/transaction-commission-payment-slip.graphql */
  paymentSlips: Array<TransactionCommissionPaymentSlip>;
};

/** This should have been named `DisplayPendingInvoiceRequestTransactionCommissionPortions` */
export type DisplayPendingInvoiceRequestTransactions = {
  __typename?: 'DisplayPendingInvoiceRequestTransactions';
  /**
   * List of unique commission types aggregated from all transactions.
   * Refer: src/graphql/definitions/object/pending-invoice-request-transaction-commission-type.graphql
   */
  possibleCommissionTypes: Array<PendingInvoiceRequestTransactionCommissionType>;
  /** Refer: src/graphql/definitions/object/filtered-transaction-commission-portions.graphql */
  search: FilteredTransactionCommissionPortions;
  /** Refer: src/graphql/definitions/object/table.graphql */
  table: Table;
  totalCount: Scalars['Int'];
  totalPayableAmount: Scalars['Float'];
};


/** This should have been named `DisplayPendingInvoiceRequestTransactionCommissionPortions` */
export type DisplayPendingInvoiceRequestTransactionsSearchArgs = {
  commissionType: Scalars['String'];
  search: Scalars['String'];
};


/** This should have been named `DisplayPendingInvoiceRequestTransactionCommissionPortions` */
export type DisplayPendingInvoiceRequestTransactionsTableArgs = {
  commissionType: Scalars['String'];
};


/** This should have been named `DisplayPendingInvoiceRequestTransactionCommissionPortions` */
export type DisplayPendingInvoiceRequestTransactionsTotalPayableAmountArgs = {
  commissionType: Scalars['String'];
};

export type DisplayPostlaunchBookingDraft = {
  __typename?: 'DisplayPostlaunchBookingDraft';
  /** Refer: src/graphql/definitions/object/booking-draft-agent.graphql */
  findAgentByAgentId?: Maybe<BookingDraftAgent>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  findAgentByMobileNum?: Maybe<User>;
  /** Refer: src/graphql/definitions/object/booking-draft-buyer.graphql */
  findBuyerByBuyerId?: Maybe<BookingDraftBuyer>;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft.graphql */
  findLatestDraftById: PostlaunchBookingDraft;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft.graphql */
  findLatestDraftByUnitId?: Maybe<PostlaunchBookingDraft>;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview.graphql */
  getOverviewById: PostlaunchBookingDraftOverview;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  getProgressById: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/booking-draft-buyer-industry.graphql */
  industryList: Array<BookingDraftBuyerIndustry>;
  leadSourceChannelList: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/booking-draft-buyer-occupation-list.graphql */
  occupationList: Array<BookingDraftBuyerOccupationList>;
};


export type DisplayPostlaunchBookingDraftFindAgentByAgentIdArgs = {
  agentId: Scalars['ID'];
};


export type DisplayPostlaunchBookingDraftFindAgentByMobileNumArgs = {
  mobileNum: Scalars['String'];
};


export type DisplayPostlaunchBookingDraftFindBuyerByBuyerIdArgs = {
  buyerId: Scalars['ID'];
};


export type DisplayPostlaunchBookingDraftFindLatestDraftByIdArgs = {
  id: Scalars['ID'];
};


export type DisplayPostlaunchBookingDraftFindLatestDraftByUnitIdArgs = {
  unitId: Scalars['ID'];
};


export type DisplayPostlaunchBookingDraftGetOverviewByIdArgs = {
  id: Scalars['ID'];
};


export type DisplayPostlaunchBookingDraftGetProgressByIdArgs = {
  id: Scalars['ID'];
};

export type DisplayPostlaunchForm = {
  __typename?: 'DisplayPostlaunchForm';
  /** Refer: src/graphql/definitions/object/postlaunch-form-field.graphql */
  defaultFields: PostlaunchFormField;
  /** Refer: src/graphql/definitions/object/postlaunch-form-default-selection.graphql */
  defaultSelections: PostlaunchFormDefaultSelection;
  /** Refer: src/graphql/definitions/object/postlaunch-form.graphql */
  findByChildProjectId: PostlaunchForm;
};


export type DisplayPostlaunchFormFindByChildProjectIdArgs = {
  childProjectId: Scalars['ID'];
};

export type DisplayPostlaunchTransaction = {
  __typename?: 'DisplayPostlaunchTransaction';
  /** Refer: src/graphql/definitions/object/postlaunch-transaction.graphql */
  findById: PostlaunchTransaction;
};


export type DisplayPostlaunchTransactionFindByIdArgs = {
  id: Scalars['ID'];
};

export type DisplayProjectAgencyGroup = {
  __typename?: 'DisplayProjectAgencyGroup';
  /** Refer: src/graphql/definitions/object/filtered-project-agency-groups.graphql */
  findMany: FilteredProjectAgencyGroups;
  /** Refer: src/graphql/definitions/object/project-agency-group.graphql */
  findOne: ProjectAgencyGroup;
  /**
   * Display agencies that has transactions on some project,
   * but do not belong to any PAGs under those projects.
   * Note: PAG = Project Agency Group
   * Refer: src/graphql/definitions/object/filtered-pagless-agencies.graphql
   */
  findPaglessAgencies: FilteredPaglessAgencies;
  /**
   * Display PAGs that are missing certain data that are crucial for the GAL/TNC
   * flow to be completed successfully by agents.
   * Refer: src/graphql/definitions/object/filtered-partial-pags.graphql
   */
  findPartialPags: FilteredPartialPags;
  /** Refer: src/graphql/definitions/object/filtered-project-agency-groups.graphql */
  search: FilteredProjectAgencyGroups;
  /** Refer: src/graphql/definitions/object/table.graphql */
  table: Table;
};


export type DisplayProjectAgencyGroupFindManyArgs = {
  projectAgencyKindId?: InputMaybe<Scalars['ID']>;
};


export type DisplayProjectAgencyGroupFindOneArgs = {
  id: Scalars['ID'];
};


export type DisplayProjectAgencyGroupFindPaglessAgenciesArgs = {
  armIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type DisplayProjectAgencyGroupFindPartialPagsArgs = {
  armIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type DisplayProjectAgencyGroupSearchArgs = {
  childProjectId?: InputMaybe<Scalars['ID']>;
  search: Scalars['String'];
};


export type DisplayProjectAgencyGroupTableArgs = {
  agencyKindId: Scalars['ID'];
};

export type DisplayProjectAgencyGroupKind = {
  __typename?: 'DisplayProjectAgencyGroupKind';
  /**
   * Search by parent project name, child project name, or the agency kind name.
   * Refer: src/graphql/definitions/object/filtered-project-agency-kind.graphql
   */
  search: FilteredProjectAgencyKind;
};


export type DisplayProjectAgencyGroupKindSearchArgs = {
  childProjectId?: InputMaybe<Scalars['ID']>;
  filter: DisplayProjectAgencyKindFilter;
  search: Scalars['String'];
};

export enum DisplayProjectAgencyKindFilter {
  All = 'ALL',
  HasMoreThan_1AgencyGroup = 'HAS_MORE_THAN_1_AGENCY_GROUP',
  HasMoreThan_1CommissionTnc = 'HAS_MORE_THAN_1_COMMISSION_TNC'
}

export type DisplayProjectCommissionTnc = {
  __typename?: 'DisplayProjectCommissionTnc';
  /** Refer: src/graphql/definitions/object/document-table-variable.graphql */
  availableTableVariables: Array<DocumentTableVariable>;
  /** Refer: src/graphql/definitions/object/document-template-variable.graphql */
  availableTemplateVariables: Array<DocumentTemplateVariable>;
  /** Refer: src/graphql/definitions/object/project-commission-tnc.graphql */
  findByProjectAgencyKindId: Array<ProjectCommissionTnc>;
  /** Refer: src/graphql/definitions/object/project-commission-tnc.graphql */
  findOne: ProjectCommissionTnc;
  previewGeneratedTnc: Scalars['Base64'];
  /** Refer: src/graphql/definitions/object/table.graphql */
  table: Table;
};


export type DisplayProjectCommissionTncFindByProjectAgencyKindIdArgs = {
  projectAgencyKindId: Scalars['ID'];
};


export type DisplayProjectCommissionTncFindOneArgs = {
  id: Scalars['ID'];
};


export type DisplayProjectCommissionTncPreviewGeneratedTncArgs = {
  projectAgencyKindId: Scalars['ID'];
  version: InputProjectCommissionTncVersion;
};


export type DisplayProjectCommissionTncTableArgs = {
  projectAgencyKindId: Scalars['ID'];
};

export type DisplayProjectDiscount = {
  __typename?: 'DisplayProjectDiscount';
  /** Refer: src/graphql/definitions/object/project-discount.graphql */
  findById: ProjectDiscount;
  /** Refer: src/graphql/definitions/object/project-discount.graphql */
  getAll: Array<ProjectDiscount>;
};


export type DisplayProjectDiscountFindByIdArgs = {
  id: Scalars['ID'];
};


export type DisplayProjectDiscountGetAllArgs = {
  childProjectId: Scalars['ID'];
};

export type DisplayProjectInquiry = {
  __typename?: 'DisplayProjectInquiry';
  /** Refer: src/graphql/definitions/enum/project-inquiry-status-type.graphql */
  activeProjectInquiryStatuses: Array<ProjectInquiryStatusType>;
  /** Refer: src/graphql/definitions/enum/project-inquiry-status-type.graphql */
  completedProjectInquiryStatuses: Array<ProjectInquiryStatusType>;
  /** Refer: src/graphql/definitions/object/project-inquiry-overview.graphql */
  overview: ProjectInquiryOverview;
  /** Refer: src/graphql/definitions/object/filtered-project-inquiries.graphql */
  searchProjectInquiries: FilteredProjectInquiries;
};


export type DisplayProjectInquirySearchProjectInquiriesArgs = {
  agencyIds?: InputMaybe<Array<Scalars['ID']>>;
  armIds?: InputMaybe<Array<Scalars['ID']>>;
  parentProjectIds?: InputMaybe<Array<Scalars['ID']>>;
  sort: InputProjectInquirySort;
  statuses?: InputMaybe<Array<ProjectInquiryStatusType>>;
};

export type DisplayProjectSalesResponse = {
  __typename?: 'DisplayProjectSalesResponse';
  /** Refer: src/graphql/definitions/object/display-project-sales-response-project.graphql */
  projects: Array<DisplayProjectSalesResponseProject>;
};

export type DisplayProjectSalesResponseProject = {
  __typename?: 'DisplayProjectSalesResponseProject';
  /** Refer: src/graphql/definitions/object/display-project-sales-response-project-period.graphql */
  periods: Array<DisplayProjectSalesResponseProjectPeriod>;
  /** Refer: src/graphql/definitions/object/project.graphql */
  project: Project;
  totalGdv: Scalars['Int'];
  totalSales: Scalars['Int'];
  transactionIds: Array<Scalars['String']>;
};

export type DisplayProjectSalesResponseProjectPeriod = {
  __typename?: 'DisplayProjectSalesResponseProjectPeriod';
  /** Gross Development Values */
  gdv: Scalars['Float'];
  sales: Scalars['Int'];
  transactionIds: Array<Scalars['String']>;
};

export enum DisplayProjectSalesStatus {
  Booking = 'BOOKING',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  /**
   * Completed:
   * 1. SPA and LA signed
   * 2. SPA and Cash buyers
   */
  Signed = 'SIGNED'
}

export type DisplayRequiredAppointmentLettersResult = {
  __typename?: 'DisplayRequiredAppointmentLettersResult';
  /** Refer: src/graphql/definitions/object/required-appointment-letter.graphql */
  requiredAppointmentLetters: Array<RequiredAppointmentLetter>;
};

export type DisplayRole = {
  __typename?: 'DisplayRole';
  /** Refer: src/graphql/definitions/object/filtered-roles.graphql */
  search: FilteredRoles;
};


export type DisplayRoleSearchArgs = {
  search: Scalars['String'];
};

export type DisplayRowsResult = {
  __typename?: 'DisplayRowsResult';
  /** Refer: src/graphql/definitions/object/table-row.graphql */
  rows: Array<TableRow>;
  /**
   * This length can be different from 'rows.length', because it represents the total number of items
   * retrieved with the current filters.
   * This property is needed for pagination to determine the index of last page.
   */
  totalCount: Scalars['Int'];
};

export type DisplaySbuKpi = {
  __typename?: 'DisplaySbuKpi';
  /** Refer: src/graphql/definitions/object/display-sbu-project.graphql */
  sbuProject: DisplaySbuProject;
};

export type DisplaySbuProject = {
  __typename?: 'DisplaySbuProject';
  /** Refer: src/graphql/definitions/object/sbu-project.graphql */
  findById: SbuProject;
  /** Refer: src/graphql/definitions/object/filtered-sbu-projects.graphql */
  search: FilteredSbuProjects;
};


export type DisplaySbuProjectFindByIdArgs = {
  id: Scalars['ID'];
};


export type DisplaySbuProjectSearchArgs = {
  search: Scalars['String'];
};

export type DisplayScheduleProjectWhitelist = {
  projectId: Scalars['String'];
};

export type DisplayServiceFee = {
  __typename?: 'DisplayServiceFee';
  /** Refer: src/graphql/definitions/object/display-service-fee-bill.graphql */
  bill: DisplayServiceFeeBill;
  /** Refer: src/graphql/definitions/object/service-fee-billable-parent-project.graphql */
  billableParentProjects: Array<ServiceFeeBillableParentProject>;
  /** Refer: src/graphql/definitions/object/display-service-fee-billable-transaction.graphql */
  billableTransaction: DisplayServiceFeeBillableTransaction;
  /** Refer: src/graphql/definitions/object/display-service-fee-setting.graphql */
  setting: DisplayServiceFeeSetting;
};

export type DisplayServiceFeeBill = {
  __typename?: 'DisplayServiceFeeBill';
  /** Refer: src/graphql/definitions/object/service-fee-bill.graphql */
  byId: ServiceFeeBill;
  /** Refer: src/graphql/definitions/object/filtered-service-fee-bills.graphql */
  byParentProject: FilteredServiceFeeBills;
};


export type DisplayServiceFeeBillByIdArgs = {
  id: Scalars['ID'];
};


export type DisplayServiceFeeBillByParentProjectArgs = {
  parentProjectId: Scalars['ID'];
};

export type DisplayServiceFeeBillableTransaction = {
  __typename?: 'DisplayServiceFeeBillableTransaction';
  /** Refer: src/graphql/definitions/object/service-fee-billable-transaction.graphql */
  byParentProject: Array<ServiceFeeBillableTransaction>;
};


export type DisplayServiceFeeBillableTransactionByParentProjectArgs = {
  filters: DisplayServiceFeeBillableTransactionsFilters;
  parentProjectId: Scalars['ID'];
};

export type DisplayServiceFeeBillableTransactionsFilters = {
  agencyIds?: InputMaybe<Array<Scalars['ID']>>;
  childProjectIds?: InputMaybe<Array<Scalars['ID']>>;
  completionDateEnd?: InputMaybe<Scalars['Date']>;
  completionDateStart?: InputMaybe<Scalars['Date']>;
  search?: InputMaybe<Scalars['String']>;
};

export type DisplayServiceFeeSetting = {
  __typename?: 'DisplayServiceFeeSetting';
  /** Refer: src/graphql/definitions/object/parent-project-service-fee-setting.graphql */
  byParentProject: Array<ParentProjectServiceFeeSetting>;
};


export type DisplayServiceFeeSettingByParentProjectArgs = {
  parentProjectId: Scalars['ID'];
};

export type DisplayTransaction = {
  __typename?: 'DisplayTransaction';
  /** Refer: src/graphql/definitions/object/filtered-transactions.graphql */
  findByParentProjectId: FilteredTransactions;
  /** Refer: src/graphql/definitions/object/transaction-overview-stats.graphql */
  overviewStats: TransactionOverviewStats;
  /** Refer: src/graphql/definitions/object/transaction-status-summary.graphql */
  statusSummary: Array<TransactionStatusSummary>;
};


export type DisplayTransactionFindByParentProjectIdArgs = {
  parentProjectId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
  showUnverifiedSalesOnly?: InputMaybe<Scalars['Boolean']>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
};


export type DisplayTransactionOverviewStatsArgs = {
  parentProjectId: Scalars['ID'];
};


export type DisplayTransactionStatusSummaryArgs = {
  parentProjectId: Scalars['ID'];
  showUnverifiedSalesOnly?: InputMaybe<Scalars['Boolean']>;
};

export type DisplayTransactionCommissionInvoice = {
  __typename?: 'DisplayTransactionCommissionInvoice';
  /** Refer: src/graphql/definitions/object/filtered-transaction-commission-invoices.graphql */
  findMany: FilteredTransactionCommissionInvoices;
  /** Refer: src/graphql/definitions/object/transaction-commission-invoice.graphql */
  findOne: TransactionCommissionInvoice;
  /**
   * Find invoices that are "pending verification" or "verified" but payment is
   * delayed (more than 7 days since creation).
   * Refer: src/graphql/definitions/object/filtered-transaction-commission-invoices.graphql
   */
  findPaymentDelayed: FilteredTransactionCommissionInvoices;
};


export type DisplayTransactionCommissionInvoiceFindManyArgs = {
  type?: InputMaybe<TransactionCommissionInvoiceType>;
};


export type DisplayTransactionCommissionInvoiceFindOneArgs = {
  id: Scalars['ID'];
};

export enum DisplayTransactionCommissionInvoiceRequestOption {
  Invoiced = 'invoiced',
  PendingInvoice = 'pending_invoice',
  Specific = 'specific'
}

export type DisplayTransactionCommissionPaymentSlipResult = {
  __typename?: 'DisplayTransactionCommissionPaymentSlipResult';
  count: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/transaction-commission-payment-slip.graphql */
  items: Array<TransactionCommissionPaymentSlip>;
};

export type DisplayTransactionUnitChange = {
  __typename?: 'DisplayTransactionUnitChange';
  /** Refer: src/graphql/definitions/object/filtered-transaction-unit-changes.graphql */
  byParentProject: FilteredTransactionUnitChanges;
};


export type DisplayTransactionUnitChangeByParentProjectArgs = {
  parentProjectId: Scalars['ID'];
  resolved: Scalars['Boolean'];
};

export enum DisplayTransactionsOption {
  Incompleted = 'INCOMPLETED',
  PendingInvoiceRequest = 'PENDING_INVOICE_REQUEST'
}

export type DisplayUploadedFile = {
  __typename?: 'DisplayUploadedFile';
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  findOne: UploadedFile;
};


export type DisplayUploadedFileFindOneArgs = {
  fileId: Scalars['ID'];
};

export type DisplayUploadedFileOption = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  /** Refer: src/graphql/definitions/enum/display-uploaded-file-sort-option.graphql */
  sortBy: DisplayUploadedFileSortOption;
  /** Refer: src/graphql/definitions/enum/display-uploaded-file-sort-order.graphql */
  sortOrder: DisplayUploadedFileSortOrder;
};

export enum DisplayUploadedFileSortOption {
  CreatedOn = 'createdOn',
  Name = 'name'
}

export enum DisplayUploadedFileSortOrder {
  Ascending = 'ascending',
  Descending = 'descending'
}

export type DisplayUser = {
  __typename?: 'DisplayUser';
  /** Refer: src/graphql/definitions/object/filtered-users.graphql */
  searchUser: FilteredUsers;
};


export type DisplayUserSearchUserArgs = {
  permissions?: InputMaybe<Array<Scalars['String']>>;
  searchString: Scalars['String'];
};

/**
 * The options below should be combined using AND.
 * If none of the options below is defined, then all ACN that the requesting user
 * can view will be returned.
 */
export type DisplayUserAcnFilter = {
  /**
   * If empty or undefined, then all options will be included.
   * The options within this array are combined using OR.
   * Refer: src/graphql/definitions/enum/display-user-acn-filter-by-ownership.graphql
   */
  byOwnership?: InputMaybe<Array<DisplayUserAcnFilterByOwnership>>;
  /**
   * If empty or undefined, then all options will be included.
   * The options within this array are combined using OR.
   * Refer: src/graphql/definitions/enum/display-user-acn-filter-by-status.graphql
   */
  byStatus?: InputMaybe<Array<DisplayUserAcnFilterByStatus>>;
};

export enum DisplayUserAcnFilterByOwnership {
  MyAcns = 'MY_ACNS',
  /** Only applicable if the requesting user is a manager of this team. */
  TeamAcns = 'TEAM_ACNS'
}

export enum DisplayUserAcnFilterByStatus {
  AppointmentScheduled = 'APPOINTMENT_SCHEDULED',
  Converted = 'CONVERTED',
  Disqualified = 'DISQUALIFIED',
  FollowUpRequired = 'FOLLOW_UP_REQUIRED',
  NewProspect = 'NEW_PROSPECT'
}

/**
 * The options below should be combined using AND.
 * If none of the options below is defined, then all buyer leads that the requesting user can view will be returned.
 */
export type DisplayUserBuyerLeadsFilter = {
  /**
   * If empty or undefined, then all options will be included.
   * The options within this array are combined using OR.
   * Refer: src/graphql/definitions/enum/display-user-buyer-leads-filter-by-ownership.graphql
   */
  byOwnership?: InputMaybe<Array<DisplayUserBuyerLeadsFilterByOwnership>>;
  /**
   * If empty or undefined, then all options will be included.
   * The options within this array are combined using OR.
   * Refer: src/graphql/definitions/enum/display-user-buyer-leads-filter-by-status.graphql
   */
  byStatus?: InputMaybe<Array<DisplayUserBuyerLeadsFilterByStatus>>;
};

export enum DisplayUserBuyerLeadsFilterByOwnership {
  MyBuyerLeads = 'MY_BUYER_LEADS',
  /** Only applicable if the requesting user is a manager of this team. */
  TeamBuyerLeads = 'TEAM_BUYER_LEADS'
}

export enum DisplayUserBuyerLeadsFilterByStatus {
  AppointmentScheduled = 'APPOINTMENT_SCHEDULED',
  Converted = 'CONVERTED',
  Disqualified = 'DISQUALIFIED',
  FollowUpRequired = 'FOLLOW_UP_REQUIRED',
  NewProspect = 'NEW_PROSPECT'
}

export type DisplayUserFinancialReportsFilter = {
  /**
   * If empty or undefined, then all options will be included.
   * The options within this array are combined using OR.
   * Refer: src/graphql/definitions/enum/display-user-financial-reports-filter-by-status.graphql
   */
  byStatus?: InputMaybe<Array<DisplayUserFinancialReportsFilterByStatus>>;
};

export enum DisplayUserFinancialReportsFilterByStatus {
  FinancialReport = 'FINANCIAL_REPORT',
  Important = 'IMPORTANT'
}

/**
 * The options below should be combined using AND.
 * If none of the options below is defined, then all transactions that the requesting user can view will be returned.
 */
export type DisplayUserTransactionsFilter = {
  /**
   * If empty or undefined, then all options will be included.
   * The options within this array are combined using OR.
   * Refer: src/graphql/definitions/enum/display-user-transactions-filter-by-ownership.graphql
   */
  byOwnership?: InputMaybe<Array<DisplayUserTransactionsFilterByOwnership>>;
  /**
   * If empty or undefined, then all options will be included.
   * The options within this array are combined using OR.
   * Refer: src/graphql/definitions/enum/display-user-transactions-filter-by-status.graphql
   */
  byStatus?: InputMaybe<Array<DisplayUserTransactionsFilterByStatus>>;
};

export enum DisplayUserTransactionsFilterByOwnership {
  MySales = 'MY_SALES',
  /** Only applicable if the requesting user is a manager of this team. */
  TeamSales = 'TEAM_SALES'
}

export enum DisplayUserTransactionsFilterByStatus {
  Cancelled = 'CANCELLED',
  CommissionPayment = 'COMMISSION_PAYMENT',
  DocumentSigning = 'DOCUMENT_SIGNING',
  Important = 'IMPORTANT',
  LoanApplication = 'LOAN_APPLICATION',
  NewBooking = 'NEW_BOOKING',
  /** Postlaunch transactions. */
  NewSales = 'NEW_SALES',
  /** Prelaunch transactions. */
  NewSurvey = 'NEW_SURVEY'
}

export type DisplayWhitelistItem = {
  __typename?: 'DisplayWhitelistItem';
  /** Refer: src/graphql/definitions/object/filtered-whitelist-items.graphql */
  findMany: FilteredWhitelistItems;
};


export type DisplayWhitelistItemFindManyArgs = {
  parentProjectId?: InputMaybe<Scalars['ID']>;
};

export type DocumentSignedRequest = {
  signingDate: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/document-signing-type.graphql */
  type: DocumentSigningType;
};

export type DocumentSigningRequest = {
  signingDate: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/document-signing-type.graphql */
  type: DocumentSigningType;
};

export enum DocumentSigningType {
  La = 'LA',
  Spa = 'SPA',
  /** This type is not used anymore */
  Spala = 'SPALA'
}

export type DocumentTableVariable = {
  __typename?: 'DocumentTableVariable';
  name: Scalars['String'];
};

export type DocumentTemplate = {
  __typename?: 'DocumentTemplate';
  /** Refer: src/graphql/definitions/object/project.graphql */
  childProject?: Maybe<Project>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy?: Maybe<User>;
  createdOn: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/object/project.graphql */
  parentProject?: Maybe<Project>;
  template: Scalars['String'];
  type: Scalars['String'];
};

export enum DocumentTemplateType {
  AppointmentLetter = 'appointment_letter'
}

export type DocumentTemplateVariable = {
  __typename?: 'DocumentTemplateVariable';
  name: Scalars['String'];
};

export enum DocumentType {
  La = 'LA',
  Spa = 'SPA'
}

export type DocumentUpdateDelayReason = {
  __typename?: 'DocumentUpdateDelayReason';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/document-type.graphql */
  documentType: DocumentType;
  id: Scalars['ID'];
  reason: Scalars['String'];
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  transaction: Transaction;
};

export type EditedBuyer = {
  addressDetails?: InputMaybe<Scalars['String']>;
  addressPlaceId?: InputMaybe<Scalars['ID']>;
  /** Refer: src/graphql/definitions/input/buyer-address.graphql */
  addresses: Array<BuyerAddress>;
  citizenship: Scalars['String'];
  companyAddressDetails?: InputMaybe<Scalars['String']>;
  companyAddressPlaceId?: InputMaybe<Scalars['ID']>;
  companyName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  employerAddress: Scalars['String'];
  employerName: Scalars['String'];
  exactMonthlyIncome?: InputMaybe<Scalars['Float']>;
  fullName: Scalars['String'];
  gender: Scalars['String'];
  houseNum: Scalars['String'];
  id: Scalars['String'];
  /** Refer: src/graphql/definitions/input/input-buyer-income-type.graphql */
  incomeType?: InputMaybe<InputBuyerIncomeType>;
  industry?: InputMaybe<Scalars['String']>;
  isBumi?: InputMaybe<Scalars['Boolean']>;
  maritalStatus: Scalars['String'];
  mobileNum: Scalars['String'];
  monthlyIncome: Scalars['String'];
  nric: Scalars['String'];
  nricCopyBackIds?: InputMaybe<Array<Scalars['ID']>>;
  nricCopyFrontIds?: InputMaybe<Array<Scalars['ID']>>;
  occupation: Scalars['String'];
  officeNum: Scalars['String'];
  race: Scalars['String'];
  signatureId?: InputMaybe<Scalars['ID']>;
};

export type Email = {
  __typename?: 'Email';
  body: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['String'];
  id: Scalars['Int'];
  subject: Scalars['String'];
};

export type EmailContent = {
  __typename?: 'EmailContent';
  htmlBody: Scalars['String'];
  subject: Scalars['String'];
  /** Refer: src/graphql/definitions/object/email-content-template-model.graphql */
  templateModel: EmailContentTemplateModel;
};

export type EmailContentTemplateModel = {
  __typename?: 'EmailContentTemplateModel';
  agency: Scalars['String'];
  agents: Scalars['String'];
  buyers: Scalars['String'];
  commission_type: Scalars['String'];
  commmission_portion: Scalars['String'];
  /** @deprecated Not used anymore */
  gross_commission_payable: Scalars['String'];
  gross_commission_percentage: Scalars['String'];
  gross_price: Scalars['String'];
  human_readable_id: Scalars['String'];
  /** @deprecated Not used anymore */
  nett_commission_payable: Scalars['String'];
  /** @deprecated Not used anymore */
  nett_commission_payable_unformatted?: Maybe<Scalars['Float']>;
  nett_commission_percentage: Scalars['String'];
  nett_price: Scalars['String'];
  project_name: Scalars['String'];
  tax_percentage: Scalars['String'];
  unit_no: Scalars['String'];
};

export type EmailVerificationUserRequest = {
  displayName: Scalars['String'];
  email: Scalars['String'];
};

export type EstoreAgentResponse = {
  __typename?: 'EstoreAgentResponse';
  /** Refer: src/graphql/definitions/object/estore-agent-response-agent.graphql */
  agent: EstoreAgentResponseAgent;
  /** Refer: src/graphql/definitions/object/user-achievement-medal.graphql */
  medals: Array<UserAchievementMedal>;
  /** Refer: src/graphql/definitions/object/estore-agent-response-project.graphql */
  projects: Array<EstoreAgentResponseProject>;
};

export type EstoreAgentResponseAgent = {
  __typename?: 'EstoreAgentResponseAgent';
  agencyName?: Maybe<Scalars['String']>;
  agentTag?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mobileNum: Scalars['String'];
  name: Scalars['String'];
  profilePicture?: Maybe<Scalars['String']>;
  soldAmount: Scalars['Int'];
  soldGrossValue: Scalars['String'];
};

export type EstoreAgentResponseProject = {
  __typename?: 'EstoreAgentResponseProject';
  coverImages: Array<Scalars['String']>;
  id: Scalars['String'];
  instalmentFrom: Scalars['String'];
  keySellingPoints: Array<Scalars['String']>;
  location: Scalars['String'];
  name: Scalars['String'];
  noOfBathrooms: Scalars['String'];
  noOfBedrooms: Scalars['String'];
  noOfCarParks: Scalars['String'];
  priceFrom: Scalars['String'];
  sizeRange?: Maybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
};

export type EstoreProjectResponse = {
  __typename?: 'EstoreProjectResponse';
  /** Refer: src/graphql/definitions/object/estore-project-response-agent.graphql */
  agent: EstoreProjectResponseAgent;
  /** Refer: src/graphql/definitions/object/estore-project-response-project.graphql */
  project: EstoreProjectResponseProject;
};

export type EstoreProjectResponseAgent = {
  __typename?: 'EstoreProjectResponseAgent';
  agencyName?: Maybe<Scalars['String']>;
  agentTag?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mobileNum: Scalars['String'];
  name: Scalars['String'];
  profilePicture?: Maybe<Scalars['String']>;
};

export type EstoreProjectResponseProject = {
  __typename?: 'EstoreProjectResponseProject';
  /** Refer: src/graphql/definitions/object/estore-project-response-project-coordinate.graphql */
  coordinate: EstoreProjectResponseProjectCoordinate;
  coverImages: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/estore-project-response-project-description.graphql */
  description: EstoreProjectResponseProjectDescription;
  detailPoints: Array<Scalars['String']>;
  facilities: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/estore-project-response-project-feature.graphql */
  features: Array<EstoreProjectResponseProjectFeature>;
  id: Scalars['String'];
  instalmentFrom: Scalars['String'];
  keySellingPoints: Array<Scalars['String']>;
  location: Scalars['String'];
  name: Scalars['String'];
  noOfBathrooms: Scalars['String'];
  noOfBedrooms: Scalars['String'];
  noOfCarParks: Scalars['String'];
  priceFrom: Scalars['String'];
  primaryColor: Scalars['String'];
  /** Refer: src/graphql/definitions/object/estore-project-response-project-promotion.graphql */
  promotions: Array<EstoreProjectResponseProjectPromotion>;
  /** Refer: src/graphql/definitions/union/estore-project-response-project-recent-event.graphql */
  recentEvents: Array<EstoreProjectResponseProjectRecentEvent>;
  secondaryColor: Scalars['String'];
  sizeRange?: Maybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/estore-project-response-project-unit-mix.graphql */
  unitMixes: Array<EstoreProjectResponseProjectUnitMix>;
  /** Refer: src/graphql/definitions/object/estore-project-response-project-virtual-showroom.graphql */
  virtualShowrooms: Array<EstoreProjectResponseProjectVirtualShowroom>;
};


export type EstoreProjectResponseProjectRecentEventsArgs = {
  fromDate?: InputMaybe<Scalars['String']>;
};

export type EstoreProjectResponseProjectCoordinate = {
  __typename?: 'EstoreProjectResponseProjectCoordinate';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type EstoreProjectResponseProjectDescription = {
  __typename?: 'EstoreProjectResponseProjectDescription';
  /** Refer: src/graphql/definitions/object/estore-project-response-project-description-section.graphql */
  sections: Array<EstoreProjectResponseProjectDescriptionSection>;
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type EstoreProjectResponseProjectDescriptionSection = {
  __typename?: 'EstoreProjectResponseProjectDescriptionSection';
  image?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type EstoreProjectResponseProjectFeature = {
  __typename?: 'EstoreProjectResponseProjectFeature';
  points: Array<Scalars['String']>;
  title: Scalars['String'];
};

export type EstoreProjectResponseProjectPromotion = {
  __typename?: 'EstoreProjectResponseProjectPromotion';
  expiresAt?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

/**
 * Refer: src/graphql/definitions/object/estore-project-response-project-recent-event_-schedule.graphql
 * Refer: src/graphql/definitions/object/estore-project-response-project-recent-event_-booking.graphql
 * Refer: src/graphql/definitions/object/estore-project-response-project-recent-event_-sale.graphql
 */
export type EstoreProjectResponseProjectRecentEvent = EstoreProjectResponseProjectRecentEvent_Booking | EstoreProjectResponseProjectRecentEvent_Sale | EstoreProjectResponseProjectRecentEvent_Schedule;

export type EstoreProjectResponseProjectRecentEvent_Booking = {
  __typename?: 'EstoreProjectResponseProjectRecentEvent_Booking';
  customerNames: Array<Scalars['String']>;
  happenedOn: Scalars['String'];
};

export type EstoreProjectResponseProjectRecentEvent_Sale = {
  __typename?: 'EstoreProjectResponseProjectRecentEvent_Sale';
  customerNames: Array<Scalars['String']>;
  happenedOn: Scalars['String'];
};

export type EstoreProjectResponseProjectRecentEvent_Schedule = {
  __typename?: 'EstoreProjectResponseProjectRecentEvent_Schedule';
  customerName: Scalars['String'];
  happenedOn: Scalars['String'];
};

export type EstoreProjectResponseProjectUnitMix = {
  __typename?: 'EstoreProjectResponseProjectUnitMix';
  image?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  noOfBathrooms: Scalars['String'];
  noOfBedrooms: Scalars['String'];
  noOfCarParks: Scalars['String'];
  size: Scalars['String'];
};

export type EstoreProjectResponseProjectVirtualShowroom = {
  __typename?: 'EstoreProjectResponseProjectVirtualShowroom';
  type: Scalars['String'];
  url: Scalars['String'];
};

export type EstoreProjectTeaser = {
  __typename?: 'EstoreProjectTeaser';
  /** Refer: src/graphql/definitions/object/estore-project-teaser-colors.graphql */
  colors: EstoreProjectTeaserColors;
  /** Refer: src/graphql/definitions/object/estore-project-teaser-description.graphql */
  description: EstoreProjectTeaserDescription;
  /** Refer: src/graphql/definitions/object/estore-project-teaser-feature-point.graphql */
  featurePoints: Array<EstoreProjectTeaserFeaturePoint>;
  fromPrice: Scalars['Float'];
  keySellingPoints: Array<Scalars['String']>;
  name: Scalars['String'];
};

export type EstoreProjectTeaserColors = {
  __typename?: 'EstoreProjectTeaserColors';
  primary: Scalars['String'];
  secondary: Scalars['String'];
};

export type EstoreProjectTeaserDescription = {
  __typename?: 'EstoreProjectTeaserDescription';
  /** Refer: src/graphql/definitions/object/estore-project-teaser-sections.graphql */
  sections: Array<EstoreProjectTeaserSections>;
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type EstoreProjectTeaserFeaturePoint = {
  __typename?: 'EstoreProjectTeaserFeaturePoint';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/object/estore-project-teaser-feature-section.graphql */
  section: EstoreProjectTeaserFeatureSection;
};

export type EstoreProjectTeaserFeatureSection = {
  __typename?: 'EstoreProjectTeaserFeatureSection';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/object/estore-project-teaser-feature-point.graphql */
  points: Array<EstoreProjectTeaserFeaturePoint>;
};

export type EstoreProjectTeaserSections = {
  __typename?: 'EstoreProjectTeaserSections';
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  image: AttachedFile;
  text?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type EstoreResponse = {
  __typename?: 'EstoreResponse';
  /** Refer: src/graphql/definitions/object/estore-response-agency.graphql */
  agency?: Maybe<EstoreResponseAgency>;
  /** Refer: src/graphql/definitions/object/estore-response-agent.graphql */
  agent?: Maybe<EstoreResponseAgent>;
  isPreferredPartner: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/user-achievement-medal.graphql */
  medals: Array<UserAchievementMedal>;
  /** Refer: src/graphql/definitions/object/estore-response-project.graphql */
  projects: Array<EstoreResponseProject>;
  topAreas: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/user-public-transaction.graphql */
  transactions: Array<UserPublicTransaction>;
};

export type EstoreResponseAgency = {
  __typename?: 'EstoreResponseAgency';
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type EstoreResponseAgent = {
  __typename?: 'EstoreResponseAgent';
  fullName?: Maybe<Scalars['String']>;
  mobileNum?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  renTag?: Maybe<Scalars['String']>;
};

export type EstoreResponseProject = {
  __typename?: 'EstoreResponseProject';
  coverImage?: Maybe<Scalars['String']>;
  coverImages: Array<Scalars['String']>;
  description: Scalars['String'];
  developerLogo?: Maybe<Scalars['String']>;
  keySellingPoints: Array<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  noOfBathrooms: Array<Scalars['String']>;
  noOfBedrooms: Array<Scalars['String']>;
  noOfCarParks: Array<Scalars['String']>;
  priceRange?: Maybe<Scalars['String']>;
  sizeRange: Scalars['String'];
  /** Refer: src/graphql/definitions/object/estore-response-project-tag.graphql */
  tags: Array<EstoreResponseProjectTag>;
};

export type EstoreResponseProjectTag = {
  __typename?: 'EstoreResponseProjectTag';
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type EstoreStats = {
  __typename?: 'EstoreStats';
  /** Refer: src/graphql/definitions/object/estore-stats-by-project.graphql */
  byProjects: Array<Maybe<EstoreStatsByProject>>;
  uniqueVisitCount: Scalars['Int'];
};

export type EstoreStatsByProject = {
  __typename?: 'EstoreStatsByProject';
  /**
   * If null, means the visit is to the agent generic
   * profile page, not specific to any project.
   * Refer: src/graphql/definitions/object/project.graphql
   */
  project?: Maybe<Project>;
  uniqueVisitCount: Scalars['Int'];
};

export type EstoreUrlResponse = {
  __typename?: 'EstoreUrlResponse';
  projects: Array<Scalars['String']>;
  suffix: Scalars['String'];
};

export type ExpressionSettingInstruction = {
  __typename?: 'ExpressionSettingInstruction';
  developerCommissionBatch: Scalars['String'];
  projectDiscount: Scalars['String'];
};

/**
 * Field contains
 * 1. Field details
 * 2. Field metadata with recursive FieldMappingMetaData (which stores the metadata of the arguments in the field)
 */
export type Field = {
  __typename?: 'Field';
  /** Refer: src/graphql/definitions/object/field-details.graphql */
  fieldDetails: FieldDetails;
  /** Refer: src/graphql/definitions/union/field-mapping-meta-data.graphql */
  metadata: FieldMappingMetaData;
};

export type FieldDetails = {
  __typename?: 'FieldDetails';
  /**
   * Affixes indicates the display type of the field mapping
   * Refer: src/graphql/definitions/enum/affix-type.graphql
   */
  affixes: AffixType;
  /** Display name is used to display in box and right bar */
  displayName?: Maybe<Scalars['String']>;
  /** Option name is used for displaying option in selection */
  optionName: Scalars['String'];
  /**
   * Type indicates the return type of the field mapping
   * Refer: src/graphql/definitions/enum/all-field-type.graphql
   */
  type: AllFieldType;
};

export type FieldListCondition = {
  __typename?: 'FieldListCondition';
  categories: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/union/field-list-condition-value.graphql */
  values: Array<FieldListConditionValue>;
};

/**
 * Refer: src/graphql/definitions/object/field-list-condition-value_-value.graphql
 * Refer: src/graphql/definitions/object/field-list-condition-value_-index.graphql
 * Refer: src/graphql/definitions/object/field-list-condition-value_-no-decimal-places.graphql
 * Refer: src/graphql/definitions/object/field-list-condition-value_-greater-than.graphql
 * Refer: src/graphql/definitions/object/field-list-condition-value_-less-than.graphql
 * Refer: src/graphql/definitions/object/field-list-condition-value_-not-equal.graphql
 */
export type FieldListConditionValue = FieldListConditionValue_GreaterThan | FieldListConditionValue_Index | FieldListConditionValue_LessThan | FieldListConditionValue_NoDecimalPlaces | FieldListConditionValue_NotEqual | FieldListConditionValue_Value;

export type FieldListConditionValue_GreaterThan = {
  __typename?: 'FieldListConditionValue_GreaterThan';
  value: Scalars['Int'];
};

/** type index convert 0 indexing to 1 indexing during display */
export type FieldListConditionValue_Index = {
  __typename?: 'FieldListConditionValue_Index';
  dummy?: Maybe<Scalars['Int']>;
};

export type FieldListConditionValue_LessThan = {
  __typename?: 'FieldListConditionValue_LessThan';
  value: Scalars['Int'];
};

export type FieldListConditionValue_NoDecimalPlaces = {
  __typename?: 'FieldListConditionValue_NoDecimalPlaces';
  dummy?: Maybe<Scalars['Int']>;
};

export type FieldListConditionValue_NotEqual = {
  __typename?: 'FieldListConditionValue_NotEqual';
  value: Scalars['Int'];
};

/**
 * type value is used to provide a list of value for the user to choose
 *
 * NOTE: elements.item is the value stored and caption is the display value,
 */
export type FieldListConditionValue_Value = {
  __typename?: 'FieldListConditionValue_Value';
  /** Refer: src/graphql/definitions/object/field-list-condition-value_-value-element.graphql */
  elements: Array<FieldListConditionValue_ValueElement>;
};

export type FieldListConditionValue_ValueElement = {
  __typename?: 'FieldListConditionValue_ValueElement';
  caption?: Maybe<Scalars['String']>;
  item: Scalars['String'];
};

/**
 * Purpose: This is for front end rendering
 * Refer: src/graphql/definitions/object/field-mapping-meta-data_-non-value.graphql
 * Refer: src/graphql/definitions/object/field-mapping-meta-data_-value.graphql
 */
export type FieldMappingMetaData = FieldMappingMetaData_NonValue | FieldMappingMetaData_Value;

export type FieldMappingMetaData_NonValue = {
  __typename?: 'FieldMappingMetaData_NonValue';
  /** Refer: src/graphql/definitions/object/field-mapping-metadata-argument.graphql */
  arguments: Array<FieldMappingMetadataArgument>;
  /** Refer: src/graphql/definitions/enum/category-type_-non-value.graphql */
  categoryNonValue: CategoryType_NonValue;
  /** Original name of FieldMapping of API is stored in value */
  value: Scalars['String'];
};

export type FieldMappingMetaData_Value = {
  __typename?: 'FieldMappingMetaData_Value';
  /** Refer: src/graphql/definitions/enum/category-type_-value.graphql */
  categoryValue: CategoryType_Value;
  /** Original name of FieldMapping of API is stored in value */
  value: Scalars['String'];
};

export type FieldMappingMetadataArgument = {
  __typename?: 'FieldMappingMetadataArgument';
  /**
   * Label in arguments is used instead of name for display purpose,
   * if label is undefined then nothing will be shown
   * Refer: src/graphql/definitions/object/field-list-condition.graphql
   */
  condition?: Maybe<FieldListCondition>;
  /** Refer: src/graphql/definitions/union/field-mapping-meta-data.graphql */
  field: FieldMappingMetaData;
  /** Condition contains the value list or restriction for the argument */
  label?: Maybe<Scalars['String']>;
  /** Name in arguments is the field name in field mapping object */
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/field-type.graphql */
  type: FieldType;
};

export type FieldMapping_NonValue = {
  __typename?: 'FieldMapping_NonValue';
  /** Refer: src/graphql/definitions/object/graph-ql-query-field-mapping-argument.graphql */
  arguments: Array<GraphQlQueryFieldMappingArgument>;
  /** Refer: src/graphql/definitions/enum/category-type_-non-value.graphql */
  categoryNonValue: CategoryType_NonValue;
  value: Scalars['String'];
};

export type FieldMapping_Value = {
  __typename?: 'FieldMapping_Value';
  /** Refer: src/graphql/definitions/enum/category-type_-value.graphql */
  categoryValue: CategoryType_Value;
  value: Scalars['String'];
};

export enum FieldType {
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  String = 'STRING',
  StringArray = 'STRING_ARRAY'
}

export type FileModificationHistory = {
  __typename?: 'FileModificationHistory';
  date: Scalars['String'];
  description: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  user: User;
};

export enum FillType {
  Checkbox = 'CHECKBOX',
  Circle = 'CIRCLE',
  File = 'FILE',
  Strikethrough = 'STRIKETHROUGH',
  String = 'STRING'
}

export type FilteredAgencies = {
  __typename?: 'FilteredAgencies';
  /** Refer: src/graphql/definitions/object/agency.graphql */
  paginate: Array<Agency>;
  totalCount: Scalars['Int'];
};


export type FilteredAgenciesPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredAgencyGroups = {
  __typename?: 'FilteredAgencyGroups';
  /** Refer: src/graphql/definitions/object/agency-group.graphql */
  paginate: Array<AgencyGroup>;
  totalCount: Scalars['Int'];
};


export type FilteredAgencyGroupsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredAgencyTeamJoinRequests = {
  __typename?: 'FilteredAgencyTeamJoinRequests';
  /** Refer: src/graphql/definitions/object/join-team-request.graphql */
  paginate: Array<JoinTeamRequest>;
  totalCount: Scalars['Int'];
};


export type FilteredAgencyTeamJoinRequestsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredAgencyTeamMemberProjectWhitelistStatuses = {
  __typename?: 'FilteredAgencyTeamMemberProjectWhitelistStatuses';
  /** Refer: src/graphql/definitions/object/agency-team-member-project-whitelist-status.graphql */
  paginate: Array<AgencyTeamMemberProjectWhitelistStatus>;
  totalCount: Scalars['Int'];
};


export type FilteredAgencyTeamMemberProjectWhitelistStatusesPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredAgencyTeams = {
  __typename?: 'FilteredAgencyTeams';
  /** Refer: src/graphql/definitions/object/agency-team.graphql */
  paginate: Array<AgencyTeam>;
  totalCount: Scalars['Int'];
};


export type FilteredAgencyTeamsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredAgentLeads = {
  __typename?: 'FilteredAgentLeads';
  /** Refer: src/graphql/definitions/object/agent-lead.graphql */
  paginate: Array<AgentLead>;
  totalCount: Scalars['Int'];
};


export type FilteredAgentLeadsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredAgents = {
  __typename?: 'FilteredAgents';
  /** Refer: src/graphql/definitions/object/agent.graphql */
  paginate: Array<Agent>;
  totalCount: Scalars['Int'];
};


export type FilteredAgentsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredBankers = {
  __typename?: 'FilteredBankers';
  /** Refer: src/graphql/definitions/object/banker.graphql */
  paginate: Array<Banker>;
  totalCount: Scalars['Int'];
};


export type FilteredBankersPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredChildProjects = {
  __typename?: 'FilteredChildProjects';
  /** Refer: src/graphql/definitions/object/child-project.graphql */
  paginate: Array<ChildProject>;
  totalCount: Scalars['Int'];
};


export type FilteredChildProjectsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredDdnApplications = {
  __typename?: 'FilteredDdnApplications';
  /** Refer: src/graphql/definitions/object/ddn-application.graphql */
  paginate: Array<DdnApplication>;
  totalCount: Scalars['Int'];
};


export type FilteredDdnApplicationsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredDdnProperties = {
  __typename?: 'FilteredDdnProperties';
  /** Refer: src/graphql/definitions/object/ddn-property.graphql */
  paginate: Array<DdnProperty>;
  totalCount: Scalars['Int'];
};


export type FilteredDdnPropertiesPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredDeveloperCommissionBatchTransactions = {
  __typename?: 'FilteredDeveloperCommissionBatchTransactions';
  /** Refer: src/graphql/definitions/object/developer-commission-batch-transaction.graphql */
  paginate: Array<DeveloperCommissionBatchTransaction>;
  totalCount: Scalars['Int'];
};


export type FilteredDeveloperCommissionBatchTransactionsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredDeveloperCommissionBatches = {
  __typename?: 'FilteredDeveloperCommissionBatches';
  /** Refer: src/graphql/definitions/object/developer-commission-batch.graphql */
  paginate: Array<DeveloperCommissionBatch>;
  totalCount: Scalars['Int'];
};


export type FilteredDeveloperCommissionBatchesPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredDeveloperCommissionInvoices = {
  __typename?: 'FilteredDeveloperCommissionInvoices';
  /** Refer: src/graphql/definitions/object/developer-commission-invoice.graphql */
  paginate: Array<DeveloperCommissionInvoice>;
  totalCount: Scalars['Int'];
};


export type FilteredDeveloperCommissionInvoicesPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredDeveloperCommissionReceipts = {
  __typename?: 'FilteredDeveloperCommissionReceipts';
  /** Refer: src/graphql/definitions/object/developer-commission-receipt.graphql */
  paginate: Array<DeveloperCommissionReceipt>;
  totalCount: Scalars['Int'];
};


export type FilteredDeveloperCommissionReceiptsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredDeveloperCommissionStages = {
  __typename?: 'FilteredDeveloperCommissionStages';
  /** Refer: src/graphql/definitions/object/developer-commission-stage.graphql */
  paginate: Array<DeveloperCommissionStage>;
  totalCount: Scalars['Int'];
};


export type FilteredDeveloperCommissionStagesPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredDeveloperCommissionTransactions = {
  __typename?: 'FilteredDeveloperCommissionTransactions';
  /** Refer: src/graphql/definitions/object/developer-commission-transaction.graphql */
  paginate: Array<DeveloperCommissionTransaction>;
  totalCount: Scalars['Int'];
};


export type FilteredDeveloperCommissionTransactionsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredDeveloperDashboardPostlaunchCancellationReasons = {
  __typename?: 'FilteredDeveloperDashboardPostlaunchCancellationReasons';
  /** Refer: src/graphql/definitions/object/developer-dashboard-postlaunch-cancellation-reason.graphql */
  paginate: Array<DeveloperDashboardPostlaunchCancellationReason>;
  totalCount: Scalars['Int'];
};


export type FilteredDeveloperDashboardPostlaunchCancellationReasonsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredDeveloperDashboardPrelaunchCancellationReasons = {
  __typename?: 'FilteredDeveloperDashboardPrelaunchCancellationReasons';
  /** Refer: src/graphql/definitions/object/developer-dashboard-prelaunch-cancellation-reason.graphql */
  paginate: Array<DeveloperDashboardPrelaunchCancellationReason>;
  totalCount: Scalars['Int'];
};


export type FilteredDeveloperDashboardPrelaunchCancellationReasonsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredDeveloperDashboardPrelaunchStatsByUnitType = {
  __typename?: 'FilteredDeveloperDashboardPrelaunchStatsByUnitType';
  /** Refer: src/graphql/definitions/object/developer-dashboard-prelaunch-stats-by-unit-type.graphql */
  paginate: Array<DeveloperDashboardPrelaunchStatsByUnitType>;
  totalCount: Scalars['Int'];
};


export type FilteredDeveloperDashboardPrelaunchStatsByUnitTypePaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredDeveloperDashboardTransactionCommissionInvoiceRequests = {
  __typename?: 'FilteredDeveloperDashboardTransactionCommissionInvoiceRequests';
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-commission-invoice-request.graphql */
  paginate: Array<DeveloperDashboardTransactionCommissionInvoiceRequest>;
  totalCount: Scalars['Int'];
};


export type FilteredDeveloperDashboardTransactionCommissionInvoiceRequestsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredDeveloperDashboardTransactionCommissionInvoices = {
  __typename?: 'FilteredDeveloperDashboardTransactionCommissionInvoices';
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-commission-invoice.graphql */
  paginate: Array<DeveloperDashboardTransactionCommissionInvoice>;
  totalCount: Scalars['Int'];
};


export type FilteredDeveloperDashboardTransactionCommissionInvoicesPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredDeveloperDashboardTransactionCommissionPaymentSlips = {
  __typename?: 'FilteredDeveloperDashboardTransactionCommissionPaymentSlips';
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction-commission-payment-slip.graphql */
  paginate: Array<DeveloperDashboardTransactionCommissionPaymentSlip>;
  totalCount: Scalars['Int'];
};


export type FilteredDeveloperDashboardTransactionCommissionPaymentSlipsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredDeveloperDashboardTransactions = {
  __typename?: 'FilteredDeveloperDashboardTransactions';
  /** Refer: src/graphql/definitions/object/developer-dashboard-transaction.graphql */
  paginate: Array<DeveloperDashboardTransaction>;
  totalCount: Scalars['Int'];
};


export type FilteredDeveloperDashboardTransactionsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredEstoreProjectTeaserFeatures = {
  __typename?: 'FilteredEstoreProjectTeaserFeatures';
  /** Refer: src/graphql/definitions/object/estore-project-teaser-feature-point.graphql */
  paginate: Array<EstoreProjectTeaserFeaturePoint>;
  totalCount: Scalars['Int'];
};


export type FilteredEstoreProjectTeaserFeaturesPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredFinancers = {
  __typename?: 'FilteredFinancers';
  /** Refer: src/graphql/definitions/object/financer.graphql */
  paginate: Array<Financer>;
  totalCount: Scalars['Int'];
};


export type FilteredFinancersPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredFullCommReadyTransactionParentProjects = {
  __typename?: 'FilteredFullCommReadyTransactionParentProjects';
  /** Refer: src/graphql/definitions/object/full-comm-ready-transaction-parent-project.graphql */
  paginate: Array<FullCommReadyTransactionParentProject>;
  totalCount: Scalars['Int'];
};


export type FilteredFullCommReadyTransactionParentProjectsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredFullCommReadyTransactions = {
  __typename?: 'FilteredFullCommReadyTransactions';
  /** Refer: src/graphql/definitions/object/full-comm-ready-transaction.graphql */
  paginate: Array<FullCommReadyTransaction>;
  totalCount: Scalars['Int'];
};


export type FilteredFullCommReadyTransactionsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredGalAgencyGroups = {
  __typename?: 'FilteredGalAgencyGroups';
  /** Refer: src/graphql/definitions/object/gal-agency-group.graphql */
  paginate: Array<GalAgencyGroup>;
  totalCount: Scalars['Int'];
};


export type FilteredGalAgencyGroupsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredGalTemplates = {
  __typename?: 'FilteredGalTemplates';
  /** Refer: src/graphql/definitions/object/gal-template.graphql */
  paginate: Array<GalTemplate>;
  totalCount: Scalars['Int'];
};


export type FilteredGalTemplatesPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredInboxChannelChat = {
  __typename?: 'FilteredInboxChannelChat';
  /** Refer: src/graphql/definitions/object/inbox-channel-chat.graphql */
  paginate: Array<InboxChannelChat>;
  totalCount: Scalars['Int'];
};


export type FilteredInboxChannelChatPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredPaglessAgencies = {
  __typename?: 'FilteredPaglessAgencies';
  /** Refer: src/graphql/definitions/object/pagless-agency.graphql */
  paginate: Array<PaglessAgency>;
  totalCount: Scalars['Int'];
};


export type FilteredPaglessAgenciesPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredParentProjects = {
  __typename?: 'FilteredParentProjects';
  /** Refer: src/graphql/definitions/object/parent-project.graphql */
  paginate: Array<ParentProject>;
  totalCount: Scalars['Int'];
};


export type FilteredParentProjectsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredPartialPags = {
  __typename?: 'FilteredPartialPags';
  /** Refer: src/graphql/definitions/object/partial-pag.graphql */
  paginate: Array<PartialPag>;
  totalCount: Scalars['Int'];
};


export type FilteredPartialPagsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredPostlaunchTransactions = {
  __typename?: 'FilteredPostlaunchTransactions';
  /** Refer: src/graphql/definitions/object/postlaunch-transaction.graphql */
  paginate: Array<PostlaunchTransaction>;
  totalCount: Scalars['Int'];
};


export type FilteredPostlaunchTransactionsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredProjectAgencyGroups = {
  __typename?: 'FilteredProjectAgencyGroups';
  /** Refer: src/graphql/definitions/object/project-agency-group.graphql */
  paginate: Array<ProjectAgencyGroup>;
  totalCount: Scalars['Int'];
};


export type FilteredProjectAgencyGroupsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredProjectAgencyKind = {
  __typename?: 'FilteredProjectAgencyKind';
  /** Refer: src/graphql/definitions/object/project-agency-kind.graphql */
  paginate: Array<ProjectAgencyKind>;
  totalCount: Scalars['Int'];
};


export type FilteredProjectAgencyKindPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredProjectInquiries = {
  __typename?: 'FilteredProjectInquiries';
  /** Refer: src/graphql/definitions/object/project-inquiry.graphql */
  paginate: Array<ProjectInquiry>;
  totalCount: Scalars['Int'];
};


export type FilteredProjectInquiriesPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredProjectInquiryOverviewByArms = {
  __typename?: 'FilteredProjectInquiryOverviewByArms';
  /** Refer: src/graphql/definitions/object/project-inquiry-overview-by-arm.graphql */
  paginate: Array<ProjectInquiryOverviewByArm>;
  totalCount: Scalars['Int'];
};


export type FilteredProjectInquiryOverviewByArmsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredProjectInquiryOverviewByParentProjects = {
  __typename?: 'FilteredProjectInquiryOverviewByParentProjects';
  /** Refer: src/graphql/definitions/object/project-inquiry-overview-by-parent-project.graphql */
  paginate: Array<ProjectInquiryOverviewByParentProject>;
  totalCount: Scalars['Int'];
};


export type FilteredProjectInquiryOverviewByParentProjectsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredProjectUnits = {
  __typename?: 'FilteredProjectUnits';
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  paginate: Array<ProjectUnit>;
  totalCount: Scalars['Int'];
};


export type FilteredProjectUnitsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredProjects = {
  __typename?: 'FilteredProjects';
  /** Refer: src/graphql/definitions/object/project.graphql */
  paginate: Array<Project>;
  totalCount: Scalars['Int'];
};


export type FilteredProjectsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredProsectiveUsers = {
  __typename?: 'FilteredProsectiveUsers';
  /** Refer: src/graphql/definitions/object/prospective-user.graphql */
  paginate: Array<ProspectiveUser>;
  totalCount: Scalars['Int'];
};


export type FilteredProsectiveUsersPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredRoles = {
  __typename?: 'FilteredRoles';
  /** Refer: src/graphql/definitions/object/role.graphql */
  paginate: Array<Role>;
  totalCount: Scalars['Int'];
};


export type FilteredRolesPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredSbuProjects = {
  __typename?: 'FilteredSbuProjects';
  /** Refer: src/graphql/definitions/object/sbu-project.graphql */
  paginate: Array<SbuProject>;
  totalCount: Scalars['Int'];
};


export type FilteredSbuProjectsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredServiceFeeBills = {
  __typename?: 'FilteredServiceFeeBills';
  /** Refer: src/graphql/definitions/object/service-fee-bill.graphql */
  paginate: Array<ServiceFeeBill>;
  totalCount: Scalars['Int'];
};


export type FilteredServiceFeeBillsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredTransactionAgents = {
  __typename?: 'FilteredTransactionAgents';
  /** Refer: src/graphql/definitions/object/transaction-agent_.graphql */
  paginate: Array<TransactionAgent_>;
  totalCount: Scalars['Int'];
};


export type FilteredTransactionAgentsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredTransactionCommissionInvoiceRequests = {
  __typename?: 'FilteredTransactionCommissionInvoiceRequests';
  /** Refer: src/graphql/definitions/object/transaction-commission-invoice-request.graphql */
  paginate: Array<TransactionCommissionInvoiceRequest>;
  totalCount: Scalars['Int'];
};


export type FilteredTransactionCommissionInvoiceRequestsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredTransactionCommissionInvoices = {
  __typename?: 'FilteredTransactionCommissionInvoices';
  /** Refer: src/graphql/definitions/object/transaction-commission-invoice.graphql */
  paginate: Array<TransactionCommissionInvoice>;
  totalCount: Scalars['Int'];
};


export type FilteredTransactionCommissionInvoicesPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredTransactionCommissionPaymentSlips = {
  __typename?: 'FilteredTransactionCommissionPaymentSlips';
  /** Refer: src/graphql/definitions/object/transaction-commission-payment-slip.graphql */
  paginate: Array<TransactionCommissionPaymentSlip>;
  totalCount: Scalars['Int'];
};


export type FilteredTransactionCommissionPaymentSlipsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredTransactionCommissionPortions = {
  __typename?: 'FilteredTransactionCommissionPortions';
  /** Refer: src/graphql/definitions/object/transaction-commission-info.graphql */
  paginate: Array<TransactionCommissionInfo>;
  totalCount: Scalars['Int'];
};


export type FilteredTransactionCommissionPortionsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredTransactionDeveloperCommissionStages = {
  __typename?: 'FilteredTransactionDeveloperCommissionStages';
  /** Refer: src/graphql/definitions/object/transaction-developer-commission-stage.graphql */
  paginate: Array<TransactionDeveloperCommissionStage>;
  totalCount: Scalars['Int'];
};


export type FilteredTransactionDeveloperCommissionStagesPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredTransactionUnitChanges = {
  __typename?: 'FilteredTransactionUnitChanges';
  /** Refer: src/graphql/definitions/object/transaction-unit-change.graphql */
  paginate: Array<TransactionUnitChange>;
  totalCount: Scalars['Int'];
};


export type FilteredTransactionUnitChangesPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredTransactions = {
  __typename?: 'FilteredTransactions';
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  paginate: Array<Transaction>;
  totalCount: Scalars['Int'];
};


export type FilteredTransactionsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredUsers = {
  __typename?: 'FilteredUsers';
  /** Refer: src/graphql/definitions/object/user.graphql */
  paginate: Array<User>;
  totalCount: Scalars['Int'];
};


export type FilteredUsersPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type FilteredWhitelistItems = {
  __typename?: 'FilteredWhitelistItems';
  /** Refer: src/graphql/definitions/object/whitelist-item.graphql */
  paginate: Array<WhitelistItem>;
  totalCount: Scalars['Int'];
};


export type FilteredWhitelistItemsPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type Financer = {
  __typename?: 'Financer';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/financer-type.graphql */
  type: FinancerType;
};

export enum FinancerType {
  Bank = 'BANK',
  Company = 'COMPANY',
  Government = 'GOVERNMENT'
}

/**
 * Refer: src/graphql/definitions/object/who-pay-financial-report.graphql
 * Refer: src/graphql/definitions/object/ctos-credit-report.graphql
 */
export type FinancialReport = CtosCreditReport | WhoPayFinancialReport;

export type FinancialReportUser = {
  __typename?: 'FinancialReportUser';
  fullName: Scalars['String'];
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  icCopiesBack: Array<AttachedFile>;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  icCopiesFront: Array<AttachedFile>;
  icNumber: Scalars['String'];
  id: Scalars['ID'];
  income: Scalars['Float'];
  mobileNumber: Scalars['String'];
};

export type Foo = {
  __typename?: 'Foo';
  bar: Scalars['String'];
  id: Scalars['Int'];
};

/** Transactions that are ready for full commission dispersion */
export type FullCommReadyTransaction = {
  __typename?: 'FullCommReadyTransaction';
  /** Refer: src/graphql/definitions/object/developer-commission-transaction.graphql */
  developerFinalStageCommission: DeveloperCommissionTransaction;
  /**
   * Refer: src/graphql/definitions/object/full-comm-ready-transaction-full-comm-adjustment.graphql
   * @deprecated This is not no longer necessary after we updated the commission derivation logic.
   */
  fullCommAdjustments: Array<FullCommReadyTransactionFullCommAdjustment>;
  nettPriceAsPerDeveloper?: Maybe<Scalars['Float']>;
  /**
   * This will be undefined if express commission invoice requests have not been sent yet
   * OR this transaction does not contains the 'express' commission portion
   * (e.g. the transaction is paid by cash, not loan).
   */
  nettPriceDuringExpressCommDispersion?: Maybe<Scalars['Float']>;
  /** Refer: src/graphql/definitions/union/full-comm-ready-transaction-nett-price-status.graphql */
  nettPriceStatus: FullCommReadyTransactionNettPriceStatus;
  /** Refer: src/graphql/definitions/object/postlaunch-transaction.graphql */
  transaction: PostlaunchTransaction;
};

export type FullCommReadyTransactionFullCommAdjustment = {
  __typename?: 'FullCommReadyTransactionFullCommAdjustment';
  /** Refer: src/graphql/definitions/object/agency.graphql */
  agency: Agency;
  amount: Scalars['Float'];
};

/**
 * Refer: src/graphql/definitions/object/full-comm-ready-transaction-nett-price-status_-ok.graphql
 * Refer: src/graphql/definitions/object/full-comm-ready-transaction-nett-price-status_-adjusted.graphql
 * Refer: src/graphql/definitions/object/full-comm-ready-transaction-nett-price-status_-s-m.graphql
 * Refer: src/graphql/definitions/object/full-comm-ready-transaction-nett-price-status_-not-tally.graphql
 * Refer: src/graphql/definitions/object/full-comm-ready-transaction-nett-price-status_-error.graphql
 */
export type FullCommReadyTransactionNettPriceStatus = FullCommReadyTransactionNettPriceStatus_Adjusted | FullCommReadyTransactionNettPriceStatus_Error | FullCommReadyTransactionNettPriceStatus_NotTally | FullCommReadyTransactionNettPriceStatus_Ok | FullCommReadyTransactionNettPriceStatus_Sm;

export type FullCommReadyTransactionNettPriceStatus_Adjusted = {
  __typename?: 'FullCommReadyTransactionNettPriceStatus_Adjusted';
  dummy?: Maybe<Scalars['String']>;
};

export type FullCommReadyTransactionNettPriceStatus_Error = {
  __typename?: 'FullCommReadyTransactionNettPriceStatus_Error';
  dummy?: Maybe<Scalars['String']>;
};

export type FullCommReadyTransactionNettPriceStatus_NotTally = {
  __typename?: 'FullCommReadyTransactionNettPriceStatus_NotTally';
  dummy?: Maybe<Scalars['String']>;
};

export type FullCommReadyTransactionNettPriceStatus_Ok = {
  __typename?: 'FullCommReadyTransactionNettPriceStatus_Ok';
  dummy?: Maybe<Scalars['String']>;
};

export type FullCommReadyTransactionNettPriceStatus_Sm = {
  __typename?: 'FullCommReadyTransactionNettPriceStatus_SM';
  dummy?: Maybe<Scalars['String']>;
};

export type FullCommReadyTransactionParentProject = {
  __typename?: 'FullCommReadyTransactionParentProject';
  fullCommReadyTransactionsCount: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/parent-project.graphql */
  parentProject: ParentProject;
};

export type GalAgencyGroup = {
  __typename?: 'GalAgencyGroup';
  /** Refer: src/graphql/definitions/object/agency-group.graphql */
  agencyGroup: AgencyGroup;
  id: Scalars['ID'];
  /**
   * The latest GAL template uploaded by accountant.
   * Refer: src/graphql/definitions/object/gal-agency-group-gal.graphql
   */
  latestGal?: Maybe<GalAgencyGroupGal>;
};

export type GalAgencyGroupGal = {
  __typename?: 'GalAgencyGroupGal';
  /**
   * This status is derived based on the latest TNC version.
   * Refer: src/graphql/definitions/union/gal-agency-group-gal-status.graphql
   */
  status: GalAgencyGroupGalStatus;
  /** Refer: src/graphql/definitions/object/gal-template.graphql */
  template: GalTemplate;
};

/**
 * Refer: src/graphql/definitions/object/gal-agency-group-gal-status-pending-upload.graphql
 * Refer: src/graphql/definitions/object/gal-agency-group-gal-status-uploaded.graphql
 * Refer: src/graphql/definitions/object/gal-agency-group-gal-status-approved.graphql
 * Refer: src/graphql/definitions/object/gal-agency-group-gal-status-rejected.graphql
 * Refer: src/graphql/definitions/object/gal-agency-group-gal-status-pending-reupload.graphql
 * Refer: src/graphql/definitions/object/gal-agency-group-gal-status-voided.graphql
 */
export type GalAgencyGroupGalStatus = GalAgencyGroupGalStatusApproved | GalAgencyGroupGalStatusPendingReupload | GalAgencyGroupGalStatusPendingUpload | GalAgencyGroupGalStatusRejected | GalAgencyGroupGalStatusUploaded | GalAgencyGroupGalStatusVoided;

export type GalAgencyGroupGalStatusApproved = {
  __typename?: 'GalAgencyGroupGalStatusApproved';
  /** Refer: src/graphql/definitions/object/user.graphql */
  by: User;
  on: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/gal-signed-copy.graphql */
  signedCopy: GalSignedCopy;
};

/**
 * If the current uploaded signed copy is not the latest template version, then the
 * status will be pending re-upload
 */
export type GalAgencyGroupGalStatusPendingReupload = {
  __typename?: 'GalAgencyGroupGalStatusPendingReupload';
  dummy?: Maybe<Scalars['String']>;
};

export type GalAgencyGroupGalStatusPendingUpload = {
  __typename?: 'GalAgencyGroupGalStatusPendingUpload';
  dummy?: Maybe<Scalars['String']>;
};

export type GalAgencyGroupGalStatusRejected = {
  __typename?: 'GalAgencyGroupGalStatusRejected';
  /** Refer: src/graphql/definitions/object/user.graphql */
  by: User;
  on: Scalars['Date'];
  reason: Scalars['String'];
};

export type GalAgencyGroupGalStatusUploaded = {
  __typename?: 'GalAgencyGroupGalStatusUploaded';
  /** Refer: src/graphql/definitions/object/gal-signed-copy.graphql */
  signedCopy: GalSignedCopy;
};

export type GalAgencyGroupGalStatusVoided = {
  __typename?: 'GalAgencyGroupGalStatusVoided';
  /** Refer: src/graphql/definitions/object/user.graphql */
  by: User;
  on: Scalars['Date'];
  reason: Scalars['String'];
};

export type GalSignedCopy = {
  __typename?: 'GalSignedCopy';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  file: UploadedFile;
  /** Refer: src/graphql/definitions/object/gal-agency-group.graphql */
  galAgencyGroup: GalAgencyGroup;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/union/gal-signed-copy-status.graphql */
  status: GalSignedCopyStatus;
};

/**
 * Refer: src/graphql/definitions/object/gal-signed-copy-status-pending.graphql
 * Refer: src/graphql/definitions/object/gal-signed-copy-status-approved.graphql
 * Refer: src/graphql/definitions/object/gal-signed-copy-status-rejected.graphql
 * Refer: src/graphql/definitions/object/gal-signed-copy-status-voided.graphql
 */
export type GalSignedCopyStatus = GalSignedCopyStatusApproved | GalSignedCopyStatusPending | GalSignedCopyStatusRejected | GalSignedCopyStatusVoided;

export type GalSignedCopyStatusApproved = {
  __typename?: 'GalSignedCopyStatusApproved';
  /** Refer: src/graphql/definitions/object/user.graphql */
  by: User;
  on: Scalars['Date'];
  /**
   * Refer: src/graphql/definitions/object/gal-signed-copy.graphql
   * @deprecated Use the parent object `GalSignedCopy` instead
   */
  signedCopy: GalSignedCopy;
};

export type GalSignedCopyStatusPending = {
  __typename?: 'GalSignedCopyStatusPending';
  dummy?: Maybe<Scalars['String']>;
};

export type GalSignedCopyStatusRejected = {
  __typename?: 'GalSignedCopyStatusRejected';
  /** Refer: src/graphql/definitions/object/user.graphql */
  by: User;
  on: Scalars['Date'];
  reason: Scalars['String'];
};

export type GalSignedCopyStatusVoided = {
  __typename?: 'GalSignedCopyStatusVoided';
  /** Refer: src/graphql/definitions/object/user.graphql */
  by: User;
  on: Scalars['Date'];
  reason: Scalars['String'];
};

export type GalTemplate = {
  __typename?: 'GalTemplate';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
  template: Scalars['String'];
  /**
   * Starts from 1, the GAL template with the largest version is the current
   * effective GAL.
   */
  version: Scalars['Int'];
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type GenerateGalResponse = {
  __typename?: 'GenerateGalResponse';
  generatedPdf: Scalars['Base64'];
};

export type GraphQlMutationBox = {
  /** Refer: src/graphql/definitions/input/graph-ql-mutation-field-mapping.graphql */
  field: GraphQlMutationFieldMapping;
  /** Refer: src/graphql/definitions/enum/fill-type.graphql */
  fillType: FillType;
  fontSize: Scalars['Float'];
  height: Scalars['Float'];
  paddingLeft: Scalars['Float'];
  paddingRight: Scalars['Float'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type GraphQlMutationCustomPdf = {
  /** Refer: src/graphql/definitions/input/background.graphql */
  background?: InputMaybe<Background>;
  /** Refer: src/graphql/definitions/input/graph-ql-mutation-field-mapping.graphql */
  condition?: InputMaybe<GraphQlMutationFieldMapping>;
  /** Refer: src/graphql/definitions/input/input-graph-ql-mutation-custom-pdf-custom-background.graphql */
  customBackground?: InputMaybe<InputGraphQlMutationCustomPdfCustomBackground>;
  /** Refer: src/graphql/definitions/input/graph-ql-mutation-box.graphql */
  shapes: Array<GraphQlMutationBox>;
  /** Refer: src/graphql/definitions/input/graph-ql-mutation-page-size.graphql */
  size?: InputMaybe<GraphQlMutationPageSize>;
};

export type GraphQlMutationFieldMapping = {
  /** Refer: src/graphql/definitions/input/graph-ql-mutation-field-mapping-argument.graphql */
  arguments?: InputMaybe<Array<GraphQlMutationFieldMappingArgument>>;
  /** Refer: src/graphql/definitions/enum/category-type.graphql */
  category: CategoryType;
  value: Scalars['String'];
};

export type GraphQlMutationFieldMappingArgument = {
  /** Refer: src/graphql/definitions/input/graph-ql-mutation-field-mapping.graphql */
  field: GraphQlMutationFieldMapping;
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/field-type.graphql */
  type: FieldType;
};

export type GraphQlMutationPageSize = {
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type GraphQlQueryBox = {
  __typename?: 'GraphQLQueryBox';
  /** Refer: src/graphql/definitions/union/graph-ql-query-field-mapping.graphql */
  field: GraphQlQueryFieldMapping;
  /** Refer: src/graphql/definitions/enum/fill-type.graphql */
  fillType: FillType;
  fontSize: Scalars['Float'];
  height: Scalars['Float'];
  paddingLeft: Scalars['Float'];
  paddingRight: Scalars['Float'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type GraphQlQueryCustomPdf = {
  __typename?: 'GraphQLQueryCustomPDF';
  /**
   * Refer: src/graphql/definitions/object/attached-file.graphql
   * @deprecated Use `customBackground` instead.
   */
  background?: Maybe<AttachedFile>;
  /** Refer: src/graphql/definitions/union/graph-ql-query-field-mapping.graphql */
  condition?: Maybe<GraphQlQueryFieldMapping>;
  /** Refer: src/graphql/definitions/union/graph-ql-query-custom-pdf-custom-background.graphql */
  customBackground?: Maybe<GraphQlQueryCustomPdfCustomBackground>;
  /** Refer: src/graphql/definitions/object/graph-ql-query-box.graphql */
  shapes: Array<GraphQlQueryBox>;
  /** Refer: src/graphql/definitions/object/graph-ql-query-page-size.graphql */
  size: GraphQlQueryPageSize;
};

/**
 * Refer: src/graphql/definitions/object/graph-ql-query-custom-pdf-custom-background-image.graphql
 * Refer: src/graphql/definitions/object/graph-ql-query-custom-pdf-custom-background-shape.graphql
 */
export type GraphQlQueryCustomPdfCustomBackground = GraphQlQueryCustomPdfCustomBackgroundImage | GraphQlQueryCustomPdfCustomBackgroundShape;

export type GraphQlQueryCustomPdfCustomBackgroundImage = {
  __typename?: 'GraphQLQueryCustomPDFCustomBackgroundImage';
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  image: AttachedFile;
};

export type GraphQlQueryCustomPdfCustomBackgroundShape = {
  __typename?: 'GraphQLQueryCustomPDFCustomBackgroundShape';
  /** Refer: src/graphql/definitions/union/graph-ql-query-field-mapping.graphql */
  shape: GraphQlQueryFieldMapping;
};

/**
 * Refer: src/graphql/definitions/object/field-mapping_-value.graphql
 * Refer: src/graphql/definitions/object/field-mapping_-non-value.graphql
 */
export type GraphQlQueryFieldMapping = FieldMapping_NonValue | FieldMapping_Value;

export type GraphQlQueryFieldMappingArgument = {
  __typename?: 'GraphQLQueryFieldMappingArgument';
  /** Refer: src/graphql/definitions/union/graph-ql-query-field-mapping.graphql */
  field: GraphQlQueryFieldMapping;
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/field-type.graphql */
  type: FieldType;
};

export type GraphQlQueryPageSize = {
  __typename?: 'GraphQLQueryPageSize';
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type HandlingProject = {
  __typename?: 'HandlingProject';
  /** Refer: src/graphql/definitions/object/project.graphql */
  project: Project;
  /**
   * Agent leads that registered interest on this project but has not been
   * whitelisted yet.
   * Refer: src/graphql/definitions/object/filtered-agent-leads.graphql
   */
  registeredInterestAgentLeads: FilteredAgentLeads;
  /** Refer: src/graphql/definitions/object/filtered-agent-leads.graphql */
  whitelistedAgentLeads: FilteredAgentLeads;
};

export type HandlingProjects = {
  __typename?: 'HandlingProjects';
  /** Refer: src/graphql/definitions/object/handling-project.graphql */
  getAll: Array<HandlingProject>;
  /** Refer: src/graphql/definitions/object/handling-project.graphql */
  getOne: HandlingProject;
};


export type HandlingProjectsGetOneArgs = {
  projectId: Scalars['ID'];
};

export type InboxChannelChat = {
  __typename?: 'InboxChannelChat';
  /** Refer: src/graphql/definitions/object/notification-channel.graphql */
  notificationChannel: NotificationChannel;
  /** Refer: src/graphql/definitions/object/inbox-group-summary.graphql */
  summary: InboxGroupSummary;
};

export type InboxGroupSummary = {
  __typename?: 'InboxGroupSummary';
  /** Refer: src/graphql/definitions/object/inbox-group-summary-latest-message.graphql */
  latestMessage?: Maybe<InboxGroupSummaryLatestMessage>;
  newMessagesCount: Scalars['Int'];
};

export type InboxGroupSummaryLatestMessage = {
  __typename?: 'InboxGroupSummaryLatestMessage';
  /** Refer: src/graphql/definitions/object/user.graphql */
  author?: Maybe<User>;
  body: Scalars['String'];
  createdOn: Scalars['String'];
  title: Scalars['String'];
};

export type InboxSummary = {
  __typename?: 'InboxSummary';
  /**
   * Refer: src/graphql/definitions/object/inbox-channel-chat.graphql
   * @deprecated Use filteredChannelChats instead, as this will return all items, causing performance issue
   */
  channelChats: Array<InboxChannelChat>;
  /** Refer: src/graphql/definitions/object/filtered-inbox-channel-chat.graphql */
  filteredChannelChats: FilteredInboxChannelChat;
  /** Refer: src/graphql/definitions/object/inbox-group-summary.graphql */
  general: InboxGroupSummary;
  totalUnreadCount: Scalars['Int'];
};

export type InfoFromBovaea = {
  __typename?: 'InfoFromBovaea';
  agency?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  updatedOn?: Maybe<Scalars['String']>;
};

export type InputActivePeriods = {
  /** Refer: src/graphql/definitions/input/active-periods-day.graphql */
  Friday?: InputMaybe<ActivePeriodsDay>;
  /** Refer: src/graphql/definitions/input/active-periods-day.graphql */
  Monday?: InputMaybe<ActivePeriodsDay>;
  /** Refer: src/graphql/definitions/input/active-periods-day.graphql */
  Saturday?: InputMaybe<ActivePeriodsDay>;
  /** Refer: src/graphql/definitions/input/active-periods-day.graphql */
  Sunday?: InputMaybe<ActivePeriodsDay>;
  /** Refer: src/graphql/definitions/input/active-periods-day.graphql */
  Thursday?: InputMaybe<ActivePeriodsDay>;
  /** Refer: src/graphql/definitions/input/active-periods-day.graphql */
  Tuesday?: InputMaybe<ActivePeriodsDay>;
  /** Refer: src/graphql/definitions/input/active-periods-day.graphql */
  Wednesday?: InputMaybe<ActivePeriodsDay>;
};

export type InputAgencyLimit = {
  agencyId: Scalars['String'];
  dailyMaximumPercentage: Scalars['Float'];
};

/** Only one of the properties should be defined */
export type InputAppScreen = {
  /** Refer: src/graphql/definitions/input/input-app-screen-didian-support.graphql */
  AppScreenDidianSupport?: InputMaybe<InputAppScreenDidianSupport>;
  /** Refer: src/graphql/definitions/input/input-app-screen-profile.graphql */
  AppScreenProfile?: InputMaybe<InputAppScreenProfile>;
  /** Refer: src/graphql/definitions/input/input-app-screen-profile-referee-invite.graphql */
  AppScreenProfileRefereeInvite?: InputMaybe<InputAppScreenProfileRefereeInvite>;
  /** Refer: src/graphql/definitions/input/input-app-screen-project.graphql */
  AppScreenProject?: InputMaybe<InputAppScreenProject>;
};

export type InputAppScreenDidianSupport = {
  messageSuggestions: Array<Scalars['String']>;
};

export type InputAppScreenProfile = {
  /** Refer: src/graphql/definitions/enum/app-screen-profile-focused-tab.graphql */
  focusedTab: AppScreenProfileFocusedTab;
};

export type InputAppScreenProfileRefereeInvite = {
  dummy?: InputMaybe<Scalars['String']>;
};

export type InputAppScreenProject = {
  dummy?: InputMaybe<Scalars['String']>;
};

export type InputAppointmentLetterCommissionTier = {
  lowerBoundaryInclusive: Scalars['Int'];
  percentage: Scalars['Float'];
};

export type InputArmCommissionSettings = {
  childProjectId?: InputMaybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/input/input-arm-commission-settings-period.graphql */
  periods?: InputMaybe<Array<InputArmCommissionSettingsPeriod>>;
  /** Refer: src/graphql/definitions/enum/input-arm-commission-settings-type.graphql */
  type: InputArmCommissionSettingsType;
};

export type InputArmCommissionSettingsAgency = {
  agencyId: Scalars['String'];
  pooling?: InputMaybe<Scalars['Boolean']>;
};

export type InputArmCommissionSettingsPeriod = {
  armIds: Array<Scalars['String']>;
  from?: InputMaybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/input/input-arm-commission-settings-period-group.graphql */
  groups: Array<InputArmCommissionSettingsPeriodGroup>;
  tierSalesIncludeProjects: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/input/input-arm-commission-settings-period-tier.graphql */
  tiers: Array<InputArmCommissionSettingsPeriodTier>;
  to?: InputMaybe<Scalars['String']>;
};

export type InputArmCommissionSettingsPeriodGroup = {
  /** Refer: src/graphql/definitions/input/input-arm-commission-settings-agency.graphql */
  agencies?: InputMaybe<Array<InputArmCommissionSettingsAgency>>;
  amount: Scalars['Float'];
  groupName?: InputMaybe<Scalars['String']>;
};

export type InputArmCommissionSettingsPeriodTier = {
  fromInclusive: Scalars['Float'];
  id: Scalars['String'];
  percentage: Scalars['Float'];
  toInclusive: Scalars['Float'];
};

export enum InputArmCommissionSettingsType {
  FollowOtherProject = 'follow_other_project',
  SelfDefined = 'self_defined'
}

export type InputAttachedFile = {
  /** Refer: src/graphql/definitions/input/input-attached-file-uploaded.graphql */
  attached?: InputMaybe<InputAttachedFileUploaded>;
  id: Scalars['String'];
};

export type InputAttachedFileUploaded = {
  by: Scalars['String'];
  on: Scalars['String'];
};

export type InputAttendeesLimit = {
  maximumNumber: Scalars['Int'];
  minimumNumber: Scalars['Int'];
};

export type InputBuyerIncomeType = {
  /** Refer: src/graphql/definitions/input/input-buyer-income-type-commission-earner.graphql */
  commissionEarner?: InputMaybe<InputBuyerIncomeTypeCommissionEarner>;
  /** Refer: src/graphql/definitions/input/input-buyer-income-type-fixed-income.graphql */
  fixedIncome?: InputMaybe<InputBuyerIncomeTypeFixedIncome>;
  /** Refer: src/graphql/definitions/input/input-buyer-income-type-self-employed.graphql */
  selfEmployed?: InputMaybe<InputBuyerIncomeTypeSelfEmployed>;
};

export type InputBuyerIncomeTypeCommissionEarner = {
  dummy?: InputMaybe<Scalars['String']>;
};

export type InputBuyerIncomeTypeFixedIncome = {
  dummy?: InputMaybe<Scalars['String']>;
};

export type InputBuyerIncomeTypeSelfEmployed = {
  dummy?: InputMaybe<Scalars['String']>;
};

export type InputChildProjectCommissionSettings = {
  commencementDate?: InputMaybe<Scalars['String']>;
  developerCommissionSstInclusive: Scalars['Boolean'];
  /** real number between 0 and 100 */
  developerPercentage: Scalars['Float'];
  expiryDate?: InputMaybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/input/input-loan-transaction-commission-portion.graphql */
  loanTransactionCommissionPortion?: InputMaybe<Array<InputLoanTransactionCommissionPortion>>;
  /** real number between 0 and 100 */
  taxPercentage: Scalars['Float'];
  taxPercentageDontAffectNetCommission: Scalars['Boolean'];
};

export type InputColor = {
  alpha: Scalars['Float'];
  blue: Scalars['Float'];
  green: Scalars['Float'];
  red: Scalars['Float'];
};

export type InputCommissionPaymentDelayReason = {
  invoiceId: Scalars['ID'];
  reason: Scalars['String'];
};

export type InputCoordinate = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type InputCreateNotificationChannelAgencyTeam = {
  agencyTeamId: Scalars['String'];
};

export type InputCreateNotificationChannelAgentCooperation = {
  agentCooperationId: Scalars['String'];
};

export type InputCreateNotificationChannelGeneralSupport = {
  userId: Scalars['String'];
};

export type InputCreateNotificationChannelPrivate = {
  userId1: Scalars['String'];
  userId2: Scalars['String'];
};

export type InputCreateNotificationChannelProjectAgencyTeam = {
  agencyTeamId: Scalars['String'];
  parentProjectId: Scalars['String'];
};

export type InputCreateNotificationChannelProjectAgent = {
  parentProjectId: Scalars['String'];
};

export type InputCreateNotificationChannelProjectAgentGpt = {
  parentProjectId: Scalars['String'];
};

export type InputCreatePopupAd = {
  /** Refer: src/graphql/definitions/input/input-create-popup-ad-active-period.graphql */
  activePeriod: InputCreatePopupAdActivePeriod;
  /** Refer: src/graphql/definitions/input/input-app-screen.graphql */
  appScreen?: InputMaybe<InputAppScreen>;
  appScreenRedirectButtonLabel?: InputMaybe<Scalars['String']>;
  body: Scalars['String'];
  externalUrl?: InputMaybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/input/upload.graphql */
  file: Upload;
  title: Scalars['String'];
};

export type InputCreatePopupAdActivePeriod = {
  endDateTime: Scalars['String'];
  startDateTime: Scalars['String'];
};

export type InputDdnAppreciationRate = {
  appreciationRate: Scalars['Float'];
  year: Scalars['Int'];
};

export type InputDeveloperCommissionBatch = {
  _id: Scalars['String'];
  expression?: InputMaybe<Scalars['String']>;
  fixedAmount?: InputMaybe<Scalars['Float']>;
  paidOn: Scalars['String'];
  percentage?: InputMaybe<Scalars['Float']>;
  sstInclusive: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/enum/input-developer-commission-batch-type.graphql */
  type: InputDeveloperCommissionBatchType;
};

export type InputDeveloperCommissionBatch2 = {
  developerCommissionStageId?: InputMaybe<Scalars['ID']>;
  expression?: InputMaybe<Scalars['String']>;
  fixedAmount?: InputMaybe<Scalars['Float']>;
  paidOn: Scalars['String'];
  /** 0 - 100 */
  percentage?: InputMaybe<Scalars['Float']>;
  sstInclusive: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/enum/input-developer-commission-batch-type.graphql */
  type: InputDeveloperCommissionBatchType;
};

export enum InputDeveloperCommissionBatchType {
  Expression = 'EXPRESSION',
  FixedAmount = 'FIXED_AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type InputDeveloperCommissionSettingPeriod = {
  commencementDate?: InputMaybe<Scalars['Date']>;
  expiryDate?: InputMaybe<Scalars['Date']>;
  projectUnitIds?: InputMaybe<Array<Scalars['ID']>>;
  sstInclusive: Scalars['Boolean'];
};

export type InputDeveloperCommissionSettingPeriodStage = {
  expression: Scalars['String'];
  name: Scalars['String'];
};

export type InputDisplayPopupAd = {
  popupAdId: Scalars['String'];
};

export type InputDisplayProjectSalesPeriod = {
  endDateTime: Scalars['String'];
  startDateTime: Scalars['String'];
};

export type InputEstoreProjectTeaserColors = {
  primary: Scalars['String'];
  secondary: Scalars['String'];
};

export type InputEstoreProjectTeaserDescription = {
  /** Refer: src/graphql/definitions/input/input-estore-project-teaser-sections.graphql */
  sections: Array<InputEstoreProjectTeaserSections>;
  text: Scalars['String'];
  title: Scalars['String'];
};

export type InputEstoreProjectTeaserSections = {
  image: Scalars['ID'];
  text: Scalars['String'];
  title: Scalars['String'];
};

/** Only either one of the fields can be defined. */
export type InputGraphQlMutationCustomPdfCustomBackground = {
  /** Refer: src/graphql/definitions/input/input-graph-ql-mutation-custom-pdf-custom-background-image.graphql */
  image?: InputMaybe<InputGraphQlMutationCustomPdfCustomBackgroundImage>;
  /** Refer: src/graphql/definitions/input/input-graph-ql-mutation-custom-pdf-custom-background-shape.graphql */
  shape?: InputMaybe<InputGraphQlMutationCustomPdfCustomBackgroundShape>;
};

export type InputGraphQlMutationCustomPdfCustomBackgroundImage = {
  /** Refer: src/graphql/definitions/input/background.graphql */
  image: Background;
};

export type InputGraphQlMutationCustomPdfCustomBackgroundShape = {
  /** Refer: src/graphql/definitions/input/graph-ql-mutation-field-mapping.graphql */
  shape: GraphQlMutationFieldMapping;
};

export type InputJma = {
  agencyId: Scalars['String'];
  otherAgencyIds?: InputMaybe<Array<Scalars['String']>>;
  /** User IDs */
  personsInCharge: Array<Scalars['String']>;
};

export type InputLoanTransactionCommissionPortion = {
  name: Scalars['String'];
  percentage: Scalars['Float'];
};

export type InputOptions = {
  endDateTime?: InputMaybe<Scalars['String']>;
  notCancelled?: InputMaybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/enum/schedule-type.graphql */
  type?: InputMaybe<ScheduleType>;
};

export type InputPostlaunchForm = {
  bankerAssignmentPreference?: InputMaybe<Scalars['Boolean']>;
  childProjectId: Scalars['ID'];
  companyAddress: Scalars['Boolean'];
  companyName: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/input/input-postlaunch-form-custom-field.graphql */
  customFields: Array<InputPostlaunchFormCustomField>;
  epfContribution: Scalars['Boolean'];
  howDoYouKnowAboutUs: Scalars['Boolean'];
  paymentProof: Scalars['Boolean'];
  repeatBuyer: Scalars['Boolean'];
  signature: Scalars['Boolean'];
};

export type InputPostlaunchFormCustomField = {
  /** Refer: src/graphql/definitions/input/input-postlaunch-form-custom-field-choice.graphql */
  choice?: InputMaybe<InputPostlaunchFormCustomFieldChoice>;
  /**
   * one and only one of the properties must be defined
   * Refer: src/graphql/definitions/input/input-postlaunch-form-custom-field-text.graphql
   */
  text?: InputMaybe<InputPostlaunchFormCustomFieldText>;
};

export type InputPostlaunchFormCustomFieldChoice = {
  choices: Array<Scalars['String']>;
  index: Scalars['Int'];
  isMultiChoice: Scalars['Boolean'];
  question: Scalars['String'];
  selected: Scalars['Boolean'];
};

export type InputPostlaunchFormCustomFieldText = {
  index: Scalars['Int'];
  question: Scalars['String'];
  selected: Scalars['Boolean'];
};

export type InputProjectAgentCooperation = {
  /** Refer: src/graphql/definitions/input/input-project-agent-cooperation-closing-agent-team.graphql */
  closingAgentTeams: Array<InputProjectAgentCooperationClosingAgentTeam>;
  enabled: Scalars['Boolean'];
  leadPercentage: Scalars['Float'];
};

export type InputProjectAgentCooperationClosingAgentTeam = {
  teamId: Scalars['String'];
};

export type InputProjectCategory = {
  description: Scalars['String'];
  name: Scalars['String'];
  projectIds: Array<Scalars['String']>;
};

export type InputProjectCommissionSettings = {
  /** Refer: src/graphql/definitions/input/input-jma.graphql */
  jmas: Array<InputJma>;
};

export type InputProjectCommissionTncFee = {
  description: Scalars['String'];
  expression: Scalars['String'];
};

export type InputProjectCommissionTncPortion = {
  /** 0 = 0%, 1 = 100% */
  percentage: Scalars['Float'];
  type: Scalars['String'];
};

export type InputProjectCommissionTncTier = {
  lowerBoundaryInclusive: Scalars['Int'];
  /** 0 = 0%, 1 = 100% */
  percentage: Scalars['Float'];
};

export type InputProjectCommissionTncVersion = {
  commencementDate: Scalars['Date'];
  /** Refer: src/graphql/definitions/input/input-project-commission-tnc-portion.graphql */
  commissionPortions: Array<InputProjectCommissionTncPortion>;
  /** Refer: src/graphql/definitions/input/input-project-commission-tnc-tier.graphql */
  commissionTiers: Array<InputProjectCommissionTncTier>;
  endDate?: InputMaybe<Scalars['Date']>;
  /** Refer: src/graphql/definitions/input/input-project-commission-tnc-fee.graphql */
  fees?: InputMaybe<Array<InputProjectCommissionTncFee>>;
  /** Refer: src/graphql/definitions/input/input-project-commission-tnc-portion.graphql */
  personalBankerCommissionPortions?: InputMaybe<Array<InputProjectCommissionTncPortion>>;
  template: Scalars['String'];
  /**
   * Default value is THRESHOLD_DETERMINED_BY_AGENCY_SALES__WITHOUT_RETROS
   * Refer: src/graphql/definitions/enum/project-commission-tnc-tier-mode.graphql
   */
  tierMode?: InputMaybe<ProjectCommissionTncTierMode>;
};

export type InputProjectInquirySort = {
  asc: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/enum/project-inquiry-column.graphql */
  column?: InputMaybe<ProjectInquiryColumn>;
};

export type InputProjectLayout = {
  floor: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/input/input-project-unit-plan.graphql */
  plan: Array<Array<InputProjectUnitPlan>>;
  view: Array<Scalars['String']>;
};

export type InputProjectLocation = {
  /** Refer: src/graphql/definitions/input/input-project-location-coordinates.graphql */
  coordinates: InputProjectLocationCoordinates;
  name: Scalars['String'];
};

export type InputProjectLocationCoordinates = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type InputProjectTag = {
  color?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type InputProjectUnit = {
  grossPrice: Scalars['Float'];
  type: Scalars['String'];
  unitNum: Scalars['String'];
};

/**
 * Input for booking method of project unit.
 * Please specify only 1 property.
 */
export type InputProjectUnitBookingMethod = {
  /** Refer: src/graphql/definitions/input/input-project-unit-booking-method-ad-hoc.graphql */
  adHoc?: InputMaybe<InputProjectUnitBookingMethodAdHoc>;
  /** Refer: src/graphql/definitions/input/input-project-unit-booking-method-exclusive.graphql */
  exclusive?: InputMaybe<InputProjectUnitBookingMethodExclusive>;
  /** Refer: src/graphql/definitions/input/input-project-unit-booking-method-semi-exclusive.graphql */
  semiExclusive?: InputMaybe<InputProjectUnitBookingMethodSemiExclusive>;
};

export type InputProjectUnitBookingMethodAdHoc = {
  dummy: Scalars['String'];
};

export type InputProjectUnitBookingMethodExclusive = {
  dummy: Scalars['String'];
};

export type InputProjectUnitBookingMethodSemiExclusive = {
  dummy: Scalars['String'];
};

export type InputProjectUnitPlan = {
  type: Scalars['String'];
  unitId?: InputMaybe<Scalars['String']>;
};

export type InputRequestCommissionPayoutClaim = {
  /** Refer: src/graphql/definitions/input/input-request-commission-payout-claim-transaction.graphql */
  transactions: Array<InputRequestCommissionPayoutClaimTransaction>;
};

export type InputRequestCommissionPayoutClaimTransaction = {
  /** Refer: src/graphql/definitions/input/input-request-commission-payout-claim-transaction-agent.graphql */
  agents: Array<InputRequestCommissionPayoutClaimTransactionAgent>;
  childProjectId: Scalars['String'];
  childProjectName: Scalars['String'];
  currentPeriodTotalSales?: InputMaybe<Scalars['Float']>;
  parentProjectId: Scalars['String'];
  parentProjectName: Scalars['String'];
  tierFromInclusive?: InputMaybe<Scalars['Float']>;
  tierId?: InputMaybe<Scalars['String']>;
  tierPercentage?: InputMaybe<Scalars['Float']>;
  tierToInclusive?: InputMaybe<Scalars['Float']>;
  transactionId: Scalars['String'];
  unitNum: Scalars['String'];
};

export type InputRequestCommissionPayoutClaimTransactionAgent = {
  actualClaimableCommissionAmount: Scalars['Float'];
  agencyId: Scalars['String'];
  agencyName: Scalars['String'];
  agencyType?: InputMaybe<Scalars['String']>;
  agentId: Scalars['String'];
  fullName: Scalars['String'];
  maxClaimableCommissionAmount: Scalars['Float'];
  /** Refer: src/graphql/definitions/input/input-request-commission-payout-claim-transaction-agent-pooled-to.graphql */
  pooledTo: Array<InputRequestCommissionPayoutClaimTransactionAgentPooledTo>;
  whitelistItemId: Scalars['String'];
  whitelistedByFullname: Scalars['String'];
  whitelistedById: Scalars['String'];
  whitelistedOn: Scalars['String'];
};

export type InputRequestCommissionPayoutClaimTransactionAgentPooledTo = {
  fullName: Scalars['String'];
  id: Scalars['String'];
};

export type InputReward = {
  price: Scalars['Float'];
  /** Refer: src/graphql/definitions/input/input-reward-secret.graphql */
  secret: InputRewardSecret;
};

export type InputRewardSecret = {
  /** Refer: src/graphql/definitions/enum/input-reward-type.graphql */
  type: InputRewardType;
  value: Scalars['String'];
};

export enum InputRewardType {
  Pin = 'pin',
  Url = 'url'
}

export type InputSbuProject = {
  childProjectIds: Array<Scalars['ID']>;
  developerCommissionRate: Scalars['Float'];
  estimatedAverageNettSellingPrice: Scalars['Float'];
  name: Scalars['String'];
  sbuHeadId: Scalars['ID'];
};

export type InputSbuProjectBudget = {
  budgetedBookings: Scalars['Int'];
  budgetedSignings: Scalars['Int'];
  endDateTime: Scalars['Date'];
  sbuProjectId: Scalars['ID'];
  startDateTime: Scalars['Date'];
};

export type InputSbuProjectMarketingExpense = {
  amount: Scalars['Float'];
  dateTime: Scalars['Date'];
  description: Scalars['String'];
  sbuProjectId: Scalars['ID'];
};

export type InputSearchByDeveloperCommissionBatch = {
  developerCommissionBatchId: Scalars['ID'];
  /** Refer: src/graphql/definitions/enum/search-by-developer-commission-batch-id-type.graphql */
  type: SearchByDeveloperCommissionBatchIdType;
};

export type InputSelectOutsourceBankerDetail = {
  bankId: Scalars['ID'];
  fullName: Scalars['String'];
  mobileNum: Scalars['String'];
};

export type InputSelectStaffLoanDetail = {
  /**
   * Three possible states:
   * - If both companyId & newCompanyName are undefined, then fallback to LPPSA.
   * - If companyId is defined, existing company will be used.
   * - If newCompanyName is defined, a new company will be created with the new name.
   */
  companyId?: InputMaybe<Scalars['ID']>;
  fullName: Scalars['String'];
  mobileNum: Scalars['String'];
  newCompanyName?: InputMaybe<Scalars['String']>;
};

export type InputServiceFeeFormula = {
  afterSalesManagement: Scalars['String'];
  agenciesManagement: Scalars['String'];
  marketingServices: Scalars['String'];
  platformServices: Scalars['String'];
};

export type InputSupportPersonnel = {
  userId: Scalars['String'];
};

export type InputTaggedUpload = {
  /** Refer: src/graphql/definitions/input/upload.graphql */
  file: Upload;
  /** Refer: src/graphql/definitions/enum/uploaded-file-tag.graphql */
  tags: Array<UploadedFileTag>;
};

export type InputTransactionSourceOfFinance = {
  /** Refer: src/graphql/definitions/input/input-transaction-source-of-finance-cash.graphql */
  cash?: InputMaybe<InputTransactionSourceOfFinanceCash>;
  /** Refer: src/graphql/definitions/input/input-transaction-source-of-finance-commercial-bank.graphql */
  commercialBank?: InputMaybe<InputTransactionSourceOfFinanceCommercialBank>;
  /** Refer: src/graphql/definitions/input/input-transaction-source-of-finance-company-staff-loan.graphql */
  companyStaffLoan?: InputMaybe<InputTransactionSourceOfFinanceCompanyStaffLoan>;
  /** Refer: src/graphql/definitions/input/input-transaction-source-of-finance-lppsa-staff-loan.graphql */
  lppsaStaffLoan?: InputMaybe<InputTransactionSourceOfFinanceLppsaStaffLoan>;
};

export type InputTransactionSourceOfFinanceCash = {
  dummy?: InputMaybe<Scalars['String']>;
};

export type InputTransactionSourceOfFinanceCommercialBank = {
  marginOfFinance: Scalars['Float'];
};

export type InputTransactionSourceOfFinanceCompanyStaffLoan = {
  marginOfFinance: Scalars['Float'];
};

export type InputTransactionSourceOfFinanceLppsaStaffLoan = {
  marginOfFinance: Scalars['Float'];
};

export type InputTransactionStatus = {
  /** Refer: src/graphql/definitions/enum/transaction-cancellation-status.graphql */
  cancellation: TransactionCancellationStatus;
  /** Refer: src/graphql/definitions/enum/transaction-financial-status.graphql */
  financial: TransactionFinancialStatus;
  /** Refer: src/graphql/definitions/enum/transaction-spa-status.graphql */
  spa: TransactionSpaStatus;
};

export type InputUpdateEntitlementImage = {
  discountId: Scalars['String'];
  /** Refer: src/graphql/definitions/input/upload.graphql */
  image?: InputMaybe<Upload>;
};

export type InputUpdatePopupAd = {
  /** Refer: src/graphql/definitions/input/input-create-popup-ad-active-period.graphql */
  activePeriod?: InputMaybe<InputCreatePopupAdActivePeriod>;
  /** Refer: src/graphql/definitions/input/input-app-screen.graphql */
  appScreen?: InputMaybe<InputAppScreen>;
  appScreenRedirectButtonLabel?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  externalUrl?: InputMaybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/input/upload.graphql */
  file?: InputMaybe<Upload>;
  live?: InputMaybe<Scalars['Boolean']>;
  popupAdId: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type InputVerifyBookingDocumentCollectionMethod = {
  /** Refer: src/graphql/definitions/input/verify-booking-document-collection-method-express.graphql */
  express?: InputMaybe<VerifyBookingDocumentCollectionMethodExpress>;
  /** Refer: src/graphql/definitions/input/verify-booking-document-collection-method-manual.graphql */
  manual?: InputMaybe<VerifyBookingDocumentCollectionMethodManual>;
};

export type InventoryPostlaunchStat = {
  __typename?: 'InventoryPostlaunchStat';
  developerRegistrations: Scalars['Int'];
  didianRegistrations: Scalars['Int'];
};

export type InventoryPrelaunchStat = {
  __typename?: 'InventoryPrelaunchStat';
  /** Refer: src/graphql/definitions/object/inventory-prelaunch-stat-by-unit-types.graphql */
  unitTypes: Array<InventoryPrelaunchStatByUnitTypes>;
};

export type InventoryPrelaunchStatByUnitTypes = {
  __typename?: 'InventoryPrelaunchStatByUnitTypes';
  availableUnits: Scalars['Int'];
  developerRegistrations: Scalars['Int'];
  didianRegistrations: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/project-unit-mix.graphql */
  info: ProjectUnitMix;
};

export type InventoryStats = {
  __typename?: 'InventoryStats';
  /** Refer: src/graphql/definitions/object/inventory-stats-info-post-launch.graphql */
  inventoryStatsInfoPostLaunch: Array<InventoryStatsInfoPostLaunch>;
  /** Refer: src/graphql/definitions/object/inventory-postlaunch-stat.graphql */
  postlaunchStats: InventoryPostlaunchStat;
  /** Refer: src/graphql/definitions/object/inventory-prelaunch-stat.graphql */
  prelaunchStats: InventoryPrelaunchStat;
  /**
   * Only applicable for post launch projects. Because during prelaunch there is not unit chart yet.
   * Refer: src/graphql/definitions/object/unit-stat.graphql
   * @deprecated Use inventoryStatsInfoPostLaunch instead due to performance issues
   */
  unitStats: Array<UnitStat>;
};

export type InventoryStatsInfoPostLaunch = {
  __typename?: 'InventoryStatsInfoPostLaunch';
  columnLabel: Scalars['String'];
  /** Refer: src/graphql/definitions/object/inventory-stats-info-post-launch-stat.graphql */
  stats: Array<InventoryStatsInfoPostLaunchStat>;
};

export type InventoryStatsInfoPostLaunchStat = {
  __typename?: 'InventoryStatsInfoPostLaunchStat';
  label: Scalars['String'];
  soldQuantity: Scalars['Int'];
  unsoldQuantity: Scalars['Int'];
};

export type InvoiceRequestCustomisation = {
  __typename?: 'InvoiceRequestCustomisation';
  bookingDateEnd?: Maybe<Scalars['Date']>;
  bookingDateStart?: Maybe<Scalars['Date']>;
  /** Refer: src/graphql/definitions/object/agency.graphql */
  childDeveloper: Agency;
  companyAddress: Scalars['String'];
  companyName: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
  sstNumber: Scalars['String'];
};

export type InvoiceRequestDelayReason = {
  __typename?: 'InvoiceRequestDelayReason';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['String'];
  id: Scalars['ID'];
  reason: Scalars['String'];
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  transaction: Transaction;
};

export type Jma = {
  __typename?: 'JMA';
  /**
   * The main agencies
   * Refer: src/graphql/definitions/object/agency.graphql
   */
  agency: Agency;
  /**
   * Other agencies that are also controlled by the personsInCharge
   * Refer: src/graphql/definitions/object/agency.graphql
   */
  otherAgencies: Array<Agency>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  personsInCharge: Array<User>;
};

export type JoinTeamRequest = {
  __typename?: 'JoinTeamRequest';
  /** Refer: src/graphql/definitions/object/user.graphql */
  approvedBy?: Maybe<User>;
  approvedOn?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  cancelledBy?: Maybe<User>;
  cancelledOn?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  rejectedBy?: Maybe<User>;
  rejectedOn?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  requestedBy?: Maybe<User>;
  requestedOn: Scalars['String'];
  /** Refer: src/graphql/definitions/object/agency-team.graphql */
  team?: Maybe<AgencyTeam>;
  type: Scalars['String'];
};

export type KpktProject = {
  __typename?: 'KpktProject';
  developerName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  minimumPrice?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  startDate?: Maybe<Scalars['Date']>;
  /** Refer: src/graphql/definitions/enum/kpkt-project-status.graphql */
  status: KpktProjectStatus;
  /** Refer: src/graphql/definitions/object/kpkt-project-unit-type.graphql */
  unitTypes: Array<KpktProjectUnitType>;
};

export enum KpktProjectStatus {
  Completed = 'COMPLETED',
  Ill = 'ILL',
  Late = 'LATE',
  NotPermitted = 'NOT_PERMITTED',
  NotStarted = 'NOT_STARTED',
  Ongoing = 'ONGOING'
}

export type KpktProjectUnitType = {
  __typename?: 'KpktProjectUnitType';
  amount?: Maybe<Scalars['Int']>;
  buildSize?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  maximumPrice?: Maybe<Scalars['Float']>;
  minimumPrice?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
};

export type LaunchPortal = {
  __typename?: 'LaunchPortal';
  /** Refer: src/graphql/definitions/object/launch-portal-display-price-chart.graphql */
  displayPriceChart: LaunchPortalDisplayPriceChart;
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  displayProjectUnit: ProjectUnit;
};


export type LaunchPortalDisplayPriceChartArgs = {
  childProjectSlug: Scalars['String'];
};


export type LaunchPortalDisplayProjectUnitArgs = {
  id: Scalars['ID'];
};

export type LaunchPortalDisplayPriceChart = {
  __typename?: 'LaunchPortalDisplayPriceChart';
  childProjectId: Scalars['ID'];
  title: Scalars['String'];
  /** Refer: src/graphql/definitions/union/project-unit-layout.graphql */
  unitLayout: ProjectUnitLayout;
};

export enum LaunchStatus {
  PostLaunch = 'postLaunch',
  PreLaunch = 'preLaunch'
}

export type Lawyer = {
  __typename?: 'Lawyer';
  /** Refer: src/graphql/definitions/object/user-address.graphql */
  addresses?: Maybe<Array<UserAddress>>;
  /**
   * Refer: src/graphql/definitions/object/user-contact.graphql
   * @deprecated use mobileNum, email, emailIsVerified instead.
   */
  contacts?: Maybe<Array<UserContact>>;
  createdOn: Scalars['String'];
  displayName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  emailIsVerified?: Maybe<Scalars['Boolean']>;
  fullName: Scalars['String'];
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/user-lawyer-info.graphql */
  lawyerInfo?: Maybe<UserLawyerInfo>;
  mobileNum?: Maybe<Scalars['String']>;
  nric?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  nricCopiesBack: Array<UploadedFile>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  nricCopiesFront: Array<UploadedFile>;
};

export type LayoutHighrise = {
  __typename?: 'LayoutHighrise';
  floor: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/project-unit-layout-legends.graphql */
  legends: ProjectUnitLayoutLegends;
  /** Refer: src/graphql/definitions/object/project-layout-high-rise-structure.graphql */
  plan: Array<Array<ProjectLayoutHighRiseStructure>>;
  view: Array<Scalars['String']>;
};

export type LayoutHighriseOverview = {
  __typename?: 'LayoutHighriseOverview';
  dummy?: Maybe<Scalars['String']>;
};

export type LayoutLanded = {
  __typename?: 'LayoutLanded';
  /** Height of the SVG viewbox on the LayoutLandedOverview. */
  height: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/project-unit-layout-legends.graphql */
  legends: ProjectUnitLayoutLegends;
  /**
   * This points back to the parent overview.
   * Refer: src/graphql/definitions/object/layout-landed-overview.graphql
   */
  overview: LayoutLandedOverview;
  /**
   * For compass to points to actual North, should be the same as that of parent
   * overview.
   */
  rotation: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/project-layout-landed-structure.graphql */
  structures: Array<ProjectLayoutLandedStructure>;
  /** Refer: src/graphql/definitions/union/svg.graphql */
  svgs: Array<Svg>;
  /** Width of the SVG viewbox on the LayoutLandedOverview. */
  width: Scalars['Float'];
  /** x-coordinate of the SVG viewbox on the LayoutLandedOverview. */
  x: Scalars['Float'];
  /** y-coordinate of the SVG viewbox on the LayoutLandedOverview. */
  y: Scalars['Float'];
  /**
   * This only contains zones within this layout.
   * Refer: src/graphql/definitions/object/project-layout-zone.graphql
   */
  zone: Array<ProjectLayoutZone>;
};

export type LayoutLandedOverview = {
  __typename?: 'LayoutLandedOverview';
  height: Scalars['Float'];
  /** For compass to points to actual North. */
  rotation: Scalars['Float'];
  /** Refer: src/graphql/definitions/union/svg.graphql */
  svgs: Array<Svg>;
  width: Scalars['Float'];
  /**
   * This contains all the zones of all layouts.
   * Refer: src/graphql/definitions/object/project-layout-zone.graphql
   */
  zone: Array<ProjectLayoutZone>;
};

export enum LayoutType {
  HighRise = 'HIGH_RISE',
  Landed = 'LANDED'
}

export type LeadsAssignedStat = {
  __typename?: 'LeadsAssignedStat';
  /** Refer: src/graphql/definitions/object/user.graphql */
  arm?: Maybe<User>;
  numberOfLeadsAssigned: Scalars['Int'];
};

export type LoanResultRequest = {
  appliedSpaDiscountIds?: InputMaybe<Array<Scalars['ID']>>;
  approved: Scalars['Boolean'];
  loanId: Scalars['String'];
  loanPercentage?: InputMaybe<Scalars['Float']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type Log = {
  __typename?: 'Log';
  error?: Maybe<Scalars['String']>;
};

export type ManageAgencyGroup = {
  __typename?: 'ManageAgencyGroup';
  /** Refer: src/graphql/definitions/object/agency-group-child-agency.graphql */
  addChildAgency: AgencyGroupChildAgency;
  /** Refer: src/graphql/definitions/object/agency-group-email.graphql */
  addEmail: AgencyGroupEmail;
  /** Refer: src/graphql/definitions/object/agency-group-pic.graphql */
  addPic: AgencyGroupPic;
  /** Refer: src/graphql/definitions/object/agency-group-child-agency.graphql */
  deleteChildAgency: AgencyGroupChildAgency;
  /** Refer: src/graphql/definitions/object/agency-group-email.graphql */
  deleteEmail: AgencyGroupEmail;
  /** Refer: src/graphql/definitions/object/agency-group-pic.graphql */
  deletePic: AgencyGroupPic;
  /** Refer: src/graphql/definitions/object/agency-group-parent-agency.graphql */
  updateParentAgency: AgencyGroupParentAgency;
};


export type ManageAgencyGroupAddChildAgencyArgs = {
  childAgencyId: Scalars['ID'];
  id: Scalars['ID'];
};


export type ManageAgencyGroupAddEmailArgs = {
  email: Scalars['String'];
  id: Scalars['ID'];
};


export type ManageAgencyGroupAddPicArgs = {
  id: Scalars['ID'];
  picId: Scalars['ID'];
};


export type ManageAgencyGroupDeleteChildAgencyArgs = {
  id: Scalars['ID'];
};


export type ManageAgencyGroupDeleteEmailArgs = {
  id: Scalars['ID'];
};


export type ManageAgencyGroupDeletePicArgs = {
  id: Scalars['ID'];
};


export type ManageAgencyGroupUpdateParentAgencyArgs = {
  id: Scalars['ID'];
  parentAgencyId: Scalars['ID'];
};

export type ManageAgencyTeam = {
  __typename?: 'ManageAgencyTeam';
  /**
   * Transfer the team members' transaction agent records that are not under the
   * team to the team.
   */
  transferAllTransactionAgents: Scalars['Boolean'];
  /** Transfer the selected transaction agents to destination team. */
  transferSelectedTransactionAgents: Scalars['Boolean'];
};


export type ManageAgencyTeamTransferAllTransactionAgentsArgs = {
  destinationTeamId: Scalars['ID'];
};


export type ManageAgencyTeamTransferSelectedTransactionAgentsArgs = {
  destinationTeamId: Scalars['ID'];
  transactionAgentIds: Array<Scalars['ID']>;
};

export type ManageAgencyTeamMember = {
  __typename?: 'ManageAgencyTeamMember';
  removeWhitelist: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/whitelist-item.graphql */
  whitelistTeamMember: WhitelistItem;
};


export type ManageAgencyTeamMemberRemoveWhitelistArgs = {
  id: Scalars['ID'];
};


export type ManageAgencyTeamMemberWhitelistTeamMemberArgs = {
  parentProjectId: Scalars['ID'];
  teamMemberId: Scalars['ID'];
};

export type ManageAgencyTeamProjectInquiry = {
  __typename?: 'ManageAgencyTeamProjectInquiry';
  /** Refer: src/graphql/definitions/object/project-inquiry.graphql */
  updateToNoActionRequired: Array<ProjectInquiry>;
};

export type ManageArrayUpload = {
  __typename?: 'ManageArrayUpload';
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  add: Array<UploadedFile>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  delete: UploadedFile;
};


export type ManageArrayUploadAddArgs = {
  uploads: Array<Upload>;
};


export type ManageArrayUploadDeleteArgs = {
  uploadedFileId: Scalars['ID'];
};

export type ManageDeveloperCommission = {
  __typename?: 'ManageDeveloperCommission';
  /** Refer: src/graphql/definitions/object/manage-developer-commission-batch.graphql */
  batch: ManageDeveloperCommissionBatch;
  /** Refer: src/graphql/definitions/object/manage-developer-commission-invoice.graphql */
  invoice: ManageDeveloperCommissionInvoice;
  /** Refer: src/graphql/definitions/object/manage-developer-commission-receipt.graphql */
  receipt: ManageDeveloperCommissionReceipt;
  /** Refer: src/graphql/definitions/object/manage-developer-commission-setting.graphql */
  setting: ManageDeveloperCommissionSetting;
  /** Refer: src/graphql/definitions/object/manage-developer-commission-stage.graphql */
  stage: ManageDeveloperCommissionStage;
  /** Refer: src/graphql/definitions/object/manage-developer-commission-transaction.graphql */
  transaction: ManageDeveloperCommissionTransaction;
  /** Refer: src/graphql/definitions/object/manage-developer-commission-transaction-nett-price.graphql */
  transactionNettPrice: ManageDeveloperCommissionTransactionNettPrice;
  /** Refer: src/graphql/definitions/object/upload-fdb-file-report.graphql */
  uploadFdbFile: UploadFdbFileReport;
};


export type ManageDeveloperCommissionUploadFdbFileArgs = {
  fdb: Upload;
  testing?: InputMaybe<Scalars['Boolean']>;
};

export type ManageDeveloperCommissionBatch = {
  __typename?: 'ManageDeveloperCommissionBatch';
  /** Refer: src/graphql/definitions/object/developer-commission-batch.graphql */
  add: DeveloperCommissionBatch;
  /** Refer: src/graphql/definitions/object/developer-commission-batch.graphql */
  delete: DeveloperCommissionBatch;
  /** Refer: src/graphql/definitions/object/developer-commission-batch.graphql */
  removeAllTransactions: DeveloperCommissionBatch;
  /** Refer: src/graphql/definitions/object/developer-commission-batch.graphql */
  update: DeveloperCommissionBatch;
};


export type ManageDeveloperCommissionBatchAddArgs = {
  batch: InputDeveloperCommissionBatch2;
  parentProjectId: Scalars['ID'];
};


export type ManageDeveloperCommissionBatchDeleteArgs = {
  id: Scalars['ID'];
};


export type ManageDeveloperCommissionBatchRemoveAllTransactionsArgs = {
  developerCommissionBatchId: Scalars['ID'];
};


export type ManageDeveloperCommissionBatchUpdateArgs = {
  batch: InputDeveloperCommissionBatch2;
  id: Scalars['ID'];
};

export type ManageDeveloperCommissionInvoice = {
  __typename?: 'ManageDeveloperCommissionInvoice';
  /** Upload developer commission invoice in CSV format */
  uploadCsv: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/csv-column.graphql */
  uploadCsvColumns: Array<CsvColumn>;
};


export type ManageDeveloperCommissionInvoiceUploadCsvArgs = {
  csv: Upload;
};

export type ManageDeveloperCommissionReceipt = {
  __typename?: 'ManageDeveloperCommissionReceipt';
  /**
   * Upload developer commission receipt in CSV format:
   * ```
   * Header = or_id,date
   * Date format = dd/mm/yyyy
   * ```
   */
  uploadCsv: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/csv-column.graphql */
  uploadCsvColumns: Array<CsvColumn>;
};


export type ManageDeveloperCommissionReceiptUploadCsvArgs = {
  csv: Upload;
};

export type ManageDeveloperCommissionSetting = {
  __typename?: 'ManageDeveloperCommissionSetting';
  /** Refer: src/graphql/definitions/object/manage-developer-commission-setting-period.graphql */
  period: ManageDeveloperCommissionSettingPeriod;
};

export type ManageDeveloperCommissionSettingPeriod = {
  __typename?: 'ManageDeveloperCommissionSettingPeriod';
  /** Refer: src/graphql/definitions/object/developer-commission-setting-period.graphql */
  add: DeveloperCommissionSettingPeriod;
  /** Refer: src/graphql/definitions/object/developer-commission-setting-period.graphql */
  delete: DeveloperCommissionSettingPeriod;
  /** Refer: src/graphql/definitions/object/manage-developer-commission-setting-period-stage.graphql */
  stage: ManageDeveloperCommissionSettingPeriodStage;
  /** Refer: src/graphql/definitions/object/developer-commission-setting-period.graphql */
  update: DeveloperCommissionSettingPeriod;
};


export type ManageDeveloperCommissionSettingPeriodAddArgs = {
  childProjectId: Scalars['ID'];
  period: InputDeveloperCommissionSettingPeriod;
};


export type ManageDeveloperCommissionSettingPeriodDeleteArgs = {
  id: Scalars['ID'];
};


export type ManageDeveloperCommissionSettingPeriodUpdateArgs = {
  id: Scalars['ID'];
  value: InputDeveloperCommissionSettingPeriod;
};

export type ManageDeveloperCommissionSettingPeriodStage = {
  __typename?: 'ManageDeveloperCommissionSettingPeriodStage';
  /** Refer: src/graphql/definitions/object/developer-commission-setting-period-stage.graphql */
  add: DeveloperCommissionSettingPeriodStage;
  /** Refer: src/graphql/definitions/object/developer-commission-setting-period-stage.graphql */
  delete: DeveloperCommissionSettingPeriodStage;
  /** Refer: src/graphql/definitions/object/developer-commission-setting-period-stage.graphql */
  update: DeveloperCommissionSettingPeriodStage;
};


export type ManageDeveloperCommissionSettingPeriodStageAddArgs = {
  developerCommissionSettingPeriodId: Scalars['ID'];
  stage: InputDeveloperCommissionSettingPeriodStage;
};


export type ManageDeveloperCommissionSettingPeriodStageDeleteArgs = {
  id: Scalars['ID'];
};


export type ManageDeveloperCommissionSettingPeriodStageUpdateArgs = {
  id: Scalars['ID'];
  value: InputDeveloperCommissionSettingPeriodStage;
};

export type ManageDeveloperCommissionStage = {
  __typename?: 'ManageDeveloperCommissionStage';
  /** Refer: src/graphql/definitions/object/developer-commission-stage.graphql */
  add: DeveloperCommissionStage;
  /** Refer: src/graphql/definitions/object/developer-commission-stage.graphql */
  delete: DeveloperCommissionStage;
  /** Refer: src/graphql/definitions/object/developer-commission-stage.graphql */
  move: DeveloperCommissionStage;
  /** Refer: src/graphql/definitions/object/developer-commission-stage.graphql */
  updateName: DeveloperCommissionStage;
};


export type ManageDeveloperCommissionStageAddArgs = {
  name: Scalars['String'];
  parentProjectId: Scalars['ID'];
};


export type ManageDeveloperCommissionStageDeleteArgs = {
  id: Scalars['ID'];
};


export type ManageDeveloperCommissionStageMoveArgs = {
  id: Scalars['ID'];
  toIndex: Scalars['Int'];
};


export type ManageDeveloperCommissionStageUpdateNameArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ManageDeveloperCommissionTransaction = {
  __typename?: 'ManageDeveloperCommissionTransaction';
  /** Upload developer commission invoice transactions in CSV format */
  uploadCsv: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/csv-column.graphql */
  uploadCsvColumns: Array<CsvColumn>;
};


export type ManageDeveloperCommissionTransactionUploadCsvArgs = {
  csv: Upload;
};

export type ManageDeveloperCommissionTransactionNettPrice = {
  __typename?: 'ManageDeveloperCommissionTransactionNettPrice';
  /** Upload developer commission invoice transactions in CSV format: */
  uploadCsv: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/csv-column.graphql */
  uploadCsvColumns: Array<CsvColumn>;
};


export type ManageDeveloperCommissionTransactionNettPriceUploadCsvArgs = {
  csv: Upload;
};

export type ManageFinancialReport = {
  __typename?: 'ManageFinancialReport';
  /**
   * For user to request whopay financial report for an existing transaction.
   * Refer: src/graphql/definitions/union/financial-report.graphql
   */
  requestTransactionWhoPay: FinancialReport;
};


export type ManageFinancialReportRequestTransactionWhoPayArgs = {
  date?: InputMaybe<Scalars['Date']>;
  loanPercentage: Scalars['Float'];
  prelaunch?: InputMaybe<RequestTransactionWhoPayPrelaunch>;
  transactionId: Scalars['String'];
  waitBackgroundTasks?: InputMaybe<Scalars['Boolean']>;
};

export type ManageGalAgencyGroup = {
  __typename?: 'ManageGalAgencyGroup';
  /**
   * Add a new GAL agency group.
   * Refer: src/graphql/definitions/object/gal-agency-group.graphql
   */
  add: GalAgencyGroup;
  /** Refer: src/graphql/definitions/object/gal-agency-group.graphql */
  delete: GalAgencyGroup;
};


export type ManageGalAgencyGroupAddArgs = {
  parentAgencyId: Scalars['ID'];
};


export type ManageGalAgencyGroupDeleteArgs = {
  id: Scalars['ID'];
};

export type ManageGalSignedCopy = {
  __typename?: 'ManageGalSignedCopy';
  /**
   * For admin to update the status of a GAL signed copy.
   * Refer: src/graphql/definitions/object/gal-signed-copy.graphql
   */
  updateStatus: GalSignedCopy;
  /**
   * For admin to void a GAL signed copy. The agency group will is allowed to
   * upload signed GAL again.
   * Refer: src/graphql/definitions/object/gal-signed-copy.graphql
   */
  void: GalSignedCopy;
};


export type ManageGalSignedCopyUpdateStatusArgs = {
  id: Scalars['ID'];
  reason: Scalars['String'];
  status: ManageGalSignedCopyUpdateStatusEnum;
};


export type ManageGalSignedCopyVoidArgs = {
  id: Scalars['ID'];
  reason: Scalars['String'];
};

export enum ManageGalSignedCopyUpdateStatusEnum {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type ManageGalTemplate = {
  __typename?: 'ManageGalTemplate';
  /**
   * For admin to create a new GAL template.
   * Calling this method will void the preceding GAL templates.
   * Refer: src/graphql/definitions/object/gal-template.graphql
   */
  add: GalTemplate;
  /** Refer: src/graphql/definitions/object/gal-template.graphql */
  delete: GalTemplate;
};


export type ManageGalTemplateAddArgs = {
  template: Scalars['String'];
};


export type ManageGalTemplateDeleteArgs = {
  id: Scalars['ID'];
};

export type ManageInvoiceRequestCustomisation = {
  __typename?: 'ManageInvoiceRequestCustomisation';
  /**
   * For finance team to add invoice request customisation.
   * Refer: src/graphql/definitions/object/invoice-request-customisation.graphql
   */
  add: InvoiceRequestCustomisation;
};


export type ManageInvoiceRequestCustomisationAddArgs = {
  bookingDateEnd?: InputMaybe<Scalars['Date']>;
  bookingDateStart?: InputMaybe<Scalars['Date']>;
  childDeveloperId: Scalars['ID'];
  customisation: ManageInvoiceRequestCustomisationAddInput;
};

export type ManageInvoiceRequestCustomisationAddInput = {
  companyAddress: Scalars['String'];
  companyName: Scalars['String'];
  sstNumber: Scalars['String'];
};

export type ManageLoan = {
  __typename?: 'ManageLoan';
  /**
   * Assign an outsource banker to handle the loan processing of a transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  selectOutsourceBanker: Transaction;
  /**
   * Select staff loan for a transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  selectStaffLoan: Transaction;
};


export type ManageLoanSelectOutsourceBankerArgs = {
  banker: InputSelectOutsourceBankerDetail;
  date?: InputMaybe<Scalars['Date']>;
  transactionId: Scalars['ID'];
};


export type ManageLoanSelectStaffLoanArgs = {
  date?: InputMaybe<Scalars['Date']>;
  detail: InputSelectStaffLoanDetail;
  transactionId: Scalars['ID'];
};

export type ManagePanelBanker = {
  __typename?: 'ManagePanelBanker';
  /**
   * Add new panel banker.
   * Refer: src/graphql/definitions/object/banker.graphql
   */
  addPanelBanker: Banker;
};


export type ManagePanelBankerAddPanelBankerArgs = {
  bankId: Scalars['ID'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  mobileNum: Scalars['String'];
};

export type ManagePanelLawyersCreate = {
  email?: InputMaybe<Scalars['String']>;
  fullName: Scalars['String'];
  lawyerFirm?: InputMaybe<Scalars['String']>;
  mobileNum?: InputMaybe<Scalars['String']>;
  personInCharge?: InputMaybe<Scalars['String']>;
  projectIds: Array<Scalars['String']>;
};

export type ManagePanelLawyersRemove = {
  id: Scalars['String'];
};

export type ManagePanelLawyersUpdate = {
  email?: InputMaybe<Scalars['String']>;
  fullName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  lawyerFirm?: InputMaybe<Scalars['String']>;
  mobileNum?: InputMaybe<Scalars['String']>;
  personInCharge?: InputMaybe<Scalars['String']>;
  projectIds: Array<Scalars['String']>;
};

export type ManageParentProjectServiceFeeSetting = {
  __typename?: 'ManageParentProjectServiceFeeSetting';
  /** Refer: src/graphql/definitions/object/parent-project-service-fee-setting.graphql */
  create: ParentProjectServiceFeeSetting;
  delete: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/parent-project-service-fee-setting.graphql */
  update: ParentProjectServiceFeeSetting;
};


export type ManageParentProjectServiceFeeSettingCreateArgs = {
  completionDateEnd: Scalars['Date'];
  completionDateStart: Scalars['Date'];
  formula: InputServiceFeeFormula;
  parentProjectId: Scalars['ID'];
};


export type ManageParentProjectServiceFeeSettingDeleteArgs = {
  id: Scalars['ID'];
};


export type ManageParentProjectServiceFeeSettingUpdateArgs = {
  completionDateEnd: Scalars['Date'];
  completionDateStart: Scalars['Date'];
  formula: InputServiceFeeFormula;
  id: Scalars['ID'];
};

export type ManagePostlaunchBookingDraft = {
  __typename?: 'ManagePostlaunchBookingDraft';
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft.graphql */
  add: PostlaunchBookingDraft;
  /** Refer: src/graphql/definitions/object/postlaunch-transaction.graphql */
  complete: PostlaunchTransaction;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft.graphql */
  delete: PostlaunchBookingDraft;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft.graphql */
  fromBookingVerification: PostlaunchBookingDraft;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft.graphql */
  fromBuyerLead: PostlaunchBookingDraft;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft.graphql */
  fromCustomerSchedule: PostlaunchBookingDraft;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft.graphql */
  fromPrelaunchBooking: PostlaunchBookingDraft;
  /** Refer: src/graphql/definitions/object/update-postlaunch-booking-draft.graphql */
  update: UpdatePostlaunchBookingDraft;
};


export type ManagePostlaunchBookingDraftAddArgs = {
  unitId: Scalars['ID'];
};


export type ManagePostlaunchBookingDraftCompleteArgs = {
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  unitLockId?: InputMaybe<Scalars['ID']>;
};


export type ManagePostlaunchBookingDraftDeleteArgs = {
  id: Scalars['ID'];
};


export type ManagePostlaunchBookingDraftFromBookingVerificationArgs = {
  bookingVerificationId: Scalars['ID'];
};


export type ManagePostlaunchBookingDraftFromBuyerLeadArgs = {
  buyerLeadId: Scalars['ID'];
  unitId: Scalars['ID'];
};


export type ManagePostlaunchBookingDraftFromCustomerScheduleArgs = {
  customerScheduleId: Scalars['ID'];
  unitId: Scalars['ID'];
};


export type ManagePostlaunchBookingDraftFromPrelaunchBookingArgs = {
  prelaunchBookingId: Scalars['ID'];
  unitId: Scalars['ID'];
};


export type ManagePostlaunchBookingDraftUpdateArgs = {
  id: Scalars['ID'];
};

export type ManagePostlaunchForm = {
  __typename?: 'ManagePostlaunchForm';
  /** Refer: src/graphql/definitions/object/postlaunch-form.graphql */
  update: PostlaunchForm;
};


export type ManagePostlaunchFormUpdateArgs = {
  form: InputPostlaunchForm;
};

export type ManageProjectAgencyGroup = {
  __typename?: 'ManageProjectAgencyGroup';
  /**
   * Note: the kind of an agency group can only be set once,
   * this is because we do not want the PICs to see changing commission rates.
   * So if admin really wants to change the kind of an agency group, they need to
   * find Tech Team.
   * Refer: src/graphql/definitions/object/project-agency-group.graphql
   */
  add: ProjectAgencyGroup;
  /**
   * Add a project agency group by using existing agency groups, whether of GAL
   * agency group, or of project agency group.
   * Refer: src/graphql/definitions/object/project-agency-group.graphql
   */
  addUsingExistingAgencyGroup: ProjectAgencyGroup;
  /** Copy all project agency groups under an agency kind to an agency kind that has zero project agency groups. */
  copy: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/project-agency-group.graphql */
  delete: ProjectAgencyGroup;
};


export type ManageProjectAgencyGroupAddArgs = {
  agencyKindId: Scalars['ID'];
  parentAgencyId: Scalars['ID'];
};


export type ManageProjectAgencyGroupAddUsingExistingAgencyGroupArgs = {
  agencyGroupId: Scalars['ID'];
  agencyKindId: Scalars['ID'];
};


export type ManageProjectAgencyGroupCopyArgs = {
  from: Scalars['ID'];
  to: Scalars['ID'];
};


export type ManageProjectAgencyGroupDeleteArgs = {
  id: Scalars['ID'];
};

export type ManageProjectAgencyKind = {
  __typename?: 'ManageProjectAgencyKind';
  /** Refer: src/graphql/definitions/object/project-agency-kind.graphql */
  add: ProjectAgencyKind;
  /** Refer: src/graphql/definitions/object/project-agency-kind.graphql */
  delete: ProjectAgencyKind;
};


export type ManageProjectAgencyKindAddArgs = {
  childProjectId: Scalars['ID'];
  kind: Scalars['String'];
};


export type ManageProjectAgencyKindDeleteArgs = {
  id: Scalars['ID'];
};

export type ManageProjectCommissionTnc = {
  __typename?: 'ManageProjectCommissionTnc';
  /** Refer: src/graphql/definitions/object/project-commission-tnc.graphql */
  add: ProjectCommissionTnc;
  /** Copy project comission T&C(s) from a project agency kind to another project agency kind. */
  copy: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/project-commission-tnc.graphql */
  delete: ProjectCommissionTnc;
  /** Refer: src/graphql/definitions/object/project-commission-tnc.graphql */
  update: ProjectCommissionTnc;
};


export type ManageProjectCommissionTncAddArgs = {
  projectAgencyKindId: Scalars['ID'];
  version: InputProjectCommissionTncVersion;
};


export type ManageProjectCommissionTncCopyArgs = {
  from: Scalars['ID'];
  to: Scalars['ID'];
};


export type ManageProjectCommissionTncDeleteArgs = {
  id: Scalars['ID'];
};


export type ManageProjectCommissionTncUpdateArgs = {
  id: Scalars['ID'];
  version: InputProjectCommissionTncVersion;
};

export type ManageProjectDiscount = {
  __typename?: 'ManageProjectDiscount';
  /** Refer: src/graphql/definitions/object/project-discount.graphql */
  copy: ProjectDiscount;
  delete: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/project-discount.graphql */
  insert: ProjectDiscount;
  reorder: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/project-discount.graphql */
  update: ProjectDiscount;
};


export type ManageProjectDiscountCopyArgs = {
  discountId: Scalars['ID'];
  specificUnitId?: InputMaybe<Scalars['ID']>;
};


export type ManageProjectDiscountDeleteArgs = {
  discountId: Scalars['ID'];
};


export type ManageProjectDiscountInsertArgs = {
  childProjectId: Scalars['ID'];
  discount: UpdatedDiscount;
};


export type ManageProjectDiscountReorderArgs = {
  childProjectId: Scalars['ID'];
  discountIds: Array<Scalars['ID']>;
};


export type ManageProjectDiscountUpdateArgs = {
  discount: UpdatedDiscount;
  discountId: Scalars['ID'];
};

export type ManageSbuBudget = {
  __typename?: 'ManageSbuBudget';
  /** Refer: src/graphql/definitions/object/sbu-project-budget.graphql */
  add: SbuProjectBudget;
  /** Refer: src/graphql/definitions/object/sbu-project-budget.graphql */
  delete: SbuProjectBudget;
  /** Refer: src/graphql/definitions/object/sbu-project-budget.graphql */
  update: SbuProjectBudget;
};


export type ManageSbuBudgetAddArgs = {
  input: InputSbuProjectBudget;
};


export type ManageSbuBudgetDeleteArgs = {
  id: Scalars['ID'];
};


export type ManageSbuBudgetUpdateArgs = {
  id: Scalars['ID'];
  input: InputSbuProjectBudget;
};

export type ManageSbuKpi = {
  __typename?: 'ManageSbuKpi';
  /** Refer: src/graphql/definitions/object/manage-sbu-budget.graphql */
  budget: ManageSbuBudget;
  /** Refer: src/graphql/definitions/object/manage-sbu-marketing-expense.graphql */
  marketingExpense: ManageSbuMarketingExpense;
  /** Refer: src/graphql/definitions/object/manage-sbu-project.graphql */
  sbuProject: ManageSbuProject;
};

export type ManageSbuMarketingExpense = {
  __typename?: 'ManageSbuMarketingExpense';
  /** Refer: src/graphql/definitions/object/sbu-project-marketing-expense.graphql */
  add: SbuProjectMarketingExpense;
  /** Refer: src/graphql/definitions/object/sbu-project-marketing-expense.graphql */
  delete: SbuProjectMarketingExpense;
  /** Refer: src/graphql/definitions/object/sbu-project-marketing-expense.graphql */
  update: SbuProjectMarketingExpense;
};


export type ManageSbuMarketingExpenseAddArgs = {
  input: InputSbuProjectMarketingExpense;
};


export type ManageSbuMarketingExpenseDeleteArgs = {
  id: Scalars['ID'];
};


export type ManageSbuMarketingExpenseUpdateArgs = {
  id: Scalars['ID'];
  input: InputSbuProjectMarketingExpense;
};

export type ManageSbuProject = {
  __typename?: 'ManageSbuProject';
  /** Refer: src/graphql/definitions/object/sbu-project.graphql */
  add: SbuProject;
  /** Refer: src/graphql/definitions/object/sbu-project.graphql */
  delete: SbuProject;
  /** Refer: src/graphql/definitions/object/sbu-project.graphql */
  update: SbuProject;
};


export type ManageSbuProjectAddArgs = {
  input: InputSbuProject;
};


export type ManageSbuProjectDeleteArgs = {
  id: Scalars['ID'];
};


export type ManageSbuProjectUpdateArgs = {
  id: Scalars['ID'];
  input: InputSbuProject;
};

export type ManageServiceFee = {
  __typename?: 'ManageServiceFee';
  /** Refer: src/graphql/definitions/object/manage-service-fee-bill.graphql */
  bill: ManageServiceFeeBill;
  /** Refer: src/graphql/definitions/object/manage-service-fee-setting.graphql */
  setting: ManageServiceFeeSetting;
};

export type ManageServiceFeeBill = {
  __typename?: 'ManageServiceFeeBill';
  /** Refer: src/graphql/definitions/object/service-fee-bill.graphql */
  create: ServiceFeeBill;
  /** Refer: src/graphql/definitions/union/delete-service-fee-bill.graphql */
  delete: DeleteServiceFeeBill;
};


export type ManageServiceFeeBillCreateArgs = {
  invoiceNumber: Scalars['String'];
  parentProjectId: Scalars['ID'];
  transactionIds: Array<Scalars['ID']>;
};


export type ManageServiceFeeBillDeleteArgs = {
  id: Scalars['ID'];
};

export type ManageServiceFeeSetting = {
  __typename?: 'ManageServiceFeeSetting';
  /** Refer: src/graphql/definitions/object/manage-parent-project-service-fee-setting.graphql */
  parentProject: ManageParentProjectServiceFeeSetting;
  /** Refer: src/graphql/definitions/object/manage-transaction-service-fee-setting.graphql */
  transaction: ManageTransactionServiceFeeSetting;
};

export type ManageTransactionServiceFeeSetting = {
  __typename?: 'ManageTransactionServiceFeeSetting';
  /** Refer: src/graphql/definitions/object/transaction-service-fee-setting.graphql */
  create: TransactionServiceFeeSetting;
  /** Refer: src/graphql/definitions/object/service-fee-billable-transaction.graphql */
  delete: ServiceFeeBillableTransaction;
};


export type ManageTransactionServiceFeeSettingCreateArgs = {
  formula: InputServiceFeeFormula;
  transactionId: Scalars['ID'];
};


export type ManageTransactionServiceFeeSettingDeleteArgs = {
  id: Scalars['ID'];
};

export type ManageUploadedFile = {
  __typename?: 'ManageUploadedFile';
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  add: UploadedFile;
};


export type ManageUploadedFileAddArgs = {
  file: Upload;
  visibility?: InputMaybe<UploadFileVisibility>;
};

export type MapPlace = {
  __typename?: 'MapPlace';
  address: Scalars['String'];
  description: Scalars['String'];
  /** This is an alias for `placeId`. */
  id: Scalars['ID'];
  placeId: Scalars['ID'];
};

export enum MaritalStatus {
  Divorced = 'DIVORCED',
  Married = 'MARRIED',
  Separated = 'SEPARATED',
  Single = 'SINGLE',
  Widowed = 'WIDOWED'
}

export type MindcraftLoanPrediction = {
  __typename?: 'MindcraftLoanPrediction';
  /** Refer: src/graphql/definitions/object/mindcraft-loan-prediction-factor.graphql */
  factors: Array<MindcraftLoanPredictionFactor>;
  /** Refer: src/graphql/definitions/object/financer.graphql */
  financer: Financer;
  id: Scalars['ID'];
  predictedOutcome: Scalars['String'];
};

export type MindcraftLoanPredictionFactor = {
  __typename?: 'MindcraftLoanPredictionFactor';
  factor: Scalars['String'];
  id: Scalars['ID'];
};

export type MoneyInfo = {
  __typename?: 'MoneyInfo';
  balance?: Maybe<Scalars['Float']>;
  /** Refer: src/graphql/definitions/object/block.graphql */
  histories: Array<Block>;
};

export type MonthlyAppointmentsStat = {
  __typename?: 'MonthlyAppointmentsStat';
  /** Refer: src/graphql/definitions/object/appointment-stat.graphql */
  appointmentsStats: Array<AppointmentStat>;
  month: Scalars['Int'];
};

export type MonthlyLeadsAssignedStat = {
  __typename?: 'MonthlyLeadsAssignedStat';
  /** Refer: src/graphql/definitions/object/leads-assigned-stat.graphql */
  leadsAssignedStats: Array<LeadsAssignedStat>;
  month: Scalars['Int'];
};

export type MonthlyWhitelistStats = {
  __typename?: 'MonthlyWhitelistStats';
  /** 0 (January) until 12 (December) */
  month: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/whitelist-stats-arm.graphql */
  whitelistStatsArm: Array<WhitelistStatsArm>;
  /** Refer: src/graphql/definitions/object/whitelist-stats-source.graphql */
  whitelistStatsSource: Array<WhitelistStatsSource>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** For a seller agent to accept an agent cooperation that is requested by a buyer agent. */
  acceptAgentCooperation: Scalars['Boolean'];
  /**
   * Add a new agent agency/property developer into the system.
   * Refer: src/graphql/definitions/object/agency.graphql
   */
  addAgency: Agency;
  /** Assign new follow up to a particular agent lead. */
  addAgentLeadFollowUp: Scalars['Boolean'];
  /** Add new agent leads */
  addAgentLeads: Scalars['Boolean'];
  /** For user to add an document template. */
  addDocumentTemplate: Scalars['Boolean'];
  /** For E-store to track visitors. */
  addEstoreVisit?: Maybe<Scalars['ID']>;
  /**
   * This method is for demonstrating how the application level code talks
   * with Postgres.
   */
  addFoo?: Maybe<Scalars['Int']>;
  /**
   * Add a note (a.k.a comment) for a transaction.
   * Refer: src/graphql/definitions/object/note.graphql
   */
  addNote: Array<Note>;
  /** For user to add feedback (the justification) to notification rating */
  addNotificationRatingFeedback: Scalars['Boolean'];
  /**
   * Add a HARM for a parent project.
   * Refer: src/graphql/definitions/object/project-harm.graphql
   */
  addProjectHarm: ProjectHarm;
  /** Add remark for a buyer lead. */
  addRemark: Scalars['Boolean'];
  /** Add remarks to agent lead. */
  addRemarksToAgentLead: Scalars['Boolean'];
  /**
   * Add a new role to the system.
   * Refer: src/graphql/definitions/object/role.graphql
   */
  addRole: Role;
  /** Add a new unit to a child project. */
  addUnits: Scalars['Boolean'];
  /** Apply a specific discounts to all related transactions. */
  applyDiscount: Scalars['Boolean'];
  /** Assign/unassign Agent Relationship Manager (ARM) to a parent project. */
  assignArmToProject: Scalars['Boolean'];
  /** Assign a planter to a signed up agent. The planter must be an ARM. */
  assignPlanterToSignedUpAgent: Scalars['Boolean'];
  /** For team lead to assign a vice. */
  assignTeamVice: Scalars['Boolean'];
  /**
   * Grant or revoke roles to/from a user.
   * Refer: src/graphql/definitions/object/user.graphql
   */
  attachRoles: User;
  /** Block certain slots for a project showroom schedule. */
  blockCustomerScheduleSlot: Scalars['Boolean'];
  /**
   * Block the given unit that is not actually sold (Usually for creating artificial demand).
   * Blocked unit is treated as the same as unavailable unit on Didian app (Indicated using same colour - red)
   * but blocked (purple) and unavailable (red) units are treated differently on the dashboard (Indicated using
   * different colours).
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  blockUnit?: Maybe<Transaction>;
  /**
   * List of mutation methods available for Didian Buyer Portal that require only
   * authentication but not authorisation.
   * Refer: src/graphql/definitions/object/buyer-portal-mutation-authenticated.graphql
   */
  buyerPortalMutationAuthenticated: BuyerPortalMutationAuthenticated;
  /** Cancel cash payment for transaction where cash payment is chosen. */
  cancelCashPayment: Scalars['Boolean'];
  /**
   * Cancel a document signing schedule for a transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  cancelDocumentSigningSchedule: Transaction;
  /**
   * Agent or ARM cancel a particular appointment.
   * Agent cancel schedule actually means leaving the appointment.
   * Otherwise the appointment is really cancelled.
   */
  cancelSchedule: Scalars['Boolean'];
  /** Cancel/Retract a signed appointment letter */
  cancelSignedAppointmentLetter: Scalars['Boolean'];
  /** For agent to cancel an uploaded transaction commission invoie. */
  cancelTransactionCommissionInvoice: Scalars['Boolean'];
  /** Cancel SPA/LA signing confirmation on the internal Dashboard. */
  cancelTransactionDocumentSigningDateConfirmation: Scalars['Boolean'];
  /**
   * Indicate that a pending cancellation transaction has its cancellation form submitted.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  cancellationFormSubmitted?: Maybe<Transaction>;
  /**
   * Change the unit of a transaction. This will mark the old unit as pending
   * cancellation confirmation and the new unit as unavailable.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  changeUnit: Transaction;
  /**
   * Calling this method will clear all database cache. This is needed when we want
   * to manually clear the cache especially after patching database.
   */
  clearDatabaseCache: Scalars['Boolean'];
  /** Confirms that an appointment initiated by agent is valid. */
  confirmAgentSchedule: Scalars['Boolean'];
  /**
   * Mark a transaction as confirm cancelled, and the related unit will be available for booking instantly.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  confirmCancellation?: Maybe<Transaction>;
  /**
   * Confirm that the buyer want to proceed using cash for a specific transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  confirmCashBuyer?: Maybe<Transaction>;
  /**
   * Confirm that a specific document (e.g. SPA, LA etc) is signed for a transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  confirmDocumentSigned?: Maybe<Transaction>;
  /**
   * Confirm that the specific unit is unavailable on external price chart
   * (developer's price chart).
   * In other words, the unit is sold by non-Didian agents.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  confirmProjectUnitSold?: Maybe<Transaction>;
  /**
   * For user to create a new buyer lead distribution
   * Refer: src/graphql/definitions/object/buyer-lead-distribution.graphql
   */
  createBuyerLeadDistribution: BuyerLeadDistribution;
  /** Create a new child project for a particular parent project */
  createChildProject: Scalars['Boolean'];
  /** For buyer agent to create a cooperation. */
  createCooperation: Scalars['String'];
  /** For Agent/ARM/Developer to creates schedule a.k.a. appointment for customer(s) to visit project showroom */
  createCustomerSchedule: Scalars['String'];
  /** Create and broadcast notifications to Didian App. */
  createGeneralNotification: Scalars['Boolean'];
  /**
   * For a user to create a notification channel, if the notification channel is already created, nothing happens.
   * Refer: src/graphql/definitions/object/notification-channel.graphql
   */
  createNotificationChannel: NotificationChannel;
  /** Create a new parent project */
  createParentProject: Scalars['Boolean'];
  /**
   * Create popup-ad for new campaign
   * Note: `live` property will be set to undefined when new popup-ad is created,
   * user needs to update the `live` property using updatePopupAd method
   */
  createPopupAd: Scalars['ID'];
  /** Create a new reward group that is redeemable by agent. */
  createRewardGroup: Scalars['Boolean'];
  /**
   * For agent to create a new schedule to visit a project.
   * This method can also be used by third party to create a schedule on behalf of an agent.
   * If this method is invoked by agent, then the agent is represented by user._id
   * If this method is invoked by third party, then the agent is represented by onBehalfOf.
   */
  createScheduleAgent: Scalars['Boolean'];
  /** For Arm to create a new schedule for an agent lead to visit a project */
  createScheduleArm: Scalars['Boolean'];
  /**
   * List of available cron jobs
   * Why do we put cron jobs as GraphQL property?:
   * 1. Can be tested
   * 2. Can be executed manually
   * Refer: src/graphql/definitions/object/cron-job.graphql
   */
  cronJob: CronJob;
  /**
   * List of mutation methods related to Didian Now.
   * Refer: src/graphql/definitions/object/ddn-portal-mutation.graphql
   */
  ddnPortalMutation: DdnPortalMutation;
  /**
   * List of public methods for Didian Now that require only authentication
   * but not authorisation.
   * Refer: src/graphql/definitions/object/ddn-portal-public.graphql
   */
  ddnPortalPublic: DdnPortalPublic;
  /** Delete remark from an agent lead. */
  deleteAgentLeadRemark: Scalars['Boolean'];
  /** Mark an appointment letter as deleted. */
  deleteAppointmentLetter: Scalars['Boolean'];
  /** Delete the given entry of ProjectHarm. */
  deleteProjectHarm: Scalars['Boolean'];
  /** Mark as delete a particular remark of a buyer lead. */
  deleteRemark: Scalars['Boolean'];
  /** Delete a role. */
  deleteRole: Scalars['Boolean'];
  /** Delete a project unit. */
  deleteUnit: Scalars['Boolean'];
  /**
   * List of methods for developer users to perform mutations throught the Developer Dashboard.
   * Examples: verify invoice, reject invoice, and upload payment slips.
   * Refer: src/graphql/definitions/object/developer-dashboard-mutation.graphql
   */
  developerDashboardMutation: DeveloperDashboardMutation;
  /**
   * Add/remove/edit buyers of a transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  editBuyers?: Maybe<Transaction>;
  /**
   * Edit the detail of a transaction object custom field.
   * @deprecated Custom field feature is removed from transaction
   */
  editCustomField: Scalars['Boolean'];
  /** Edit or delete a transaction note. */
  editNote: Scalars['Boolean'];
  /** Update the information of a panel banker. */
  editPanelBanker: Scalars['Boolean'];
  /** Edit a particular remark of a buyer lead. */
  editRemark: Scalars['Boolean'];
  /**
   * Edit a role (update its name or its linked permissions).
   * Refer: src/graphql/definitions/object/role.graphql
   */
  editRole: Role;
  /**
   * Rename or delete a document of a transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  editUploadedDocument: Transaction;
  /** Give arbitary amount of money to any user. (WARNING: misusing this method will induce financial lost to the company). */
  giveMoney: Scalars['Boolean'];
  /** Insert a new buyer lead, and let the system distribute the lead straightaway. */
  insertBuyerLead: Scalars['Boolean'];
  /** Mark a transaction commission invoice as wrong. */
  invalidateTransactionCommissionInvoice: Scalars['Boolean'];
  /** This is to allow agents to join appointment on an ad hoc basis. */
  joinSchedule: Scalars['Boolean'];
  /** For agent to submit a join team request. */
  joinTeam: Scalars['Boolean'];
  /** For user to leave a team OR for team leader to remove a member. */
  leaveTeam: Scalars['Boolean'];
  /**
   * For admin to update a given agency group.
   * Refer: src/graphql/definitions/object/manage-agency-group.graphql
   */
  manageAgencyGroup: ManageAgencyGroup;
  /**
   * Methods for admin to manage agency team.
   * Refer: src/graphql/definitions/object/manage-agency-team.graphql
   */
  manageAgencyTeam: ManageAgencyTeam;
  /**
   * Methods for team leader to manage their team member.
   * Refer: src/graphql/definitions/object/manage-agency-team-member.graphql
   */
  manageAgencyTeamMember: ManageAgencyTeamMember;
  /**
   * This is for Agency Team Managers to manage project inquiries
   * Refer: src/graphql/definitions/object/manage-agency-team-project-inquiry.graphql
   */
  manageAgencyTeamProjectInquiry: ManageAgencyTeamProjectInquiry;
  /**
   * Methods for admins to manage data related to developer commission.
   * Refer: src/graphql/definitions/object/manage-developer-commission.graphql
   */
  manageDeveloperCommission: ManageDeveloperCommission;
  /**
   * List of mutations available for managing financial reports.
   * Refer: src/graphql/definitions/object/manage-financial-report.graphql
   */
  manageFinancialReport: ManageFinancialReport;
  /**
   * Methods for admin to manage GAL agency groups.
   * Refer: src/graphql/definitions/object/manage-gal-agency-group.graphql
   */
  manageGalAgencyGroup: ManageGalAgencyGroup;
  /**
   * List of methods for admin to manage GAL signed copies.
   * Refer: src/graphql/definitions/object/manage-gal-signed-copy.graphql
   */
  manageGalSignedCopy: ManageGalSignedCopy;
  /**
   * Methods for admin to manage GAL templates.
   * Refer: src/graphql/definitions/object/manage-gal-template.graphql
   */
  manageGalTemplate: ManageGalTemplate;
  /**
   * Methods for finance team to manage invoice request customisations.
   * Refer: src/graphql/definitions/object/manage-invoice-request-customisation.graphql
   */
  manageInvoiceRequestCustomisation: ManageInvoiceRequestCustomisation;
  /**
   * Methods for admin to manage loans.
   * Refer: src/graphql/definitions/object/manage-loan.graphql
   */
  manageLoan: ManageLoan;
  /**
   * Methods for admin to manage panel bankers.
   * Refer: src/graphql/definitions/object/manage-panel-banker.graphql
   */
  managePanelBanker: ManagePanelBanker;
  /** Add/Update/Remove panel lawyers */
  managePanelLawyers: Scalars['Boolean'];
  /**
   * Manage Booking Draft
   * Refer: src/graphql/definitions/object/manage-postlaunch-booking-draft.graphql
   */
  managePostlaunchBookingDraft: ManagePostlaunchBookingDraft;
  /**
   * Manage Booking Form
   * Refer: src/graphql/definitions/object/manage-postlaunch-form.graphql
   */
  managePostlaunchForm: ManagePostlaunchForm;
  /**
   * Methods for admin to manage project agency groups.
   * Refer: src/graphql/definitions/object/manage-project-agency-group.graphql
   */
  manageProjectAgencyGroup: ManageProjectAgencyGroup;
  /**
   * Methods for admin to manage project agency kinds.
   * Refer: src/graphql/definitions/object/manage-project-agency-kind.graphql
   */
  manageProjectAgencyKind: ManageProjectAgencyKind;
  /**
   * Methods for admin to manage project terms & conditions that are
   * related to commission payment.
   * Refer: src/graphql/definitions/object/manage-project-commission-tnc.graphql
   */
  manageProjectCommissionTnc: ManageProjectCommissionTnc;
  /**
   * Set of methods for admins to manage project discounts.
   * Refer: src/graphql/definitions/object/manage-project-discount.graphql
   */
  manageProjectDiscount: ManageProjectDiscount;
  /**
   * Methods to manage SBU KPIs.
   * Refer: src/graphql/definitions/object/manage-sbu-kpi.graphql
   */
  manageSbuKpi: ManageSbuKpi;
  /**
   * Methods for user to manage data related to service fee.
   * Refer: src/graphql/definitions/object/manage-service-fee.graphql
   */
  manageServiceFee: ManageServiceFee;
  /**
   * Upload file into the system
   * Refer: src/graphql/definitions/object/manage-uploaded-file.graphql
   */
  manageUploadedFile: ManageUploadedFile;
  /**
   * Mark/unmark the specific commission info of a transaction as paid by developer.
   * @deprecated use toggleDeveloperCommissionBatch instead
   */
  markAsPaidByDeveloper: Scalars['Boolean'];
  /** For a user to mark a notification that they created as deleted. */
  markDeleteNotification: Scalars['Boolean'];
  /** Mark user notification as read */
  markReadNotification?: Maybe<Scalars['Boolean']>;
  /** For user to mark all the notifications in a channel as read. */
  markReadNotificationChannel: Scalars['Boolean'];
  /** For agent to mark all non-channel notifications as read. */
  markReadNotificationGroup: Scalars['Boolean'];
  /** Mark schedules as read after the user view them. user will be notified if there is any schedule unread */
  markSchedulesAsRead: Scalars['Boolean'];
  /**
   * For user to mark a transaction as either claimable for ARE's commisison or not.
   * Note:
   *   The latest name of this method should be `markTransactionAsNotClaimableForArmCommission`,
   *   the old name(as below) is preserved for backward compatability purpose
   */
  markTransactionAsClaimedForCommission: Scalars['Boolean'];
  /**
   * Apple App Store Guideline requires all app to have an account deletion button
   * https://developer.apple.com/news/?id=i71db0mv#:~:text=Account%20deletion%20within%20apps&text=1%20provides%20people%20with%20greater,submissions%20by%20January%2031%2C%202022.
   * This method is created for user who wants their account to be deleted to notify us
   */
  notifyAccountDeletion?: Maybe<Scalars['Boolean']>;
  /**
   * List of mutations available for Didian Payment Portal
   * Refer: src/graphql/definitions/object/payment-portal-mutation.graphql
   */
  paymentPortalMutation: PaymentPortalMutation;
  /**
   * Send invoice request(s) for this commission portion.
   * The number of invoice requests sent is determined by the project agency
   * groupings and the agents of this transaction.
   * Each group will have one invoice request.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  prepareCommission: Transaction;
  /**
   * For user to preview a generated appointment letter, given the values of interpolatable variables.
   * Refer: src/graphql/definitions/object/preview-generated-appointment-letter-response.graphql
   */
  previewGeneratedAppointmentLetter: PreviewGeneratedAppointmentLetterResponse;
  /** For agents to print generated forms on demand. */
  printGeneratedForms: Scalars['Boolean'];
  /**
   * List of methods for managing prospective users.
   * Refer: src/graphql/definitions/object/prospective-user-mutation.graphql
   */
  prospectiveUserMutation: ProspectiveUserMutation;
  /** Publish rewards to a reward group so that they can be redeemed by agents. */
  publishRewards: Scalars['Boolean'];
  /**
   * For user to rate auto-generated messages like GPT messages
   * Refer: src/graphql/definitions/object/notification-rating.graphql
   */
  rateNotification: NotificationRating;
  /**
   * For agent to redeem a reward.
   * Refer: src/graphql/definitions/object/reward.graphql
   */
  redeemReward?: Maybe<Reward>;
  /** Refresh price chart of a child project */
  refreshPriceChart: Scalars['Boolean'];
  /**
   * Refreshes the commission portions for a transaction according to the latest
   * binding T&C.
   * Refer: src/graphql/definitions/object/transaction-commission-info.graphql
   */
  refreshTransactionCommissionPortions: Array<TransactionCommissionInfo>;
  /** Regenerate the booking form PDF of a transaction based on its latest data */
  regenerateBookingForm: Scalars['Boolean'];
  /** Add current iOS or Android device. Usually upon user login. This method is needed for push notification to work. */
  registerDevice?: Maybe<Scalars['Boolean']>;
  /**
   * Register as a user who logs in with a mobile number.
   * Refer: src/graphql/definitions/object/user.graphql
   */
  registerMobile?: Maybe<User>;
  /**
   * Register as a user who logs in with a Facebook/Google/Apple account.
   * Refer: src/graphql/definitions/object/user.graphql
   */
  registerSocialMedia?: Maybe<User>;
  /** Reject the signed appoinment letter uploaded by PIC. */
  rejectSignedAppointmentLetter: Scalars['Boolean'];
  /**
   * Release a lock on a unit. Can be used on any lock, regardless of who set the lock.
   * Refer: src/graphql/definitions/object/project-unit-lock.graphql
   */
  releaseAnyProjectUnitLock: Array<ProjectUnitLock>;
  /**
   * Release a unit lock that is set by the requesting user.
   * Refer: src/graphql/definitions/object/project-unit-lock.graphql
   */
  releaseProjectUnitLock: Array<ProjectUnitLock>;
  /** Remove blacklisted user from agency team. */
  removeBlacklist?: Maybe<Scalars['Boolean']>;
  /** Remove current iOS or Android device. Usually upon user logout. */
  removeDevice?: Maybe<Scalars['Boolean']>;
  /**
   * Remove a loan info from a transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  removeLoan?: Maybe<Transaction>;
  /** Remove the showroom operation details of a parent project. */
  removeShowroomOperationDetails: Scalars['Boolean'];
  /** Remove whitelisted agent/team from a parent project whitelist. */
  removeWhitelistItem: Scalars['Boolean'];
  /**
   * Batch remove whitelisted agent/team from a parent project whitelist.
   * Refer: src/graphql/definitions/object/project-inquiry.graphql
   */
  removeWhitelistItems: Array<ProjectInquiry>;
  /**
   * Rename a file that was uplaoded into the system.
   * Refer: src/graphql/definitions/object/uploaded-file.graphql
   */
  renameFile: UploadedFile;
  /**
   * Purpose: For agent to request booking verification from buyer(s)
   * Refer: src/graphql/definitions/object/booking-verification.graphql
   */
  requestBookingVerification: BookingVerification;
  /** For user to request the commission payout for the whole ARM team, including Head of ARM. */
  requestCommissionPayout: Scalars['Boolean'];
  /**
   * For user to request whopay financial report before booking a unit.
   * Refer: src/graphql/definitions/union/financial-report.graphql
   */
  requestWhoPay: FinancialReport;
  /** For user to resend invoice request email in case the PIC didn't receive it. */
  resendInvoiceRequestEmail: Scalars['Boolean'];
  /**
   * Schedule the signing for a particular document on a specific date.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  scheduleDocumentSigning?: Maybe<Transaction>;
  /**
   * Select the default lawyer who will handle every document signing process of a transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  selectLawyer?: Maybe<Transaction>;
  /**
   * Assign loan issuer which are neither panel/personal banker to handle the loan process of a transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   * @deprecated Replaced by `selectOutsourceBanker` and `selectStaffLoan`.
   */
  selectOtherLoan?: Maybe<Transaction>;
  /**
   * Assign a panel banker to handle the loan process of a transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  selectPanelBankers?: Maybe<Transaction>;
  /**
   * Assign or change the lawyer for a document signing process of a transaction to a panel lawyer.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  selectPanelLawyer: Transaction;
  /**
   * Assign a personal banker to handle the loan process of a transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  selectPersonalBanker?: Maybe<Transaction>;
  /**
   * Assign or change the lawyer for a document signing process of a transaction to a personal lawyer.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  selectPersonalLawyer: Transaction;
  /** For user to tell Agent GPT to start a new topic resetting the conversation. */
  sendChannelNewTopic?: Maybe<Scalars['Boolean']>;
  /**
   * For user to send a notification to a channel.
   * Returns ID of the newly created notification.
   */
  sendChannelNotification: Scalars['String'];
  /** Send email to agent for verification */
  sendVerificationEmail: Scalars['Boolean'];
  /** Set the status of agent lead as no_action_required or future_prospect. */
  setAgentLeadStatus: Scalars['Boolean'];
  /**
   * For authorized user to lock a unit for someone else with a specific time period.
   * Refer: src/graphql/definitions/object/project-unit-lock.graphql
   */
  setAnyProjectUnitLock: Array<ProjectUnitLock>;
  /** Arm sets his or her days that he or she wants to allocate for a project */
  setArmSchedulePreferences: Scalars['Boolean'];
  /** Arm blocks certain dates where he or she is not available due to some reasons i.e. personal reasons */
  setBlockedDays: Scalars['Boolean'];
  /**
   * This is for testing purposes only.
   * Because in reality, these values are too big (e.g. 30 minutes, 1 hour) to be tested.
   * Refer: src/graphql/definitions/object/set-config.graphql
   */
  setConfig: SetConfig;
  /** Set the stamping date of document (i.e. SPA or LA etc) of a transaction. */
  setDocumentStampingDate: Scalars['Boolean'];
  /**
   * For agent to lock a particular units for specific duration to fill in booking
   * form.
   * Refer: src/graphql/definitions/object/project-unit-lock.graphql
   */
  setProjectUnitLock: Array<ProjectUnitLock>;
  /** Set/override the specific type of price (SPA/billing/nett) for a particular transaction */
  setTransactionPrice: Scalars['Boolean'];
  /** Sort/reorder cover images of a parent project */
  sortCoverImages: Scalars['Boolean'];
  /** Submit a booking form for a unit, this will mark the unit as unavailable and a new transaction will be created. */
  submitBookingForm: Scalars['String'];
  /**
   * Mark the specified transaction as pending cancellation confirmation.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  submitCancellation?: Maybe<Transaction>;
  /**
   * Confirm that the buyer chosen to proceed with an approved loan for a specific transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  submitLoanDecision?: Maybe<Transaction>;
  /**
   * Confirm that the buyer submitted documents to a specific banker.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  submitLoanDocument?: Maybe<Transaction>;
  /**
   * Confirm that a loan of a transaction is approved or rejected by corresponding banker.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  submitLoanResult?: Maybe<Transaction>;
  /** For agents to submit their project preferences during on boarding. */
  submitPreferenceOptions?: Maybe<Scalars['Boolean']>;
  /** For newly sign up agents to enter their referrer's referral code during on-boarding. */
  submitReferralCode?: Maybe<Scalars['Boolean']>;
  /** For agent to notify us that they are interested in selling a project. */
  submitSaleInterest?: Maybe<Scalars['Boolean']>;
  /**
   * Allow dashboard user to submit RHB loan for a transaction
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  submitTransactionRhbLoanApplication?: Maybe<Transaction>;
  /** This method is for swapping the firebaseId and roles with another user */
  switchIdentity?: Maybe<Scalars['Boolean']>;
  /**
   * For admin to terminate a project commission TNC agreement.
   * Refer: src/graphql/definitions/object/project-commission-tnc-version-agreement.graphql
   */
  terminateProjectCommissionTncAgreement: ProjectCommissionTncVersionAgreement;
  /**
   * This is for testing our printer which are located at project gallery. When
   * this method is invoked, we will send a print request to the project's printer.
   */
  testPrinter: Scalars['Boolean'];
  /** To include or exclude a transaction from a developer commission disbursement batch. */
  toggleDeveloperCommissionBatch: Scalars['Boolean'];
  /**
   * Toggle discounts for a transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  toggleDiscounts: Transaction;
  /** This is for switching between the highrise and landed price chart. */
  toggleHighriseLandedPriceChart: Scalars['Boolean'];
  /** For team lead to unassign a vice. */
  unassignTeamVice: Scalars['Boolean'];
  /** Unchoose a chosen loan info for a transaction. */
  unchooseLoanInfo: Scalars['Boolean'];
  /**
   * Undo a specific event of a transaction. For example, undo 'Chosen Banker Libbie'
   * Refer: src/graphql/definitions/object/transaction.graphql
   * @deprecated Transaction is migrated to postgres. We not longer have a generic table to store the events
   */
  undoEvent: Transaction;
  /**
   * Undo the cancellation confirmation of a transaction.
   * This will fail if the transaction's unit is no longer available.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  undoTransactionCancellationConfirmation: Transaction;
  /**
   * Undo the cancellation form submission of a transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  undoTransactionCancellationFormSubmission: Transaction;
  /**
   * Undo the cancellation submission of a transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  undoTransactionCancellationSubmission: Transaction;
  /** Update the details of agent agency/property developer. */
  updateAgencyDetails: Scalars['Boolean'];
  /** Toggle whether agent can view the generated forms of transcations made on a project. */
  updateAgentCanViewGeneratedForms: Scalars['Boolean'];
  /**
   * Agents update their information
   * Refer: src/graphql/definitions/object/user.graphql
   */
  updateAgentInfo?: Maybe<User>;
  /** Update the project interested of an agent lead. */
  updateAgentLeadProjectInterested: Scalars['Boolean'];
  /** Update the source of an agent lead. */
  updateAgentLeadSource: Scalars['Boolean'];
  /** Update agent leads for a schedule (There might be more than one agent visiting the project during the appointment) */
  updateAgentLeads: Scalars['Boolean'];
  /** Update all custom PDF. */
  updateAllCustomPDF: Scalars['Boolean'];
  /** Update the details on an appointment letter. */
  updateAppointmentLetter: Scalars['Boolean'];
  /** Update the ARM commission settings for a child project */
  updateArmCommissionSettings: Scalars['Boolean'];
  /** Update the booking form of a child project. */
  updateBookingForm: Scalars['Boolean'];
  /**
   * Modify booking steps of a parent project.
   * Refer: src/graphql/definitions/object/project.graphql
   */
  updateBookingSteps?: Maybe<Project>;
  /**
   * Rename or delete uploaded booking steps files of a parent project.
   * Refer: src/graphql/definitions/object/project.graphql
   */
  updateBookingStepsFile?: Maybe<Project>;
  /** Update the details of a buyer lead distribution. */
  updateBuyerLeadDistribution: Scalars['Boolean'];
  /** Update the status of a buyer lead */
  updateBuyerLeadStatus: Scalars['Boolean'];
  /** Update the commission settings of a child project. */
  updateChildProjectCommissionSettings: Scalars['Boolean'];
  /** Update the detail of a child project */
  updateChildProjectDetail: Scalars['Boolean'];
  /** Update the commission infos of a project */
  updateCommissionInfos: Scalars['Boolean'];
  /**
   * Rename or delete uploaded cover images of a parent project.
   * Refer: src/graphql/definitions/object/project.graphql
   */
  updateCoverImages: Project;
  /**
   * Update a custom field value of a transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  updateCustomFieldValue?: Maybe<Transaction>;
  /** Update background image for a specific page of custom PDF. */
  updateCustomPDFImage: Scalars['Boolean'];
  /**
   * For admins to update the variables related to various calculations of DDN.
   * Refer https://app.nuclino.com/Didian/Product/update-calculation-variable-inputs-1fa9200c-3224-4741-81f3-1d6ebde23f70
   * Refer: src/graphql/definitions/object/update-ddn-calculation-variables.graphql
   */
  updateDdnCalculationVariables: UpdateDdnCalculationVariables;
  /**
   * For Didian internal team to update Ddn property status after inspection/verification.
   * Refer: src/graphql/definitions/object/update-ddn-property-status.graphql
   */
  updateDdnPropertyStatus: UpdateDdnPropertyStatus;
  /**
   * For accountant to update the developer commission batches for a particular project.
   * @deprecated Use `manageDeveloperCommission.batch` instead.
   */
  updateDeveloperCommissionBatches: Scalars['Boolean'];
  /**
   * Methods for admins to update the developer dashboard settings
   * Refer: src/graphql/definitions/object/update-developer-dashboard-setting.graphql
   */
  updateDeveloperDashboardSetting: UpdateDeveloperDashboardSetting;
  /** Update the developer info of a user. */
  updateDeveloperInfo: Scalars['Boolean'];
  /**
   * Update discounts of a child project.
   * @deprecated Use `manageProjectDiscount` instead.
   */
  updateDiscounts?: Maybe<Scalars['Boolean']>;
  /** Update the data of an appointment letter generator template. */
  updateDocumentTemplate: Scalars['Boolean'];
  /** Add/remove image for an entitlement */
  updateEntitlementImage: Scalars['Boolean'];
  /**
   * For updating E-store information.
   * If E-store does not exists, insert a new E-store, otherwise update existing E-store.
   * Refer: src/graphql/definitions/object/estore-project-teaser.graphql
   */
  updateEstoreProjectTeaser: EstoreProjectTeaser;
  /** For agent to upate the URL suffix of their Estore. */
  updateEstoreUrlSuffix: Scalars['Boolean'];
  /**
   * Modify and update facilities of a parent project.
   * Refer: src/graphql/definitions/object/project.graphql
   */
  updateFacilities: Project;
  /** Update the jmaOnly property of a parent project. */
  updateJmaOnly: Scalars['Boolean'];
  /** Approve or reject a join team request. */
  updateJoinTeamRequest: Scalars['Boolean'];
  /**
   * Modify and update key selling points of a parent project.
   * Refer: src/graphql/definitions/object/project.graphql
   */
  updateKeySellingPoints: Project;
  /** This is for updating landed price chart layout for a child project and overview. */
  updateLandedPriceChart: Scalars['Boolean'];
  /**
   * Rename or delete uploaded marketing material of a parent project.
   * Refer: src/graphql/definitions/object/project.graphql
   */
  updateMarketingMaterial: Project;
  /** Update the mode of the note either to public or private */
  updateNoteMode: Scalars['Boolean'];
  /**
   * Modify and update payment infos detail of a project.
   * Refer: src/graphql/definitions/object/project.graphql
   */
  updatePaymentInfos: Project;
  /** Update popup-ad properties */
  updatePopupAd: Scalars['Boolean'];
  /** Update the price chart layout of a child project */
  updatePriceChartLayout: Scalars['Boolean'];
  /** Update the agent cooperation settings for a parent project. */
  updateProjectAgentCooperation: Scalars['Boolean'];
  /** Update project categories. */
  updateProjectCategories: Scalars['Boolean'];
  /** Update the commission settings of a parent project. */
  updateProjectCommissionSettings: Scalars['Boolean'];
  /**
   * Update the FAQs for a parent project
   * This will also update all the prompts for the chat
   */
  updateProjectFaqs: Scalars['Boolean'];
  /** Update the project handler of a project either the listing agency or developer. */
  updateProjectHandler: Scalars['Boolean'];
  /**
   * Update the project inquiry status on the internal dashboard
   * Refer: src/graphql/definitions/object/update-project-inquiry-status.graphql
   */
  updateProjectInquiryStatus: UpdateProjectInquiryStatus;
  /** Update the status (active / preparing / concluded) of a child/parent project. */
  updateProjectStatus: Scalars['Boolean'];
  /**
   * Update the summary of a project.
   * Refer: src/graphql/definitions/object/project.graphql
   */
  updateProjectSummary: Project;
  /** Update the support personnels for a parent project. */
  updateProjectSupportPersonnels: Scalars['Boolean'];
  /** Update the tags of a parent project. Example of tags are "Prelaunch", "Hot", etc. */
  updateProjectTags: Scalars['Boolean'];
  /** Update the project type of Project. */
  updateProjectType: Scalars['Boolean'];
  /** Update details of a reward group. */
  updateRewardGroupDetails: Scalars['Boolean'];
  /** Update the picture of a reward group. */
  updateRewardGroupPicture: Scalars['Boolean'];
  /**
   * Rename or delete sales package of a project.
   * Refer: src/graphql/definitions/object/project.graphql
   */
  updateSalesPackage: Project;
  /**
   * ARM updates the active hours of the project showroom, max number of
   * customers allowed per time slot and the duration of every time slot.
   */
  updateShowroomOperationDetails: Scalars['Boolean'];
  /**
   * Update teaser images of a project
   * @deprecated Not used anymore
   */
  updateTeaserImages: Scalars['Boolean'];
  /** Update the agents of a transaction. */
  updateTransactionAgents: Scalars['Boolean'];
  /** Update the details of a project unit. */
  updateUnit: Scalars['Boolean'];
  /** Update the unit mix detail of a project. */
  updateUnitMix: Scalars['Boolean'];
  /** Update the details of multiple project units. */
  updateUnits: Scalars['Boolean'];
  /** Update the whitelister of a whitelist item */
  updateWhitelister: Scalars['Boolean'];
  /** Upload supportive payment slips for a payment slip. */
  uploadAdditionalPaymentSlips: Scalars['Boolean'];
  /**
   * For accountant to upload project appointment letter template for an agency,
   * which then the PIC of the agency can download and sign it and upload the signed appointment letter
   * via payment portal.
   */
  uploadAppointmentLetterTemplate: Scalars['Boolean'];
  /**
   * Upload files related to booking steps of a project.
   * Refer: src/graphql/definitions/object/project.graphql
   */
  uploadBookingStepsFiles: Project;
  /**
   * Upload cover images of a parent project.
   * Refer: src/graphql/definitions/object/project.graphql
   */
  uploadCoverImages: Project;
  /** Upload and add background images to a specific index of custom PDF. */
  uploadCustomPDFImages: Scalars['Boolean'];
  /**
   * Upload documents for a transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  uploadDocuments: Transaction;
  /**
   * Upload files into the system
   * Refer: src/graphql/definitions/object/uploaded-file.graphql
   */
  uploadFiles: Array<UploadedFile>;
  /** Upload the same set of files for multiple transacions */
  uploadFilesForMultipleTransactions: Scalars['Boolean'];
  /**
   * Upload marketing materials for a project.
   * Refer: src/graphql/definitions/object/project.graphql
   */
  uploadMarketingMaterials: Project;
  /** Upload list of panel bankers for a parent project. */
  uploadPanelBankers: Scalars['Boolean'];
  /**
   * Upload sales packages of a project.
   * Refer: src/graphql/definitions/object/project.graphql
   */
  uploadSalesPackages: Project;
  /** For user to upload signed appointment letter. */
  uploadSignedAppointmentLetter: Scalars['Boolean'];
  /** Upload transaction commission invoice for multiple invoice requests. */
  uploadTransactionCommissionInvoice: Scalars['Boolean'];
  /** Upload payment slip for one or multiple transaction commission invoices. */
  uploadTransactionCommissionPaymentSlip: Scalars['Boolean'];
  /**
   * Verify booking form, intended to be used by sales admin.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  verifyBookingForm?: Maybe<Transaction>;
  /** Verify that a transaction commission invoice is correct. */
  verifyTransactionCommissionInvoice: Scalars['Boolean'];
  /** Verify a user and award him/her with referral rewards (if he/she attempted to submit referral code) */
  verifyUser: Scalars['Boolean'];
  /** Void a reward so that it cannot be redeemed by anyone. */
  voidReward: Scalars['Boolean'];
  /**
   * For user to void all the invoice requests of a specific transaction commission portion (e.g. 'express').
   * Refer: src/graphql/definitions/object/transaction-commission-info.graphql
   */
  voidTransactionCommissionInvoiceRequests: TransactionCommissionInfo;
  /** Void a transaction commission payment slip. */
  voidTransactionCommissionPaymentSlip: Scalars['Boolean'];
  /**
   * Update the project inquiry status on the internal dashboard
   * Refer: src/graphql/definitions/object/project-inquiry.graphql
   */
  whitelistAgents: Array<ProjectInquiry>;
  /**
   * Whitelist one single agent for a particular parent project. (Superuser don't
   * have to specify scheduleId / ARM has to specify scheduleId)
   * NOTE: Only whitelisted agent can view details of the specified project.
   * This will affect the project whitelisting section (Dashboard) and projects listing screen (Didian App)
   */
  whitelistIndividualAgent: Scalars['Boolean'];
};


export type MutationAcceptAgentCooperationArgs = {
  agentCooperationId: Scalars['String'];
  sellerAgentId: Scalars['String'];
};


export type MutationAddAgencyArgs = {
  agencyType: AgencyType;
  name: Scalars['String'];
};


export type MutationAddAgentLeadFollowUpArgs = {
  agentLeadId: Scalars['String'];
  date: Scalars['String'];
  passTo: Scalars['String'];
};


export type MutationAddAgentLeadsArgs = {
  leads: Array<NewAgentLead>;
};


export type MutationAddDocumentTemplateArgs = {
  childProjectId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parentProjectId?: InputMaybe<Scalars['String']>;
  template: Scalars['String'];
  type: DocumentTemplateType;
};


export type MutationAddEstoreVisitArgs = {
  agentId: Scalars['ID'];
  fingerprintJsVersion: Scalars['String'];
  parentProjectId?: InputMaybe<Scalars['ID']>;
  platform?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  vendor?: InputMaybe<Scalars['String']>;
  visitorHash: Scalars['String'];
};


export type MutationAddFooArgs = {
  bar: Scalars['String'];
};


export type MutationAddNoteArgs = {
  note: AddNoteRequest;
};


export type MutationAddNotificationRatingFeedbackArgs = {
  elaborate?: InputMaybe<Scalars['String']>;
  notificationRating: Scalars['Int'];
  preset: Scalars['String'];
};


export type MutationAddProjectHarmArgs = {
  endDateTime: Scalars['String'];
  harmId: Scalars['ID'];
  parentProjectId: Scalars['ID'];
  startDateTime: Scalars['String'];
};


export type MutationAddRemarkArgs = {
  buyerLeadId: Scalars['String'];
  date?: InputMaybe<Scalars['String']>;
  remark: Scalars['String'];
};


export type MutationAddRemarksToAgentLeadArgs = {
  agentLeadId: Scalars['String'];
  remark: Scalars['String'];
};


export type MutationAddRoleArgs = {
  name: Scalars['String'];
  permissions: Array<Scalars['String']>;
};


export type MutationAddUnitsArgs = {
  childProjectId: Scalars['String'];
  units: Array<InputProjectUnit>;
};


export type MutationApplyDiscountArgs = {
  discountId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationAssignArmToProjectArgs = {
  armId: Scalars['String'];
  date?: InputMaybe<Scalars['String']>;
  mode: AssignMode;
  projectId: Scalars['String'];
};


export type MutationAssignPlanterToSignedUpAgentArgs = {
  agentId: Scalars['String'];
  planterId: Scalars['String'];
};


export type MutationAssignTeamViceArgs = {
  memberId?: InputMaybe<Scalars['String']>;
  restrictedToProjectIds?: InputMaybe<Array<Scalars['String']>>;
  teamCode: Scalars['String'];
};


export type MutationAttachRolesArgs = {
  roleIds: Array<Scalars['String']>;
  userId: Scalars['String'];
};


export type MutationBlockCustomerScheduleSlotArgs = {
  projectId: Scalars['String'];
  startDateTime: Scalars['String'];
};


export type MutationBlockUnitArgs = {
  unitId: Scalars['String'];
};


export type MutationCancelCashPaymentArgs = {
  transactionId: Scalars['String'];
};


export type MutationCancelDocumentSigningScheduleArgs = {
  documentType: DocumentType;
  transactionId: Scalars['String'];
};


export type MutationCancelScheduleArgs = {
  scheduleId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationCancelSignedAppointmentLetterArgs = {
  appointmentLetterId: Scalars['String'];
  date?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


export type MutationCancelTransactionCommissionInvoiceArgs = {
  date?: InputMaybe<Scalars['Date']>;
  token: Scalars['String'];
  transactionCommissionInvoiceId: Scalars['String'];
};


export type MutationCancelTransactionDocumentSigningDateConfirmationArgs = {
  transactionDocumentSigningDateStatusId: Scalars['String'];
};


export type MutationCancellationFormSubmittedArgs = {
  transactionId: Scalars['String'];
};


export type MutationChangeUnitArgs = {
  newUnitId: Scalars['String'];
  proofs: Array<Upload>;
  reason?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
};


export type MutationConfirmAgentScheduleArgs = {
  scheduleId: Scalars['String'];
};


export type MutationConfirmCancellationArgs = {
  date?: InputMaybe<Scalars['Date']>;
  sequenceId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
};


export type MutationConfirmCashBuyerArgs = {
  sequenceId: Scalars['String'];
};


export type MutationConfirmDocumentSignedArgs = {
  date?: InputMaybe<Scalars['String']>;
  document: DocumentSignedRequest;
  documentUpdateDelayReason?: InputMaybe<Scalars['String']>;
  sequenceId: Scalars['String'];
};


export type MutationConfirmProjectUnitSoldArgs = {
  ignoreCheck?: InputMaybe<Scalars['Boolean']>;
  unitId: Scalars['String'];
};


export type MutationCreateBuyerLeadDistributionArgs = {
  parentProjectId: Scalars['String'];
};


export type MutationCreateChildProjectArgs = {
  layoutType: LayoutType;
  name: Scalars['String'];
  parentProjectId: Scalars['String'];
  projectType: ProjectType;
};


export type MutationCreateCooperationArgs = {
  buyers: Array<ProjectCooperationBuyer>;
  date?: InputMaybe<Scalars['String']>;
  parentProjectId: Scalars['String'];
  sellerTeamId: Scalars['String'];
};


export type MutationCreateCustomerScheduleArgs = {
  agentCooperationId?: InputMaybe<Scalars['String']>;
  agentIds?: InputMaybe<Array<Scalars['String']>>;
  buyerLeadId?: InputMaybe<Scalars['String']>;
  customerCarPlate?: InputMaybe<Scalars['String']>;
  customerMobileNum: Scalars['String'];
  customerName: Scalars['String'];
  date?: InputMaybe<Scalars['String']>;
  numberOfAttendees?: InputMaybe<Scalars['Float']>;
  projectId: Scalars['String'];
  startDateTime: Scalars['String'];
};


export type MutationCreateGeneralNotificationArgs = {
  body: Scalars['String'];
  createdOn?: InputMaybe<Scalars['String']>;
  externalUrl?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<Array<Upload>>;
  projectId?: InputMaybe<Scalars['String']>;
  push: Scalars['Boolean'];
  sendSms?: InputMaybe<Scalars['Boolean']>;
  targetedUserIds?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};


export type MutationCreateNotificationChannelArgs = {
  agencyTeam?: InputMaybe<InputCreateNotificationChannelAgencyTeam>;
  agentCooperation?: InputMaybe<InputCreateNotificationChannelAgentCooperation>;
  generalSupport?: InputMaybe<InputCreateNotificationChannelGeneralSupport>;
  private?: InputMaybe<InputCreateNotificationChannelPrivate>;
  projectAgencyTeam?: InputMaybe<InputCreateNotificationChannelProjectAgencyTeam>;
  projectAgent?: InputMaybe<InputCreateNotificationChannelProjectAgent>;
  projectAgentGpt?: InputMaybe<InputCreateNotificationChannelProjectAgentGpt>;
};


export type MutationCreateParentProjectArgs = {
  name: Scalars['String'];
};


export type MutationCreatePopupAdArgs = {
  input: InputCreatePopupAd;
  testInput?: InputMaybe<TestInputCreatePopupAd>;
};


export type MutationCreateRewardGroupArgs = {
  color: InputColor;
  description: Scalars['String'];
  name: Scalars['String'];
};


export type MutationCreateScheduleAgentArgs = {
  armId: Scalars['String'];
  date: Scalars['String'];
  daySlotIndex: Scalars['Int'];
  onBehalfOf?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  relativeDate?: InputMaybe<Scalars['String']>;
  remarks: Scalars['String'];
  scheduleId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateScheduleArmArgs = {
  agentLeadIds: Array<Scalars['String']>;
  date: Scalars['String'];
  daySlotIndex: Scalars['Int'];
  projectId: Scalars['String'];
  relativeDate?: InputMaybe<Scalars['String']>;
  remarks: Scalars['String'];
};


export type MutationDeleteAgentLeadRemarkArgs = {
  agentLeadId: Scalars['String'];
  createdOn: Scalars['String'];
};


export type MutationDeleteAppointmentLetterArgs = {
  appointmentLetterId: Scalars['String'];
};


export type MutationDeleteProjectHarmArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteRemarkArgs = {
  date?: InputMaybe<Scalars['String']>;
  remarkId: Scalars['String'];
};


export type MutationDeleteRoleArgs = {
  roleId: Scalars['String'];
};


export type MutationDeleteUnitArgs = {
  unitId: Scalars['String'];
};


export type MutationEditBuyersArgs = {
  editedBuyers: Array<EditedBuyer>;
  newBuyers: Array<NewBuyer>;
  proofs?: InputMaybe<Array<Upload>>;
  removedBuyers: Array<RemovedBuyer>;
  transactionId: Scalars['String'];
};


export type MutationEditCustomFieldArgs = {
  creations: Array<Creation>;
  deletions: Array<Deletion>;
  projectId: Scalars['String'];
  updates: Array<Update>;
};


export type MutationEditNoteArgs = {
  noteId: Scalars['String'];
  updatedContent?: InputMaybe<Scalars['String']>;
};


export type MutationEditPanelBankerArgs = {
  assignedProjectIds: Array<Scalars['String']>;
  bankId?: InputMaybe<Scalars['ID']>;
  bankName?: InputMaybe<Scalars['String']>;
  emails: Array<Scalars['String']>;
  mobileNums: Array<Scalars['String']>;
  name: Scalars['String'];
  panelBankerId: Scalars['String'];
};


export type MutationEditRemarkArgs = {
  date?: InputMaybe<Scalars['String']>;
  newContent: Scalars['String'];
  remarkId: Scalars['String'];
};


export type MutationEditRoleArgs = {
  newName: Scalars['String'];
  newPermissions: Array<Scalars['String']>;
  roleId: Scalars['String'];
};


export type MutationEditUploadedDocumentArgs = {
  date?: InputMaybe<Scalars['Date']>;
  documentId: Scalars['String'];
  newName?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
};


export type MutationGiveMoneyArgs = {
  amount: Scalars['Float'];
  password: Scalars['String'];
  reason: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationInsertBuyerLeadArgs = {
  advertisementId: Scalars['String'];
  advertisementName: Scalars['String'];
  campaignId: Scalars['String'];
  campaignName: Scalars['String'];
  date?: InputMaybe<Scalars['Date']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  mobileNum: Scalars['String'];
  platform: Scalars['String'];
};


export type MutationInvalidateTransactionCommissionInvoiceArgs = {
  date?: InputMaybe<Scalars['Date']>;
  reason: Scalars['String'];
  transactionCommissionInvoiceId: Scalars['String'];
};


export type MutationJoinScheduleArgs = {
  invitationCode: Scalars['String'];
};


export type MutationJoinTeamArgs = {
  date?: InputMaybe<Scalars['String']>;
  mockJoinTeamRequestId?: InputMaybe<Scalars['String']>;
  teamCode: Scalars['String'];
};


export type MutationLeaveTeamArgs = {
  memberId?: InputMaybe<Scalars['String']>;
  teamCode: Scalars['String'];
};


export type MutationManageAgencyTeamProjectInquiryArgs = {
  projectInquiryIds: Array<Scalars['ID']>;
};


export type MutationManagePanelLawyersArgs = {
  create?: InputMaybe<Array<ManagePanelLawyersCreate>>;
  remove?: InputMaybe<ManagePanelLawyersRemove>;
  update?: InputMaybe<ManagePanelLawyersUpdate>;
};


export type MutationMarkAsPaidByDeveloperArgs = {
  commmissionInfoType: Scalars['String'];
  transactionId: Scalars['String'];
  unmark?: InputMaybe<Scalars['Boolean']>;
};


export type MutationMarkDeleteNotificationArgs = {
  notificationId: Scalars['String'];
};


export type MutationMarkReadNotificationArgs = {
  notificationIds: Array<Scalars['String']>;
};


export type MutationMarkReadNotificationChannelArgs = {
  notificationChannelId: Scalars['String'];
};


export type MutationMarkTransactionAsClaimedForCommissionArgs = {
  transactionId: Scalars['String'];
};


export type MutationPaymentPortalMutationArgs = {
  token: Scalars['String'];
};


export type MutationPrepareCommissionArgs = {
  adjustments: Array<TransactionCommissionInvoiceRequestAdjustment>;
  commissionType: Scalars['String'];
  dontSendRequestForInvoice?: InputMaybe<Scalars['Boolean']>;
  invoiceRequestDelayReason?: InputMaybe<Scalars['String']>;
  relativeDate?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
};


export type MutationPreviewGeneratedAppointmentLetterArgs = {
  agencyId: Scalars['String'];
  commencementDate: Scalars['String'];
  contractDate: Scalars['String'];
  documentTemplateId: Scalars['String'];
  expiryDate: Scalars['String'];
};


export type MutationPrintGeneratedFormsArgs = {
  transactionId: Scalars['String'];
};


export type MutationPublishRewardsArgs = {
  expiryDate?: InputMaybe<Scalars['String']>;
  rewardGroupId: Scalars['String'];
  rewards: Array<InputReward>;
};


export type MutationRateNotificationArgs = {
  notificationId: Scalars['String'];
  type: NotificationRatingType;
};


export type MutationRedeemRewardArgs = {
  price: Scalars['Float'];
  rewardGroupId: Scalars['String'];
};


export type MutationRefreshPriceChartArgs = {
  childProjectId: Scalars['String'];
  waitForScraping?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRefreshTransactionCommissionPortionsArgs = {
  transactionId: Scalars['ID'];
};


export type MutationRegenerateBookingFormArgs = {
  date?: InputMaybe<Scalars['String']>;
  formType: RegenerateBookingFormType;
  transactionId: Scalars['String'];
};


export type MutationRegisterDeviceArgs = {
  device: RegisterUserDeviceRequest;
};


export type MutationRegisterMobileArgs = {
  user: RegisterMobileUserRequest;
  waitBackgroundTasks?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRegisterSocialMediaArgs = {
  user: RegisterSocialMediaUserRequest;
  waitBackgroundTasks?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRejectSignedAppointmentLetterArgs = {
  appointmentLetterId: Scalars['String'];
  rejectionDescription: Scalars['String'];
  rejectionTitle: Scalars['String'];
};


export type MutationReleaseAnyProjectUnitLockArgs = {
  unitId: Scalars['String'];
};


export type MutationReleaseProjectUnitLockArgs = {
  unitId: Scalars['String'];
};


export type MutationRemoveBlacklistArgs = {
  agencyId: Scalars['String'];
  blacklistedUserId: Scalars['String'];
  teamId: Scalars['String'];
};


export type MutationRemoveDeviceArgs = {
  device: RemoveUserDeviceRequest;
};


export type MutationRemoveLoanArgs = {
  date?: InputMaybe<Scalars['Date']>;
  loanId: Scalars['String'];
  transactionId: Scalars['String'];
};


export type MutationRemoveShowroomOperationDetailsArgs = {
  parentProjectId: Scalars['String'];
};


export type MutationRemoveWhitelistItemArgs = {
  projectId?: InputMaybe<Scalars['String']>;
  whitelistItemId: Scalars['String'];
};


export type MutationRemoveWhitelistItemsArgs = {
  projectInquiryIds: Array<Scalars['ID']>;
};


export type MutationRenameFileArgs = {
  fileId: Scalars['String'];
  newName: Scalars['String'];
};


export type MutationRequestBookingVerificationArgs = {
  buyers: Array<RequestBookingVerificationBuyer>;
  parentProjectId: Scalars['ID'];
  sourceOfFinance?: InputMaybe<InputTransactionSourceOfFinance>;
  unitId?: InputMaybe<Scalars['ID']>;
};


export type MutationRequestCommissionPayoutArgs = {
  claim: InputRequestCommissionPayoutClaim;
  emailBody: Scalars['String'];
  emailSubject: Scalars['String'];
  harmCommissionPercentage: Scalars['Float'];
};


export type MutationRequestWhoPayArgs = {
  applicants: Array<RequestWhoPayApplicant>;
  appliedDiscountIds: Array<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  loanPercentage: Scalars['Float'];
  skipConsent?: InputMaybe<Scalars['Boolean']>;
  unitId: Scalars['String'];
  waitBackgroundTasks?: InputMaybe<Scalars['Boolean']>;
};


export type MutationResendInvoiceRequestEmailArgs = {
  invoiceRequestId: Scalars['String'];
};


export type MutationScheduleDocumentSigningArgs = {
  date?: InputMaybe<Scalars['Date']>;
  document: DocumentSigningRequest;
  sequenceId: Scalars['String'];
};


export type MutationSelectLawyerArgs = {
  date?: InputMaybe<Scalars['Date']>;
  lawyerId: Scalars['String'];
  transactionId: Scalars['String'];
};


export type MutationSelectOtherLoanArgs = {
  date?: InputMaybe<Scalars['Date']>;
  detail: Scalars['String'];
  transactionId: Scalars['String'];
};


export type MutationSelectPanelBankersArgs = {
  bankers: Array<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
  sequenceId: Scalars['String'];
};


export type MutationSelectPanelLawyerArgs = {
  date?: InputMaybe<Scalars['Date']>;
  documentType: Scalars['String'];
  lawyerId: Scalars['String'];
  transactionId: Scalars['String'];
};


export type MutationSelectPersonalBankerArgs = {
  banker: PersonalBankerRequest;
  date?: InputMaybe<Scalars['Date']>;
  sequenceId: Scalars['String'];
};


export type MutationSelectPersonalLawyerArgs = {
  date?: InputMaybe<Scalars['Date']>;
  documentType: Scalars['String'];
  email: Scalars['String'];
  fullName: Scalars['String'];
  lawyerFirm: Scalars['String'];
  mobileNum: Scalars['String'];
  personInCharge: Scalars['String'];
  transactionId: Scalars['String'];
};


export type MutationSendChannelNewTopicArgs = {
  notificationChannelId: Scalars['String'];
};


export type MutationSendChannelNotificationArgs = {
  files?: InputMaybe<Array<Upload>>;
  message: Scalars['String'];
  messageId: Scalars['String'];
  notificationChannelId: Scalars['String'];
};


export type MutationSendVerificationEmailArgs = {
  info: EmailVerificationUserRequest;
};


export type MutationSetAgentLeadStatusArgs = {
  agentLeadId: Scalars['String'];
  status?: InputMaybe<AgentLeadStatus>;
};


export type MutationSetAnyProjectUnitLockArgs = {
  lockDurationInMilliseconds?: InputMaybe<Scalars['Int']>;
  lockedOn?: InputMaybe<Scalars['String']>;
  minutes?: InputMaybe<Scalars['Int']>;
  unitId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationSetArmSchedulePreferencesArgs = {
  preferences: Array<Preferences>;
};


export type MutationSetBlockedDaysArgs = {
  blockedDays: Array<BlockedDays>;
};


export type MutationSetDocumentStampingDateArgs = {
  date?: InputMaybe<Scalars['Date']>;
  documentType: Scalars['String'];
  stampingDate?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
};


export type MutationSetProjectUnitLockArgs = {
  bookingVerificationId?: InputMaybe<Scalars['ID']>;
  lockDurationInMilliseconds?: InputMaybe<Scalars['Float']>;
  lockedOn?: InputMaybe<Scalars['String']>;
  unitId: Scalars['String'];
};


export type MutationSetTransactionPriceArgs = {
  amount?: InputMaybe<Scalars['Float']>;
  transactionId: Scalars['String'];
  transactionPriceType: TransactionPriceType;
};


export type MutationSortCoverImagesArgs = {
  parentProjectId: Scalars['String'];
  sortedCoverImageIds: Array<Scalars['String']>;
};


export type MutationSubmitBookingFormArgs = {
  agentCooperationId?: InputMaybe<Scalars['String']>;
  bankerAssignmentPreference?: InputMaybe<TransactionBankerAssignmentPreference>;
  bookingVerificationId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['String']>;
  form: BookingFormRequest;
  prelaunchTransactionId?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  skipLoanPrediction?: InputMaybe<Scalars['Boolean']>;
  unitLockId?: InputMaybe<Scalars['ID']>;
  waitBackgroundTasks?: InputMaybe<Scalars['Boolean']>;
  waitFormGeneration?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSubmitCancellationArgs = {
  date?: InputMaybe<Scalars['Date']>;
  reason?: InputMaybe<Scalars['String']>;
  sequenceId: Scalars['String'];
  waitBackgroundTasks?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSubmitLoanDecisionArgs = {
  date?: InputMaybe<Scalars['Date']>;
  loanId: Scalars['String'];
  sequenceId: Scalars['String'];
};


export type MutationSubmitLoanDocumentArgs = {
  date?: InputMaybe<Scalars['Date']>;
  loanId: Scalars['String'];
  sequenceId: Scalars['String'];
};


export type MutationSubmitLoanResultArgs = {
  date?: InputMaybe<Scalars['Date']>;
  result: LoanResultRequest;
  sequenceId: Scalars['String'];
};


export type MutationSubmitPreferenceOptionsArgs = {
  preference: ProjectPreference;
};


export type MutationSubmitReferralCodeArgs = {
  referralCode: Scalars['String'];
};


export type MutationSubmitSaleInterestArgs = {
  projectId: Scalars['String'];
  submittedOn?: InputMaybe<Scalars['String']>;
};


export type MutationSubmitTransactionRhbLoanApplicationArgs = {
  date?: InputMaybe<Scalars['Date']>;
  loanId: Scalars['ID'];
  transactionId: Scalars['ID'];
};


export type MutationSwitchIdentityArgs = {
  userId: Scalars['String'];
};


export type MutationTerminateProjectCommissionTncAgreementArgs = {
  effectiveDate: Scalars['Date'];
  id: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationTestPrinterArgs = {
  parentProjectId: Scalars['String'];
};


export type MutationToggleDeveloperCommissionBatchArgs = {
  developerCommissionBatchId: Scalars['String'];
  transactionId: Scalars['String'];
};


export type MutationToggleDiscountsArgs = {
  discountIds: Array<Scalars['String']>;
  transactionId: Scalars['String'];
};


export type MutationToggleHighriseLandedPriceChartArgs = {
  parentProjectId: Scalars['String'];
};


export type MutationUnassignTeamViceArgs = {
  memberId?: InputMaybe<Scalars['String']>;
  teamCode: Scalars['String'];
};


export type MutationUnchooseLoanInfoArgs = {
  loanId: Scalars['String'];
  transactionId: Scalars['String'];
};


export type MutationUndoEventArgs = {
  eventId: Scalars['String'];
  reason: Scalars['String'];
  transactionId: Scalars['String'];
};


export type MutationUndoTransactionCancellationConfirmationArgs = {
  transactionId: Scalars['ID'];
};


export type MutationUndoTransactionCancellationFormSubmissionArgs = {
  transactionId: Scalars['ID'];
};


export type MutationUndoTransactionCancellationSubmissionArgs = {
  transactionId: Scalars['ID'];
};


export type MutationUpdateAgencyDetailsArgs = {
  address?: InputMaybe<Scalars['String']>;
  agencyId: Scalars['String'];
  agencyType: AgencyType;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  hotline?: InputMaybe<Scalars['String']>;
  logoFile?: InputMaybe<Array<Upload>>;
  name?: InputMaybe<Scalars['String']>;
  officeNum?: InputMaybe<Scalars['String']>;
  parentAgencyId?: InputMaybe<Scalars['String']>;
  registrationNum?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateAgentCanViewGeneratedFormsArgs = {
  agentCanViewGeneratedForms: Scalars['Boolean'];
  parentProjectId: Scalars['String'];
};


export type MutationUpdateAgentInfoArgs = {
  newAgentInfoRequest: NewAgentInfoRequest;
};


export type MutationUpdateAgentLeadProjectInterestedArgs = {
  agentLeadId: Scalars['String'];
  projectIds: Array<Scalars['String']>;
};


export type MutationUpdateAgentLeadSourceArgs = {
  agentLeadId: Scalars['String'];
  source?: InputMaybe<AgentLeadSources>;
};


export type MutationUpdateAgentLeadsArgs = {
  agentLeadIds: Array<Scalars['String']>;
  scheduleId: Scalars['String'];
};


export type MutationUpdateAllCustomPdfArgs = {
  graphqlCustomPDFs: Array<GraphQlMutationCustomPdf>;
  projectId: Scalars['String'];
};


export type MutationUpdateAppointmentLetterArgs = {
  agencyId?: InputMaybe<Scalars['String']>;
  autoRenew?: InputMaybe<Scalars['Boolean']>;
  childProjectId?: InputMaybe<Scalars['String']>;
  commencementDate?: InputMaybe<Scalars['String']>;
  commissionTiers?: InputMaybe<Array<InputAppointmentLetterCommissionTier>>;
  expiryDate?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  parentProjectId?: InputMaybe<Scalars['String']>;
  physicalCopyReceivedConfirmed?: InputMaybe<Scalars['Boolean']>;
  signedVersionVerified?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateArmCommissionSettingsArgs = {
  armCommissionSettings: InputArmCommissionSettings;
  childProjectId: Scalars['String'];
  relativeDate?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateBookingFormArgs = {
  form: PropertyRegistrationForm;
  mode: UpdateBookingFormMode;
  projectId: Scalars['String'];
};


export type MutationUpdateBookingStepsArgs = {
  bookingSteps: Array<Scalars['String']>;
  projectId: Scalars['String'];
};


export type MutationUpdateBookingStepsFileArgs = {
  fileId: Scalars['String'];
  newName?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};


export type MutationUpdateBuyerLeadDistributionArgs = {
  advertisementIds?: InputMaybe<Array<Scalars['String']>>;
  beneficiaryAgents?: InputMaybe<Array<Scalars['String']>>;
  dedup?: InputMaybe<Scalars['Boolean']>;
  distributionMechanism?: InputMaybe<BuyerLeadDistributionDistributionMechanism>;
  id: Scalars['String'];
  markAsDeleted?: InputMaybe<Scalars['Boolean']>;
  parentProjectId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateBuyerLeadStatusArgs = {
  buyerLeadId: Scalars['String'];
  date?: InputMaybe<Scalars['String']>;
  secondaryStatus?: InputMaybe<Scalars['String']>;
  status: BuyerLeadPrimaryStatus;
};


export type MutationUpdateChildProjectCommissionSettingsArgs = {
  childProjectId: Scalars['String'];
  commissionSettings: Array<InputChildProjectCommissionSettings>;
};


export type MutationUpdateChildProjectDetailArgs = {
  bookingFee: Scalars['Float'];
  childProjectId: Scalars['String'];
  launchedOn?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};


export type MutationUpdateCommissionInfosArgs = {
  commissionInfos: Array<Scalars['String']>;
  projectId: Scalars['String'];
};


export type MutationUpdateCoverImagesArgs = {
  fileId: Scalars['String'];
  newName?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};


export type MutationUpdateCustomFieldValueArgs = {
  fieldName: Scalars['String'];
  fieldValue?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
};


export type MutationUpdateCustomPdfImageArgs = {
  files: Array<Upload>;
  index: Scalars['Int'];
  projectId: Scalars['String'];
};


export type MutationUpdateDdnPropertyStatusArgs = {
  id: Scalars['ID'];
};


export type MutationUpdateDeveloperCommissionBatchesArgs = {
  batches: Array<InputDeveloperCommissionBatch>;
  parentProjectId: Scalars['String'];
};


export type MutationUpdateDeveloperInfoArgs = {
  developerId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationUpdateDiscountsArgs = {
  discounts: Array<UpdatedDiscount>;
  projectId: Scalars['String'];
};


export type MutationUpdateDocumentTemplateArgs = {
  childProjectId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  markAsDeleted?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parentProjectId?: InputMaybe<Scalars['String']>;
  template: Scalars['String'];
};


export type MutationUpdateEntitlementImageArgs = {
  input: InputUpdateEntitlementImage;
};


export type MutationUpdateEstoreProjectTeaserArgs = {
  colors: InputEstoreProjectTeaserColors;
  description: InputEstoreProjectTeaserDescription;
  featurePoints: Array<Scalars['ID']>;
  from: Scalars['Float'];
  keySellingPoints: Array<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['ID'];
};


export type MutationUpdateEstoreUrlSuffixArgs = {
  newEstoreUrlSuffix: Scalars['String'];
};


export type MutationUpdateFacilitiesArgs = {
  facilities: Array<Scalars['String']>;
  projectId: Scalars['String'];
};


export type MutationUpdateJmaOnlyArgs = {
  jmaOnly: Scalars['Boolean'];
  parentProjectId: Scalars['String'];
};


export type MutationUpdateJoinTeamRequestArgs = {
  addToBlacklist?: InputMaybe<Scalars['Boolean']>;
  date?: InputMaybe<Scalars['String']>;
  joinTeamRequestId: Scalars['String'];
  type: UpdateJoinTeamRequestType;
};


export type MutationUpdateKeySellingPointsArgs = {
  keySellingPoints: Array<Scalars['String']>;
  projectId: Scalars['String'];
};


export type MutationUpdateLandedPriceChartArgs = {
  childProjectId: Scalars['String'];
  layout: UpdateLandedPriceChartLayout;
};


export type MutationUpdateMarketingMaterialArgs = {
  fileId: Scalars['String'];
  newName?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};


export type MutationUpdateNoteModeArgs = {
  isPublic: Scalars['Boolean'];
  noteId: Scalars['String'];
};


export type MutationUpdatePaymentInfosArgs = {
  paymentInfos: Array<PaymentInfo>;
  projectId: Scalars['String'];
};


export type MutationUpdatePopupAdArgs = {
  input: InputUpdatePopupAd;
  testInput?: InputMaybe<TestInputUpdatePopupAd>;
};


export type MutationUpdatePriceChartLayoutArgs = {
  childProjectId: Scalars['String'];
  layout: InputProjectLayout;
};


export type MutationUpdateProjectAgentCooperationArgs = {
  agentCooperation: InputProjectAgentCooperation;
  parentProjectId: Scalars['String'];
};


export type MutationUpdateProjectCategoriesArgs = {
  projectCategories: Array<InputProjectCategory>;
};


export type MutationUpdateProjectCommissionSettingsArgs = {
  commissionSettings: InputProjectCommissionSettings;
  parentProjectId: Scalars['String'];
};


export type MutationUpdateProjectFaqsArgs = {
  faqSections: Array<ProjectFaqSection>;
  parentProjectId: Scalars['String'];
};


export type MutationUpdateProjectHandlerArgs = {
  agencyId: Scalars['String'];
  agencyType: AgencyType;
  mode: UpdateProjectHandlerMode;
  projectId: Scalars['String'];
};


export type MutationUpdateProjectInquiryStatusArgs = {
  projectInquiryIds: Array<Scalars['ID']>;
};


export type MutationUpdateProjectStatusArgs = {
  projectId: Scalars['String'];
  status: ProjectStatus;
};


export type MutationUpdateProjectSummaryArgs = {
  description: Scalars['String'];
  estimatedCompletion: Scalars['String'];
  location: InputProjectLocation;
  name: Scalars['String'];
  noOfBathrooms: Array<Scalars['String']>;
  noOfBedrooms: Array<Scalars['String']>;
  noOfCarParks: Array<Scalars['String']>;
  pricePerSquareFt: Scalars['String'];
  priceRange: Scalars['String'];
  projectId: Scalars['String'];
  sizeRange?: InputMaybe<Scalars['String']>;
  tenure: Scalars['String'];
};


export type MutationUpdateProjectSupportPersonnelsArgs = {
  parentProjectId: Scalars['String'];
  supportPersonnels: Array<InputSupportPersonnel>;
};


export type MutationUpdateProjectTagsArgs = {
  projectId: Scalars['String'];
  tags: Array<InputProjectTag>;
};


export type MutationUpdateProjectTypeArgs = {
  id: Scalars['ID'];
  projectType: ProjectType;
};


export type MutationUpdateRewardGroupDetailsArgs = {
  color: InputColor;
  description: Scalars['String'];
  name: Scalars['String'];
  rewardGroupId: Scalars['String'];
};


export type MutationUpdateRewardGroupPictureArgs = {
  fileId: Scalars['String'];
  rewardGroupId: Scalars['String'];
};


export type MutationUpdateSalesPackageArgs = {
  fileId: Scalars['String'];
  newName?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};


export type MutationUpdateShowroomOperationDetailsArgs = {
  activePeriods: InputActivePeriods;
  agencyLimits?: InputMaybe<Array<InputAgencyLimit>>;
  attendeesLimit?: InputMaybe<InputAttendeesLimit>;
  canStillBookWhenLimitReached: Scalars['Boolean'];
  customerLimitPerTimeSlot: Scalars['Int'];
  parentProjectId: Scalars['String'];
  requiresCustomerCarPlate: Scalars['Boolean'];
  slotDuration: Scalars['Int'];
};


export type MutationUpdateTeaserImagesArgs = {
  images: Array<InputAttachedFile>;
  projectId: Scalars['String'];
};


export type MutationUpdateTransactionAgentsArgs = {
  agents: Array<TransactionAgent>;
  transactionId: Scalars['String'];
};


export type MutationUpdateUnitArgs = {
  address?: InputMaybe<Scalars['String']>;
  defaultLawyerId?: InputMaybe<Scalars['String']>;
  entrance?: InputMaybe<Scalars['String']>;
  grossPrice: Scalars['Float'];
  houseNum?: InputMaybe<Scalars['String']>;
  inputBookingMethod?: InputMaybe<InputProjectUnitBookingMethod>;
  landSize?: InputMaybe<Scalars['String']>;
  staircase?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  unitId: Scalars['String'];
  unitNum: Scalars['String'];
};


export type MutationUpdateUnitMixArgs = {
  projectId: Scalars['String'];
  unitMix: Array<UnitMix>;
};


export type MutationUpdateUnitsArgs = {
  address?: InputMaybe<Scalars['String']>;
  defaultLawyerId?: InputMaybe<Scalars['String']>;
  entrance?: InputMaybe<Scalars['String']>;
  grossPrice?: InputMaybe<Scalars['Float']>;
  houseNum?: InputMaybe<Scalars['String']>;
  landSize?: InputMaybe<Scalars['String']>;
  staircase?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  unitIds: Array<Scalars['String']>;
};


export type MutationUpdateWhitelisterArgs = {
  newArmId: Scalars['String'];
  projectId?: InputMaybe<Scalars['String']>;
  whitelistItemId: Scalars['String'];
};


export type MutationUploadAdditionalPaymentSlipsArgs = {
  additionalPaymentSlips: Array<Upload>;
  date?: InputMaybe<Scalars['String']>;
  paymentSlipId: Scalars['String'];
};


export type MutationUploadAppointmentLetterTemplateArgs = {
  agencyId: Scalars['String'];
  appointmentLetterTemplates: Array<Upload>;
  autoRenew?: InputMaybe<Scalars['Boolean']>;
  childProjectId?: InputMaybe<Scalars['String']>;
  commencementDate: Scalars['String'];
  commissionTiers: Array<InputAppointmentLetterCommissionTier>;
  expiryDate: Scalars['String'];
  notifyPIC: Scalars['Boolean'];
  parentProjectId: Scalars['String'];
};


export type MutationUploadBookingStepsFilesArgs = {
  files: Array<Upload>;
  projectId: Scalars['String'];
};


export type MutationUploadCoverImagesArgs = {
  files: Array<Upload>;
  projectId: Scalars['String'];
};


export type MutationUploadCustomPdfImagesArgs = {
  files: Array<Upload>;
  index: Scalars['Int'];
  projectId: Scalars['String'];
};


export type MutationUploadDocumentsArgs = {
  documents: Array<Upload>;
  transactionId: Scalars['String'];
};


export type MutationUploadFilesArgs = {
  compressImage?: InputMaybe<Scalars['Boolean']>;
  files: Array<Upload>;
  visibility?: InputMaybe<UploadFileVisibility>;
};


export type MutationUploadFilesForMultipleTransactionsArgs = {
  files: Array<Upload>;
  transactionIds: Array<Scalars['String']>;
};


export type MutationUploadMarketingMaterialsArgs = {
  documents: Array<Upload>;
  projectId: Scalars['String'];
  sendNotification?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUploadPanelBankersArgs = {
  bankers: Array<PanelBanker>;
  parentProjectId: Scalars['String'];
};


export type MutationUploadSalesPackagesArgs = {
  files: Array<Upload>;
  projectId: Scalars['String'];
  sendNotification?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUploadSignedAppointmentLetterArgs = {
  appointmentLetterId: Scalars['String'];
  signedAppointmentLetters: Array<Upload>;
  token: Scalars['String'];
};


export type MutationUploadTransactionCommissionInvoiceArgs = {
  date?: InputMaybe<Scalars['Date']>;
  invoice: Array<Upload>;
  invoiceRequestIds: Array<Scalars['String']>;
  token: Scalars['String'];
};


export type MutationUploadTransactionCommissionPaymentSlipArgs = {
  commissionPaymentDelayReasons?: InputMaybe<Array<InputCommissionPaymentDelayReason>>;
  date?: InputMaybe<Scalars['String']>;
  paymentSlip: Array<Upload>;
  transactionCommissionInvoiceIds: Array<Scalars['String']>;
};


export type MutationVerifyBookingFormArgs = {
  date?: InputMaybe<Scalars['Date']>;
  payments: Array<VerifyBookingFormPayment>;
  proofs?: InputMaybe<Array<Upload>>;
  sequenceId: Scalars['String'];
};


export type MutationVerifyTransactionCommissionInvoiceArgs = {
  date?: InputMaybe<Scalars['Date']>;
  transactionCommissionInvoiceId: Scalars['String'];
};


export type MutationVerifyUserArgs = {
  awardReferral?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};


export type MutationVoidRewardArgs = {
  rewardId: Scalars['String'];
};


export type MutationVoidTransactionCommissionInvoiceRequestsArgs = {
  commissionPortionId: Scalars['ID'];
  reason: Scalars['String'];
};


export type MutationVoidTransactionCommissionPaymentSlipArgs = {
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['String'];
};


export type MutationWhitelistAgentsArgs = {
  projectInquiryIds: Array<Scalars['ID']>;
  relativeDate?: InputMaybe<Scalars['Date']>;
};


export type MutationWhitelistIndividualAgentArgs = {
  agentId: Scalars['String'];
  projectId: Scalars['String'];
  relativeDate?: InputMaybe<Scalars['String']>;
  remarks: Scalars['String'];
  scheduleId?: InputMaybe<Scalars['String']>;
};

export type NettPriceResult = {
  __typename?: 'NettPriceResult';
  nettPrice: Scalars['Float'];
  /**
   * Steps are actually 2D array of discounts showing the calculation steps
   * Refer: src/graphql/definitions/object/nett-price-result-step.graphql
   */
  steps: Array<NettPriceResultStep>;
};

export type NettPriceResultStep = {
  __typename?: 'NettPriceResultStep';
  /** Refer: src/graphql/definitions/object/step-discount.graphql */
  discountsOnCurrentStep: Array<StepDiscount>;
  remainingAmount: Scalars['Float'];
};

export type NewAgentInfoRequest = {
  agencyId?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/input/upload.graphql */
  profilePicture?: InputMaybe<Array<Upload>>;
  profilePictureUri?: InputMaybe<Scalars['String']>;
};

export type NewAgentLead = {
  agencyName: Scalars['String'];
  fullName: Scalars['String'];
  handleBy?: InputMaybe<Scalars['String']>;
  mobileNum: Scalars['String'];
  renTag: Scalars['String'];
  /** Refer: src/graphql/definitions/input/agent-lead-source.graphql */
  source?: InputMaybe<AgentLeadSource>;
};

export type NewBuyer = {
  addressDetails?: InputMaybe<Scalars['String']>;
  addressPlaceId?: InputMaybe<Scalars['ID']>;
  /** Refer: src/graphql/definitions/input/buyer-address.graphql */
  addresses: Array<BuyerAddress>;
  citizenship: Scalars['String'];
  companyAddressDetails?: InputMaybe<Scalars['String']>;
  companyAddressPlaceId?: InputMaybe<Scalars['ID']>;
  companyName?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  employerAddress: Scalars['String'];
  employerName: Scalars['String'];
  exactMonthlyIncome?: InputMaybe<Scalars['Float']>;
  fullName: Scalars['String'];
  gender: Scalars['String'];
  houseNum: Scalars['String'];
  /** Refer: src/graphql/definitions/input/input-buyer-income-type.graphql */
  incomeType?: InputMaybe<InputBuyerIncomeType>;
  industry?: InputMaybe<Scalars['String']>;
  isBumi?: InputMaybe<Scalars['Boolean']>;
  maritalStatus: Scalars['String'];
  mobileNum: Scalars['String'];
  monthlyIncome: Scalars['String'];
  nric: Scalars['String'];
  nricCopyBackIds?: InputMaybe<Array<Scalars['ID']>>;
  nricCopyFrontIds?: InputMaybe<Array<Scalars['ID']>>;
  occupation: Scalars['String'];
  officeNum: Scalars['String'];
  race: Scalars['String'];
  signatureId?: InputMaybe<Scalars['ID']>;
};

export type Note = {
  __typename?: 'Note';
  /** Refer: src/graphql/definitions/object/user.graphql */
  author?: Maybe<User>;
  content: Scalars['String'];
  createdOn: Scalars['String'];
  /** Refer: src/graphql/definitions/object/note-edit-history.graphql */
  editHistories: Array<NoteEditHistory>;
  /** Only exists if this note is auto-generated */
  eventId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPublic?: Maybe<Scalars['Boolean']>;
  isSystemGenerated: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/note-owner.graphql */
  owner: NoteOwner;
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  transaction?: Maybe<Transaction>;
};

export type NoteEditHistory = {
  __typename?: 'NoteEditHistory';
  /** Refer: src/graphql/definitions/object/user.graphql */
  by?: Maybe<User>;
  from: Scalars['String'];
  on: Scalars['String'];
  to: Scalars['String'];
};

export type NoteOwner = {
  __typename?: 'NoteOwner';
  displayName: Scalars['String'];
  id: Scalars['ID'];
};

export type Notification = {
  __typename?: 'Notification';
  /** Refer: src/graphql/definitions/object/block.graphql */
  block?: Maybe<Block>;
  body: Scalars['String'];
  /** Refer: src/graphql/definitions/object/buyer-lead.graphql */
  buyerLead?: Maybe<BuyerLead>;
  /**
   * This call to actions is what we use to show the buttons in the notification
   * Refer: src/graphql/definitions/union/notification-call-to-action.graphql
   */
  callToActions?: Maybe<Array<NotificationCallToAction>>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy?: Maybe<User>;
  createdOn: Scalars['String'];
  deleted?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  files: Array<UploadedFile>;
  /**
   * This index is only available for GPT notification
   * To show the index of the notification after a new topic when its paginated
   */
  gptNotificationIndexInTopic?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  /** If this is true, it means that the requester is same as the author (a.k.a createdBy) of this notification */
  isMe: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/notification-link.graphql */
  learnMoreLink?: Maybe<NotificationLink>;
  /** Refer: src/graphql/definitions/object/notification-channel.graphql */
  notificationChannel?: Maybe<NotificationChannel>;
  /** Refer: src/graphql/definitions/object/project.graphql */
  project?: Maybe<Project>;
  push: Scalars['Boolean'];
  /**
   * This rating is currently used for GPT notification
   * Refer: src/graphql/definitions/object/notification-rating.graphql
   */
  rating?: Maybe<NotificationRating>;
  /** If this is true, it means that it is read by the retriever of this notification. */
  read?: Maybe<Scalars['Boolean']>;
  /** If this is true, it means that all targeted users of this notification has read this notification. */
  readByAll?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/object/notification-read.graphql */
  reads: Array<NotificationRead>;
  /** Refer: src/graphql/definitions/object/schedule.graphql */
  schedule?: Maybe<Schedule>;
  /**
   * This determines if the app will redirect user to the respective CTA or inbox
   * Refer: src/graphql/definitions/enum/notification-severity.graphql
   */
  severity: NotificationSeverity;
  /** Refer: src/graphql/definitions/object/user.graphql */
  targetedUsers: Array<User>;
  targetedUsersLength: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/agency-team.graphql */
  team?: Maybe<AgencyTeam>;
  title: Scalars['String'];
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  transaction?: Maybe<Transaction>;
  type: Scalars['String'];
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  unit?: Maybe<ProjectUnit>;
};

/**
 * Refer: src/graphql/definitions/object/notification-call-to-action-link.graphql
 * Refer: src/graphql/definitions/object/notification-call-to-action-app-screen.graphql
 */
export type NotificationCallToAction = NotificationCallToActionAppScreen | NotificationCallToActionLink;

export type NotificationCallToActionAppScreen = {
  __typename?: 'NotificationCallToActionAppScreen';
  /** Refer: src/graphql/definitions/union/app-screen.graphql */
  appScreen: AppScreen;
  label: Scalars['String'];
};

export type NotificationCallToActionLink = {
  __typename?: 'NotificationCallToActionLink';
  label: Scalars['String'];
  link: Scalars['String'];
};

export type NotificationChannel = {
  __typename?: 'NotificationChannel';
  /** To indicate whether the user querying this data can send message in this channel. */
  canSendMessage: Scalars['Boolean'];
  /**
   * The current users that are in this channel.
   * Metadata of each user regarding this channel are also included.
   * Refer: src/graphql/definitions/object/notification-channel-user.graphql
   */
  channelUsers: Array<NotificationChannelUser>;
  id: Scalars['ID'];
  name: Scalars['String'];
  numberOfUsers: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  requestingUser: User;
  /**
   * The current members that are in this channel.
   * Refer: src/graphql/definitions/object/user.graphql
   * @deprecated Use channelUsers instead.
   */
  users: Array<User>;
  /** Refer: src/graphql/definitions/union/notification-channel-variant.graphql */
  variant: NotificationChannelVariant;
};

export type NotificationChannelUser = {
  __typename?: 'NotificationChannelUser';
  roleDescription?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  user: User;
};

/**
 * Refer: src/graphql/definitions/object/notification-channel-variant-private.graphql
 * Refer: src/graphql/definitions/object/notification-channel-variant-agency-team.graphql
 * Refer: src/graphql/definitions/object/notification-channel-variant-project-agent.graphql
 * Refer: src/graphql/definitions/object/notification-channel-variant-project-agent-gpt.graphql
 * Refer: src/graphql/definitions/object/notification-channel-variant-project-agency-team.graphql
 * Refer: src/graphql/definitions/object/notification-channel-variant-general-support.graphql
 * Refer: src/graphql/definitions/object/notification-channel-variant-agent-cooperation.graphql
 */
export type NotificationChannelVariant = NotificationChannelVariantAgencyTeam | NotificationChannelVariantAgentCooperation | NotificationChannelVariantGeneralSupport | NotificationChannelVariantPrivate | NotificationChannelVariantProjectAgencyTeam | NotificationChannelVariantProjectAgent | NotificationChannelVariantProjectAgentGpt;

export type NotificationChannelVariantAgencyTeam = {
  __typename?: 'NotificationChannelVariantAgencyTeam';
  /** Refer: src/graphql/definitions/object/agency-team.graphql */
  team: AgencyTeam;
};

export type NotificationChannelVariantAgentCooperation = {
  __typename?: 'NotificationChannelVariantAgentCooperation';
  /** Refer: src/graphql/definitions/object/agent-cooperation.graphql */
  cooperation: AgentCooperation;
  /** To bypass syntax error only, please do not query */
  dummy?: Maybe<Scalars['String']>;
};

export type NotificationChannelVariantGeneralSupport = {
  __typename?: 'NotificationChannelVariantGeneralSupport';
  /** Return trues if the user ID of this channel is same as the requesting user */
  isMine: Scalars['Boolean'];
};

export type NotificationChannelVariantPrivate = {
  __typename?: 'NotificationChannelVariantPrivate';
  profilePicture?: Maybe<Scalars['String']>;
};

export type NotificationChannelVariantProjectAgencyTeam = {
  __typename?: 'NotificationChannelVariantProjectAgencyTeam';
  /** To bypass syntax error only, please do not query */
  dummy?: Maybe<Scalars['String']>;
};

export type NotificationChannelVariantProjectAgent = {
  __typename?: 'NotificationChannelVariantProjectAgent';
  /** To bypass syntax error only, please do not query */
  dummy?: Maybe<Scalars['String']>;
};

export type NotificationChannelVariantProjectAgentGpt = {
  __typename?: 'NotificationChannelVariantProjectAgentGPT';
  dummy?: Maybe<Scalars['String']>;
};

export type NotificationLink = {
  __typename?: 'NotificationLink';
  type: Scalars['String'];
  url: Scalars['String'];
};

export type NotificationRating = {
  __typename?: 'NotificationRating';
  /** Refer: src/graphql/definitions/object/notification-rating-feedback.graphql */
  feedback?: Maybe<NotificationRatingFeedback>;
  id: Scalars['Int'];
  /** Refer: src/graphql/definitions/enum/notification-rating-type.graphql */
  type: NotificationRatingType;
};

export type NotificationRatingFeedback = {
  __typename?: 'NotificationRatingFeedback';
  reasonElaborated?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/enum/notification-rating-feedback-reason-preset.graphql */
  reasonPreset: NotificationRatingFeedbackReasonPreset;
};

export enum NotificationRatingFeedbackReasonPreset {
  Inaccurate = 'INACCURATE',
  Inappropriate = 'INAPPROPRIATE',
  Irrelevant = 'IRRELEVANT',
  Offensive = 'OFFENSIVE',
  Other = 'OTHER'
}

export enum NotificationRatingType {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export type NotificationRead = {
  __typename?: 'NotificationRead';
  on: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  user?: Maybe<User>;
};

export enum NotificationSeverity {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type OldUnit = {
  __typename?: 'OldUnit';
  projectName: Scalars['String'];
  proofs: Array<Scalars['String']>;
  unitGrossPrice?: Maybe<Scalars['Float']>;
  unitNum: Scalars['String'];
};

export type PagingOptions = {
  /** Starts with zero. */
  currentPage: Scalars['Int'];
  itemsPerPage: Scalars['Int'];
};

export type PaglessAgency = {
  __typename?: 'PaglessAgency';
  /** Refer: src/graphql/definitions/object/agency.graphql */
  agency: Agency;
  /** Refer: src/graphql/definitions/object/child-project.graphql */
  childProject: ChildProject;
  /**
   * Will be undefined if the requesting user do not have permission to display transactions.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  transactions?: Maybe<Array<Transaction>>;
  transactionsCount: Scalars['Int'];
};

export type PanelBanker = {
  bankName: Scalars['String'];
  email: Scalars['String'];
  mobileNum: Scalars['String'];
  name: Scalars['String'];
};

export type ParentProject = {
  __typename?: 'ParentProject';
  agentCanViewGeneratedForms: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/project-agent-cooperation.graphql */
  agentCooperation?: Maybe<ProjectAgentCooperation>;
  allowRequestFinancialReport: Scalars['Boolean'];
  allowSchedule: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/arm.graphql */
  arms: Array<Arm>;
  /** Refer: src/graphql/definitions/object/project-printer.graphql */
  associatedPrinter?: Maybe<ProjectPrinter>;
  /** Refer: src/graphql/definitions/object/booking-step.graphql */
  bookingSteps: BookingStep;
  /** Indicate that project have Chat GPT prompts or not */
  canPromptChatGPT: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/child-project.graphql */
  children: Array<ChildProject>;
  commissionInfos: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  coverImageFiles?: Maybe<Array<AttachedFile>>;
  createdOn: Scalars['String'];
  /** Refer: src/graphql/definitions/object/agency.graphql */
  developer?: Maybe<Agency>;
  /** Refer: src/graphql/definitions/union/project-developer-commission-batch.graphql */
  developerCommissionBatches: Array<ProjectDeveloperCommissionBatch>;
  /** Refer: src/graphql/definitions/object/project-discount.graphql */
  discounts: Array<ProjectDiscount>;
  /** Refer: src/graphql/definitions/object/estore-project-teaser.graphql */
  estoreProjectTeaser?: Maybe<EstoreProjectTeaser>;
  /** Refer: src/graphql/definitions/object/expression-setting-instruction.graphql */
  expressionSettingInstruction: ExpressionSettingInstruction;
  facilities: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/project-gross-price-range.graphql */
  grossPriceRange: ProjectGrossPriceRange;
  /**
   * Head of ARMS that are in charge of this parent project.
   * Refer: src/graphql/definitions/object/project-harm.graphql
   */
  harms: Array<ProjectHarm>;
  id: Scalars['ID'];
  /** This indicates whether the requester has submitted interest for this project. */
  interestSubmitted: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/jma.graphql */
  jmas: Array<Jma>;
  keySellingPoints: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/enum/launch-status.graphql */
  launchStatus: LaunchStatus;
  launchedOn?: Maybe<Scalars['Date']>;
  /** Refer: src/graphql/definitions/object/project-location.graphql */
  location: ProjectLocation;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  logoFile?: Maybe<AttachedFile>;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  marketingMaterials: Array<AttachedFile>;
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  panelBankers: Array<User>;
  /** Refer: src/graphql/definitions/object/financer.graphql */
  panelBanks: Array<Financer>;
  /** Refer: src/graphql/definitions/object/agency.graphql */
  partnerAgency?: Maybe<Agency>;
  /** Refer: src/graphql/definitions/object/project-payment-info.graphql */
  paymentInfos: Array<ProjectPaymentInfo>;
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  prelaunchTransactions: Array<Transaction>;
  /** Refer: src/graphql/definitions/enum/project-type.graphql */
  projectType: ProjectType;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  salesPackages: Array<AttachedFile>;
  showCtosBanner: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/showroom-operation-details.graphql */
  showroomOperationDetails?: Maybe<ShowroomOperationDetails>;
  /** Refer: src/graphql/definitions/object/project-summary.graphql */
  summary: ProjectSummary;
  /** Refer: src/graphql/definitions/object/project-support-personnel.graphql */
  supportPersonnels: Array<ProjectSupportPersonnel>;
  surveyPreLaunch: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/project-tag.graphql */
  tags: Array<ProjectTag>;
  /** Refer: src/graphql/definitions/object/project-teaser.graphql */
  teaser?: Maybe<ProjectTeaser>;
  /** Refer: src/graphql/definitions/union/project-unit-layout.graphql */
  unitLayout?: Maybe<ProjectUnitLayout>;
  /** Refer: src/graphql/definitions/object/project-unit-mix.graphql */
  unitMix: Array<ProjectUnitMix>;
  /** Refer: src/graphql/definitions/object/project-virtual-sales-galleries.graphql */
  virtualSalesGalleries: Array<ProjectVirtualSalesGalleries>;
  /** This indicates whether the requester is whitelisted for this project. */
  whitelisted: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/whitelist-item.graphql */
  whitelists: Array<WhitelistItem>;
};

export type ParentProjectServiceFeeSetting = {
  __typename?: 'ParentProjectServiceFeeSetting';
  completionDateEnd: Scalars['Date'];
  completionDateStart: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/service-fee-formula.graphql */
  formula: ServiceFeeFormula;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/parent-project.graphql */
  parentProject: ParentProject;
};

export type PartialPag = {
  __typename?: 'PartialPag';
  /**
   * This will only be defined if the related GAG is missing email.
   * Refer: src/graphql/definitions/object/gal-agency-group.graphql
   */
  gagMissingEmail?: Maybe<GalAgencyGroup>;
  /**
   * This will only be defined if the related GAG is missing PIC.
   * Refer: src/graphql/definitions/object/gal-agency-group.graphql
   */
  gagMissingPic?: Maybe<GalAgencyGroup>;
  notLinkedToAnyGag: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/project-agency-group.graphql */
  pag: ProjectAgencyGroup;
  pagMissingPic: Scalars['Boolean'];
  pagMissingTnc: Scalars['Boolean'];
};

export type PaymentInfo = {
  description: Scalars['String'];
  method: Scalars['String'];
};

export type PaymentPortal = {
  __typename?: 'PaymentPortal';
  expiryDate: Scalars['String'];
  /**
   * The GAL agency groups where the requesting user is one of the PICs.
   * Refer: src/graphql/definitions/object/payment-portal-gal-agency-groups.graphql
   */
  galAgencyGroups: PaymentPortalGalAgencyGroups;
  /**
   * For the PIC of a GAL agency group to get the generated GAL.
   * The file is generated from the given GAL template,
   * and should include the details of the given agency group.
   * Refer: src/graphql/definitions/object/generate-gal-response.graphql
   */
  generateGal: GenerateGalResponse;
  /** Refer: src/graphql/definitions/object/payment-portal-invoice-requests.graphql */
  invoiceRequests: PaymentPortalInvoiceRequests;
  /** Refer: src/graphql/definitions/object/payment-portal-invoices.graphql */
  invoices: PaymentPortalInvoices;
  /** Refer: src/graphql/definitions/object/payment-portal-payment-slips.graphql */
  paymentSlips: PaymentPortalPaymentSlips;
  /**
   * The project agency groups where the requesting user is one of the PICs.
   * Refer: src/graphql/definitions/object/payment-portal-project-agency-groups.graphql
   */
  projectAgencyGroups: PaymentPortalProjectAgencyGroups;
  /**
   * The `user` as identified from the `token` provided.
   * Refer: src/graphql/definitions/object/user.graphql
   */
  user: User;
};


export type PaymentPortalGenerateGalArgs = {
  galAgencyGroupId: Scalars['ID'];
  galTemplateId: Scalars['ID'];
};

export type PaymentPortalGalAgencyGroups = {
  __typename?: 'PaymentPortalGalAgencyGroups';
  /** This indicates how many GAL agency groups need action from users. */
  actionNeededCount: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/filtered-gal-agency-groups.graphql */
  findMany: FilteredGalAgencyGroups;
};

export type PaymentPortalInvoiceRequests = {
  __typename?: 'PaymentPortalInvoiceRequests';
  /** This indicates how many invoice requests need action from users. */
  actionNeededCount: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/filtered-transaction-commission-invoice-requests.graphql */
  findMany: FilteredTransactionCommissionInvoiceRequests;
  /** Refer: src/graphql/definitions/object/transaction-commission-invoice-request.graphql */
  findOne: TransactionCommissionInvoiceRequest;
};


export type PaymentPortalInvoiceRequestsFindManyArgs = {
  filter: PaymentPortalInvoiceRequestsFilter;
};


export type PaymentPortalInvoiceRequestsFindOneArgs = {
  id: Scalars['ID'];
};

export enum PaymentPortalInvoiceRequestsFilter {
  PendingInvoice = 'PENDING_INVOICE'
}

export type PaymentPortalInvoices = {
  __typename?: 'PaymentPortalInvoices';
  /** Refer: src/graphql/definitions/object/filtered-transaction-commission-invoices.graphql */
  findMany: FilteredTransactionCommissionInvoices;
};


export type PaymentPortalInvoicesFindManyArgs = {
  filter: PaymentPortalInvoicesFilter;
};

export enum PaymentPortalInvoicesFilter {
  All = 'ALL'
}

export type PaymentPortalMutation = {
  __typename?: 'PaymentPortalMutation';
  /**
   * For the PIC of a project agency group to agree to a project
   * commission TNC.
   * Refer: src/graphql/definitions/object/project-commission-tnc-version-agreement.graphql
   */
  agreeProjectCommissionTnc: ProjectCommissionTncVersionAgreement;
  /**
   * For PIC to upload signed GAL.
   * Refer: src/graphql/definitions/object/gal-signed-copy.graphql
   */
  uploadGalSignedCopy: GalSignedCopy;
};


export type PaymentPortalMutationAgreeProjectCommissionTncArgs = {
  projectAgencyGroupId: Scalars['ID'];
  tncVersionId: Scalars['ID'];
};


export type PaymentPortalMutationUploadGalSignedCopyArgs = {
  file: Upload;
  galAgencyGroupId: Scalars['ID'];
  galTemplateId: Scalars['ID'];
};

export type PaymentPortalPaymentSlips = {
  __typename?: 'PaymentPortalPaymentSlips';
  /** Refer: src/graphql/definitions/object/filtered-transaction-commission-payment-slips.graphql */
  findMany: FilteredTransactionCommissionPaymentSlips;
};


export type PaymentPortalPaymentSlipsFindManyArgs = {
  filter: PaymentPortalPaymentSlipsFilter;
};

export enum PaymentPortalPaymentSlipsFilter {
  NonVoided = 'NON_VOIDED'
}

export type PaymentPortalProjectAgencyGroups = {
  __typename?: 'PaymentPortalProjectAgencyGroups';
  /** This indicates how many project agency groups need action from users. */
  actionNeededCount: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/filtered-project-agency-groups.graphql */
  findMany: FilteredProjectAgencyGroups;
};

export type PendingInvoiceRequestTransactionCommissionType = {
  __typename?: 'PendingInvoiceRequestTransactionCommissionType';
  count: Scalars['Int'];
  type: Scalars['String'];
};

export type Permission = {
  __typename?: 'Permission';
  description: Scalars['String'];
  name: Scalars['String'];
};

export type PersonalBankerRequest = {
  bankId?: InputMaybe<Scalars['ID']>;
  bankName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  mobileNum?: InputMaybe<Scalars['String']>;
};

/**
 * Refer: src/graphql/definitions/object/places-project-autocomplete-place.graphql
 * Refer: src/graphql/definitions/object/places-project-autocomplete-project.graphql
 */
export type PlacesProjectAutocomplete = PlacesProjectAutocompletePlace | PlacesProjectAutocompleteProject;

export type PlacesProjectAutocompletePlace = {
  __typename?: 'PlacesProjectAutocompletePlace';
  amountOfProjects: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/places-project-autocomplete-place-bounds.graphql */
  bounds: PlacesProjectAutocompletePlaceBounds;
  /** Refer: src/graphql/definitions/object/coordinate.graphql */
  coordinate: Coordinate;
  googlePlacesId: Scalars['String'];
  name: Scalars['String'];
};

export type PlacesProjectAutocompletePlaceBounds = {
  __typename?: 'PlacesProjectAutocompletePlaceBounds';
  /** Refer: src/graphql/definitions/object/coordinate.graphql */
  northeast: Coordinate;
  /** Refer: src/graphql/definitions/object/coordinate.graphql */
  southwest: Coordinate;
};

export type PlacesProjectAutocompleteProject = {
  __typename?: 'PlacesProjectAutocompleteProject';
  /** Refer: src/graphql/definitions/object/coordinate.graphql */
  coordinate: Coordinate;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PopupAd = {
  __typename?: 'PopupAd';
  /** Refer: src/graphql/definitions/object/active-period.graphql */
  activePeriod: ActivePeriod;
  /** Refer: src/graphql/definitions/union/app-screen.graphql */
  appScreen?: Maybe<AppScreen>;
  /** Refer: src/graphql/definitions/object/popup-ad-app-screen-redirect-button.graphql */
  appScreenRedirectButton?: Maybe<PopupAdAppScreenRedirectButton>;
  body: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['String'];
  externalUrl?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  file: AttachedFile;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/popup-ad-live.graphql */
  live?: Maybe<PopupAdLive>;
  title: Scalars['String'];
};

export type PopupAdAppScreenRedirectButton = {
  __typename?: 'PopupAdAppScreenRedirectButton';
  label?: Maybe<Scalars['String']>;
};

export type PopupAdLive = {
  __typename?: 'PopupAdLive';
  /** Refer: src/graphql/definitions/object/user.graphql */
  by: User;
  on: Scalars['String'];
};

export type PostText = {
  contents: Array<Scalars['String']>;
  italic: Scalars['Boolean'];
};

export type PostlaunchBookingDraft = {
  __typename?: 'PostlaunchBookingDraft';
  /** Refer: src/graphql/definitions/enum/transaction-banker-assignment-preference.graphql */
  bankerAssignmentPreference?: Maybe<TransactionBankerAssignmentPreference>;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-custom-field.graphql */
  customFields?: Maybe<Array<PostlaunchBookingDraftCustomField>>;
  epfContribution?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/enum/booking-draft-finance-source.graphql */
  financeSource?: Maybe<BookingDraftFinanceSource>;
  firstTimeHomeBuyer?: Maybe<Scalars['Boolean']>;
  howDoYouKnowAboutUs?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  /** Margin of finance should be value between 0 - 1 */
  marginOfFinance?: Maybe<Scalars['Float']>;
  /** Refer: src/graphql/definitions/object/booking-draft-agent.graphql */
  otherAgents?: Maybe<Array<BookingDraftAgent>>;
  /** Refer: src/graphql/definitions/object/booking-draft-buyer.graphql */
  otherBuyers?: Maybe<Array<BookingDraftBuyer>>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  paymentProof?: Maybe<UploadedFile>;
  /** Refer: src/graphql/definitions/object/postlaunch-form.graphql */
  postlaunchForm: PostlaunchForm;
  /** Refer: src/graphql/definitions/object/booking-draft-agent.graphql */
  primaryAgent?: Maybe<BookingDraftAgent>;
  /** Refer: src/graphql/definitions/object/booking-draft-buyer.graphql */
  primaryBuyer?: Maybe<BookingDraftBuyer>;
  repeatBuyer?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/union/postlaunch-booking-draft-source.graphql */
  source?: Maybe<PostlaunchBookingDraftSource>;
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  unit: ProjectUnit;
};

export type PostlaunchBookingDraftCustomField = {
  __typename?: 'PostlaunchBookingDraftCustomField';
  answers: Array<Scalars['String']>;
  id: Scalars['ID'];
  question: Scalars['String'];
};

export type PostlaunchBookingDraftOverview = {
  __typename?: 'PostlaunchBookingDraftOverview';
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-additional-info.graphql */
  additionalInfo: PostlaunchBookingDraftOverviewAdditionalInfo;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-agent-info.graphql */
  agentsInfo: Array<PostlaunchBookingDraftOverviewAgentInfo>;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-personal-particulars.graphql */
  buyersPersonalParticulars: Array<PostlaunchBookingDraftOverviewPersonalParticulars>;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-financing-method.graphql */
  financingMethods: PostlaunchBookingDraftOverviewFinancingMethod;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-supporting-document.graphql */
  supportingDocuments: PostlaunchBookingDraftOverviewSupportingDocument;
};

export type PostlaunchBookingDraftOverviewAdditionalInfo = {
  __typename?: 'PostlaunchBookingDraftOverviewAdditionalInfo';
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-custom-field.graphql */
  customFields: Array<PostlaunchBookingDraftOverviewCustomField>;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  firstTimeHomeBuyer: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  howDoYouKnowAboutUs: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  repeatBuyer: PostlaunchBookingDraftOverviewField;
};

export type PostlaunchBookingDraftOverviewAgentInfo = {
  __typename?: 'PostlaunchBookingDraftOverviewAgentInfo';
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  agentUserId: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  hasNextAgent: PostlaunchBookingDraftOverviewField;
};

export type PostlaunchBookingDraftOverviewCustomField = {
  __typename?: 'PostlaunchBookingDraftOverviewCustomField';
  isCompleted: Scalars['Boolean'];
  isRequired: Scalars['Boolean'];
  question: Scalars['String'];
};

export type PostlaunchBookingDraftOverviewField = {
  __typename?: 'PostlaunchBookingDraftOverviewField';
  isCompleted: Scalars['Boolean'];
  isRequired: Scalars['Boolean'];
};

export type PostlaunchBookingDraftOverviewFinancingMethod = {
  __typename?: 'PostlaunchBookingDraftOverviewFinancingMethod';
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  bankerAssignmentPreference: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  epfContribution: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  financeSource: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  marginOfFinance: PostlaunchBookingDraftOverviewField;
};

export type PostlaunchBookingDraftOverviewPersonalParticulars = {
  __typename?: 'PostlaunchBookingDraftOverviewPersonalParticulars';
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  addressDetails: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  addressPlaceId: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  companyAddressDetails: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  companyAddressPlaceId: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  companyName: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  email: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  fullName: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  gender: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  grossMonthlyIncome: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  hasNextBuyer: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  incomeType: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  industry: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  isBumi: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  maritalStatus: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  mobileNum: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  nric: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  nricCopyBack: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  nricCopyFront: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  occupation: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  race: PostlaunchBookingDraftOverviewField;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  signature: PostlaunchBookingDraftOverviewField;
};

export type PostlaunchBookingDraftOverviewSupportingDocument = {
  __typename?: 'PostlaunchBookingDraftOverviewSupportingDocument';
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-overview-field.graphql */
  paymentProof: PostlaunchBookingDraftOverviewField;
};

export type PostlaunchBookingDraftProgress = {
  __typename?: 'PostlaunchBookingDraftProgress';
  currentStep: Scalars['Int'];
  /** Refer: src/graphql/definitions/union/booking-draft-next-page.graphql */
  nextPage: BookingDraftNextPage;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft.graphql */
  postlaunchBookingDraft: PostlaunchBookingDraft;
  /** Refer: src/graphql/definitions/enum/postlaunch-booking-draft-progress-section.graphql */
  section: PostlaunchBookingDraftProgressSection;
  totalSteps: Scalars['Int'];
};

export enum PostlaunchBookingDraftProgressSection {
  AdditionalInfo = 'ADDITIONAL_INFO',
  AgentInfo = 'AGENT_INFO',
  FinancingMethods = 'FINANCING_METHODS',
  PersonalParticulars = 'PERSONAL_PARTICULARS',
  Summary = 'SUMMARY',
  SupportingDocuments = 'SUPPORTING_DOCUMENTS'
}

/**
 * Refer: src/graphql/definitions/object/postlaunch-booking-draft-source-booking-verification.graphql
 * Refer: src/graphql/definitions/object/postlaunch-booking-draft-source-customer-schedule.graphql
 * Refer: src/graphql/definitions/object/postlaunch-booking-draft-source-buyer-lead.graphql
 */
export type PostlaunchBookingDraftSource = PostlaunchBookingDraftSourceBookingVerification | PostlaunchBookingDraftSourceBuyerLead | PostlaunchBookingDraftSourceCustomerSchedule;

export type PostlaunchBookingDraftSourceBookingVerification = {
  __typename?: 'PostlaunchBookingDraftSourceBookingVerification';
  /** Refer: src/graphql/definitions/object/booking-verification.graphql */
  bookingVerification: BookingVerification;
};

export type PostlaunchBookingDraftSourceBuyerLead = {
  __typename?: 'PostlaunchBookingDraftSourceBuyerLead';
  /** Refer: src/graphql/definitions/object/buyer-lead.graphql */
  buyerLead: BuyerLead;
};

export type PostlaunchBookingDraftSourceCustomerSchedule = {
  __typename?: 'PostlaunchBookingDraftSourceCustomerSchedule';
  /** Refer: src/graphql/definitions/object/schedule.graphql */
  customerSchedule: Schedule;
};

export type PostlaunchForm = {
  __typename?: 'PostlaunchForm';
  bankerAssignmentPreference: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/child-project.graphql */
  childProject: ChildProject;
  companyAddress: Scalars['Boolean'];
  companyName: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/union/postlaunch-form-custom-field.graphql */
  customFields: Array<PostlaunchFormCustomField>;
  epfContribution: Scalars['Boolean'];
  howDoYouKnowAboutUs: Scalars['Boolean'];
  id: Scalars['ID'];
  paymentProof: Scalars['Boolean'];
  repeatBuyer: Scalars['Boolean'];
  signature: Scalars['Boolean'];
};

/**
 * Refer: src/graphql/definitions/object/postlaunch-form-custom-field-choice.graphql
 * Refer: src/graphql/definitions/object/postlaunch-form-custom-field-text.graphql
 */
export type PostlaunchFormCustomField = PostlaunchFormCustomFieldChoice | PostlaunchFormCustomFieldText;

export type PostlaunchFormCustomFieldChoice = {
  __typename?: 'PostlaunchFormCustomFieldChoice';
  choices: Array<Scalars['String']>;
  id: Scalars['ID'];
  index: Scalars['Int'];
  isMultiChoice: Scalars['Boolean'];
  question: Scalars['String'];
  selected: Scalars['Boolean'];
};

export type PostlaunchFormCustomFieldText = {
  __typename?: 'PostlaunchFormCustomFieldText';
  id: Scalars['ID'];
  index: Scalars['Int'];
  question: Scalars['String'];
  selected: Scalars['Boolean'];
};

export type PostlaunchFormDefaultSelection = {
  __typename?: 'PostlaunchFormDefaultSelection';
  bankerAssignmentPreference: Scalars['Boolean'];
  companyAddress: Scalars['Boolean'];
  companyName: Scalars['Boolean'];
  epfContribution: Scalars['Boolean'];
  howDoYouKnowAboutUs: Scalars['Boolean'];
  paymentProof: Scalars['Boolean'];
  repeatBuyer: Scalars['Boolean'];
  signature: Scalars['Boolean'];
};

export type PostlaunchFormField = {
  __typename?: 'PostlaunchFormField';
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-additional-info.graphql */
  additionalInfo: PostlaunchFormFieldAdditionalInfo;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-financing-methods.graphql */
  financingMethods: PostlaunchFormFieldFinancingMethods;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-personal-particulars.graphql */
  personalParticulars: PostlaunchFormFieldPersonalParticulars;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-supporting-documents.graphql */
  supportingDocuments: PostlaunchFormFieldSupportingDocuments;
};

export type PostlaunchFormFieldAdditionalInfo = {
  __typename?: 'PostlaunchFormFieldAdditionalInfo';
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  firstTimeHomeBuyer: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  howDoYouKnowAboutUs: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  repeatBuyer: PostlaunchFormFieldItem;
};

export type PostlaunchFormFieldFinancingMethods = {
  __typename?: 'PostlaunchFormFieldFinancingMethods';
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  bankerAssignmentPreference: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  epfContribution: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  financeSource: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  marginOfFinance: PostlaunchFormFieldItem;
};

export type PostlaunchFormFieldItem = {
  __typename?: 'PostlaunchFormFieldItem';
  editable: Scalars['Boolean'];
  selected: Scalars['Boolean'];
};

export type PostlaunchFormFieldPersonalParticulars = {
  __typename?: 'PostlaunchFormFieldPersonalParticulars';
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  address: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  companyAddress: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  companyName: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  email: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  fullName: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  gender: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  grossMonthlyIncome: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  incomeType: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  industry: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  isBumi: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  maritalStatus: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  mobileNum: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  nric: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  nricCopyBack: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  nricCopyFront: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  occupation: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  race: PostlaunchFormFieldItem;
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  signature: PostlaunchFormFieldItem;
};

export type PostlaunchFormFieldSupportingDocuments = {
  __typename?: 'PostlaunchFormFieldSupportingDocuments';
  /** Refer: src/graphql/definitions/object/postlaunch-form-field-item.graphql */
  paymentProof: PostlaunchFormFieldItem;
};

export type PostlaunchTransaction = {
  __typename?: 'PostlaunchTransaction';
  /** Refer: src/graphql/definitions/object/transaction-agent_.graphql */
  agents: Array<TransactionAgent_>;
  /** Refer: src/graphql/definitions/object/transaction-app-status.graphql */
  appStatus: TransactionAppStatus;
  /** Refer: src/graphql/definitions/enum/transaction-banker-assignment-preference.graphql */
  bankerAssignmentPreference?: Maybe<TransactionBankerAssignmentPreference>;
  bookedOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/buyer.graphql */
  buyers: Array<Buyer>;
  /** Refer: src/graphql/definitions/object/transaction-cancellation-submission.graphql */
  cancellationSubmission?: Maybe<TransactionCancellationSubmission>;
  /** Refer: src/graphql/definitions/object/child-project.graphql */
  childProject: ChildProject;
  /** Refer: src/graphql/definitions/object/transaction-commission-details.graphql */
  commissionDetails?: Maybe<TransactionCommissionDetails>;
  /** Refer: src/graphql/definitions/object/transaction-commission-info.graphql */
  commissionPortions: Array<TransactionCommissionInfo>;
  /** Refer: src/graphql/definitions/object/transaction-developer-commission-batch.graphql */
  developerCommissionBatches: Array<TransactionDeveloperCommissionBatch>;
  /**
   * The stages of the developer commission batches linked to this transaction.
   * The stages are ordered by stage index ascendingly.
   * Refer: src/graphql/definitions/object/filtered-transaction-developer-commission-stages.graphql
   */
  developerCommissionStages: FilteredTransactionDeveloperCommissionStages;
  /** Refer: src/graphql/definitions/object/transaction-discount.graphql */
  discounts: Array<TransactionDiscount>;
  /**
   * +----------------------+-----------------------------------------------------------------+
   * | isFirstTimeHomeBuyer |                             Reason                              |
   * +----------------------+-----------------------------------------------------------------+
   * | true                 | 'First time home buyer' field is checked on booking form        |
   * | false                | 'First time home buyer' field is not checked on booking form    |
   * | undefined            | Project booking form doesn't have 'First time home buyer' field |
   * +----------------------+-----------------------------------------------------------------+
   */
  firstTimeHomeBuyer?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  generatedForms?: Maybe<Array<AttachedFile>>;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/transaction-document-info.graphql */
  laDocument?: Maybe<TransactionDocumentInfo>;
  /** Refer: src/graphql/definitions/object/lawyer.graphql */
  lawyer?: Maybe<Lawyer>;
  /** Refer: src/graphql/definitions/object/nett-price-result.graphql */
  nettPriceResult: NettPriceResult;
  /** Refer: src/graphql/definitions/object/transaction-payment-info.graphql */
  paymentInfo: Array<TransactionPaymentInfo>;
  signingCompletedDate?: Maybe<Scalars['Date']>;
  /** Refer: src/graphql/definitions/object/transaction-document-info.graphql */
  spaDocument?: Maybe<TransactionDocumentInfo>;
  /**
   * The following precedence level is used to derive the spaPrice:
   * Transaction level SPA price > Project Level SPA price > unit gross price
   */
  spaPrice?: Maybe<Scalars['Float']>;
  /**
   * The stageless developer commission batches that are linked to this transaction.
   * Refer: src/graphql/definitions/object/filtered-developer-commission-batch-transactions.graphql
   */
  stagelessDeveloperCommissionBatches: FilteredDeveloperCommissionBatchTransactions;
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  unit: ProjectUnit;
  unitGrossPrice?: Maybe<Scalars['Float']>;
  updatedOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  uploadedDocuments?: Maybe<Array<AttachedFile>>;
};


export type PostlaunchTransactionGeneratedFormsArgs = {
  excludedFileTags?: InputMaybe<Array<UploadedFileTag>>;
};

export type Preference = {
  __typename?: 'Preference';
  /** Refer: src/graphql/definitions/enum/day.graphql */
  day: Day;
  daySlotIndex: Scalars['Int'];
};

export type Preferences = {
  projectId: Scalars['String'];
  /** Refer: src/graphql/definitions/input/arm-schedule-preference.graphql */
  schedulePreferences: Array<ArmSchedulePreference>;
};

export type PreviewGeneratedAppointmentLetterResponse = {
  __typename?: 'PreviewGeneratedAppointmentLetterResponse';
  generatedPDF: Scalars['String'];
};

export enum PriorityQueue {
  BankerNotAssigned = 'bankerNotAssigned',
  NewBookings = 'newBookings',
  PendingLoans = 'pendingLoans',
  SpaLaNotScheduled = 'spaLaNotScheduled',
  SpaLaPassedSchedule = 'spaLaPassedSchedule'
}

export type Project = {
  __typename?: 'Project';
  /** Refer: src/graphql/definitions/object/project-agency-kind.graphql */
  agencyKinds: Array<ProjectAgencyKind>;
  agentCanViewGeneratedForms: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/project-agent-cooperation.graphql */
  agentCooperation?: Maybe<ProjectAgentCooperation>;
  allowRequestFinancialReport: Scalars['Boolean'];
  /**
   * This is undefined for child project because showroom operation details is not
   * applicable for child project.
   */
  allowSchedule?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/object/project-arm-commission-settings.graphql */
  armCommissionSettings?: Maybe<ProjectArmCommissionSettings>;
  /** Refer: src/graphql/definitions/object/arm.graphql */
  arms: Array<Arm>;
  /** Refer: src/graphql/definitions/object/project-printer.graphql */
  associatedPrinter?: Maybe<ProjectPrinter>;
  bookingFee?: Maybe<Scalars['Float']>;
  bookingMethods?: Maybe<Array<Scalars['String']>>;
  /** Refer: src/graphql/definitions/object/booking-step.graphql */
  bookingSteps?: Maybe<BookingStep>;
  /**
   * This field is applicable for child project only.
   * Refer: src/graphql/definitions/union/project-buyer-consent-flow-setting.graphql
   */
  buyerConsentFlowSetting?: Maybe<ProjectBuyerConsentFlowSetting>;
  /** This field is only applicable for parent project */
  canPromptChatGPT?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/object/agency.graphql */
  childDeveloper?: Maybe<Agency>;
  /** Refer: src/graphql/definitions/object/project.graphql */
  children?: Maybe<Array<Project>>;
  commissionInfos?: Maybe<Array<Scalars['String']>>;
  /** Refer: src/graphql/definitions/object/project-commission-settings.graphql */
  commissionSettings?: Maybe<Array<ProjectCommissionSettings>>;
  /** @deprecated Use coverImageFiles instead. */
  coverImage?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  coverImageFiles?: Maybe<Array<AttachedFile>>;
  /** @deprecated Use coverImageFiles instead. */
  coverImages?: Maybe<Array<Scalars['String']>>;
  createdOn: Scalars['String'];
  /** Refer: src/graphql/definitions/object/agency.graphql */
  developer?: Maybe<Agency>;
  /** Refer: src/graphql/definitions/union/project-developer-commission-batch.graphql */
  developerCommissionBatches: Array<ProjectDeveloperCommissionBatch>;
  /** Refer: src/graphql/definitions/object/project-discount.graphql */
  discounts: Array<ProjectDiscount>;
  /**
   * Refer: src/graphql/definitions/union/project-discount-enum.graphql
   * @deprecated Use `discounts` instead
   */
  discountsEnum: Array<ProjectDiscountEnum>;
  /** Refer: src/graphql/definitions/object/project-entitlement.graphql */
  entitlements: Array<ProjectEntitlement>;
  /** Refer: src/graphql/definitions/object/estore-project-teaser.graphql */
  estoreProjectTeaser?: Maybe<EstoreProjectTeaser>;
  /**
   * This is the instruction for how to set up a valid expression using the given
   * list of supported operators, variables and functions.
   * Refer: src/graphql/definitions/object/expression-setting-instruction.graphql
   */
  expressionSettingInstruction: ExpressionSettingInstruction;
  facilities?: Maybe<Array<Scalars['String']>>;
  /** Refer: src/graphql/definitions/object/project-gross-price-range.graphql */
  grossPriceRange: ProjectGrossPriceRange;
  /** Refer: src/graphql/definitions/object/project-handler.graphql */
  handledBy?: Maybe<Array<ProjectHandler>>;
  /**
   * Head of ARMS that are in charge of this parent project.
   * Refer: src/graphql/definitions/object/project-harm.graphql
   */
  harms: Array<ProjectHarm>;
  /** @deprecated Use associatedPrinter instead. */
  hasAssociatedPrinter?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /** This is the instruction for setting up the developer commission batch of type EXPRESSION */
  instructionForSettingCommissionBatchTypeExpression: Scalars['String'];
  interestSubmitted?: Maybe<Scalars['Boolean']>;
  jmaOnly?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/object/jma.graphql */
  jmas?: Maybe<Array<Jma>>;
  keySellingPoints?: Maybe<Array<Scalars['String']>>;
  /** Refer: src/graphql/definitions/enum/launch-status.graphql */
  launchStatus: LaunchStatus;
  launchedOn?: Maybe<Scalars['String']>;
  /**
   * Refer: src/graphql/definitions/object/project-layout.graphql
   * @deprecated Use unitLayout instead.
   */
  layout?: Maybe<ProjectLayout>;
  /** Refer: src/graphql/definitions/object/project-location.graphql */
  location?: Maybe<ProjectLocation>;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  marketingMaterials?: Maybe<Array<AttachedFile>>;
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  panelBankers: Array<User>;
  /** Refer: src/graphql/definitions/object/financer.graphql */
  panelBanks?: Maybe<Array<Financer>>;
  /** Refer: src/graphql/definitions/object/project.graphql */
  parent?: Maybe<Project>;
  /** Refer: src/graphql/definitions/object/agency.graphql */
  partnerAgency?: Maybe<Agency>;
  /** Refer: src/graphql/definitions/object/project-partner-appointment.graphql */
  partnerAppointments?: Maybe<Array<ProjectPartnerAppointment>>;
  /** Refer: src/graphql/definitions/object/project-payment-info.graphql */
  paymentInfos?: Maybe<Array<ProjectPaymentInfo>>;
  /** @deprecated Use grossPriceRange for more details */
  priceRange?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/enum/project-type.graphql */
  projectType: ProjectType;
  /** Default project unit lock duration for agent in minutes */
  projectUnitLockDuration: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  salesPackages?: Maybe<Array<AttachedFile>>;
  /** Refer: src/graphql/definitions/object/scraper-stats.graphql */
  scraperStats?: Maybe<ScraperStats>;
  shouldRefreshPriceChart: Scalars['Boolean'];
  /** This field is only applicable for parent project */
  showCtosBanner?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/object/showroom-operation-details.graphql */
  showroomOperationDetails?: Maybe<ShowroomOperationDetails>;
  status?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/project-summary.graphql */
  summary?: Maybe<ProjectSummary>;
  /** Refer: src/graphql/definitions/object/project-support-personnel.graphql */
  supportPersonnels: Array<ProjectSupportPersonnel>;
  surveyPreLaunch: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/project-tag.graphql */
  tags: Array<ProjectTag>;
  /**
   * Both teaser and teaserData is the same
   * Refer: src/graphql/definitions/object/project-teaser.graphql
   */
  teaser?: Maybe<ProjectTeaser>;
  /** Refer: src/graphql/definitions/object/project-teaser.graphql */
  teaserData?: Maybe<ProjectTeaser>;
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  transactions: Array<Transaction>;
  /** @deprecated Use projectType instead. */
  type: Scalars['String'];
  /**
   * Only applicable for resolveTransaction
   * Refer: src/graphql/definitions/object/project-unit.graphql
   * @deprecated Use `Transaction.unit` instead.
   */
  unit?: Maybe<ProjectUnit>;
  /** Refer: src/graphql/definitions/union/project-unit-layout.graphql */
  unitLayout?: Maybe<ProjectUnitLayout>;
  /** Refer: src/graphql/definitions/object/project-unit-mix.graphql */
  unitMix: Array<ProjectUnitMix>;
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  units: Array<ProjectUnit>;
  /** Refer: src/graphql/definitions/object/project-virtual-sales-galleries.graphql */
  virtualSalesGalleries?: Maybe<Array<ProjectVirtualSalesGalleries>>;
  /** This indicates whether the requester is whitelisted for this project. */
  whitelisted?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/object/whitelist-item.graphql */
  whitelists: Array<WhitelistItem>;
};


export type ProjectEntitlementsArgs = {
  displayOnPriceChart?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectAgencyGroup = {
  __typename?: 'ProjectAgencyGroup';
  /** Refer: src/graphql/definitions/object/agency-group.graphql */
  agencyGroup: AgencyGroup;
  /** Refer: src/graphql/definitions/object/project-agency-kind.graphql */
  agencyKind: ProjectAgencyKind;
  /** Refer: src/graphql/definitions/object/project-agency-group-commission-tnc.graphql */
  commissionTncs: Array<ProjectAgencyGroupCommissionTnc>;
  id: Scalars['ID'];
};

export type ProjectAgencyGroupCommissionTnc = {
  __typename?: 'ProjectAgencyGroupCommissionTnc';
  /** Refer: src/graphql/definitions/object/project-agency-group.graphql */
  projectAgencyGroup: ProjectAgencyGroup;
  /**
   * This status is derived based on the latest TNC version.
   * Refer: src/graphql/definitions/union/project-agency-group-commission-tnc-status.graphql
   */
  status: ProjectAgencyGroupCommissionTncStatus;
  /**
   * Refer: src/graphql/definitions/object/project-commission-tnc.graphql
   * @deprecated Use `tncVersion` instead, because this property does not tell us which version of the TNC is applied to the corresponding invoice request.
   */
  tnc: ProjectCommissionTnc;
  /** Refer: src/graphql/definitions/object/project-commission-tnc-version.graphql */
  tncVersion: ProjectCommissionTncVersion;
};

/**
 * Refer: src/graphql/definitions/object/project-agency-group-commission-tnc-status-pending-agreement.graphql
 * Refer: src/graphql/definitions/object/project-agency-group-commission-tnc-status-agreed.graphql
 * Refer: src/graphql/definitions/object/project-agency-group-commission-tnc-status-pending-reagreement.graphql
 * Refer: src/graphql/definitions/object/project-agency-group-commission-tnc-status-terminated.graphql
 */
export type ProjectAgencyGroupCommissionTncStatus = ProjectAgencyGroupCommissionTncStatusAgreed | ProjectAgencyGroupCommissionTncStatusPendingAgreement | ProjectAgencyGroupCommissionTncStatusPendingReagreement | ProjectAgencyGroupCommissionTncStatusTerminated;

export type ProjectAgencyGroupCommissionTncStatusAgreed = {
  __typename?: 'ProjectAgencyGroupCommissionTncStatusAgreed';
  /** Refer: src/graphql/definitions/object/project-commission-tnc-version-agreement.graphql */
  agreement: ProjectCommissionTncVersionAgreement;
};

export type ProjectAgencyGroupCommissionTncStatusPendingAgreement = {
  __typename?: 'ProjectAgencyGroupCommissionTncStatusPendingAgreement';
  dummy?: Maybe<Scalars['String']>;
};

/**
 * If the current agreed TNC version is not the latest TNC version, then the
 * status will be pending reagreement.
 */
export type ProjectAgencyGroupCommissionTncStatusPendingReagreement = {
  __typename?: 'ProjectAgencyGroupCommissionTncStatusPendingReagreement';
  dummy?: Maybe<Scalars['String']>;
};

export type ProjectAgencyGroupCommissionTncStatusTerminated = {
  __typename?: 'ProjectAgencyGroupCommissionTncStatusTerminated';
  /** Refer: src/graphql/definitions/object/project-commission-tnc-version-agreement-termination.graphql */
  termination: ProjectCommissionTncVersionAgreementTermination;
};

export type ProjectAgencyKind = {
  __typename?: 'ProjectAgencyKind';
  /**
   * Refer: src/graphql/definitions/object/project.graphql
   * @deprecated Use `project` instead, as it has a better type.
   */
  childProject: Project;
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/object/child-project.graphql */
  project: ChildProject;
};

export type ProjectAgentCooperation = {
  __typename?: 'ProjectAgentCooperation';
  /** Refer: src/graphql/definitions/object/agency-team.graphql */
  closingAgentTeams: Array<AgencyTeam>;
  enabled: Scalars['Boolean'];
  leadPercentage: Scalars['Float'];
};

export type ProjectArmCommissionSettings = {
  __typename?: 'ProjectArmCommissionSettings';
  /** Refer: src/graphql/definitions/object/project.graphql */
  followingProject?: Maybe<Project>;
  /** Refer: src/graphql/definitions/object/project-arm-commission-settings-period.graphql */
  periods?: Maybe<Array<ProjectArmCommissionSettingsPeriod>>;
  /** @deprecated Use typeEnum instead. */
  type?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/enum/project-arm-commission-settings-type.graphql */
  typeEnum: ProjectArmCommissionSettingsType;
};

export type ProjectArmCommissionSettingsAgency = {
  __typename?: 'ProjectArmCommissionSettingsAgency';
  /** Refer: src/graphql/definitions/object/agency.graphql */
  agency?: Maybe<Agency>;
  pooling?: Maybe<Scalars['Boolean']>;
};

export type ProjectArmCommissionSettingsPeriod = {
  __typename?: 'ProjectArmCommissionSettingsPeriod';
  /** Refer: src/graphql/definitions/object/user.graphql */
  arms: Array<User>;
  from?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/project-arm-commission-settings-period-group.graphql */
  groups: Array<ProjectArmCommissionSettingsPeriodGroup>;
  tierSalesIncludeProjects: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/project-arm-commission-settings-period-tier.graphql */
  tiers: Array<ProjectArmCommissionSettingsPeriodTier>;
  to?: Maybe<Scalars['String']>;
};

export type ProjectArmCommissionSettingsPeriodGroup = {
  __typename?: 'ProjectArmCommissionSettingsPeriodGroup';
  /** Refer: src/graphql/definitions/object/project-arm-commission-settings-agency.graphql */
  agencies: Array<ProjectArmCommissionSettingsAgency>;
  amount: Scalars['Float'];
  groupName?: Maybe<Scalars['String']>;
};

export type ProjectArmCommissionSettingsPeriodTier = {
  __typename?: 'ProjectArmCommissionSettingsPeriodTier';
  fromInclusive: Scalars['Float'];
  id: Scalars['String'];
  percentage: Scalars['Float'];
  toInclusive: Scalars['Float'];
};

export enum ProjectArmCommissionSettingsType {
  FollowOtherProject = 'FOLLOW_OTHER_PROJECT',
  SelfDefined = 'SELF_DEFINED'
}

/**
 * Refer: src/graphql/definitions/object/buyer-consent-flow-setting-enabled-blocking.graphql
 * Refer: src/graphql/definitions/object/buyer-consent-flow-setting-enabled-non-blocking.graphql
 * Refer: src/graphql/definitions/object/buyer-consent-flow-setting-disabled.graphql
 */
export type ProjectBuyerConsentFlowSetting = BuyerConsentFlowSettingDisabled | BuyerConsentFlowSettingEnabledBlocking | BuyerConsentFlowSettingEnabledNonBlocking;

export type ProjectCategory = {
  __typename?: 'ProjectCategory';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy?: Maybe<User>;
  createdOn: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/project.graphql */
  projects: Array<Project>;
};

export type ProjectCommissionSettings = {
  __typename?: 'ProjectCommissionSettings';
  commencementDate?: Maybe<Scalars['String']>;
  developerCommissionSstInclusive: Scalars['Boolean'];
  developerPercentage: Scalars['Float'];
  expiryDate?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/project-commission-settings-commission-portion.graphql */
  loanTransactionCommissionPortion: Array<ProjectCommissionSettingsCommissionPortion>;
  taxPercentage: Scalars['Float'];
  taxPercentageDontAffectNetCommission: Scalars['Boolean'];
};

export type ProjectCommissionSettingsCommissionPortion = {
  __typename?: 'ProjectCommissionSettingsCommissionPortion';
  name: Scalars['String'];
  percentage: Scalars['Float'];
};

export type ProjectCommissionTnc = {
  __typename?: 'ProjectCommissionTnc';
  /** Refer: src/graphql/definitions/object/project-agency-kind.graphql */
  agencyKind: ProjectAgencyKind;
  /** Refer: src/graphql/definitions/object/project-commission-tnc-version.graphql */
  allVersions: Array<ProjectCommissionTncVersion>;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/project-commission-tnc-version.graphql */
  latestVersion: ProjectCommissionTncVersion;
};

export enum ProjectCommissionTncTierMode {
  ThresholdDeterminedByAgencySalesWithoutRetros = 'THRESHOLD_DETERMINED_BY_AGENCY_SALES__WITHOUT_RETROS',
  ThresholdDeterminedByAgencySalesWithRetros = 'THRESHOLD_DETERMINED_BY_AGENCY_SALES__WITH_RETROS',
  ThresholdDeterminedByCompanySalesWithRetros = 'THRESHOLD_DETERMINED_BY_COMPANY_SALES__WITH_RETROS'
}

export type ProjectCommissionTncVersion = {
  __typename?: 'ProjectCommissionTncVersion';
  /** Refer: src/graphql/definitions/object/project-commission-tnc-version-agreement.graphql */
  agreements: Array<ProjectCommissionTncVersionAgreement>;
  commencementDate: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/project-commission-tnc-version-commission-portion.graphql */
  commissionPortions: Array<ProjectCommissionTncVersionCommissionPortion>;
  /** Refer: src/graphql/definitions/object/project-commission-tnc-version-commission-tier.graphql */
  commissionTiers: Array<ProjectCommissionTncVersionCommissionTier>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/project-commission-tnc-version-end-date.graphql */
  endDate?: Maybe<ProjectCommissionTncVersionEndDate>;
  /** Refer: src/graphql/definitions/object/project-commission-tnc-version-fee.graphql */
  fees?: Maybe<Array<ProjectCommissionTncVersionFee>>;
  /**
   * The PDF file generated from the template.
   * Refer: src/graphql/definitions/object/uploaded-file.graphql
   */
  file: UploadedFile;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/project-commission-tnc-version-commission-portion.graphql */
  personalBankerCommissionPortions: Array<ProjectCommissionTncVersionCommissionPortion>;
  template: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/project-commission-tnc-tier-mode.graphql */
  tierMode: ProjectCommissionTncTierMode;
  /** Refer: src/graphql/definitions/object/project-commission-tnc.graphql */
  tnc: ProjectCommissionTnc;
};

export type ProjectCommissionTncVersionAgreement = {
  __typename?: 'ProjectCommissionTncVersionAgreement';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/email.graphql */
  email?: Maybe<Email>;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/project-commission-tnc-version-agreement-termination.graphql */
  termination?: Maybe<ProjectCommissionTncVersionAgreementTermination>;
  /** Refer: src/graphql/definitions/object/project-commission-tnc-version.graphql */
  tncVersion: ProjectCommissionTncVersion;
};

export type ProjectCommissionTncVersionAgreementTermination = {
  __typename?: 'ProjectCommissionTncVersionAgreementTermination';
  /** Refer: src/graphql/definitions/object/user.graphql */
  by: User;
  effectiveDate: Scalars['Date'];
  id: Scalars['ID'];
  on: Scalars['Date'];
  reason: Scalars['String'];
};

export type ProjectCommissionTncVersionCommissionPortion = {
  __typename?: 'ProjectCommissionTncVersionCommissionPortion';
  percentage: Scalars['Float'];
  type: Scalars['String'];
};

export type ProjectCommissionTncVersionCommissionTier = {
  __typename?: 'ProjectCommissionTncVersionCommissionTier';
  id: Scalars['ID'];
  lowerBoundaryInclusive: Scalars['Int'];
  percentage: Scalars['Float'];
  upperBoundaryInclusive?: Maybe<Scalars['Int']>;
};

export type ProjectCommissionTncVersionEndDate = {
  __typename?: 'ProjectCommissionTncVersionEndDate';
  defined: Scalars['Boolean'];
  value: Scalars['Date'];
};

export type ProjectCommissionTncVersionFee = {
  __typename?: 'ProjectCommissionTncVersionFee';
  description: Scalars['String'];
  expression: Scalars['String'];
};

export type ProjectCooperationBuyer = {
  mobileNum: Scalars['String'];
  name: Scalars['String'];
};

/**
 * Refer: src/graphql/definitions/object/project-developer-commission-batch-percentage.graphql
 * Refer: src/graphql/definitions/object/project-developer-commission-batch-fixed-amount.graphql
 * Refer: src/graphql/definitions/object/project-developer-commission-batch-expression.graphql
 */
export type ProjectDeveloperCommissionBatch = ProjectDeveloperCommissionBatchExpression | ProjectDeveloperCommissionBatchFixedAmount | ProjectDeveloperCommissionBatchPercentage;

export type ProjectDeveloperCommissionBatchExpression = {
  __typename?: 'ProjectDeveloperCommissionBatchExpression';
  _id: Scalars['String'];
  expression: Scalars['String'];
  paidOn: Scalars['String'];
  sstInclusive: Scalars['Boolean'];
};

export type ProjectDeveloperCommissionBatchFixedAmount = {
  __typename?: 'ProjectDeveloperCommissionBatchFixedAmount';
  _id: Scalars['String'];
  fixedAmount: Scalars['Float'];
  paidOn: Scalars['String'];
  sstInclusive: Scalars['Boolean'];
};

export type ProjectDeveloperCommissionBatchPercentage = {
  __typename?: 'ProjectDeveloperCommissionBatchPercentage';
  _id: Scalars['String'];
  paidOn: Scalars['String'];
  percentage: Scalars['Float'];
  sstInclusive: Scalars['Boolean'];
};

export type ProjectDeveloperCommissionSetting = {
  __typename?: 'ProjectDeveloperCommissionSetting';
  /** Refer: src/graphql/definitions/object/developer-commission-setting-period.graphql */
  periods: Array<DeveloperCommissionSettingPeriod>;
};

export type ProjectDevelopmentValue = {
  __typename?: 'ProjectDevelopmentValue';
  /** Refer: src/graphql/definitions/object/development-value.graphql */
  dvs: Array<DevelopmentValue>;
  projectId: Scalars['String'];
  projectName: Scalars['String'];
};

export type ProjectDiscount = {
  __typename?: 'ProjectDiscount';
  /** @deprecated Use `typeUnion` instead. */
  amount: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/project-discount-applicable-period.graphql */
  applicablePeriods?: Maybe<Array<ProjectDiscountApplicablePeriod>>;
  /**
   * Discounts that are place before this discount in the discounts list.
   * Refer: src/graphql/definitions/object/project-discount.graphql
   */
  dependableDiscounts: Array<ProjectDiscount>;
  /** Refer: src/graphql/definitions/object/project-discount-dependency.graphql */
  dependsOn?: Maybe<ProjectDiscountDependency>;
  description: Scalars['String'];
  /** @deprecated Use `typeUnion` instead. */
  displayOnEstore?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use `typeUnion` instead. */
  displayOnPriceChart?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  exclusive?: Maybe<Array<ProjectUnit>>;
  /** @deprecated Use `typeUnion` instead. */
  expression?: Maybe<Scalars['String']>;
  forBumiOnly: Scalars['Boolean'];
  id: Scalars['String'];
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  image?: Maybe<AttachedFile>;
  isOptional: Scalars['Boolean'];
  name: Scalars['String'];
  /**
   * For future purpose will have other transaction price types
   * - nettPrice
   * - billingPrice
   * Refer: src/graphql/definitions/enum/transaction-price-type.graphql
   */
  remainingAmountPriceType?: Maybe<TransactionPriceType>;
  /** @deprecated Use statusEnum instead. */
  status: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/project-discount-status.graphql */
  statusEnum: ProjectDiscountStatus;
  /** Refer: src/graphql/definitions/object/project-discount-toggle-key-values.graphql */
  toggleKeyValues: Array<ProjectDiscountToggleKeyValues>;
  /**
   * Refer: src/graphql/definitions/enum/project-discount-type.graphql
   * @deprecated Use `typeUnion` instead.
   */
  type: ProjectDiscountType;
  /** Refer: src/graphql/definitions/union/project-discount-type-union.graphql */
  typeUnion: ProjectDiscountTypeUnion;
};

export type ProjectDiscountApplicablePeriod = {
  __typename?: 'ProjectDiscountApplicablePeriod';
  from: Scalars['String'];
  to: Scalars['String'];
};

export type ProjectDiscountDependency = {
  __typename?: 'ProjectDiscountDependency';
  discountId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type ProjectDiscountEntitlement = {
  __typename?: 'ProjectDiscountEntitlement';
  amount: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/project-discount-applicable-period.graphql */
  applicablePeriods?: Maybe<Array<ProjectDiscountApplicablePeriod>>;
  description: Scalars['String'];
  displayOnEstore?: Maybe<Scalars['Boolean']>;
  displayOnPriceChart?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  exclusive?: Maybe<Array<ProjectUnit>>;
  forBumiOnly: Scalars['Boolean'];
  id: Scalars['String'];
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  image?: Maybe<AttachedFile>;
  isOptional: Scalars['Boolean'];
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/project-discount-status.graphql */
  status: ProjectDiscountStatus;
  /** Refer: src/graphql/definitions/object/project-discount-toggle-key-values.graphql */
  toggleKeyValues: Array<ProjectDiscountToggleKeyValues>;
  /** Refer: src/graphql/definitions/enum/project-discount-type.graphql */
  type: ProjectDiscountType;
};

/**
 * Refer: src/graphql/definitions/object/project-discount-fixed-amount.graphql
 * Refer: src/graphql/definitions/object/project-discount-percentage.graphql
 * Refer: src/graphql/definitions/object/project-discount-expression.graphql
 * Refer: src/graphql/definitions/object/project-discount-entitlement.graphql
 */
export type ProjectDiscountEnum = ProjectDiscountEntitlement | ProjectDiscountExpression | ProjectDiscountFixedAmount | ProjectDiscountPercentage;

export type ProjectDiscountExpression = {
  __typename?: 'ProjectDiscountExpression';
  /** Refer: src/graphql/definitions/object/project-discount-applicable-period.graphql */
  applicablePeriods?: Maybe<Array<ProjectDiscountApplicablePeriod>>;
  /** Refer: src/graphql/definitions/object/project-discount-dependency.graphql */
  dependsOn?: Maybe<ProjectDiscountDependency>;
  description: Scalars['String'];
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  exclusive?: Maybe<Array<ProjectUnit>>;
  expression: Scalars['String'];
  forBumiOnly: Scalars['Boolean'];
  id: Scalars['String'];
  isOptional: Scalars['Boolean'];
  name: Scalars['String'];
  /**
   * For future purpose will have other transaction price types
   * - nettPrice
   * - billingPrice
   * Refer: src/graphql/definitions/enum/transaction-price-type.graphql
   */
  remainingAmountPriceType?: Maybe<TransactionPriceType>;
  /** Refer: src/graphql/definitions/enum/project-discount-status.graphql */
  status: ProjectDiscountStatus;
  /** Refer: src/graphql/definitions/object/project-discount-toggle-key-values.graphql */
  toggleKeyValues: Array<ProjectDiscountToggleKeyValues>;
  /** Refer: src/graphql/definitions/enum/project-discount-type.graphql */
  type: ProjectDiscountType;
};

export type ProjectDiscountFixedAmount = {
  __typename?: 'ProjectDiscountFixedAmount';
  amount: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/project-discount-applicable-period.graphql */
  applicablePeriods?: Maybe<Array<ProjectDiscountApplicablePeriod>>;
  /** Refer: src/graphql/definitions/object/project-discount-dependency.graphql */
  dependsOn?: Maybe<ProjectDiscountDependency>;
  description: Scalars['String'];
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  exclusive?: Maybe<Array<ProjectUnit>>;
  forBumiOnly: Scalars['Boolean'];
  id: Scalars['String'];
  isOptional: Scalars['Boolean'];
  name: Scalars['String'];
  /**
   * For future purpose will have other transaction price types
   * - nettPrice
   * - billingPrice
   * Refer: src/graphql/definitions/enum/transaction-price-type.graphql
   */
  remainingAmountPriceType?: Maybe<TransactionPriceType>;
  /** Refer: src/graphql/definitions/enum/project-discount-status.graphql */
  status: ProjectDiscountStatus;
  /** Refer: src/graphql/definitions/object/project-discount-toggle-key-values.graphql */
  toggleKeyValues: Array<ProjectDiscountToggleKeyValues>;
  /** Refer: src/graphql/definitions/enum/project-discount-type.graphql */
  type: ProjectDiscountType;
};

export type ProjectDiscountPercentage = {
  __typename?: 'ProjectDiscountPercentage';
  amount: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/project-discount-applicable-period.graphql */
  applicablePeriods?: Maybe<Array<ProjectDiscountApplicablePeriod>>;
  /** Refer: src/graphql/definitions/object/project-discount-dependency.graphql */
  dependsOn?: Maybe<ProjectDiscountDependency>;
  description: Scalars['String'];
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  exclusive?: Maybe<Array<ProjectUnit>>;
  forBumiOnly: Scalars['Boolean'];
  id: Scalars['String'];
  isOptional: Scalars['Boolean'];
  name: Scalars['String'];
  /**
   * For future purpose will have other transaction price types
   * - nettPrice
   * - billingPrice
   * Refer: src/graphql/definitions/enum/transaction-price-type.graphql
   */
  remainingAmountPriceType?: Maybe<TransactionPriceType>;
  /** Refer: src/graphql/definitions/enum/project-discount-status.graphql */
  status: ProjectDiscountStatus;
  /** Refer: src/graphql/definitions/object/project-discount-toggle-key-values.graphql */
  toggleKeyValues: Array<ProjectDiscountToggleKeyValues>;
  /** Refer: src/graphql/definitions/enum/project-discount-type.graphql */
  type: ProjectDiscountType;
};

export enum ProjectDiscountStatus {
  Active = 'ACTIVE',
  Discontinued = 'DISCONTINUED'
}

export type ProjectDiscountToggleKeyValues = {
  __typename?: 'ProjectDiscountToggleKeyValues';
  key: Scalars['String'];
  values: Array<Scalars['String']>;
};

export enum ProjectDiscountType {
  Entitlement = 'entitlement',
  Expression = 'expression',
  FixedAmount = 'fixedAmount',
  Percentage = 'percentage'
}

export type ProjectDiscountTypeEntitlement = {
  __typename?: 'ProjectDiscountTypeEntitlement';
  displayOnEstore: Scalars['Boolean'];
  displayOnPriceChart: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  image?: Maybe<UploadedFile>;
};

export type ProjectDiscountTypeExpression = {
  __typename?: 'ProjectDiscountTypeExpression';
  expression: Scalars['String'];
};

export type ProjectDiscountTypeFixedAmount = {
  __typename?: 'ProjectDiscountTypeFixedAmount';
  amount: Scalars['Float'];
};

export type ProjectDiscountTypePercentage = {
  __typename?: 'ProjectDiscountTypePercentage';
  /**
   * 0 means 0%.
   * 100 means 100%.
   */
  amount: Scalars['Float'];
};

/**
 * Refer: src/graphql/definitions/object/project-discount-type-fixed-amount.graphql
 * Refer: src/graphql/definitions/object/project-discount-type-entitlement.graphql
 * Refer: src/graphql/definitions/object/project-discount-type-expression.graphql
 * Refer: src/graphql/definitions/object/project-discount-type-percentage.graphql
 */
export type ProjectDiscountTypeUnion = ProjectDiscountTypeEntitlement | ProjectDiscountTypeExpression | ProjectDiscountTypeFixedAmount | ProjectDiscountTypePercentage;

export type ProjectEntitlement = {
  __typename?: 'ProjectEntitlement';
  description?: Maybe<Scalars['String']>;
  displayOnPriceChart: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  exclusive?: Maybe<Array<ProjectUnit>>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ProjectFaq = {
  answer: Scalars['String'];
  question: Scalars['String'];
};

export type ProjectFaqSection = {
  /** Refer: src/graphql/definitions/input/project-faq.graphql */
  faqs: Array<ProjectFaq>;
  title: Scalars['String'];
};

export type ProjectFinancer = {
  __typename?: 'ProjectFinancer';
  bankerCount: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/financer.graphql */
  financer: Financer;
};

export type ProjectGrossPriceRange = {
  __typename?: 'ProjectGrossPriceRange';
  from: Scalars['Float'];
  to: Scalars['Float'];
};

export type ProjectHandler = {
  __typename?: 'ProjectHandler';
  employeeId: Scalars['ID'];
};

export type ProjectHarm = {
  __typename?: 'ProjectHarm';
  endDateTime: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  harm: User;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/project.graphql */
  project: Project;
  startDateTime: Scalars['String'];
};

export type ProjectInquiry = {
  __typename?: 'ProjectInquiry';
  /** Refer: src/graphql/definitions/object/user.graphql */
  arm: User;
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/project.graphql */
  parentProject: Project;
  remark: Scalars['String'];
  status: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  updatedBy: User;
};

export enum ProjectInquiryColumn {
  CreatedOn = 'created_on'
}

export type ProjectInquiryOverview = {
  __typename?: 'ProjectInquiryOverview';
  /** Refer: src/graphql/definitions/object/filtered-project-inquiry-overview-by-arms.graphql */
  arms: FilteredProjectInquiryOverviewByArms;
  /** Refer: src/graphql/definitions/object/filtered-project-inquiry-overview-by-parent-projects.graphql */
  parentProjects: FilteredProjectInquiryOverviewByParentProjects;
};


export type ProjectInquiryOverviewParentProjectsArgs = {
  armId: Scalars['ID'];
};

export type ProjectInquiryOverviewByArm = {
  __typename?: 'ProjectInquiryOverviewByArm';
  /** Refer: src/graphql/definitions/object/user.graphql */
  arm: User;
  inquiriesToday: Scalars['Int'];
  remainingInquiries: Scalars['Int'];
};

export type ProjectInquiryOverviewByParentProject = {
  __typename?: 'ProjectInquiryOverviewByParentProject';
  inquiriesToday: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/project.graphql */
  parentProject: Project;
  remainingInquiries: Scalars['Int'];
};

export enum ProjectInquiryStatusType {
  FollowUpRequired = 'FOLLOW_UP_REQUIRED',
  NoActionRequired = 'NO_ACTION_REQUIRED',
  RegisteredInterest = 'REGISTERED_INTEREST',
  Whitelisted = 'WHITELISTED'
}

export type ProjectInterest = {
  __typename?: 'ProjectInterest';
  /** Refer: src/graphql/definitions/object/project.graphql */
  project: Project;
  projectId: Scalars['String'];
  submittedOn: Scalars['String'];
  /**
   * Return the whitelist item that is related to the requesting user and this
   * `projectId`.
   * Refer: src/graphql/definitions/object/whitelist-item.graphql
   */
  whitelist?: Maybe<WhitelistItem>;
};

export type ProjectLayout = {
  __typename?: 'ProjectLayout';
  floor?: Maybe<Array<Scalars['String']>>;
  height?: Maybe<Scalars['Float']>;
  /** Refer: src/graphql/definitions/object/project-layout-overview.graphql */
  overview?: Maybe<ProjectLayoutOverview>;
  /** Refer: src/graphql/definitions/object/project-layout-high-rise-structure.graphql */
  plan?: Maybe<Array<Array<ProjectLayoutHighRiseStructure>>>;
  rotation?: Maybe<Scalars['Float']>;
  /** Refer: src/graphql/definitions/object/project-layout-svg.graphql */
  shapes?: Maybe<Array<ProjectLayoutSvg>>;
  /** Refer: src/graphql/definitions/object/project-layout-landed-structure.graphql */
  structures?: Maybe<Array<ProjectLayoutLandedStructure>>;
  type: Scalars['String'];
  view?: Maybe<Array<Scalars['String']>>;
  width?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  /** Refer: src/graphql/definitions/object/project-layout-zone.graphql */
  zone?: Maybe<Array<ProjectLayoutZone>>;
};

export type ProjectLayoutHighRiseStructure = {
  __typename?: 'ProjectLayoutHighRiseStructure';
  type: Scalars['String'];
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  unit?: Maybe<ProjectUnit>;
};

export type ProjectLayoutLandedStructure = {
  __typename?: 'ProjectLayoutLandedStructure';
  rotation: Scalars['Float'];
  /**
   * Refer: src/graphql/definitions/object/project-layout-svg.graphql
   * @deprecated Use svgs instead
   */
  shapes: Array<ProjectLayoutSvg>;
  /** Refer: src/graphql/definitions/union/svg.graphql */
  svgs: Array<Svg>;
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  unit?: Maybe<ProjectUnit>;
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type ProjectLayoutOverview = {
  __typename?: 'ProjectLayoutOverview';
  height?: Maybe<Scalars['Float']>;
  paths?: Maybe<Array<Scalars['String']>>;
  width?: Maybe<Scalars['Float']>;
  /** Refer: src/graphql/definitions/object/project-layout-zone.graphql */
  zone?: Maybe<Array<ProjectLayoutZone>>;
};

export type ProjectLayoutSvg = {
  __typename?: 'ProjectLayoutSvg';
  anchor?: Maybe<Scalars['String']>;
  cx?: Maybe<Scalars['Float']>;
  cy?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  path?: Maybe<Scalars['String']>;
  points?: Maybe<Array<Scalars['Float']>>;
  r?: Maybe<Scalars['Float']>;
  rotation?: Maybe<Scalars['Float']>;
  rx?: Maybe<Scalars['Float']>;
  ry?: Maybe<Scalars['Float']>;
  scale?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  width?: Maybe<Scalars['Float']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type ProjectLayoutZone = {
  __typename?: 'ProjectLayoutZone';
  childProjectId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /**
   * Refer: src/graphql/definitions/object/project-layout-svg.graphql
   * @deprecated Use svgs instead
   */
  shapes: Array<ProjectLayoutSvg>;
  /** Refer: src/graphql/definitions/union/svg.graphql */
  svgs: Array<Svg>;
};

export type ProjectLocation = {
  __typename?: 'ProjectLocation';
  /** Refer: src/graphql/definitions/object/project-location-coordinates.graphql */
  coordinates?: Maybe<ProjectLocationCoordinates>;
  name: Scalars['String'];
};

export type ProjectLocationCoordinates = {
  __typename?: 'ProjectLocationCoordinates';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

/**
 * Refer: src/graphql/definitions/object/project-map-marker-cluster.graphql
 * Refer: src/graphql/definitions/object/project-map-marker-kpkt-project.graphql
 */
export type ProjectMapMarker = ProjectMapMarkerCluster | ProjectMapMarkerKpktProject;

export type ProjectMapMarkerCluster = {
  __typename?: 'ProjectMapMarkerCluster';
  /** Refer: src/graphql/definitions/object/coordinate.graphql */
  coordinate: Coordinate;
  count: Scalars['Int'];
  expansionZoom: Scalars['Float'];
};

export type ProjectMapMarkerKpktProject = {
  __typename?: 'ProjectMapMarkerKpktProject';
  /** Refer: src/graphql/definitions/object/coordinate.graphql */
  coordinate: Coordinate;
  /** Refer: src/graphql/definitions/object/kpkt-project.graphql */
  project: KpktProject;
};

export type ProjectPartnerAppointment = {
  __typename?: 'ProjectPartnerAppointment';
  clientLastName?: Maybe<Scalars['String']>;
  closerAgentId: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/project-partner-appointment-conversion.graphql */
  conversion?: Maybe<ProjectPartnerAppointmentConversion>;
  date?: Maybe<Scalars['String']>;
  introducerAgentId: Scalars['ID'];
  last4Digits?: Maybe<Scalars['String']>;
};

export type ProjectPartnerAppointmentConversion = {
  __typename?: 'ProjectPartnerAppointmentConversion';
  bookingId: Scalars['ID'];
};

export type ProjectPaymentInfo = {
  __typename?: 'ProjectPaymentInfo';
  description: Scalars['String'];
  method: Scalars['String'];
};

export type ProjectPreference = {
  locations: Array<Scalars['String']>;
  priceRange: Array<Array<InputMaybe<Scalars['Int']>>>;
  propertyType: Scalars['String'];
};

export type ProjectPreferenceOption = {
  __typename?: 'ProjectPreferenceOption';
  locations: Array<Scalars['String']>;
  priceRange: Array<Array<Maybe<Scalars['Int']>>>;
  /** Refer: src/graphql/definitions/object/project-preference-property-type.graphql */
  propertyType: Array<ProjectPreferencePropertyType>;
  recorded: Scalars['Boolean'];
};

export type ProjectPreferencePropertyType = {
  __typename?: 'ProjectPreferencePropertyType';
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ProjectPrinter = {
  __typename?: 'ProjectPrinter';
  online?: Maybe<Scalars['Boolean']>;
};

export type ProjectSalesSummaryByUnitType = {
  __typename?: 'ProjectSalesSummaryByUnitType';
  /** Refer: src/graphql/definitions/object/project-sales-summary-by-unit-type-row.graphql */
  rowTotal: ProjectSalesSummaryByUnitTypeRow;
  /** Refer: src/graphql/definitions/object/project-sales-summary-by-unit-type-row.graphql */
  rows: Array<ProjectSalesSummaryByUnitTypeRow>;
};

/**
 * Note: percent values can be nullable when the divisor is zero.
 * For example, `totalSignedPercent` is null when `totalActiveBooking` is 0,
 * since `totalSignedPercent = totalSigned / totalActiveBooking`
 */
export type ProjectSalesSummaryByUnitTypeRow = {
  __typename?: 'ProjectSalesSummaryByUnitTypeRow';
  /** @deprecated Use `totalSignedGrossPrice` instead */
  totalGrossPrice: Scalars['Float'];
  /** @deprecated Use `totalSignedNettPrice` instead */
  totalNettPrice: Scalars['Float'];
  totalSigned: Scalars['Int'];
  totalSignedGrossPrice: Scalars['Float'];
  totalSignedNettPrice: Scalars['Float'];
  totalSignedPercent?: Maybe<Scalars['Float']>;
  totalUnits: Scalars['Int'];
  totalUnsigned: Scalars['Int'];
  totalUnsignedGrossPrice: Scalars['Float'];
  totalUnsignedPercent?: Maybe<Scalars['Float']>;
  totalUnsold: Scalars['Int'];
  totalUnsoldGrossPrice: Scalars['Float'];
  totalUnsoldPercent?: Maybe<Scalars['Float']>;
  unitType: Scalars['String'];
};

export type ProjectStats = {
  __typename?: 'ProjectStats';
  /** Refer: src/graphql/definitions/object/project-whitelists-stat.graphql */
  projectWhitelistsStats: Array<ProjectWhitelistsStat>;
};

export enum ProjectStatus {
  Active = 'active',
  ActiveTeaser = 'active_teaser',
  Concluded = 'concluded',
  Preparing = 'preparing'
}

export type ProjectSummary = {
  __typename?: 'ProjectSummary';
  description: Scalars['String'];
  estimatedCompletion: Scalars['String'];
  noOfBathrooms?: Maybe<Array<Scalars['String']>>;
  noOfBedrooms?: Maybe<Array<Scalars['String']>>;
  noOfCarParks?: Maybe<Array<Scalars['String']>>;
  pricePerSquareFt?: Maybe<Scalars['String']>;
  sizeRange?: Maybe<Scalars['String']>;
  tenure: Scalars['String'];
};

export type ProjectSupportPersonnel = {
  __typename?: 'ProjectSupportPersonnel';
  /** Refer: src/graphql/definitions/object/user.graphql */
  user: User;
};

export type ProjectTag = {
  __typename?: 'ProjectTag';
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ProjectTeaser = {
  __typename?: 'ProjectTeaser';
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  coverImages?: Maybe<Array<AttachedFile>>;
  name?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/project-teaser-point.graphql */
  points?: Maybe<Array<ProjectTeaserPoint>>;
  priceRange?: Maybe<Scalars['String']>;
};

export type ProjectTeaserPoint = {
  __typename?: 'ProjectTeaserPoint';
  icon?: Maybe<Scalars['String']>;
  text: Scalars['String'];
};

export type ProjectTransaction = {
  __typename?: 'ProjectTransaction';
  newBookingLastWeek: Scalars['Int'];
  newSalesLastWeek: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/project.graphql */
  project: Project;
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  transactions: Array<Transaction>;
};

export enum ProjectType {
  AdHoc = 'AD_HOC',
  Exclusive = 'EXCLUSIVE',
  SemiExclusive = 'SEMI_EXCLUSIVE'
}

export type ProjectUnit = {
  __typename?: 'ProjectUnit';
  /** Refer: src/graphql/definitions/object/postlaunch-transaction.graphql */
  activeTransaction?: Maybe<PostlaunchTransaction>;
  address?: Maybe<Scalars['String']>;
  bookingFee?: Maybe<Scalars['Float']>;
  /** @deprecated Use `bookingMethodEnum` instead. */
  bookingMethod: Scalars['String'];
  /** Refer: src/graphql/definitions/union/project-unit-booking-method.graphql */
  bookingMethodEnum: ProjectUnitBookingMethod;
  carParkUnitNums?: Maybe<Array<Scalars['String']>>;
  /** Refer: src/graphql/definitions/object/child-project.graphql */
  childProject: ChildProject;
  /** Refer: src/graphql/definitions/union/project-unit-status.graphql */
  currentStatus: ProjectUnitStatus;
  /** Refer: src/graphql/definitions/object/lawyer.graphql */
  defaultLawyer?: Maybe<Lawyer>;
  /**
   * Refer: src/graphql/definitions/object/project-unit-discount.graphql
   * @deprecated Use discountsEnum instead
   */
  discounts: Array<ProjectUnitDiscount>;
  /** Refer: src/graphql/definitions/union/project-discount-enum.graphql */
  discountsEnum: Array<ProjectDiscountEnum>;
  /**
   * Only applicable for highrise units.
   * Example: `left`, `right`, etc.
   */
  entrance?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  floorPlan?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  floorPlanFiles?: Maybe<Array<AttachedFile>>;
  grossPrice: Scalars['Float'];
  houseNum?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isBlocked?: Maybe<Scalars['Boolean']>;
  isBlockedOrMarkedAsSoldByMe?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use `project.entitlement` instead */
  isHoc?: Maybe<Scalars['Boolean']>;
  landSize?: Maybe<Scalars['String']>;
  noOfBathrooms?: Maybe<Scalars['String']>;
  noOfBedrooms?: Maybe<Scalars['String']>;
  noOfCarParks?: Maybe<Scalars['String']>;
  /**
   * Refer: src/graphql/definitions/object/project.graphql
   * @deprecated Use `childProject` instead
   */
  project?: Maybe<Project>;
  relatedToSomeTransactions: Scalars['Boolean'];
  size?: Maybe<Scalars['String']>;
  staircase?: Maybe<Scalars['String']>;
  /** @deprecated Use `currentStatus` instead. */
  status: Scalars['String'];
  /**
   * This returns the latest transaction that is related to this unit, regardless of cancellation.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  transaction?: Maybe<Transaction>;
  type: Scalars['String'];
  unitNum: Scalars['String'];
  unitSize?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/project-update.graphql */
  updates: Array<ProjectUpdate>;
  view?: Maybe<Scalars['String']>;
};


export type ProjectUnitDiscountsArgs = {
  onlySpaDiscounts?: InputMaybe<Scalars['Boolean']>;
};


export type ProjectUnitDiscountsEnumArgs = {
  onlySpaDiscounts?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Refer: src/graphql/definitions/object/project-unit-booking-method-exclusive.graphql
 * Refer: src/graphql/definitions/object/project-unit-booking-method-semi-exclusive.graphql
 * Refer: src/graphql/definitions/object/project-unit-booking-method-ad-hoc.graphql
 */
export type ProjectUnitBookingMethod = ProjectUnitBookingMethodAdHoc | ProjectUnitBookingMethodExclusive | ProjectUnitBookingMethodSemiExclusive;

export type ProjectUnitBookingMethodAdHoc = {
  __typename?: 'ProjectUnitBookingMethodAdHoc';
  dummy?: Maybe<Scalars['String']>;
};

export type ProjectUnitBookingMethodExclusive = {
  __typename?: 'ProjectUnitBookingMethodExclusive';
  dummy?: Maybe<Scalars['String']>;
};

export type ProjectUnitBookingMethodSemiExclusive = {
  __typename?: 'ProjectUnitBookingMethodSemiExclusive';
  dummy?: Maybe<Scalars['String']>;
};

export type ProjectUnitDiscount = {
  __typename?: 'ProjectUnitDiscount';
  amount: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/project-discount-dependency.graphql */
  dependsOn?: Maybe<ProjectDiscountDependency>;
  id: Scalars['ID'];
  name: Scalars['String'];
  optional?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/enum/transaction-price-type.graphql */
  remainingAmountPriceType?: Maybe<TransactionPriceType>;
  type: Scalars['String'];
};

/**
 * Refer: src/graphql/definitions/object/layout-highrise-overview.graphql
 * Refer: src/graphql/definitions/object/layout-highrise.graphql
 * Refer: src/graphql/definitions/object/layout-landed-overview.graphql
 * Refer: src/graphql/definitions/object/layout-landed.graphql
 */
export type ProjectUnitLayout = LayoutHighrise | LayoutHighriseOverview | LayoutLanded | LayoutLandedOverview;

/** To show the amount */
export type ProjectUnitLayoutLegend = {
  __typename?: 'ProjectUnitLayoutLegend';
  /**
   * Currently not implemented. To be implemented after we migrate Project to PostgreSQL.
   * So please derive the amount by querying units.currentStatus
   */
  amount?: Maybe<Scalars['Int']>;
};

/** For frontend to determine which kind of legend to render always. */
export type ProjectUnitLayoutLegends = {
  __typename?: 'ProjectUnitLayoutLegends';
  /** Refer: src/graphql/definitions/object/project-unit-layout-legend.graphql */
  available?: Maybe<ProjectUnitLayoutLegend>;
  /** Refer: src/graphql/definitions/object/project-unit-layout-legend.graphql */
  locked?: Maybe<ProjectUnitLayoutLegend>;
  /** Refer: src/graphql/definitions/object/project-unit-layout-legend.graphql */
  unavailable?: Maybe<ProjectUnitLayoutLegend>;
  /** Refer: src/graphql/definitions/object/project-unit-layout-legend.graphql */
  unknown?: Maybe<ProjectUnitLayoutLegend>;
};

export type ProjectUnitLock = {
  __typename?: 'ProjectUnitLock';
  /** Refer: src/graphql/definitions/object/booking-verification.graphql */
  bookingVerification?: Maybe<BookingVerification>;
  date: Scalars['String'];
  /** This is the unit ID instead of unit lock ID. */
  id: Scalars['String'];
  lockDuration: Scalars['Float'];
  /** This is the actual unit lock ID. */
  lockId: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  lockedBy?: Maybe<User>;
  lockedOn: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/project-unit-lock-party.graphql */
  party: ProjectUnitLockParty;
  /** Refer: src/graphql/definitions/object/project-unit-lock-releasement.graphql */
  releasement?: Maybe<ProjectUnitLockReleasement>;
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  unit: ProjectUnit;
  /** Refer: src/graphql/definitions/object/user.graphql */
  user?: Maybe<User>;
};

export enum ProjectUnitLockParty {
  First = 'first',
  Third = 'third'
}

export type ProjectUnitLockReleasement = {
  __typename?: 'ProjectUnitLockReleasement';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/enum/project-unit-lock-releasement-type.graphql */
  type: ProjectUnitLockReleasementType;
};

export enum ProjectUnitLockReleasementType {
  BookingSubmitted = 'BOOKING_SUBMITTED',
  LockingAnotherUnit = 'LOCKING_ANOTHER_UNIT',
  Manual = 'MANUAL',
  Timeout = 'TIMEOUT'
}

/** This is also known as ProjectUnitType. */
export type ProjectUnitMix = {
  __typename?: 'ProjectUnitMix';
  /** @deprecated Use floorPlanFile instead. */
  floorPlan?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  floorPlanFiles: Array<AttachedFile>;
  name: Scalars['String'];
  noOfBathrooms?: Maybe<Scalars['String']>;
  noOfBedrooms?: Maybe<Scalars['String']>;
  noOfCarParks?: Maybe<Scalars['String']>;
  size: Scalars['String'];
  variants: Array<Scalars['String']>;
};

/**
 * Refer: src/graphql/definitions/object/project-unit-status-available.graphql
 * Refer: src/graphql/definitions/object/project-unit-status-unavailable.graphql
 * Refer: src/graphql/definitions/object/project-unit-status-locked.graphql
 * Refer: src/graphql/definitions/object/project-unit-status-unknown.graphql
 */
export type ProjectUnitStatus = ProjectUnitStatusAvailable | ProjectUnitStatusLocked | ProjectUnitStatusUnavailable | ProjectUnitStatusUnknown;

export type ProjectUnitStatusAvailable = {
  __typename?: 'ProjectUnitStatusAvailable';
  grossPrice: Scalars['Float'];
};

export type ProjectUnitStatusLocked = {
  __typename?: 'ProjectUnitStatusLocked';
  grossPrice: Scalars['Float'];
  /** True if this unit is locked for/by the requesting user. Otherwise false or undefined. */
  lockedForMe?: Maybe<Scalars['Boolean']>;
};

export type ProjectUnitStatusUnavailable = {
  __typename?: 'ProjectUnitStatusUnavailable';
  dummy?: Maybe<Scalars['String']>;
  /**
   * Used for internal Dashboard only.
   * @deprecated Use `type` instead
   */
  isBlocked: Scalars['Boolean'];
  /**
   * Indicates if the active transaction of this unit is pending cancellation.
   * @deprecated Use `type` instead
   */
  pendingCancellation: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/enum/project-unit-status-unavailable-type.graphql */
  type: ProjectUnitStatusUnavailableType;
};

export enum ProjectUnitStatusUnavailableType {
  Blocked = 'BLOCKED',
  Booked = 'BOOKED',
  BookedButPendingCancellation = 'BOOKED_BUT_PENDING_CANCELLATION',
  DueToUnitChange = 'DUE_TO_UNIT_CHANGE',
  UnavailableOnExternalPriceChart = 'UNAVAILABLE_ON_EXTERNAL_PRICE_CHART'
}

export type ProjectUnitStatusUnknown = {
  __typename?: 'ProjectUnitStatusUnknown';
  dummy?: Maybe<Scalars['String']>;
  grossPrice: Scalars['Float'];
};

export type ProjectUpdate = {
  __typename?: 'ProjectUpdate';
  id: Scalars['ID'];
  on: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  triggeredBy?: Maybe<User>;
  /** Refer: src/graphql/definitions/enum/project-update-type.graphql */
  type: ProjectUpdateType;
  /** Refer: src/graphql/definitions/object/unit-update.graphql */
  unit?: Maybe<UnitUpdate>;
};

export enum ProjectUpdateType {
  Unit = 'UNIT'
}

export type ProjectVirtualSalesGalleries = {
  __typename?: 'ProjectVirtualSalesGalleries';
  type: Scalars['String'];
  url: Scalars['String'];
};

export type ProjectWhitelistsStat = {
  __typename?: 'ProjectWhitelistsStat';
  numberOfWhitelistedAgents: Scalars['Int'];
  projectName: Scalars['String'];
};

export type PropertyRegistrationForm = {
  /** Refer: src/graphql/definitions/input/developer-detail.graphql */
  developer?: InputMaybe<DeveloperDetail>;
  /** Refer: src/graphql/definitions/input/property-registration-form-section.graphql */
  sections: Array<PropertyRegistrationFormSection>;
  title: Scalars['String'];
};

export type PropertyRegistrationFormField = {
  aspectRatio?: InputMaybe<Scalars['Float']>;
  inline?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  mask?: InputMaybe<Array<Scalars['String']>>;
  minimize?: InputMaybe<Scalars['Boolean']>;
  multiline?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  optional?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<Scalars['String']>>;
  regexp?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  watermark?: InputMaybe<Scalars['String']>;
};

export type PropertyRegistrationFormSection = {
  /** Refer: src/graphql/definitions/input/add-new.graphql */
  addNew?: InputMaybe<AddNew>;
  /** Refer: src/graphql/definitions/input/property-registration-form-field.graphql */
  fields: Array<PropertyRegistrationFormField>;
  officeUse?: InputMaybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/input/post-text.graphql */
  postText?: InputMaybe<PostText>;
  print?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ProspectiveUser = {
  __typename?: 'ProspectiveUser';
  /** Refer: src/graphql/definitions/object/agency.graphql */
  agency?: Maybe<Agency>;
  createdOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/prospective-user-fulfillment.graphql */
  fulfillment?: Maybe<ProspectiveUserFulfillment>;
  id: Scalars['ID'];
  mobileNum: Scalars['String'];
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/object/role.graphql */
  roles: Array<Role>;
};

export type ProspectiveUserFulfillment = {
  __typename?: 'ProspectiveUserFulfillment';
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
};

export type ProspectiveUserMutation = {
  __typename?: 'ProspectiveUserMutation';
  /** Refer: src/graphql/definitions/object/prospective-user.graphql */
  create: ProspectiveUser;
  /** Refer: src/graphql/definitions/object/prospective-user.graphql */
  delete: ProspectiveUser;
};


export type ProspectiveUserMutationCreateArgs = {
  agencyId?: InputMaybe<Scalars['ID']>;
  mobileNum: Scalars['String'];
  name: Scalars['String'];
  roles: Array<Scalars['ID']>;
};


export type ProspectiveUserMutationDeleteArgs = {
  id: Scalars['ID'];
};

export type ProspectiveUserQuery = {
  __typename?: 'ProspectiveUserQuery';
  /** Refer: src/graphql/definitions/object/filtered-prosective-users.graphql */
  findMany: FilteredProsectiveUsers;
};


export type ProspectiveUserQueryFindManyArgs = {
  search: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  /**
   * List of queries available for Didian Buyer Portal that require only
   * authentication but not authorisation.
   * Refer: src/graphql/definitions/object/buyer-portal-authenticated.graphql
   */
  buyerPortalAuthenticated: BuyerPortalAuthenticated;
  /**
   * List of public queries available for Didian Buyer Portal.
   * Refer: src/graphql/definitions/object/buyer-portal-public.graphql
   */
  buyerPortalPublic: BuyerPortalPublic;
  /** User with this permission can display the commission of all ARMs. */
  canDisplayCommissionOfAllArms: Scalars['Boolean'];
  /** User with this permission can display the user of a project unit lock */
  canDisplayProjectUnitLockUser: Scalars['Boolean'];
  /** User with this permission can submit booking form on behalf of others i.e. can edit the agent info on the booking form */
  canMakeBookingOnOtherBehalf: Scalars['Boolean'];
  /** User with this permission can release unit that is blocked or marked as sold by other */
  canReleaseUnitBlockedOrMarkedAsSoldByOther: Scalars['Boolean'];
  /** User with this permission can skip the advance booking days restriction when creating customer schedule */
  canSkipAdvanceBookingDaysRestriction: Scalars['Boolean'];
  /** User with this permission can bypass project whitelist checking. */
  canSkipWhitelisting: Scalars['Boolean'];
  /**
   * User with this permission can submit booking for unavailable units that are not linked with any active transactions.
   * This usually happens on project where price chart are mirrored from external system (for example MHUB),
   * when the units are closed on the external system, only the unit's status is updated, no transaction will be created.
   * These are the kind of units that can be overriden with new bookings.
   */
  canSubmitBookingForUnavailableUnits: Scalars['Boolean'];
  /** User with this permission can upload invoice on behalf of any agent. */
  canUploadInvoiceOnBehalfOfAnyAgent: Scalars['Boolean'];
  /** Users with this permissions can view Agency Commission pages on the developer dashboard. */
  canViewAgencyCommissionOnDeveloperDashboard: Scalars['Boolean'];
  /**
   * User with this permission can always view all popup ads active at the request
   * time regardless of whether the popup ad is LIVE or not.
   */
  canViewAllActivePopupAds: Scalars['Boolean'];
  /** Users with this permissions can view all projects on the developer dashboard. */
  canViewAllProjectsOnDeveloperDashboard: Scalars['Boolean'];
  /** Users with this permissions can view the Analytics pages on the developer dashboard. */
  canViewAnalyticsOnDeveloperDashboard: Scalars['Boolean'];
  /**
   * Users with this permission can view the secret of any reward, regardless of
   * whether the rewards are redeemed by them or not.
   */
  canViewAnyRewardSecret: Scalars['Boolean'];
  /** Users with this permissions can view the Appointments pages on the developer dashboard. */
  canViewAppointmentsOnDeveloperDashboard: Scalars['Boolean'];
  /** Users with this permissions can view the Price Chart pages on the developer dashboard. */
  canViewPriceChartOnDeveloperDashboard: Scalars['Boolean'];
  /** Users with this permissions can view the Sales pages on the developer dashboard. */
  canViewSalesOnDeveloperDashboard: Scalars['Boolean'];
  /** User with this permission will be able to view the file content of transaction commmisison invoices uploaded by agents. */
  canViewTransactionCommissionInvoiceFile: Scalars['Boolean'];
  /**
   * User with this permission will be able to view the file content of transaction
   * commmisison payment slip uploaded by accountant.
   */
  canViewTransactionCommissionPaymentSlipFile: Scalars['Boolean'];
  /** User with this permission can whitelist any agent for any project without being in-charged for that project. */
  canWhitelistAnyProject: Scalars['Boolean'];
  /**
   * Whitelist individual agent for a project without needing to schedule an
   * appointment to visit the project first (Normal SOP)
   */
  canWhitelistWithoutSchedulingAppointment: Scalars['Boolean'];
  /**
   * List of query methods related to Didian Now Portal.
   * Refer: src/graphql/definitions/object/ddn-portal.graphql
   */
  ddnPortal: DdnPortal;
  /**
   * List of DDN public-accessible fields.
   * Refer: src/graphql/definitions/object/ddn-public.graphql
   */
  ddnPublic: DdnPublic;
  /** For dashboard to derive the unit commission paid by developer. */
  deriveDeveloperTransactionCommission: Scalars['Float'];
  /**
   * For display developer dashboard.
   * Refer: src/graphql/definitions/object/developer-dashboard.graphql
   */
  developerDashboard: DeveloperDashboard;
  /**
   * Developer displays the customer schedules for a particular project
   * Refer: src/graphql/definitions/object/schedule.graphql
   */
  developerDisplayCustomerSchedules: Array<Schedule>;
  /**
   * For developer to display their transactions.
   * The reason why we don't use existing schema for this method is because we want
   * to prevent developer from viewing data that they shouldn't be viewing.
   * Refer: src/graphql/definitions/object/developer-display-transaction-result.graphql
   */
  developerDisplayTransactions: DeveloperDisplayTransactionResult;
  /**
   * Display all agencies or property developers or both.
   * Refer: src/graphql/definitions/object/agency.graphql
   */
  displayAgencies: Array<Agency>;
  /**
   * For admins to display all agency groups.
   * Refer: src/graphql/definitions/object/display-agency-group.graphql
   */
  displayAgencyGroup: DisplayAgencyGroup;
  /**
   * Display sales performance of each agencies (and their agents) for the specified project.
   * Refer: src/graphql/definitions/object/agency-data.graphql
   */
  displayAgencyPerformance: AgencyData;
  /**
   * For admins to display all agency teams and agency team related data.
   * Refer: src/graphql/definitions/object/display-agency-team.graphql
   */
  displayAgencyTeam: DisplayAgencyTeam;
  /**
   * Methods for team leaders to view data of their team members.
   * Refer: src/graphql/definitions/object/display-agency-team-member.graphql
   */
  displayAgencyTeamMember: DisplayAgencyTeamMember;
  /**
   * This is for Agency Team Managers to display project inquiries
   * Refer: src/graphql/definitions/object/display-agency-team-project-inquiry.graphql
   */
  displayAgencyTeamProjectInquiry: DisplayAgencyTeamProjectInquiry;
  /**
   * Display all information of an agent, including their sales.
   * Refer: src/graphql/definitions/object/display-agent-result.graphql
   */
  displayAgent: DisplayAgentResult;
  /**
   * Display list of Agent Acquisition Executives
   * Refer: src/graphql/definitions/object/user.graphql
   */
  displayAgentAcquisitionExecutive: Array<User>;
  /**
   * Display all/specific agent lead(s).
   * Refer: src/graphql/definitions/object/agent-lead.graphql
   */
  displayAgentLeads: Array<AgentLead>;
  /**
   * Display information about a specific schedule made by an agent
   * Refer: src/graphql/definitions/object/schedule.graphql
   */
  displayAgentSchedule?: Maybe<Schedule>;
  /**
   * Display the information about the schedules made by an agent
   * Refer: src/graphql/definitions/object/schedule.graphql
   */
  displayAgentSchedules: Array<Schedule>;
  /**
   * Display the verfication status statistics for signed up agents on a weekly basis
   * Refer: src/graphql/definitions/object/agent-signup-stats.graphql
   * @deprecated This stat will be moved to Holistics.
   */
  displayAgentSignupStats: Array<AgentSignupStats>;
  /**
   * Display details of all verified agents.
   * Refer: src/graphql/definitions/object/agent.graphql
   */
  displayAgents: Array<Agent>;
  /**
   * Display the agents table
   * Refer: src/graphql/definitions/object/table.graphql
   */
  displayAgentsTable: Table;
  /**
   * Display the aging transactions table.
   * Refer: src/graphql/definitions/object/table.graphql
   */
  displayAgingTransactionsTable: Table;
  /**
   * Display all appointment letters that are not marked as deleted.
   * Refer: src/graphql/definitions/object/appointment-letter.graphql
   */
  displayAllAppointmentLetters: Array<AppointmentLetter>;
  /**
   * Display all buyer leads.
   * Refer: src/graphql/definitions/object/display-buyer-leads-response.graphql
   */
  displayAllBuyerLeads: DisplayBuyerLeadsResponse;
  /**
   * Display all occupied estore URL. Primarily for Didian Homepage server to generate sitemap for crawler to improve SEO.
   * Refer: src/graphql/definitions/object/estore-url-response.graphql
   */
  displayAllEstoreUrl?: Maybe<Array<EstoreUrlResponse>>;
  /**
   * Display all occupied estore URL suffix. Primarily for Didian Homepage server
   * to generate sitemap for crawler to improve SEO.
   */
  displayAllEstoreUrlSuffix?: Maybe<Array<Scalars['String']>>;
  /**
   * Display all the details of any transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  displayAnyTransaction?: Maybe<Transaction>;
  /**
   * Display all transactions of the specified project.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  displayAnyTransactions: Array<Transaction>;
  /**
   * Display the appointment letters table.
   * Refer: src/graphql/definitions/object/table.graphql
   */
  displayAppointmentLettersTable: Table;
  /**
   * Display the agent leads of an ARM.
   * Refer: src/graphql/definitions/object/filtered-agent-leads.graphql
   */
  displayArmAgentLeads: FilteredAgentLeads;
  /**
   * Display the ARMs' performance which are leads assigned, appointments made and units sold
   * Refer: src/graphql/definitions/object/arm-performance.graphql
   * @deprecated Use Holistics instead
   */
  displayArmPerformance: ArmPerformance;
  /**
   * Display the information about the schedules to be attended by ARMs.
   * Refer: src/graphql/definitions/object/schedule.graphql
   */
  displayArmSchedules: Array<Schedule>;
  /**
   * Display list of Agent Relationship Managers (ARMS).
   * Refer: src/graphql/definitions/object/user.graphql
   */
  displayArms: Array<User>;
  /**
   * Display assigned buyer leads of requesting user.
   * Refer: src/graphql/definitions/object/buyer-lead.graphql
   */
  displayAssignedBuyerLeads: Array<BuyerLead>;
  /**
   * Display all available permissions of the system.
   * Refer: src/graphql/definitions/object/permission.graphql
   */
  displayAvailablePermissions: Array<Permission>;
  /**
   * Display available secondary statuses for a specific primary status.
   * Refer: src/graphql/definitions/object/detailed-buyer-lead-status.graphql
   */
  displayAvailableSecondaryStatuses: Array<DetailedBuyerLeadStatus>;
  /**
   * Display the available appointment timeslots for visiting a project
   * Refer: src/graphql/definitions/object/display-available-time-slots-result.graphql
   */
  displayAvailableTimeslots: DisplayAvailableTimeSlotsResult;
  /**
   * Display available units that is related to the specified transaction. This method will be used during changing unit.
   * Refer: src/graphql/definitions/object/filtered-project-units.graphql
   */
  displayAvailableUnit: FilteredProjectUnits;
  /**
   * Display available units that is related to the specified transaction. This method will be used during changing unit.
   * Refer: src/graphql/definitions/object/available-unit.graphql
   * @deprecated Use `displayAvailableUnit` instead.
   */
  displayAvailableUnits: Array<AvailableUnit>;
  /**
   * Methods for admin to display panel bankers.
   * Refer: src/graphql/definitions/object/display-banker.graphql
   */
  displayBanker: DisplayBanker;
  /**
   * Display panel bankers of a child/parent project
   * Refer: src/graphql/definitions/object/banker-info.graphql
   */
  displayBankers: Array<BankerInfo>;
  /**
   * Display the panel bankers table.
   * Refer: src/graphql/definitions/object/table.graphql
   */
  displayBankersTable: Table;
  /**
   * Display booking form for a specific child project.
   * Refer: src/graphql/definitions/object/registration-form.graphql
   */
  displayBookingForm: RegistrationForm;
  /**
   * List of query methods for displaying booking verifications.
   * Refer: src/graphql/definitions/object/display-booking-verification.graphql
   */
  displayBookingVerification: DisplayBookingVerification;
  /**
   * Display the detail of a user based on Bovaea website.
   * Refer: src/graphql/definitions/object/display-bovaea-detail-response.graphql
   */
  displayBovaeaDetail?: Maybe<DisplayBovaeaDetailResponse>;
  /**
   * Display buyer demographics data of the specified project.
   * Refer: src/graphql/definitions/object/buyer-demographic-data.graphql
   */
  displayBuyerDemographics: BuyerDemographicData;
  /**
   * Display list of buyer lead distributions
   * Refer: src/graphql/definitions/object/buyer-lead-distribution.graphql
   */
  displayBuyerLeadDistributions: Array<BuyerLeadDistribution>;
  /**
   * Display the statistics of buyer leads.
   * Refer: src/graphql/definitions/object/display-buyer-lead-stats-response.graphql
   */
  displayBuyerLeadStats: DisplayBuyerLeadStatsResponse;
  /**
   * Display the buyer leads table.
   * Refer: src/graphql/definitions/object/table.graphql
   */
  displayBuyerLeadsTable: Table;
  /**
   * Display details of all active projects in categories (will be different for every user).
   * Refer: src/graphql/definitions/object/categorized-projects.graphql
   */
  displayCategorizedProjects: CategorizedProjects;
  /**
   * For admins to display all child projects.
   * Refer: src/graphql/definitions/object/display-child-project.graphql
   */
  displayChildProject: DisplayChildProject;
  /**
   * Display the commission of ARMs.
   * Refer: src/graphql/definitions/object/arm-commission.graphql
   */
  displayCommission: Array<ArmCommission>;
  /** User with this permission can view in/out commission amount of each transaction. */
  displayCommissionDetails: Scalars['Boolean'];
  /** Display the commission settings (i.e. jmas, commission percentage, etc.) of a project. */
  displayCommissionSettings: Scalars['Boolean'];
  /**
   * For displaying common utilities e.g. loan rejection reasons, etc.
   * Refer: src/graphql/definitions/object/display-common-utility.graphql
   */
  displayCommonUtility: DisplayCommonUtility;
  /**
   * Display cooperations related to the requesting user (e.g. agent, team lead, etc.) filter by agentId or projectId
   * Refer: src/graphql/definitions/object/agent-cooperation.graphql
   */
  displayCooperations: Array<AgentCooperation>;
  /**
   * Display Custom PDF
   * Refer: src/graphql/definitions/object/graph-ql-query-custom-pdf.graphql
   */
  displayCustomPDF: Array<GraphQlQueryCustomPdf>;
  /**
   * The purpose of this method is for Didian App to find out a particular customer schedule timeslot
   * is occupied with how many existing schedules.
   * Refer: src/graphql/definitions/object/display-customer-schedule-timeslots-response.graphql
   */
  displayCustomerScheduleTimeslots: DisplayCustomerScheduleTimeslotsResponse;
  /**
   * Didian staff displays the information about the customer schedules.
   * Refer: src/graphql/definitions/object/schedule.graphql
   */
  displayCustomerSchedules: Array<Schedule>;
  /**
   * Methods for Didian internal team to display Ddn properties.
   * Refer: src/graphql/definitions/object/display-ddn-property.graphql
   */
  displayDdnProperty: DisplayDdnProperty;
  /**
   * Methods for finance team to display data related to developer commission.
   * Refer: src/graphql/definitions/object/display-developer-commission.graphql
   */
  displayDeveloperCommission: DisplayDeveloperCommission;
  /**
   * Display the weekly development values of a project.
   * Refer: src/graphql/definitions/object/project-development-value.graphql
   */
  displayDevelopmentValues: Array<ProjectDevelopmentValue>;
  /**
   * Display list of interpolatable variables for a specific type of document template
   * Refer: src/graphql/definitions/object/document-template-variable.graphql
   */
  displayDocumentTemplateVariables: Array<DocumentTemplateVariable>;
  /**
   * Display all or specified appointment letter generator template(s)
   * Refer: src/graphql/definitions/object/document-template.graphql
   */
  displayDocumentTemplates: Array<DocumentTemplate>;
  /**
   * Display information about an agent.
   * Refer: src/graphql/definitions/object/estore-response.graphql
   * @deprecated Use displayEstoreAgent and displayEstoreProject.
   */
  displayEstore: EstoreResponse;
  /**
   * Display public information about an agent
   * Refer: src/graphql/definitions/object/estore-agent-response.graphql
   */
  displayEstoreAgent: EstoreAgentResponse;
  /**
   * Display public information about an agent and a project he/she is selling
   * Refer: src/graphql/definitions/object/estore-project-response.graphql
   */
  displayEstoreProject: EstoreProjectResponse;
  /**
   * Methods for displaying project teaser features.
   * Refer: src/graphql/definitions/object/display-estore-project-teaser-features.graphql
   */
  displayEstoreProjectTeaserFeatures: DisplayEstoreProjectTeaserFeatures;
  /**
   * Display field mapping fields for custom PDF
   * Refer: src/graphql/definitions/object/field.graphql
   */
  displayFieldMappingFields: Array<Field>;
  /**
   * Methods for admin to displays financers.
   * Refer: src/graphql/definitions/object/display-financer.graphql
   */
  displayFinancer: DisplayFinancer;
  /**
   * List of queries available for retrieving financial reports.
   * Refer: src/graphql/definitions/object/display-financial-report.graphql
   */
  displayFinancialReport: DisplayFinancialReport;
  /**
   * For user to display all requested financial reports for a project.
   * Refer: src/graphql/definitions/union/financial-report.graphql
   */
  displayFinancialReports: Array<FinancialReport>;
  /**
   * Display financial reports table
   * Refer: src/graphql/definitions/object/table.graphql
   */
  displayFinancialReportsTable: Table;
  /**
   * This method is for demonstrating how the application level code talks
   * with Postgres.
   * Refer: src/graphql/definitions/object/foo.graphql
   */
  displayFoo?: Maybe<Foo>;
  /** For user to get question suggestions after agent GPT gave an answer */
  displayGPTNotificationSuggestions: Array<Scalars['String']>;
  /**
   * Methods for displaying all GAL agency groups.
   * Refer: src/graphql/definitions/object/display-gal-agency-group.graphql
   */
  displayGalAgencyGroup: DisplayGalAgencyGroup;
  /**
   * Methods for displaying GAL signed copies.
   * Refer: src/graphql/definitions/object/display-gal-signed-copy.graphql
   */
  displayGalSignedCopy: DisplayGalSignedCopy;
  /**
   * Methods for displaying GAL template (GAL template)
   * Refer: src/graphql/definitions/object/display-gal-template.graphql
   */
  displayGalTemplate: DisplayGalTemplate;
  /**
   * Display list of broadcasted admin-generated notifications.
   * Refer: src/graphql/definitions/object/notification.graphql
   */
  displayGeneralNotifications: Array<Notification>;
  /**
   * Display users that were HARM during the given date.
   * Refer: src/graphql/definitions/object/user.graphql
   */
  displayHeadsOfArm: Array<User>;
  /**
   * For Didian App to retrieve the summary of each group in inbox page.
   * Refer: src/graphql/definitions/object/inbox-summary.graphql
   */
  displayInboxSummary: InboxSummary;
  /**
   * Display the inventory stats of a project.
   * Refer: src/graphql/definitions/object/inventory-stats.graphql
   */
  displayInventoryStats: InventoryStats;
  /**
   * Methods for internal users to display a KPKT project's detail information.
   * Refer: src/graphql/definitions/object/display-kpkt-projects.graphql
   */
  displayKpktProjects?: Maybe<DisplayKpktProjects>;
  /**
   * Display the latest error log.
   * To ensure that error logs are inserted into database properly.
   * For testing purpose only.
   * Refer: src/graphql/definitions/object/log.graphql
   */
  displayLatestErrorLog?: Maybe<Log>;
  /**
   * Retrieve notifications which are created on the past 7 days of the requesting user.
   * Refer: src/graphql/definitions/object/notification.graphql
   */
  displayLatestNotifications: Array<Maybe<Notification>>;
  /**
   * Display the panel lawyers of a child/parent project.
   * Refer: src/graphql/definitions/object/lawyer.graphql
   */
  displayLawyers: Array<Lawyer>;
  /**
   * Display the panel lawyers table.
   * Refer: src/graphql/definitions/object/table.graphql
   */
  displayLawyersTable: Table;
  /**
   * Method for users to search map places.
   * Refer: src/graphql/definitions/object/display-map-place.graphql
   */
  displayMapPlace: DisplayMapPlace;
  /**
   * Display notes of a transaction. Notes includes user created notes and system generated notes.
   * Refer: src/graphql/definitions/object/note.graphql
   */
  displayNotes: Array<Note>;
  /**
   * For user to display a notification that he/she can read.
   * Refer: src/graphql/definitions/object/notification.graphql
   */
  displayNotification: Notification;
  /**
   * Display a notification channel.
   * Refer: src/graphql/definitions/object/notification-channel.graphql
   */
  displayNotificationChannel: NotificationChannel;
  /**
   * Display all panel lawyers.
   * Refer: src/graphql/definitions/object/lawyer.graphql
   */
  displayPanelLawyers: Array<Lawyer>;
  /**
   * For admins to display all parent projects.
   * Refer: src/graphql/definitions/object/display-parent-project.graphql
   */
  displayParentProject: DisplayParentProject;
  /**
   * For agent to retrieve their list of transaction commission invoice requests.
   * Refer: src/graphql/definitions/object/display-payment-portal-data-response.graphql
   * @deprecated Use `paymentPortal` instead, because `displayPaymentPortalData` method does not include pagination mechanism, which causes performance issue.
   */
  displayPaymentPortalData?: Maybe<DisplayPaymentPortalDataResponse>;
  /**
   * Generate a public token (on behalf of the requesting user) that is used to access the Didian Payment Portal.
   * Refer: src/graphql/definitions/object/token.graphql
   */
  displayPaymentPortalToken: Token;
  /**
   * Display pending (a.k.a unaccepted) cooperations of the requesting user
   * Refer: src/graphql/definitions/object/agent-cooperation.graphql
   */
  displayPendingCoopInvites: Array<AgentCooperation>;
  /**
   * List of methods for admin to display pending invoice request transactions.
   * Refer: src/graphql/definitions/object/display-pending-invoice-request-transactions.graphql
   */
  displayPendingInvoiceRequestTransactions: DisplayPendingInvoiceRequestTransactions;
  /**
   * Display transactions pivot table of a project.
   * Refer: src/graphql/definitions/object/transaction-pivot-table.graphql
   * @deprecated Project pivot table is moved to Holistics.
   */
  displayPivotTable?: Maybe<TransactionPivotTable>;
  /**
   * Display specific popup ad
   * Refer: src/graphql/definitions/object/popup-ad.graphql
   */
  displayPopupAd: PopupAd;
  /**
   * Display popup ad table
   * Refer: src/graphql/definitions/object/table.graphql
   */
  displayPopupAdsTable: Table;
  /**
   * Display Booking Draft
   * Refer: src/graphql/definitions/object/display-postlaunch-booking-draft.graphql
   */
  displayPostlaunchBookingDraft: DisplayPostlaunchBookingDraft;
  /**
   * Display Booking Form
   * Refer: src/graphql/definitions/object/display-postlaunch-form.graphql
   */
  displayPostlaunchForm: DisplayPostlaunchForm;
  /**
   * Methods for admin to display all postlaunch transactions.
   * Refer: src/graphql/definitions/object/display-postlaunch-transaction.graphql
   */
  displayPostlaunchTransaction: DisplayPostlaunchTransaction;
  /**
   * Display all the available preference options.
   * Refer: src/graphql/definitions/object/project-preference-option.graphql
   */
  displayPreferenceOptions: ProjectPreferenceOption;
  /**
   * Display the detail of the requesting user.
   * Refer: src/graphql/definitions/object/user.graphql
   */
  displayProfile?: Maybe<User>;
  /**
   * Display the detail of a child/parent project.
   * If the requesting user is a property developer, then only return projects that they can view.
   * This method will NOT return inactive child projects and inactive discounts related to this project.
   * This is meant to be the consumed by Didian App.
   * Refer: src/graphql/definitions/object/project.graphql
   */
  displayProject: Project;
  /**
   * Methods for displaying project agency group
   * Refer: src/graphql/definitions/object/display-project-agency-group.graphql
   */
  displayProjectAgencyGroup: DisplayProjectAgencyGroup;
  /**
   * Methods for admn to display all the project agency kinds.
   * Refer: src/graphql/definitions/object/display-project-agency-group-kind.graphql
   */
  displayProjectAgencyKind: DisplayProjectAgencyGroupKind;
  /**
   * Display list of project categories.
   * Refer: src/graphql/definitions/object/project-category.graphql
   */
  displayProjectCategories: Array<ProjectCategory>;
  /**
   * Methods for displaying project commission tnc
   * Refer: src/graphql/definitions/object/display-project-commission-tnc.graphql
   */
  displayProjectCommissionTnc: DisplayProjectCommissionTnc;
  /**
   * Set of methods for admins to display project discounts.
   * Refer: src/graphql/definitions/object/display-project-discount.graphql
   */
  displayProjectDiscount: DisplayProjectDiscount;
  /**
   * Get the full information of a parent or child project.
   * If the requesting user is a property developer, then only return projects that they can view.
   * This method will return inactive child projects and inactive discounts related to this project.
   * This is meant to be the consumed by admin dashboard.
   * Refer: src/graphql/definitions/object/project.graphql
   */
  displayProjectFullInfo: Project;
  /**
   * This is for ARMs to display project inquiries
   * Refer: src/graphql/definitions/object/display-project-inquiry.graphql
   */
  displayProjectInquiry: DisplayProjectInquiry;
  /**
   * Display data of transactions related to the requesting user (e.g. agents, team leads, etc.) grouped by project.
   * Refer: src/graphql/definitions/object/project-transaction.graphql
   */
  displayProjectSequences: Array<ProjectTransaction>;
  /**
   * Display the project statistics (number of whitelisted agents)
   * Refer: src/graphql/definitions/object/project-stats.graphql
   */
  displayProjectStats: ProjectStats;
  /**
   * Display the detail of a unit.
   * Refer: src/graphql/definitions/object/project-unit.graphql
   */
  displayProjectUnit: ProjectUnit;
  /**
   * Display the detail of a specific unit lock.
   * Refer: src/graphql/definitions/object/project-unit-lock.graphql
   */
  displayProjectUnitLock?: Maybe<ProjectUnitLock>;
  /**
   * Display all the locked units of every project.
   * Refer: src/graphql/definitions/object/project-unit-lock.graphql
   */
  displayProjectUnitLocks: Array<ProjectUnitLock>;
  /**
   * For Didian internal users to display details of all projects in the system.
   * Refer: src/graphql/definitions/object/project.graphql
   */
  displayProjects: Array<Project>;
  /**
   * To display the sales of all projects.
   * Refer: src/graphql/definitions/object/display-project-sales-response.graphql
   * @deprecated Projects sales is moved to Holistics.
   */
  displayProjectsSales: DisplayProjectSalesResponse;
  /**
   * Display all promptable whitelisted projects for the requesting user.
   * This method is meant to be used externally.
   * Refer: src/graphql/definitions/object/filtered-parent-projects.graphql
   */
  displayPromptableWhitelistedProjects: FilteredParentProjects;
  /**
   * Suggest project units that is similar to a specific unit on the client app/unit page.
   * Refer: src/graphql/definitions/object/related-project-units.graphql
   */
  displayRelatedProjectUnits?: Maybe<Array<RelatedProjectUnits>>;
  /**
   * Display latest user created notes of a transaction (public remarks).
   * Refer: src/graphql/definitions/object/note.graphql
   */
  displayRemark: Array<Maybe<Note>>;
  /**
   * Display invoice requests preview of a transaction.
   * Refer: src/graphql/definitions/object/transaction-commission-invoice-request.graphql
   */
  displayRequestForInvoice: Array<TransactionCommissionInvoiceRequest>;
  /**
   * Display list of required appointment letters that is not uploaded yet.
   * Refer: src/graphql/definitions/object/display-required-appointment-letters-result.graphql
   */
  displayRequiredAppointmentLetters: DisplayRequiredAppointmentLettersResult;
  /**
   * Display reward groups.
   * Refer: src/graphql/definitions/object/reward-group.graphql
   */
  displayRewardGroups: Array<RewardGroup>;
  /**
   * Display users' missions for earning didian angpow.
   * Refer: src/graphql/definitions/object/user-mission.graphql
   */
  displayRewardMissions: Array<UserMission>;
  /**
   * List of methods for user to display roles.
   * Refer: src/graphql/definitions/object/display-role.graphql
   */
  displayRole: DisplayRole;
  /**
   * Display details of all roles.
   * Refer: src/graphql/definitions/object/role.graphql
   */
  displayRoles: Array<Role>;
  /**
   * Display the sales performance of the specified projects.
   * Details:
   *   - Number of sales per week.
   *   - Average number of days needed to complete a sale.
   * Refer: src/graphql/definitions/object/sales-metric.graphql
   */
  displaySalesMetric: SalesMetric;
  /**
   * Display sales table (Used by teams other than sales management team)
   * Refer: src/graphql/definitions/object/table.graphql
   */
  displaySalesTableOtherTeam: Table;
  /**
   * Display sales table (Used by sales management team)
   * Refer: src/graphql/definitions/object/table.graphql
   */
  displaySalesTableSalesTeam: Table;
  /**
   * Methods to display data of SBU KPIs.
   * Refer: src/graphql/definitions/object/display-sbu-kpi.graphql
   */
  displaySbuKpi: DisplaySbuKpi;
  /**
   * Display the information about a schedule
   * Refer: src/graphql/definitions/object/schedule.graphql
   */
  displaySchedule?: Maybe<Schedule>;
  /** Display the one-time invitation code for a schedule to allow agents to join the schedule. */
  displayScheduleInvitationCode: Scalars['String'];
  /**
   * For users to display the detail of their transaction.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  displaySequence: Transaction;
  /**
   * For users to display their transactions, can filter by either transaction types or projectId or agentId.
   * Refer: src/graphql/definitions/object/transaction.graphql
   */
  displaySequences: Array<Transaction>;
  /**
   * Get the current server time, the purpose of this method is to allow multiple
   * clients to display a synchronized clock, which is especially important during
   * unit selection of a project launch.
   * Returns date as ISO string.
   */
  displayServerTime: Scalars['String'];
  /**
   * For users to display data related to service fee.
   * Refer: src/graphql/definitions/object/display-service-fee.graphql
   */
  displayServiceFee: DisplayServiceFee;
  /**
   * Display the timeslot templates for scheduling appointments.
   * Refer: src/graphql/definitions/object/slot-template.graphql
   */
  displaySlotTemplates: Array<SlotTemplate>;
  /**
   * Display the detail of the requesting team by referral code.
   * Refer: src/graphql/definitions/object/agency-team.graphql
   */
  displayTeam?: Maybe<AgencyTeam>;
  /**
   * Methods for admin to display transactions.
   * Refer: src/graphql/definitions/object/display-transaction.graphql
   */
  displayTransaction: DisplayTransaction;
  /**
   * Display the aging report of transactions, grouped by project.
   * Refer: src/graphql/definitions/object/transaction-aging-report.graphql
   */
  displayTransactionAgingReport: TransactionAgingReport;
  /**
   * List of methods for display transaction commission invoices.
   * Refer: src/graphql/definitions/object/display-transaction-commission-invoice.graphql
   */
  displayTransactionCommissionInvoice: DisplayTransactionCommissionInvoice;
  /**
   * Display transactionn commission invoice requests.
   * Refer: src/graphql/definitions/object/transaction-commission-invoice-request.graphql
   */
  displayTransactionCommissionInvoiceRequests: Array<TransactionCommissionInvoiceRequest>;
  /**
   * Display list of transaction commission invoices.
   * Refer: src/graphql/definitions/object/transaction-commission-invoice.graphql
   * @deprecated Use `displayTransactionCommissionInvoice` instead, it has pagination mechanism.
   */
  displayTransactionCommissionInvoices: Array<TransactionCommissionInvoice>;
  /**
   * Display transaction commission payment slips
   * Refer: src/graphql/definitions/object/display-transaction-commission-payment-slip-result.graphql
   */
  displayTransactionCommissionPaymentSlip: DisplayTransactionCommissionPaymentSlipResult;
  /**
   * Display the current transactions statuses of a project.
   * Refer: src/graphql/definitions/object/transaction-status-overview.graphql
   */
  displayTransactionStatus: Array<TransactionStatusOverview>;
  /**
   * For sales admins to display the transaction unit changes.
   * Refer: src/graphql/definitions/object/display-transaction-unit-change.graphql
   */
  displayTransactionUnitChange: DisplayTransactionUnitChange;
  /**
   * This method is for testing purpose only,
   * it shall only be called by the test script after all api test suites finished.
   */
  displayUninvokedPermissions: Array<Scalars['String']>;
  /**
   * This method is needed in order to insert buyer lead manually.
   * Before marketing team member insert a buyer lead manually on Dashboard, they
   * will need to pick a campaign-advertisement pair from a list of unique
   * campaign-advertisement pairs retrieved from this method.
   * This is because every buyer lead needs to have campaignId and advertisementId
   * in order for the system to perform lead distribution.
   * Refer: src/graphql/definitions/object/buyer-lead-campaign.graphql
   */
  displayUniqueCampaigns: Array<BuyerLeadCampaign>;
  /**
   * Display unscheduled cooperations of the buyer agent
   * Refer: src/graphql/definitions/object/agent-cooperation.graphql
   */
  displayUnscheduledCoops: Array<AgentCooperation>;
  /**
   * List of methods for displaying uploaded files
   * Refer: src/graphql/definitions/object/display-uploaded-file.graphql
   */
  displayUploadedFile: DisplayUploadedFile;
  /**
   * Display list of uploaded files.
   * Refer: src/graphql/definitions/object/uploaded-file.graphql
   */
  displayUploadedFiles: Array<UploadedFile>;
  /**
   * This is for admins to display users.
   * Refer: src/graphql/definitions/object/display-user.graphql
   */
  displayUser: DisplayUser;
  /**
   * For user to display summary about their ACN.
   * Note that only active ACN will be included.
   * *Active* means *requires attention*.
   * Refer: src/graphql/definitions/object/user-acn-summary.graphql
   */
  displayUserAcnSummary: UserAcnSummary;
  /**
   * For user to display their agent cooperations.
   * Refer: src/graphql/definitions/object/user-acn-result.graphql
   */
  displayUserAcns: UserAcnResult;
  /**
   * For user to display their buyer leads.
   * Refer: src/graphql/definitions/object/user-buyer-leads-result.graphql
   */
  displayUserBuyerLeads: UserBuyerLeadsResult;
  /**
   * For user to display summary about their buyer leads.
   * Note that only active buyer leads will be included.
   * *Active* means *requires attention*.
   * Refer: src/graphql/definitions/object/user-buyer-leads-summary.graphql
   */
  displayUserBuyerLeadsSummary: UserBuyerLeadsSummary;
  /**
   * For user to display the notifications of a channel.
   * Refer: src/graphql/definitions/object/notification.graphql
   */
  displayUserChannelNotifications: Array<Notification>;
  /**
   * For user to display their financial reports
   * Refer: src/graphql/definitions/object/user-financial-reports-result.graphql
   */
  displayUserFinancialReports: UserFinancialReportsResult;
  /**
   * For user to display summary about their active financial reports.
   * *Active* means *report is not expired i.e. creation date not exceeds 30 days*.
   * Refer: src/graphql/definitions/object/user-financial-reports-summary.graphql
   */
  displayUserFinancialReportsSummary: UserFinancialReportsSummary;
  /**
   * For agents to display their non-channel notifications.
   * Refer: src/graphql/definitions/object/notification.graphql
   */
  displayUserGeneralNotifications: Array<Notification>;
  /**
   * For user to display summary about their upcoming schedules.
   * *Upcoming* means *future, not cancelled*.
   * Refer: src/graphql/definitions/object/user-schedules-summary.graphql
   */
  displayUserSchedulesSummary: UserSchedulesSummary;
  /**
   * For user to display their transactions.
   * Refer: src/graphql/definitions/object/user-transactions-result.graphql
   */
  displayUserTransactions: UserTransactionsResult;
  /**
   * For user to display summary about their transactions.
   * Note that cancelled transactions will not be included.
   * Refer: src/graphql/definitions/object/user-transactions-summary.graphql
   */
  displayUserTransactionsSummary: UserTransactionsSummary;
  /**
   * Display details of all users.
   * Refer: src/graphql/definitions/object/user.graphql
   */
  displayUsers: Array<User>;
  /**
   * List of methods for display whitelist item.
   * Refer: src/graphql/definitions/object/display-whitelist-item.graphql
   */
  displayWhitelistItem: DisplayWhitelistItem;
  /**
   * Display the weekly whitelist stats for all ARMs and sources
   * Refer: src/graphql/definitions/object/whitelist-stats.graphql
   */
  displayWhitelistStats: WhitelistStats;
  /** For user to request whopay consent agreement. */
  displayWhoPayAgreement: Scalars['String'];
  /**
   * User with this permission will be identified as Adhoc Project Support. Adhoc
   * Project means project that is listed with a partner agency.
   */
  isAdhocProjectSupport: Scalars['Boolean'];
  /** User with this permission will be treated as Agent Acquisition Executive. */
  isAgentAcquisitionExecutive: Scalars['Boolean'];
  /**
   * Users who are assigned this permission will be able to answer queries from
   * agents that chat in via Didian Support channel on Didian App.
   */
  isGeneralSupportPersonnel: Scalars['Boolean'];
  /**
   * User with this permission will be identified as the Head of ARM.
   * @deprecated HARM is now determined by ProjectHarm settings.
   */
  isHeadOfArm: Scalars['Boolean'];
  /** User with this permission will be identified as the Head of SBU. */
  isHeadOfSbu: Scalars['Boolean'];
  /** User with this permission will be identified as the Head of SM Team. */
  isHeadOfSmTeam: Scalars['Boolean'];
  /** Users with this permission, will show up as sales management when creating a note in the transaction */
  isNoteAuthorSalesManagement: Scalars['Boolean'];
  /**
   * List of methods for Didian Launch Portal.
   * Refer https://launch.mydidian.com/
   * Refer: src/graphql/definitions/object/launch-portal.graphql
   */
  launchPortal: LaunchPortal;
  /**
   * List of queries available for Didian Payment Portal.
   * Refer: src/graphql/definitions/object/payment-portal.graphql
   */
  paymentPortal: PaymentPortal;
  /**
   * List of methods for user to display prospective users.
   * Refer: src/graphql/definitions/object/prospective-user-query.graphql
   */
  prospectiveUser: ProspectiveUserQuery;
  /**
   * Search agencies by name or registration number.
   * Refer: src/graphql/definitions/object/filtered-agencies.graphql
   */
  searchAgencies: FilteredAgencies;
  /**
   * Search agency team by team leader name.
   * Refer: src/graphql/definitions/object/filtered-agency-teams.graphql
   */
  searchAgencyTeams: FilteredAgencyTeams;
  /**
   * Search agent leads by name, REN tag, mobile number or email.
   * Refer: src/graphql/definitions/object/filtered-agent-leads.graphql
   */
  searchAgentLeads: FilteredAgentLeads;
  /**
   * Search verified agents by name or mobile number.
   * Refer: src/graphql/definitions/object/filtered-agents.graphql
   */
  searchAgents: FilteredAgents;
  /**
   * Method for internal users to get autocomplete places or projects suggestion
   * Refer: src/graphql/definitions/object/search-map-places-projects.graphql
   */
  searchMapPlacesProjects: SearchMapPlacesProjects;
  /**
   * Search parent projects by name.
   * Refer: src/graphql/definitions/object/filtered-projects.graphql
   */
  searchParentProjects: FilteredProjects;
  /**
   * For admins to search for prelaunch transactions of a parent project
   * that has not been converted yet.
   * Refer: src/graphql/definitions/object/filtered-transactions.graphql
   */
  searchProjectPrelaunchTransactions: FilteredTransactions;
  /**
   * To check if a firebase user created a user object in our database.
   * Refer: src/graphql/definitions/object/sign-in-user-response.graphql
   */
  signIn?: Maybe<SignInUserResponse>;
};


export type QueryDeriveDeveloperTransactionCommissionArgs = {
  developerCommissionBatchId: Scalars['String'];
  transactionId: Scalars['String'];
};


export type QueryDeveloperDisplayCustomerSchedulesArgs = {
  endDateTime: Scalars['String'];
  projectId: Scalars['String'];
  startDateTime: Scalars['String'];
};


export type QueryDeveloperDisplayTransactionsArgs = {
  projectId?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayAgenciesArgs = {
  agencyType?: InputMaybe<AgencyType>;
  dontRemoveAgencyWithDuplicatedName?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayAgencyPerformanceArgs = {
  projectId: Scalars['String'];
};


export type QueryDisplayAgentArgs = {
  agentId: Scalars['String'];
};


export type QueryDisplayAgentLeadsArgs = {
  id?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  latestFollowerId?: InputMaybe<Scalars['String']>;
  relativeDate?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayAgentScheduleArgs = {
  date?: InputMaybe<Scalars['String']>;
  projectWhitelist?: InputMaybe<DisplayScheduleProjectWhitelist>;
  scheduleId?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayAgentSchedulesArgs = {
  agentId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<InputOptions>;
};


export type QueryDisplayAgentSignupStatsArgs = {
  relativeDate: Scalars['String'];
};


export type QueryDisplayAgingTransactionsTableArgs = {
  transactionIds: Array<Scalars['String']>;
};


export type QueryDisplayAllAppointmentLettersArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayAllBuyerLeadsArgs = {
  pagingOptions: PagingOptions;
  searchString: Scalars['String'];
};


export type QueryDisplayAllEstoreUrlArgs = {
  secret: Scalars['String'];
};


export type QueryDisplayAllEstoreUrlSuffixArgs = {
  secret: Scalars['String'];
};


export type QueryDisplayAnyTransactionArgs = {
  transactionId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayAnyTransactionsArgs = {
  option?: InputMaybe<DisplayTransactionsOption>;
  projectId?: InputMaybe<Scalars['String']>;
  transactionIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryDisplayArmAgentLeadsArgs = {
  armId: Scalars['ID'];
  status: DerivedAgentLeadStatus;
};


export type QueryDisplayArmSchedulesArgs = {
  armId?: InputMaybe<Scalars['String']>;
  endDateTime: Scalars['String'];
  startDateTime: Scalars['String'];
};


export type QueryDisplayArmsArgs = {
  armId?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayAssignedBuyerLeadsArgs = {
  agentId?: InputMaybe<Scalars['String']>;
  leadId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayAvailableTimeslotsArgs = {
  agentId?: InputMaybe<Scalars['String']>;
  agentLeadId?: InputMaybe<Scalars['String']>;
  minimumCount: Scalars['Int'];
  projectId: Scalars['String'];
  startDate: Scalars['String'];
};


export type QueryDisplayAvailableUnitArgs = {
  search: Scalars['String'];
  transactionId: Scalars['ID'];
};


export type QueryDisplayAvailableUnitsArgs = {
  transactionId: Scalars['String'];
};


export type QueryDisplayBankersArgs = {
  bankerId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayBookingFormArgs = {
  agentId?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<DisplayBookingFormMode>;
  projectId: Scalars['String'];
  referenceDate?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayBovaeaDetailArgs = {
  link?: InputMaybe<Scalars['String']>;
  mobileNum?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayBuyerDemographicsArgs = {
  date?: InputMaybe<Scalars['Date']>;
  projectId: Scalars['String'];
  unitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryDisplayBuyerLeadDistributionsArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayBuyerLeadStatsArgs = {
  endDateTime?: InputMaybe<Scalars['String']>;
  startDateTime?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayCategorizedProjectsArgs = {
  projectIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryDisplayCooperationsArgs = {
  agentId?: InputMaybe<Scalars['String']>;
  cooperationId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  valid?: InputMaybe<Scalars['Boolean']>;
};


export type QueryDisplayCustomPdfArgs = {
  maximumLayers?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['String'];
};


export type QueryDisplayCustomerScheduleTimeslotsArgs = {
  endDate: Scalars['String'];
  parentProjectId: Scalars['String'];
  startDate: Scalars['String'];
};


export type QueryDisplayCustomerSchedulesArgs = {
  endDateTime: Scalars['String'];
  projectId: Scalars['String'];
  startDateTime: Scalars['String'];
};


export type QueryDisplayDevelopmentValuesArgs = {
  projectId: Scalars['String'];
  relativeDate: Scalars['String'];
};


export type QueryDisplayDocumentTemplateVariablesArgs = {
  type: DocumentTemplateType;
};


export type QueryDisplayDocumentTemplatesArgs = {
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DocumentTemplateType>;
};


export type QueryDisplayEstoreArgs = {
  date?: InputMaybe<Scalars['String']>;
  displayPersonalSalesOnly?: InputMaybe<Scalars['Boolean']>;
  estoreUrlSuffix: Scalars['String'];
};


export type QueryDisplayEstoreAgentArgs = {
  date?: InputMaybe<Scalars['String']>;
  personalOnly?: InputMaybe<Scalars['Boolean']>;
  suffix?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayEstoreProjectArgs = {
  project?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayFieldMappingFieldsArgs = {
  date?: InputMaybe<Scalars['Date']>;
  projectId: Scalars['String'];
};


export type QueryDisplayFinancialReportsArgs = {
  date?: InputMaybe<Scalars['String']>;
  parentProjectId?: InputMaybe<Scalars['String']>;
  reportId?: InputMaybe<Scalars['String']>;
  waitBackgroundTasks?: InputMaybe<Scalars['Boolean']>;
};


export type QueryDisplayFinancialReportsTableArgs = {
  parentProjectId: Scalars['String'];
};


export type QueryDisplayFooArgs = {
  id: Scalars['Int'];
};


export type QueryDisplayGptNotificationSuggestionsArgs = {
  messageId: Scalars['String'];
};


export type QueryDisplayGeneralNotificationsArgs = {
  pagingOptions: PagingOptions;
};


export type QueryDisplayHeadsOfArmArgs = {
  date?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayInventoryStatsArgs = {
  projectId: Scalars['String'];
};


export type QueryDisplayLatestNotificationsArgs = {
  referenceDate?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayLawyersArgs = {
  projectId: Scalars['String'];
};


export type QueryDisplayNotesArgs = {
  sequenceId: Scalars['String'];
};


export type QueryDisplayNotificationArgs = {
  id: Scalars['String'];
};


export type QueryDisplayNotificationChannelArgs = {
  id: Scalars['String'];
};


export type QueryDisplayPanelLawyersArgs = {
  ids?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryDisplayPaymentPortalDataArgs = {
  token: Scalars['String'];
};


export type QueryDisplayPivotTableArgs = {
  projectId: Scalars['String'];
};


export type QueryDisplayPopupAdArgs = {
  input: InputDisplayPopupAd;
};


export type QueryDisplayProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryDisplayProjectFullInfoArgs = {
  projectId: Scalars['String'];
};


export type QueryDisplayProjectInquiryArgs = {
  date?: InputMaybe<Scalars['Date']>;
};


export type QueryDisplayProjectUnitArgs = {
  unitId: Scalars['String'];
};


export type QueryDisplayProjectUnitLockArgs = {
  unitId: Scalars['String'];
};


export type QueryDisplayProjectUnitLocksArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryDisplayProjectsSalesArgs = {
  includeSpaInProgressCases?: InputMaybe<Scalars['Boolean']>;
  periods: Array<InputDisplayProjectSalesPeriod>;
  status: DisplayProjectSalesStatus;
};


export type QueryDisplayRelatedProjectUnitsArgs = {
  unitId: Scalars['String'];
};


export type QueryDisplayRemarkArgs = {
  transactionId: Scalars['String'];
};


export type QueryDisplayRequestForInvoiceArgs = {
  adjustments: Array<TransactionCommissionInvoiceRequestAdjustment>;
  commissionType: Scalars['String'];
  relativeDate?: InputMaybe<Scalars['Date']>;
  transactionId: Scalars['String'];
};


export type QueryDisplayRewardGroupsArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayRewardMissionsArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryDisplaySalesMetricArgs = {
  projectId: Scalars['String'];
  referenceDate: Scalars['String'];
};


export type QueryDisplaySalesTableOtherTeamArgs = {
  parentProjectId: Scalars['String'];
};


export type QueryDisplaySalesTableSalesTeamArgs = {
  parentProjectId: Scalars['String'];
};


export type QueryDisplayScheduleArgs = {
  scheduleId: Scalars['String'];
};


export type QueryDisplayScheduleInvitationCodeArgs = {
  scheduleId: Scalars['String'];
};


export type QueryDisplaySequenceArgs = {
  sequenceId?: InputMaybe<Scalars['String']>;
  unitId?: InputMaybe<Scalars['String']>;
};


export type QueryDisplaySequencesArgs = {
  agentId?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryDisplayTeamArgs = {
  referralCode: Scalars['String'];
};


export type QueryDisplayTransactionAgingReportArgs = {
  date?: InputMaybe<Scalars['String']>;
  excludeSpaSignedCases?: InputMaybe<Scalars['Boolean']>;
};


export type QueryDisplayTransactionCommissionInvoiceRequestsArgs = {
  id?: InputMaybe<Scalars['String']>;
  option: DisplayTransactionCommissionInvoiceRequestOption;
};


export type QueryDisplayTransactionCommissionInvoicesArgs = {
  id?: InputMaybe<Scalars['String']>;
  paid?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<TransactionCommissionInvoiceType>;
};


export type QueryDisplayTransactionCommissionPaymentSlipArgs = {
  endDateTime?: InputMaybe<Scalars['String']>;
  pagingOptions: PagingOptions;
  startDateTime?: InputMaybe<Scalars['String']>;
  voided?: InputMaybe<Scalars['Boolean']>;
};


export type QueryDisplayTransactionStatusArgs = {
  projectId: Scalars['String'];
};


export type QueryDisplayUnscheduledCoopsArgs = {
  projectId?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayUploadedFilesArgs = {
  fileIds?: InputMaybe<Array<Scalars['String']>>;
  option?: InputMaybe<DisplayUploadedFileOption>;
};


export type QueryDisplayUserAcnsArgs = {
  parentProjectId?: InputMaybe<Scalars['ID']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryDisplayUserBuyerLeadsArgs = {
  parentProjectId?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryDisplayUserChannelNotificationsArgs = {
  notificationChannelId: Scalars['String'];
  pagingOptions: PagingOptions;
};


export type QueryDisplayUserFinancialReportsArgs = {
  parentProjectId?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayUserFinancialReportsSummaryArgs = {
  date?: InputMaybe<Scalars['String']>;
};


export type QueryDisplayUserGeneralNotificationsArgs = {
  pagingOptions: PagingOptions;
};


export type QueryDisplayUserTransactionsArgs = {
  parentProjectId?: InputMaybe<Scalars['String']>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryDisplayUsersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  types?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryDisplayWhitelistStatsArgs = {
  relativeDate: Scalars['String'];
};


export type QueryLaunchPortalArgs = {
  token: Scalars['String'];
};


export type QueryPaymentPortalArgs = {
  token: Scalars['String'];
};


export type QuerySearchAgenciesArgs = {
  search: Scalars['String'];
};


export type QuerySearchAgencyTeamsArgs = {
  agencyId?: InputMaybe<Scalars['ID']>;
  search: Scalars['String'];
};


export type QuerySearchAgentLeadsArgs = {
  searchString: Scalars['String'];
};


export type QuerySearchAgentsArgs = {
  search: Scalars['String'];
};


export type QuerySearchParentProjectsArgs = {
  search: Scalars['String'];
};


export type QuerySearchProjectPrelaunchTransactionsArgs = {
  parentProjectId: Scalars['ID'];
  search: Scalars['String'];
};

export enum Race {
  Chinese = 'CHINESE',
  Indian = 'INDIAN',
  Malay = 'MALAY',
  Other = 'OTHER'
}

export type RecordedBuyerLeadStatus = {
  __typename?: 'RecordedBuyerLeadStatus';
  /** Refer: src/graphql/definitions/object/user.graphql */
  recordedBy: User;
  recordedOn: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/buyer-lead-status.graphql */
  status: BuyerLeadStatus;
};

export type ReengagementNotification = {
  __typename?: 'ReengagementNotification';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/reengagement-notification-schedule.graphql */
  schedules: Array<ReengagementNotificationSchedule>;
  /** Refer: src/graphql/definitions/union/reengagement-notification-variant.graphql */
  variant: ReengagementNotificationVariant;
};

export type ReengagementNotificationSchedule = {
  __typename?: 'ReengagementNotificationSchedule';
  id: Scalars['ID'];
  scheduledSendTime: Scalars['Date'];
  /** Refer: src/graphql/definitions/union/reengagement-notification-schedule-status.graphql */
  status: ReengagementNotificationScheduleStatus;
};

/**
 * Refer: src/graphql/definitions/object/reengagement-notification-schedule-status-pending-delivery.graphql
 * Refer: src/graphql/definitions/object/reengagement-notification-schedule-status-sent.graphql
 * Refer: src/graphql/definitions/object/reengagement-notification-schedule-status-obsolete.graphql
 */
export type ReengagementNotificationScheduleStatus = ReengagementNotificationScheduleStatusObsolete | ReengagementNotificationScheduleStatusPendingDelivery | ReengagementNotificationScheduleStatusSent;

export type ReengagementNotificationScheduleStatusObsolete = {
  __typename?: 'ReengagementNotificationScheduleStatusObsolete';
  createdOn: Scalars['Date'];
};

export type ReengagementNotificationScheduleStatusPendingDelivery = {
  __typename?: 'ReengagementNotificationScheduleStatusPendingDelivery';
  scheduledSendTime: Scalars['Date'];
};

export type ReengagementNotificationScheduleStatusSent = {
  __typename?: 'ReengagementNotificationScheduleStatusSent';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/notification.graphql */
  notification: Notification;
};

/**
 * Refer: src/graphql/definitions/object/reengagement-notification-variant-booking-timeout-reminder.graphql
 * Refer: src/graphql/definitions/object/reengagement-notification-variant-booking-abandonment.graphql
 * Refer: src/graphql/definitions/object/reengagement-notification-variant-panel-banker-assignment-reminder.graphql
 */
export type ReengagementNotificationVariant = ReengagementNotificationVariantBookingAbandonment | ReengagementNotificationVariantBookingTimeoutReminder | ReengagementNotificationVariantPanelBankerAssignmentReminder;

export type ReengagementNotificationVariantBookingAbandonment = {
  __typename?: 'ReengagementNotificationVariantBookingAbandonment';
  /** Refer: src/graphql/definitions/object/booking-verification.graphql */
  bookingVerification?: Maybe<BookingVerification>;
  /** Refer: src/graphql/definitions/object/project-unit-lock.graphql */
  unitLock: ProjectUnitLock;
};

export type ReengagementNotificationVariantBookingTimeoutReminder = {
  __typename?: 'ReengagementNotificationVariantBookingTimeoutReminder';
  /** Refer: src/graphql/definitions/object/booking-verification.graphql */
  bookingVerification?: Maybe<BookingVerification>;
  /** Refer: src/graphql/definitions/object/project-unit-lock.graphql */
  unitLock: ProjectUnitLock;
};

export type ReengagementNotificationVariantPanelBankerAssignmentReminder = {
  __typename?: 'ReengagementNotificationVariantPanelBankerAssignmentReminder';
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  transaction: Transaction;
};

export type Referral = {
  __typename?: 'Referral';
  createdOn: Scalars['String'];
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  referee?: Maybe<User>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  referrer?: Maybe<User>;
};

export enum RegenerateBookingFormType {
  Postlaunch = 'postlaunch',
  Prelaunch = 'prelaunch'
}

export type RegisterMobileUserRequest = {
  agencyId?: InputMaybe<Scalars['String']>;
  bovaeaLink?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  renTag?: InputMaybe<Scalars['String']>;
};

export type RegisterSocialMediaUserRequest = {
  agencyId?: InputMaybe<Scalars['String']>;
  bovaeaLink?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  renTag?: InputMaybe<Scalars['String']>;
};

export type RegisterUserDeviceRequest = {
  applePushToken?: InputMaybe<Scalars['String']>;
  deviceId: Scalars['String'];
  registrationToken: Scalars['String'];
};

export type RegistrationForm = {
  __typename?: 'RegistrationForm';
  /** Refer: src/graphql/definitions/object/registration-form-developer.graphql */
  developer?: Maybe<RegistrationFormDeveloper>;
  /**
   * Refer: src/graphql/definitions/object/registration-form-section.graphql
   * @deprecated Use sections instead.
   */
  form: Array<RegistrationFormSection>;
  possibleKeys: Array<Scalars['String']>;
  prefillValueKeys: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/registration-form-project.graphql */
  project: RegistrationFormProject;
  /** Refer: src/graphql/definitions/object/registration-form-section.graphql */
  sections: Array<RegistrationFormSection>;
  title: Scalars['String'];
};

export type RegistrationFormAdd = {
  __typename?: 'RegistrationFormAdd';
  label: Scalars['String'];
  limit: Scalars['Int'];
};

export type RegistrationFormDeveloper = {
  __typename?: 'RegistrationFormDeveloper';
  address?: Maybe<Scalars['String']>;
  hotline?: Maybe<Scalars['String']>;
  logo: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  officeNum?: Maybe<Scalars['String']>;
};

export type RegistrationFormField = {
  __typename?: 'RegistrationFormField';
  aspectRatio?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  inline?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  mask?: Maybe<Array<Scalars['String']>>;
  minimize?: Maybe<Scalars['Boolean']>;
  multiline?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  optional?: Maybe<Scalars['Boolean']>;
  options?: Maybe<Array<Scalars['String']>>;
  prefilledValues: Array<Scalars['String']>;
  regexp?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  watermark?: Maybe<Scalars['String']>;
};

export type RegistrationFormProject = {
  __typename?: 'RegistrationFormProject';
  hasAssociatedPrinter?: Maybe<Scalars['Boolean']>;
  launchedOn?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  surveyPreLaunch?: Maybe<Scalars['Boolean']>;
};

export type RegistrationFormSection = {
  __typename?: 'RegistrationFormSection';
  /** Refer: src/graphql/definitions/object/registration-form-add.graphql */
  addNew?: Maybe<RegistrationFormAdd>;
  /** Refer: src/graphql/definitions/object/registration-form-field.graphql */
  fields: Array<RegistrationFormField>;
  id: Scalars['String'];
  officeUse?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/object/registration-form-text.graphql */
  postText?: Maybe<RegistrationFormText>;
  print?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type RegistrationFormText = {
  __typename?: 'RegistrationFormText';
  contents: Array<Scalars['String']>;
  italic?: Maybe<Scalars['Boolean']>;
};

export type RelatedProjectUnits = {
  __typename?: 'RelatedProjectUnits';
  /** Refer: src/graphql/definitions/object/project.graphql */
  project: Project;
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  unit: ProjectUnit;
};

export type RemoveUserDeviceRequest = {
  deviceId: Scalars['String'];
};

export type RemovedBuyer = {
  id: Scalars['String'];
};

export type RequestBookingVerificationBuyer = {
  /** Refer: src/graphql/definitions/input/input-buyer-income-type.graphql */
  _incomeType?: InputMaybe<InputBuyerIncomeType>;
  fullName: Scalars['String'];
  grossIncome: Scalars['Float'];
  incomeType?: InputMaybe<Scalars['String']>;
  mobileNum: Scalars['String'];
  nric: Scalars['String'];
  /** Refer: src/graphql/definitions/input/upload.graphql */
  nricCopies: Array<Upload>;
  /** Refer: src/graphql/definitions/input/upload.graphql */
  nricCopiesBack?: InputMaybe<Array<Upload>>;
  /** Refer: src/graphql/definitions/input/upload.graphql */
  nricCopiesFront?: InputMaybe<Array<Upload>>;
};

export type RequestTransactionWhoPayPrelaunch = {
  spaPrice: Scalars['Float'];
};

export type RequestWhoPayApplicant = {
  /** Refer: src/graphql/definitions/input/upload.graphql */
  icCopiesBack: Array<Upload>;
  /** Refer: src/graphql/definitions/input/upload.graphql */
  icCopiesFront: Array<Upload>;
  icNumber: Scalars['String'];
  income: Scalars['Float'];
  mobileNumber: Scalars['String'];
  name: Scalars['String'];
};

export type RequiredAppointmentLetter = {
  __typename?: 'RequiredAppointmentLetter';
  /** Refer: src/graphql/definitions/object/agency.graphql */
  agency?: Maybe<Agency>;
  /** Refer: src/graphql/definitions/object/project.graphql */
  parentProject?: Maybe<Project>;
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  relatedTransactions: Array<Transaction>;
};

export type Reward = {
  __typename?: 'Reward';
  createdOn: Scalars['String'];
  expiryDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  price: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  redeemedBy?: Maybe<User>;
  redeemedOn?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/reward-group.graphql */
  rewardGroup?: Maybe<RewardGroup>;
  secret?: Maybe<Scalars['String']>;
  secretType?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  uploadedBy?: Maybe<User>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  voidedBy?: Maybe<User>;
  voidedOn?: Maybe<Scalars['String']>;
};

export type RewardGroup = {
  __typename?: 'RewardGroup';
  /** Refer: src/graphql/definitions/object/color.graphql */
  color: Color;
  createdOn: Scalars['String'];
  description: Scalars['String'];
  highlighted?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  picture?: Maybe<AttachedFile>;
  redeemableDenominations: Array<Scalars['Float']>;
  redeemableTypes: Array<Scalars['String']>;
  redeemedAmount: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/reward.graphql */
  rewards: Array<Reward>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  uploadedBy?: Maybe<User>;
};

export type Role = {
  __typename?: 'Role';
  /** Refer: src/graphql/definitions/object/role-modification-history.graphql */
  histories: Array<RoleModificationHistory>;
  id: Scalars['String'];
  name: Scalars['String'];
  permissions: Array<Scalars['String']>;
};

export type RoleModificationHistory = {
  __typename?: 'RoleModificationHistory';
  date: Scalars['String'];
  name: Scalars['String'];
  permissions: Array<Maybe<Scalars['String']>>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  triggeredBy: User;
};

/**
 * Refer: src/graphql/definitions/object/sale-type-prelaunch.graphql
 * Refer: src/graphql/definitions/object/sale-type-postlaunch.graphql
 */
export type SaleType = SaleTypePostlaunch | SaleTypePrelaunch;

export type SaleTypePostlaunch = {
  __typename?: 'SaleTypePostlaunch';
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  unit: ProjectUnit;
};

export type SaleTypePrelaunch = {
  __typename?: 'SaleTypePrelaunch';
  dummy?: Maybe<Scalars['String']>;
};

export type SalesMetric = {
  __typename?: 'SalesMetric';
  /** In milliseconds. */
  averageTimeToCompletion: Scalars['Float'];
  salesThisWeek: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/time-series-datum.graphql */
  timeSeriesData: Array<TimeSeriesDatum>;
};

export type SbuProject = {
  __typename?: 'SbuProject';
  /** Refer: src/graphql/definitions/object/sbu-project-budget.graphql */
  budgets: Array<SbuProjectBudget>;
  /** Refer: src/graphql/definitions/object/child-project.graphql */
  childProjects: Array<ChildProject>;
  developerCommissionRate: Scalars['Float'];
  estimatedAverageNettSellingPrice: Scalars['Float'];
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/sbu-project-marketing-expense.graphql */
  marketingExpenses: Array<SbuProjectMarketingExpense>;
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  sbuHead: User;
};

export type SbuProjectBudget = {
  __typename?: 'SbuProjectBudget';
  budgetedBookings: Scalars['Int'];
  budgetedSignings: Scalars['Int'];
  endDateTime: Scalars['Date'];
  id: Scalars['ID'];
  startDateTime: Scalars['Date'];
};

export type SbuProjectMarketingExpense = {
  __typename?: 'SbuProjectMarketingExpense';
  amount: Scalars['Float'];
  dateTime: Scalars['Date'];
  description: Scalars['String'];
  id: Scalars['ID'];
};

export type Schedule = {
  __typename?: 'Schedule';
  /** Refer: src/graphql/definitions/object/agent-cooperation.graphql */
  agentCooperation?: Maybe<AgentCooperation>;
  /** Refer: src/graphql/definitions/object/agent-lead.graphql */
  agentLeads: Array<AgentLead>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  agents: Array<User>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  arm?: Maybe<User>;
  /** Refer: src/graphql/definitions/object/buyer-lead.graphql */
  buyerLead?: Maybe<BuyerLead>;
  /** Refer: src/graphql/definitions/object/cancelled.graphql */
  cancelled?: Maybe<Cancelled>;
  confirmed?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/enum/created-by.graphql */
  createdBy: CreatedBy;
  createdOn: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  creator?: Maybe<User>;
  customerCarPlate?: Maybe<Scalars['String']>;
  customerMobileNum?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  endDateTime: Scalars['String'];
  /** Refer: src/graphql/definitions/object/schedule-event.graphql */
  events: Array<ScheduleEvent>;
  id: Scalars['ID'];
  numberOfAttendees?: Maybe<Scalars['Float']>;
  /** Refer: src/graphql/definitions/object/project.graphql */
  project?: Maybe<Project>;
  read?: Maybe<Scalars['Boolean']>;
  remarks: Scalars['String'];
  startDateTime: Scalars['String'];
  /** @deprecated use typeEnum instead. */
  type: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/schedule-type.graphql */
  typeEnum: ScheduleType;
  /** Refer: src/graphql/definitions/object/whitelist-item.graphql */
  whitelistItems: Array<WhitelistItem>;
};

export type ScheduleConfig = {
  __typename?: 'ScheduleConfig';
  /** Refer: src/graphql/definitions/object/slot-template.graphql */
  slotTemplates: Array<SlotTemplate>;
};

export type ScheduleEvent = {
  __typename?: 'ScheduleEvent';
  /** Refer: src/graphql/definitions/object/user.graphql */
  author?: Maybe<User>;
  createdOn: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
};

export enum ScheduleType {
  CustomerAppointment = 'CUSTOMER_APPOINTMENT',
  CustomerAppointmentBlockingSlot = 'CUSTOMER_APPOINTMENT_BLOCKING_SLOT',
  ProjectWhitelistAppointment = 'PROJECT_WHITELIST_APPOINTMENT'
}

export type ScraperStats = {
  __typename?: 'ScraperStats';
  /** Refer: src/graphql/definitions/union/scraper-stats-current-status.graphql */
  currentStatus: ScraperStatsCurrentStatus;
};

/**
 * Refer: src/graphql/definitions/object/scraper-stats-current-status-not-initialized.graphql
 * Refer: src/graphql/definitions/object/scraper-stats-current-status-initialized.graphql
 * Refer: src/graphql/definitions/object/scraper-stats-current-status-success.graphql
 * Refer: src/graphql/definitions/object/scraper-stats-current-status-error.graphql
 */
export type ScraperStatsCurrentStatus = ScraperStatsCurrentStatusError | ScraperStatsCurrentStatusInitialized | ScraperStatsCurrentStatusNotInitialized | ScraperStatsCurrentStatusSuccess;

export type ScraperStatsCurrentStatusError = {
  __typename?: 'ScraperStatsCurrentStatusError';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
};

export type ScraperStatsCurrentStatusInitialized = {
  __typename?: 'ScraperStatsCurrentStatusInitialized';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
};

export type ScraperStatsCurrentStatusNotInitialized = {
  __typename?: 'ScraperStatsCurrentStatusNotInitialized';
  dummy?: Maybe<Scalars['String']>;
};

export type ScraperStatsCurrentStatusSuccess = {
  __typename?: 'ScraperStatsCurrentStatusSuccess';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
};

export enum SearchByDeveloperCommissionBatchIdType {
  ExcludeSignedTransactionsOfThisBatch = 'EXCLUDE_SIGNED_TRANSACTIONS_OF_THIS_BATCH',
  IncludeOnlySignedTransactionsOfThisBatch = 'INCLUDE_ONLY_SIGNED_TRANSACTIONS_OF_THIS_BATCH'
}

export type SearchMapPlacesProjects = {
  __typename?: 'SearchMapPlacesProjects';
  /** Refer: src/graphql/definitions/union/places-project-autocomplete.graphql */
  autocomplete: Array<PlacesProjectAutocomplete>;
};


export type SearchMapPlacesProjectsAutocompleteArgs = {
  query: Scalars['String'];
};

export type SearchOption = {
  chosenColumns: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/input/column-filter.graphql */
  columnFilters: Array<ColumnFilter>;
  /** Refer: src/graphql/definitions/input/column-search.graphql */
  columnSearch: ColumnSearch;
  /** Refer: src/graphql/definitions/input/column-sort.graphql */
  columnSort?: InputMaybe<ColumnSort>;
  /** Refer: src/graphql/definitions/input/paging-options.graphql */
  pagingOptions: PagingOptions;
};

export type ServiceFee = {
  __typename?: 'ServiceFee';
  /** Refer: src/graphql/definitions/object/service-fee-amount.graphql */
  currentAmount: ServiceFeeAmount;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/service-fee-amount.graphql */
  netAmount: ServiceFeeAmount;
  /** Refer: src/graphql/definitions/object/service-fee-previous-amount.graphql */
  previousAmount: ServiceFeePreviousAmount;
  /** Refer: src/graphql/definitions/union/service-fee-setting.graphql */
  setting?: Maybe<ServiceFeeSetting>;
};

export type ServiceFeeAmount = {
  __typename?: 'ServiceFeeAmount';
  afterSalesManagement: Scalars['Float'];
  agenciesManagement: Scalars['Float'];
  marketingServices: Scalars['Float'];
  platformServices: Scalars['Float'];
  total: Scalars['Float'];
};

export type ServiceFeeBill = {
  __typename?: 'ServiceFeeBill';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
  invoiceNumber: Scalars['String'];
  /** Refer: src/graphql/definitions/object/service-fee-bill-item.graphql */
  items: Array<ServiceFeeBillItem>;
  /** Refer: src/graphql/definitions/object/parent-project.graphql */
  parentProject: ParentProject;
};

export type ServiceFeeBillItem = {
  __typename?: 'ServiceFeeBillItem';
  /** Refer: src/graphql/definitions/object/service-fee-bill.graphql */
  bill: ServiceFeeBill;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/service-fee.graphql */
  serviceFee: ServiceFee;
  /** Refer: src/graphql/definitions/object/postlaunch-transaction.graphql */
  transaction: PostlaunchTransaction;
};

export type ServiceFeeBillItemGroupedByBill = {
  __typename?: 'ServiceFeeBillItemGroupedByBill';
  /** Refer: src/graphql/definitions/object/service-fee-bill.graphql */
  bill: ServiceFeeBill;
  /** Refer: src/graphql/definitions/object/service-fee-bill-item.graphql */
  items: Array<ServiceFeeBillItem>;
};

export type ServiceFeeBillableParentProject = {
  __typename?: 'ServiceFeeBillableParentProject';
  billableTransactionsCount: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/parent-project.graphql */
  parentProject: ParentProject;
};

export type ServiceFeeBillableTransaction = {
  __typename?: 'ServiceFeeBillableTransaction';
  /** Refer: src/graphql/definitions/object/service-fee.graphql */
  serviceFee: ServiceFee;
  /** Refer: src/graphql/definitions/object/postlaunch-transaction.graphql */
  transaction: PostlaunchTransaction;
};

export type ServiceFeeFormula = {
  __typename?: 'ServiceFeeFormula';
  afterSalesManagement: Scalars['String'];
  agenciesManagement: Scalars['String'];
  id: Scalars['ID'];
  marketingServices: Scalars['String'];
  platformServices: Scalars['String'];
};

export type ServiceFeePreviousAmount = {
  __typename?: 'ServiceFeePreviousAmount';
  /** Refer: src/graphql/definitions/object/service-fee-amount.graphql */
  amount: ServiceFeeAmount;
  /**
   * The service bill items that made up the previous amount.
   * Refer: src/graphql/definitions/object/service-fee-bill-item.graphql
   */
  items: Array<ServiceFeeBillItem>;
};

/**
 * Refer: src/graphql/definitions/object/transaction-service-fee-setting.graphql
 * Refer: src/graphql/definitions/object/parent-project-service-fee-setting.graphql
 */
export type ServiceFeeSetting = ParentProjectServiceFeeSetting | TransactionServiceFeeSetting;

export type SetConfig = {
  __typename?: 'SetConfig';
  reengagementNotification: Scalars['Boolean'];
  unitLock: Scalars['Boolean'];
};


export type SetConfigReengagementNotificationArgs = {
  bookingAbandonmentRemindsAfterMs?: InputMaybe<Array<Scalars['Int']>>;
  bookingTimeoutReminderRemainingTimesInMs?: InputMaybe<Array<Scalars['Int']>>;
};


export type SetConfigUnitLockArgs = {
  unitLockDurationInMs: Scalars['Int'];
};

export type ShowroomOperationDetails = {
  __typename?: 'ShowroomOperationDetails';
  /** Refer: src/graphql/definitions/object/showroom-operation-details-active-periods.graphql */
  activePeriods: ShowroomOperationDetailsActivePeriods;
  /**
   * This property return active periods in an array format instead of object
   * Refer: src/graphql/definitions/object/showroom-operation-details-active-period-weekday.graphql
   */
  activePeriodsArray: Array<ShowroomOperationDetailsActivePeriodWeekday>;
  advanceBookingDays?: Maybe<Scalars['Int']>;
  /** Refer: src/graphql/definitions/object/showroom-operation-details-agency-limit.graphql */
  agencyLimits: Array<ShowroomOperationDetailsAgencyLimit>;
  /** Refer: src/graphql/definitions/object/attendees-limit.graphql */
  attendeesLimit?: Maybe<AttendeesLimit>;
  canStillBookWhenLimitReached: Scalars['Boolean'];
  customerLimitPerTimeSlot: Scalars['Int'];
  requiresCustomerCarPlate: Scalars['Boolean'];
  slotDuration: Scalars['Int'];
};

export type ShowroomOperationDetailsActivePeriod = {
  __typename?: 'ShowroomOperationDetailsActivePeriod';
  /** Refer: src/graphql/definitions/object/showroom-operation-details-active-period-range.graphql */
  periods: Array<ShowroomOperationDetailsActivePeriodRange>;
};

export type ShowroomOperationDetailsActivePeriodHourMinute = {
  __typename?: 'ShowroomOperationDetailsActivePeriodHourMinute';
  hour: Scalars['Int'];
  minute: Scalars['Int'];
};

export type ShowroomOperationDetailsActivePeriodRange = {
  __typename?: 'ShowroomOperationDetailsActivePeriodRange';
  /** Refer: src/graphql/definitions/object/showroom-operation-details-active-period-hour-minute.graphql */
  closingTime: ShowroomOperationDetailsActivePeriodHourMinute;
  /** Refer: src/graphql/definitions/object/showroom-operation-details-active-period-hour-minute.graphql */
  openingTime: ShowroomOperationDetailsActivePeriodHourMinute;
};

export type ShowroomOperationDetailsActivePeriodWeekday = {
  __typename?: 'ShowroomOperationDetailsActivePeriodWeekday';
  day: Scalars['String'];
  /** Refer: src/graphql/definitions/object/showroom-operation-details-active-period-range.graphql */
  periods: Array<ShowroomOperationDetailsActivePeriodRange>;
};

export type ShowroomOperationDetailsActivePeriods = {
  __typename?: 'ShowroomOperationDetailsActivePeriods';
  /** Refer: src/graphql/definitions/object/showroom-operation-details-active-period.graphql */
  Friday?: Maybe<ShowroomOperationDetailsActivePeriod>;
  /** Refer: src/graphql/definitions/object/showroom-operation-details-active-period.graphql */
  Monday?: Maybe<ShowroomOperationDetailsActivePeriod>;
  /** Refer: src/graphql/definitions/object/showroom-operation-details-active-period.graphql */
  Saturday?: Maybe<ShowroomOperationDetailsActivePeriod>;
  /** Refer: src/graphql/definitions/object/showroom-operation-details-active-period.graphql */
  Sunday?: Maybe<ShowroomOperationDetailsActivePeriod>;
  /** Refer: src/graphql/definitions/object/showroom-operation-details-active-period.graphql */
  Thursday?: Maybe<ShowroomOperationDetailsActivePeriod>;
  /** Refer: src/graphql/definitions/object/showroom-operation-details-active-period.graphql */
  Tuesday?: Maybe<ShowroomOperationDetailsActivePeriod>;
  /** Refer: src/graphql/definitions/object/showroom-operation-details-active-period.graphql */
  Wednesday?: Maybe<ShowroomOperationDetailsActivePeriod>;
};

export type ShowroomOperationDetailsAgencyLimit = {
  __typename?: 'ShowroomOperationDetailsAgencyLimit';
  /** Refer: src/graphql/definitions/object/agency.graphql */
  agency: Agency;
  dailyMaximumPercentage: Scalars['Float'];
};

export type SignInUserResponse = {
  __typename?: 'SignInUserResponse';
  /** Refer: src/graphql/definitions/object/sign-in-user-response-detail.graphql */
  detail?: Maybe<SignInUserResponseDetail>;
  verified: Scalars['Boolean'];
};

export type SignInUserResponseDetail = {
  __typename?: 'SignInUserResponseDetail';
  agencyId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  renTag?: Maybe<Scalars['String']>;
  skipAgent?: Maybe<Scalars['Boolean']>;
};

export type SimplifiedProjectCategory = {
  __typename?: 'SimplifiedProjectCategory';
  name: Scalars['String'];
  projects: Array<Scalars['String']>;
};

export type Slot = {
  __typename?: 'Slot';
  /** Refer: src/graphql/definitions/object/user.graphql */
  armInCharge?: Maybe<User>;
  daySlotIndex: Scalars['Int'];
};

export type SlotTemplate = {
  __typename?: 'SlotTemplate';
  endTime: Scalars['String'];
  startTime: Scalars['String'];
};

export enum Source {
  ArmsInitiated = 'arms_initiated',
  DidianMarketplace = 'didian_marketplace',
  Other = 'other',
  StarProperty = 'star_property'
}

export enum SpaPriceFrom {
  ProjectLevel = 'PROJECT_LEVEL',
  TransactionLevel = 'TRANSACTION_LEVEL'
}

export type StepDiscount = {
  __typename?: 'StepDiscount';
  amount: Scalars['Float'];
  deductionAmount: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/project-discount-dependency.graphql */
  dependsOn?: Maybe<ProjectDiscountDependency>;
  id: Scalars['String'];
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/transaction-price-type.graphql */
  remainingAmountPriceType?: Maybe<TransactionPriceType>;
  /** Refer: src/graphql/definitions/enum/project-discount-type.graphql */
  type: ProjectDiscountType;
};

export type SubmittedForArmCommissionClaiming = {
  __typename?: 'SubmittedForArmCommissionClaiming';
  /** Refer: src/graphql/definitions/object/user.graphql */
  by?: Maybe<User>;
  on: Scalars['String'];
};

/**
 * Refer: src/graphql/definitions/object/svg-rect.graphql
 * Refer: src/graphql/definitions/object/svg-circle.graphql
 * Refer: src/graphql/definitions/object/svg-ellipse.graphql
 * Refer: src/graphql/definitions/object/svg-polygon.graphql
 * Refer: src/graphql/definitions/object/svg-path.graphql
 * Refer: src/graphql/definitions/object/svg-text.graphql
 */
export type Svg = SvgCircle | SvgEllipse | SvgPath | SvgPolygon | SvgRect | SvgText;

export type SvgCircle = {
  __typename?: 'SvgCircle';
  cx: Scalars['Float'];
  cy: Scalars['Float'];
  r: Scalars['Float'];
};

export type SvgEllipse = {
  __typename?: 'SvgEllipse';
  cx: Scalars['Float'];
  cy: Scalars['Float'];
  rotation: Scalars['Float'];
  rx: Scalars['Float'];
  ry: Scalars['Float'];
};

export type SvgPath = {
  __typename?: 'SvgPath';
  path: Scalars['String'];
};

export type SvgPolygon = {
  __typename?: 'SvgPolygon';
  points: Array<Scalars['Float']>;
};

export type SvgRect = {
  __typename?: 'SvgRect';
  height: Scalars['Float'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type SvgText = {
  __typename?: 'SvgText';
  /** Refer: src/graphql/definitions/enum/svg-text-anchor.graphql */
  anchor: SvgTextAnchor;
  rotation: Scalars['Float'];
  scale: Scalars['Float'];
  text: Scalars['String'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export enum SvgTextAnchor {
  End = 'end',
  Middle = 'middle',
  Start = 'start'
}

export type Table = {
  __typename?: 'Table';
  /**
   * Display the unique values of a column
   * Refer: src/graphql/definitions/object/column-unique-value.graphql
   */
  columnUniqueValues: Array<ColumnUniqueValue>;
  /** Refer: src/graphql/definitions/object/table-column.graphql */
  possibleColumns: Array<TableColumn>;
  /** Refer: src/graphql/definitions/object/display-rows-result.graphql */
  rows: DisplayRowsResult;
};


export type TableColumnUniqueValuesArgs = {
  columnFilters: Array<ColumnFilter>;
  columnName: Scalars['String'];
};


export type TableRowsArgs = {
  searchOption: SearchOption;
};

/**
 * Refer: src/graphql/definitions/object/table-cell-text.graphql
 * Refer: src/graphql/definitions/object/table-cell-multi-text.graphql
 */
export type TableCell = TableCellMultiText | TableCellText;

export type TableCellMultiText = {
  __typename?: 'TableCellMultiText';
  texts: Array<Scalars['String']>;
};

export type TableCellText = {
  __typename?: 'TableCellText';
  text: Scalars['String'];
};

export type TableColumn = {
  __typename?: 'TableColumn';
  name: Scalars['String'];
};

export type TableRow = {
  __typename?: 'TableRow';
  /** Refer: src/graphql/definitions/union/table-cell.graphql */
  cells: Array<TableCell>;
  id: Scalars['ID'];
};

export type TestInputCreatePopupAd = {
  createdOn?: InputMaybe<Scalars['String']>;
};

export type TestInputUpdatePopupAd = {
  liveOn?: InputMaybe<Scalars['String']>;
};

export type TimeSeriesDatum = {
  __typename?: 'TimeSeriesDatum';
  label: Scalars['String'];
  /** Refer: src/graphql/definitions/object/weekly-frequency.graphql */
  weeklyFrequencies: Array<WeeklyFrequency>;
};

export enum TimeUnit {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type Token = {
  __typename?: 'Token';
  token: Scalars['String'];
};

/**
 * This type is deprecated.
 * Use either `PostlaunchTransaction` or `PrelaunchTransaction` instead.
 */
export type Transaction = {
  __typename?: 'Transaction';
  /**
   * Refer: src/graphql/definitions/object/agent.graphql
   * @deprecated Use `transactionAgents` instead.
   */
  agents: Array<Agent>;
  /** Refer: src/graphql/definitions/object/transaction-app-status.graphql */
  appStatus: TransactionAppStatus;
  /** Refer: src/graphql/definitions/enum/transaction-banker-assignment-preference.graphql */
  bankerAssignmentPreference?: Maybe<TransactionBankerAssignmentPreference>;
  bookedOn?: Maybe<Scalars['String']>;
  /**
   * Refer: src/graphql/definitions/object/attached-file.graphql
   * @deprecated Use 'generatedForms' instead
   */
  bookingForms?: Maybe<Array<AttachedFile>>;
  /** Refer: src/graphql/definitions/object/booking-verification.graphql */
  bookingVerification?: Maybe<BookingVerification>;
  /** Refer: src/graphql/definitions/object/buyer.graphql */
  buyers: Array<Buyer>;
  /** For testing purpose only */
  cachedDeveloperPayableAmount?: Maybe<Scalars['Float']>;
  /** For testing purpose only */
  cachedNettPrice?: Maybe<Scalars['Float']>;
  /** For testing purpose only */
  cachedUsPayableAmount?: Maybe<Scalars['Float']>;
  /**
   * Refer: src/graphql/definitions/object/transaction-cancellation.graphql
   * @deprecated Use `cancellationSubmission` instead.
   */
  cancellation?: Maybe<TransactionCancellation>;
  /** @deprecated Use `cancellationSubmission` instead. */
  cancellationFormSubmittedOn?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/transaction-cancellation-submission.graphql */
  cancellationSubmission?: Maybe<TransactionCancellationSubmission>;
  /**
   * This represents the cancellation submission date, not the cancellation confirmation date.
   * @deprecated Use `cancellationSubmission` instead.
   */
  cancelledOn?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/transaction-commission-details.graphql */
  commissionDetails?: Maybe<TransactionCommissionDetails>;
  /** Refer: src/graphql/definitions/object/transaction-commission-info.graphql */
  commissionInfo?: Maybe<Array<TransactionCommissionInfo>>;
  /** Refer: src/graphql/definitions/object/transaction-commission-invoice-request.graphql */
  commissionInvoiceRequests: Array<TransactionCommissionInvoiceRequest>;
  creditProfile?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/custom-field.graphql */
  customFields?: Maybe<Array<CustomField>>;
  developerCommissionBatchIds: Array<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/transaction-developer-commission-batch.graphql */
  developerCommissionBatches: Array<TransactionDeveloperCommissionBatch>;
  /**
   * Refer: src/graphql/definitions/object/discount.graphql
   * @deprecated Use discountsEnum instead
   */
  discounts: Array<Discount>;
  /** Refer: src/graphql/definitions/object/transaction-discount.graphql */
  discountsEnum: Array<TransactionDiscount>;
  /** Refer: src/graphql/definitions/object/transaction-document-info.graphql */
  documentInfo?: Maybe<Array<TransactionDocumentInfo>>;
  /**
   * Refer: src/graphql/definitions/object/transaction-event.graphql
   * @deprecated Events is removed from transaction
   */
  events: Array<TransactionEvent>;
  /**
   * Refer: src/graphql/definitions/union/financial-report.graphql
   * @deprecated Use `whoPayReport` or `buyers.ctosReport` instead.
   */
  financialReport?: Maybe<FinancialReport>;
  /**
   * +----------------------+-----------------------------------------------------------------+
   * | isFirstTimeHomeBuyer |                             Reason                              |
   * +----------------------+-----------------------------------------------------------------+
   * | true                 | 'First time home buyer' field is checked on booking form        |
   * | false                | 'First time home buyer' field is not checked on booking form    |
   * | undefined            | Project booking form doesn't have 'First time home buyer' field |
   * +----------------------+-----------------------------------------------------------------+
   */
  firstTimeHomeBuyer?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/object/transaction-form-info.graphql */
  formInfo?: Maybe<Array<TransactionFormInfo>>;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  generatedForms?: Maybe<Array<AttachedFile>>;
  id: Scalars['ID'];
  /**
   * Invoice request delay reason will be defined when SM team member requests the
   * FIRST portion commission invoice more than two days after SPA/LA Update date
   * Refer: src/graphql/definitions/object/invoice-request-delay-reason.graphql
   */
  invoiceRequestDelayReason?: Maybe<InvoiceRequestDelayReason>;
  /** @deprecated This will always be false since we have migrated 'transaction created due to unit change' to `transaction_unit_change`. */
  isCreatedDueToChangeOfUnit: Scalars['Boolean'];
  /** @deprecated Use 'firstTimeHomeBuyer' instead */
  isFirstTimeHomeBuyer: Scalars['Boolean'];
  isValidNewSale: Scalars['Boolean'];
  /** Only applicable for pre-launch transaction. */
  launchingSequence?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/lawyer.graphql */
  lawyer?: Maybe<Lawyer>;
  /** Refer: src/graphql/definitions/object/transaction-loan-info.graphql */
  loanInfo?: Maybe<Array<TransactionLoanInfo>>;
  /** Refer: src/graphql/definitions/object/mindcraft-loan-prediction.graphql */
  mindcraftLoanPredictions: Array<MindcraftLoanPrediction>;
  /** @deprecated Use 'nettPrice' from 'nettPriceResult' instead */
  nettPrice?: Maybe<Scalars['Float']>;
  /** Refer: src/graphql/definitions/object/nett-price-result.graphql */
  nettPriceResult?: Maybe<NettPriceResult>;
  notClaimableForArmCommission: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/note.graphql */
  notes: Array<Note>;
  /** For testing purpose */
  oid: Scalars['ID'];
  /**
   * Refer: src/graphql/definitions/object/old-unit.graphql
   * @deprecated Events is removed from transaction
   */
  oldUnits: Array<OldUnit>;
  /** Refer: src/graphql/definitions/object/project.graphql */
  parentProject: Project;
  /**
   * Refer: src/graphql/definitions/object/transaction-payment-info.graphql
   * @deprecated Use `Transaction.verification.payments` instead.
   */
  paymentInfo: Array<TransactionPaymentInfo>;
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  postLaunchTransaction?: Maybe<Transaction>;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft.graphql */
  postlaunchBookingDraft?: Maybe<PostlaunchBookingDraft>;
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  preLaunchTransaction?: Maybe<Transaction>;
  /** Refer: src/graphql/definitions/object/project.graphql */
  project?: Maybe<Project>;
  /** Refer: src/graphql/definitions/union/sale-type.graphql */
  saleType: SaleType;
  /**
   * The following precedence level is used to derive the spaPrice:
   * Transaction level SPA price > Project Level SPA price > unit gross price
   */
  spaPrice?: Maybe<Scalars['Float']>;
  /**
   * - This indicates where the spa price is derived from according to the precendence level (See `spaPrice`)
   * - Why spaPriceFrom is needed ? On the dashboard, this is needed to determine
   * if the spa price is set on transaction level so that
   * the project level spa price will not clash with the transaction level spa price
   * Refer: src/graphql/definitions/enum/spa-price-from.graphql
   */
  spaPriceFrom?: Maybe<SpaPriceFrom>;
  /**
   * Refer: src/graphql/definitions/object/submitted-for-arm-commission-claiming.graphql
   * @deprecated Use 'notClaimableForArmCommission' instead
   */
  submittedForArmCommissionClaiming?: Maybe<SubmittedForArmCommissionClaiming>;
  /** Refer: src/graphql/definitions/object/transaction-agent_.graphql */
  transactionAgents: Array<TransactionAgent_>;
  transactionSequenceId: Scalars['ID'];
  /** @deprecated Unreliable. Please derive the status according to your scenario using other properties of transaction. */
  type: Scalars['String'];
  /**
   * Only applicable for post-launch transaction.
   * Refer: src/graphql/definitions/object/project-unit.graphql
   */
  unit?: Maybe<ProjectUnit>;
  unitGrossPrice?: Maybe<Scalars['Float']>;
  updatedOn: Scalars['String'];
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  uploadedDocuments?: Maybe<Array<AttachedFile>>;
  /** Refer: src/graphql/definitions/object/transaction-verification.graphql */
  verification?: Maybe<TransactionVerification>;
  /** Refer: src/graphql/definitions/object/who-pay-financial-report.graphql */
  whoPayReport?: Maybe<WhoPayFinancialReport>;
};


/**
 * This type is deprecated.
 * Use either `PostlaunchTransaction` or `PrelaunchTransaction` instead.
 */
export type TransactionEventsArgs = {
  excludeUndoneEvents?: InputMaybe<Scalars['Boolean']>;
};


/**
 * This type is deprecated.
 * Use either `PostlaunchTransaction` or `PrelaunchTransaction` instead.
 */
export type TransactionGeneratedFormsArgs = {
  excludedFileTags?: InputMaybe<Array<UploadedFileTag>>;
};

export type TransactionAgent = {
  agencyId: Scalars['String'];
  agentId: Scalars['String'];
  teamId?: InputMaybe<Scalars['ID']>;
};

export type TransactionAgent_ = {
  __typename?: 'TransactionAgent_';
  /** Refer: src/graphql/definitions/object/agency.graphql */
  agency: Agency;
  /** Refer: src/graphql/definitions/object/user.graphql */
  agent: User;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/agency-team.graphql */
  team?: Maybe<AgencyTeam>;
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  transaction: Transaction;
};

export enum TransactionAgingDayType {
  FromBooking = 'FROM_BOOKING',
  FromLastUpdated = 'FROM_LAST_UPDATED'
}

export type TransactionAgingReport = {
  __typename?: 'TransactionAgingReport';
  /** Refer: src/graphql/definitions/object/transaction-aging-report-project.graphql */
  parentProjects: Array<TransactionAgingReportProject>;
};

export type TransactionAgingReportProject = {
  __typename?: 'TransactionAgingReportProject';
  /** Refer: src/graphql/definitions/object/transaction-aging-report-project-aging-group.graphql */
  ageGroups: Array<TransactionAgingReportProjectAgingGroup>;
  /** Refer: src/graphql/definitions/object/project.graphql */
  parentProject: Project;
};

export type TransactionAgingReportProjectAgingGroup = {
  __typename?: 'TransactionAgingReportProjectAgingGroup';
  /** Null means infinity */
  rangeEnd?: Maybe<Scalars['Int']>;
  rangeStart: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  transactions: Array<Transaction>;
  transactionsCount: Scalars['Int'];
};

export type TransactionAppStatus = {
  __typename?: 'TransactionAppStatus';
  /** Refer: src/graphql/definitions/union/transaction-app-status-agent-mobile-app.graphql */
  agentMobileApp: TransactionAppStatusAgentMobileApp;
};

/**
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-new-sales.graphql
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-new-booking.graphql
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-new-sales-express.graphql
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-new-sales-pending-banker.graphql
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-loan-application-pending-documents.graphql
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-loan-application-processing-documents.graphql
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-loan-application-pending-approval.graphql
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-loan-application-loan-approved.graphql
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-loan-application-loan-rejected.graphql
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-document-signing-pending-scheduling.graphql
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-document-signing-pending-signing.graphql
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-document-signing-signed.graphql
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-commission-payment-pending.graphql
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-commission-payment-pending-invoice.graphql
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-commission-payment-pending-payment.graphql
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-commission-payment-express-paid.graphql
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-commission-payment-completed.graphql
 * Refer: src/graphql/definitions/object/transaction-app-status-agent-mobile-app-cancelled.graphql
 */
export type TransactionAppStatusAgentMobileApp = TransactionAppStatusAgentMobileAppCancelled | TransactionAppStatusAgentMobileAppCommissionPaymentCompleted | TransactionAppStatusAgentMobileAppCommissionPaymentExpressPaid | TransactionAppStatusAgentMobileAppCommissionPaymentPending | TransactionAppStatusAgentMobileAppCommissionPaymentPendingInvoice | TransactionAppStatusAgentMobileAppCommissionPaymentPendingPayment | TransactionAppStatusAgentMobileAppDocumentSigningPendingScheduling | TransactionAppStatusAgentMobileAppDocumentSigningPendingSigning | TransactionAppStatusAgentMobileAppDocumentSigningSigned | TransactionAppStatusAgentMobileAppLoanApplicationLoanApproved | TransactionAppStatusAgentMobileAppLoanApplicationLoanRejected | TransactionAppStatusAgentMobileAppLoanApplicationPendingApproval | TransactionAppStatusAgentMobileAppLoanApplicationPendingDocuments | TransactionAppStatusAgentMobileAppLoanApplicationProcessingDocuments | TransactionAppStatusAgentMobileAppNewBooking | TransactionAppStatusAgentMobileAppNewSales | TransactionAppStatusAgentMobileAppNewSalesExpress | TransactionAppStatusAgentMobileAppNewSalesPendingBanker;

export type TransactionAppStatusAgentMobileAppCancelled = {
  __typename?: 'TransactionAppStatusAgentMobileAppCancelled';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionAppStatusAgentMobileAppCommissionPaymentCompleted = {
  __typename?: 'TransactionAppStatusAgentMobileAppCommissionPaymentCompleted';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionAppStatusAgentMobileAppCommissionPaymentExpressPaid = {
  __typename?: 'TransactionAppStatusAgentMobileAppCommissionPaymentExpressPaid';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionAppStatusAgentMobileAppCommissionPaymentPending = {
  __typename?: 'TransactionAppStatusAgentMobileAppCommissionPaymentPending';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionAppStatusAgentMobileAppCommissionPaymentPendingInvoice = {
  __typename?: 'TransactionAppStatusAgentMobileAppCommissionPaymentPendingInvoice';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionAppStatusAgentMobileAppCommissionPaymentPendingPayment = {
  __typename?: 'TransactionAppStatusAgentMobileAppCommissionPaymentPendingPayment';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionAppStatusAgentMobileAppDocumentSigningPendingScheduling = {
  __typename?: 'TransactionAppStatusAgentMobileAppDocumentSigningPendingScheduling';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionAppStatusAgentMobileAppDocumentSigningPendingSigning = {
  __typename?: 'TransactionAppStatusAgentMobileAppDocumentSigningPendingSigning';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionAppStatusAgentMobileAppDocumentSigningSigned = {
  __typename?: 'TransactionAppStatusAgentMobileAppDocumentSigningSigned';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionAppStatusAgentMobileAppLoanApplicationLoanApproved = {
  __typename?: 'TransactionAppStatusAgentMobileAppLoanApplicationLoanApproved';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionAppStatusAgentMobileAppLoanApplicationLoanRejected = {
  __typename?: 'TransactionAppStatusAgentMobileAppLoanApplicationLoanRejected';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionAppStatusAgentMobileAppLoanApplicationPendingApproval = {
  __typename?: 'TransactionAppStatusAgentMobileAppLoanApplicationPendingApproval';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionAppStatusAgentMobileAppLoanApplicationPendingDocuments = {
  __typename?: 'TransactionAppStatusAgentMobileAppLoanApplicationPendingDocuments';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionAppStatusAgentMobileAppLoanApplicationProcessingDocuments = {
  __typename?: 'TransactionAppStatusAgentMobileAppLoanApplicationProcessingDocuments';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionAppStatusAgentMobileAppNewBooking = {
  __typename?: 'TransactionAppStatusAgentMobileAppNewBooking';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionAppStatusAgentMobileAppNewSales = {
  __typename?: 'TransactionAppStatusAgentMobileAppNewSales';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionAppStatusAgentMobileAppNewSalesExpress = {
  __typename?: 'TransactionAppStatusAgentMobileAppNewSalesExpress';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionAppStatusAgentMobileAppNewSalesPendingBanker = {
  __typename?: 'TransactionAppStatusAgentMobileAppNewSalesPendingBanker';
  dummy?: Maybe<Scalars['String']>;
};

export enum TransactionBankerAssignmentPreference {
  Agent = 'AGENT',
  DidianSalesManagement = 'DIDIAN_SALES_MANAGEMENT'
}

export type TransactionBuyerAddress = {
  __typename?: 'TransactionBuyerAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  postCode: Scalars['String'];
  state: Scalars['String'];
  streetName: Scalars['String'];
};

export type TransactionBuyerFile = {
  __typename?: 'TransactionBuyerFile';
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  file: UploadedFile;
  id: Scalars['ID'];
};

/**
 * Refer: src/graphql/definitions/object/transaction-buyer-income-type-fixed-income.graphql
 * Refer: src/graphql/definitions/object/transaction-buyer-income-type-commission-earner.graphql
 * Refer: src/graphql/definitions/object/transaction-buyer-income-type-self-employed.graphql
 */
export type TransactionBuyerIncomeType = TransactionBuyerIncomeTypeCommissionEarner | TransactionBuyerIncomeTypeFixedIncome | TransactionBuyerIncomeTypeSelfEmployed;

export type TransactionBuyerIncomeTypeCommissionEarner = {
  __typename?: 'TransactionBuyerIncomeTypeCommissionEarner';
  bookingFormKey: Scalars['String'];
};

export type TransactionBuyerIncomeTypeFixedIncome = {
  __typename?: 'TransactionBuyerIncomeTypeFixedIncome';
  bookingFormKey: Scalars['String'];
};

export type TransactionBuyerIncomeTypeSelfEmployed = {
  __typename?: 'TransactionBuyerIncomeTypeSelfEmployed';
  bookingFormKey: Scalars['String'];
};

export type TransactionCancellation = {
  __typename?: 'TransactionCancellation';
  reason?: Maybe<Scalars['String']>;
  submittedOn: Scalars['Date'];
};

export type TransactionCancellationConfirmation = {
  __typename?: 'TransactionCancellationConfirmation';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
};

export type TransactionCancellationFormSubmission = {
  __typename?: 'TransactionCancellationFormSubmission';
  /** Refer: src/graphql/definitions/object/transaction-cancellation-confirmation.graphql */
  confirmation?: Maybe<TransactionCancellationConfirmation>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
};

export enum TransactionCancellationStatus {
  NotApplicable = 'NOT_APPLICABLE',
  '0PendingCancellation' = '_0_PENDING_CANCELLATION',
  '1CancellationConfirmed' = '_1_CANCELLATION_CONFIRMED'
}

export type TransactionCancellationSubmission = {
  __typename?: 'TransactionCancellationSubmission';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/transaction-cancellation-form-submission.graphql */
  formSubmission?: Maybe<TransactionCancellationFormSubmission>;
  id: Scalars['ID'];
  /**
   * This is only defined if this transaction is created due to change of unit.
   * Refer: src/graphql/definitions/object/transaction.graphql
   * @deprecated This will always be null since we have migrated 'transaction created due to unit change' to `transaction_unit_change`.
   */
  previousTransaction?: Maybe<Transaction>;
  reason: Scalars['String'];
};

export type TransactionCommissionDetails = {
  __typename?: 'TransactionCommissionDetails';
  /** How much have we paid to ARMs for this transaction */
  amountPaidToArms: Scalars['Float'];
  /** How much have we paid to head of ARMs for this transaction */
  amountPaidToHarm: Scalars['Float'];
  /** How much have the developer paid to us */
  developerPaidAmount: Scalars['Float'];
  /** How much are the developer suppose to pay us */
  developerPayableAmount: Scalars['Float'];
  latestDeveloperPaidDate?: Maybe<Scalars['Date']>;
  /** How much have we paid to our agents */
  usPaidAmount: Scalars['Float'];
  /** How much are we suppose to pay to our agents */
  usPayableAmount: Scalars['Float'];
};

/** This is also known as Transaction Commission Portion. */
export type TransactionCommissionInfo = {
  __typename?: 'TransactionCommissionInfo';
  batchNo?: Maybe<Scalars['String']>;
  disbursedOn?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/transaction-commission-invoice-request.graphql */
  invoiceRequestPreviews: Array<TransactionCommissionInvoiceRequest>;
  invoicedOn?: Maybe<Scalars['String']>;
  /** @deprecated Use `kind` instead */
  isRetrospective: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/enum/transaction-commission-portion-kind.graphql */
  kind?: Maybe<TransactionCommissionPortionKind>;
  /** Refer: src/graphql/definitions/object/transaction-commission-info-mark-as-paid-by-developer.graphql */
  markAsPaidByDeveloper?: Maybe<TransactionCommissionInfoMarkAsPaidByDeveloper>;
  percentage: Scalars['Float'];
  preparedOn?: Maybe<Scalars['String']>;
  /**
   * All the non-voided invoice requsts that is sent for this commission portion.
   * Refer: src/graphql/definitions/object/transaction-commission-invoice-request.graphql
   */
  sentInvoiceRequests: Array<TransactionCommissionInvoiceRequest>;
  status?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/postlaunch-transaction.graphql */
  transaction: PostlaunchTransaction;
  type: Scalars['String'];
};

export type TransactionCommissionInfoMarkAsPaidByDeveloper = {
  __typename?: 'TransactionCommissionInfoMarkAsPaidByDeveloper';
  /** Refer: src/graphql/definitions/object/user.graphql */
  by?: Maybe<User>;
  on?: Maybe<Scalars['String']>;
};

export type TransactionCommissionInvoice = {
  __typename?: 'TransactionCommissionInvoice';
  /** Refer: src/graphql/definitions/object/commission-payment-delay-reason.graphql */
  commissionPaymentDelayReason?: Maybe<CommissionPaymentDelayReason>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy?: Maybe<User>;
  createdOn: Scalars['String'];
  /**
   * Only PIC of this invoice or user with special permission can query this property.
   * Refer: src/graphql/definitions/object/attached-file.graphql
   */
  file?: Maybe<AttachedFile>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  invalidatedBy?: Maybe<User>;
  invalidatedOn?: Maybe<Scalars['String']>;
  invalidatedReason?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/transaction-commission-invoice-request.graphql */
  invoiceRequests: Array<TransactionCommissionInvoiceRequest>;
  /** Refer: src/graphql/definitions/object/transaction-commission-payment-slip.graphql */
  paymentSlip?: Maybe<TransactionCommissionPaymentSlip>;
  /** Refer: src/graphql/definitions/enum/transaction-commission-invoice-type.graphql */
  type: TransactionCommissionInvoiceType;
  /** Refer: src/graphql/definitions/object/user.graphql */
  verifiedBy?: Maybe<User>;
  verifiedOn?: Maybe<Scalars['String']>;
};

export type TransactionCommissionInvoiceProjectAgencyPair = {
  __typename?: 'TransactionCommissionInvoiceProjectAgencyPair';
  /** Refer: src/graphql/definitions/object/agency.graphql */
  agency?: Maybe<Agency>;
  /** Refer: src/graphql/definitions/object/appointment-letter.graphql */
  appointmentLetters: Array<AppointmentLetter>;
  /** Refer: src/graphql/definitions/object/project.graphql */
  parentProject?: Maybe<Project>;
};

export type TransactionCommissionInvoiceRequest = {
  __typename?: 'TransactionCommissionInvoiceRequest';
  /**
   * The current non-invalidated and non-cancelled invoice that contains this invoice request.
   * Refer: src/graphql/definitions/object/transaction-commission-invoice.graphql
   */
  activeInvoice?: Maybe<TransactionCommissionInvoice>;
  /** Refer: src/graphql/definitions/object/transaction-commission-invoice-request-adjustment-result.graphql */
  adjustments: Array<TransactionCommissionInvoiceRequestAdjustmentResult>;
  /** Refer: src/graphql/definitions/object/agency.graphql */
  agency: Agency;
  /**
   * Refer: src/graphql/definitions/object/project-discount.graphql
   * @deprecated This is no longer persisted in database.
   */
  appliedDiscounts: Array<ProjectDiscount>;
  /**
   * Refer: src/graphql/definitions/object/appointment-letter.graphql
   * @deprecated Use `projectCommissionTnc` instead.
   */
  appointmentLetter?: Maybe<AppointmentLetter>;
  commissionType: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['String'];
  /** Refer: src/graphql/definitions/object/email-content.graphql */
  emailContent?: Maybe<EmailContent>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  forAgents: Array<User>;
  humanReadableId: Scalars['String'];
  id: Scalars['String'];
  /**
   * All the invoices that contains this invoice request, regardless of whether it
   * is cancelled or invalidated.
   * Refer: src/graphql/definitions/object/transaction-commission-invoice.graphql
   */
  invoices: Array<TransactionCommissionInvoice>;
  nettPrice?: Maybe<Scalars['Float']>;
  /**
   * Refer: src/graphql/definitions/object/nett-price-result.graphql
   * @deprecated This is no longer persisted in database. Use `nettPrice` instead.
   */
  nettPriceResult?: Maybe<NettPriceResult>;
  payableAmount: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  personsInCharge: Array<User>;
  /** Refer: src/graphql/definitions/object/project-agency-group-commission-tnc.graphql */
  projectCommissionTnc?: Maybe<ProjectAgencyGroupCommissionTnc>;
  /**
   * This is the same as personsInCharge
   * Refer: src/graphql/definitions/object/user.graphql
   */
  receivers: Array<User>;
  /** Refer: src/graphql/definitions/object/transaction-commission-invoice-request-tiering-info.graphql */
  tieringInfo?: Maybe<TransactionCommissionInvoiceRequestTieringInfo>;
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  transaction: Transaction;
};

export type TransactionCommissionInvoiceRequestAdjustment = {
  /**
   * If `agencyId` is null, then this adjustment applies to all invoice requests
   * of the given commission portion.
   * Otherwise, this adjustment only applies to the invoice request of the given `agencyId`.
   */
  agencyId?: InputMaybe<Scalars['ID']>;
  amount: Scalars['Float'];
  description: Scalars['String'];
};

/**
 * This should be named `TransactionCommissionInvoiceRequestAdjustment`,
 * but unfortunately, I used the name for the input, which should have been named
 * as `InputTransactionCommissionInvoiceRequestAdjustment`.
 */
export type TransactionCommissionInvoiceRequestAdjustmentResult = {
  __typename?: 'TransactionCommissionInvoiceRequestAdjustmentResult';
  amount: Scalars['Float'];
  description: Scalars['String'];
};

export type TransactionCommissionInvoiceRequestTieringInfo = {
  __typename?: 'TransactionCommissionInvoiceRequestTieringInfo';
  /** Refer: src/graphql/definitions/object/transaction-commission-invoice-request-tiering-info-current-tier.graphql */
  currentTier: TransactionCommissionInvoiceRequestTieringInfoCurrentTier;
  /** Refer: src/graphql/definitions/object/transaction-commission-invoice-request-tiering-info-transaction.graphql */
  transactions: Array<TransactionCommissionInvoiceRequestTieringInfoTransaction>;
};

export type TransactionCommissionInvoiceRequestTieringInfoCurrentTier = {
  __typename?: 'TransactionCommissionInvoiceRequestTieringInfoCurrentTier';
  higherInclusive?: Maybe<Scalars['Int']>;
  lowerInclusive: Scalars['Int'];
};

export type TransactionCommissionInvoiceRequestTieringInfoTransaction = {
  __typename?: 'TransactionCommissionInvoiceRequestTieringInfoTransaction';
  salesValue: Scalars['Float'];
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  transaction: Transaction;
};

export enum TransactionCommissionInvoiceType {
  Cancelled = 'cancelled',
  Invalidated = 'invalidated',
  Paid = 'paid',
  PendingVerification = 'pending_verification',
  Verified = 'verified'
}

export type TransactionCommissionPaymentSlip = {
  __typename?: 'TransactionCommissionPaymentSlip';
  /** Refer: src/graphql/definitions/object/transaction-commission-payment-slip.graphql */
  additionalPaymentSlips: Array<TransactionCommissionPaymentSlip>;
  /** Refer: src/graphql/definitions/object/transaction-commission-invoice.graphql */
  commissionInvoices: Array<TransactionCommissionInvoice>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy?: Maybe<User>;
  createdOn: Scalars['String'];
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  file?: Maybe<AttachedFile>;
  generatedFilename: Scalars['String'];
  id: Scalars['String'];
  originalFilename: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user.graphql */
  voidedBy?: Maybe<User>;
  voidedOn?: Maybe<Scalars['String']>;
};

export enum TransactionCommissionPortionKind {
  Balance = 'BALANCE',
  Retrospective = 'RETROSPECTIVE'
}

export type TransactionDeveloperCommissionBatch = {
  __typename?: 'TransactionDeveloperCommissionBatch';
  cachedPaidAmount?: Maybe<Scalars['Float']>;
  cachedPaidOn?: Maybe<Scalars['Date']>;
};

export type TransactionDeveloperCommissionStage = {
  __typename?: 'TransactionDeveloperCommissionStage';
  /**
   * If `batch` is null, it means that this `Transaction` is not related to this `stage`.
   * Refer: src/graphql/definitions/object/developer-commission-batch-transaction.graphql
   */
  batch?: Maybe<DeveloperCommissionBatchTransaction>;
  /** Refer: src/graphql/definitions/object/developer-commission-stage.graphql */
  stage: DeveloperCommissionStage;
};

export type TransactionDiscount = {
  __typename?: 'TransactionDiscount';
  /**
   * Refer: src/graphql/definitions/union/project-discount-enum.graphql
   * @deprecated Use `discountValue` instead
   */
  discount: ProjectDiscountEnum;
  /** Refer: src/graphql/definitions/object/project-discount.graphql */
  discountValue: ProjectDiscount;
  selected: Scalars['Boolean'];
};

export type TransactionDocumentInfo = {
  __typename?: 'TransactionDocumentInfo';
  /**
   * Document update delay reasons will be defined when SM team member updates the
   * SPA/LA document more than 3 days after actual SPA/LA Signing date
   * Refer: src/graphql/definitions/object/document-update-delay-reason.graphql
   */
  documentUpdateDelayReason?: Maybe<DocumentUpdateDelayReason>;
  /** Refer: src/graphql/definitions/object/transaction-document-info-lawyer.graphql */
  lawyer?: Maybe<TransactionDocumentInfoLawyer>;
  /**
   * The date where the signing date of this document is determined.
   * @deprecated use `signingDate.createdOn` instead.
   */
  markScheduledDate?: Maybe<Scalars['String']>;
  /**
   * The date where this document is confirmed as signed.
   * @deprecated use `signingDate.confirmation.createdOn` instead.
   */
  markSignedDate?: Maybe<Scalars['String']>;
  /**
   * The signing date for this document.
   * @deprecated use `signingDate.signingDate` instead.
   */
  scheduledOn?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/transaction-document-info-signing-date.graphql */
  signingDate?: Maybe<TransactionDocumentInfoSigningDate>;
  stampedOn?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  type: Scalars['String'];
};

export type TransactionDocumentInfoLawyer = {
  __typename?: 'TransactionDocumentInfoLawyer';
  email?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  lawyerFirm?: Maybe<Scalars['String']>;
  mobileNum?: Maybe<Scalars['String']>;
  personInCharge?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type TransactionDocumentInfoSigningDate = {
  __typename?: 'TransactionDocumentInfoSigningDate';
  /** Refer: src/graphql/definitions/object/transaction-document-info-signing-date-confirmation.graphql */
  confirmation?: Maybe<TransactionDocumentInfoSigningDateConfirmation>;
  createdOn: Scalars['Date'];
  signingDate: Scalars['Date'];
};

export type TransactionDocumentInfoSigningDateConfirmation = {
  __typename?: 'TransactionDocumentInfoSigningDateConfirmation';
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
};

export type TransactionEvent = {
  __typename?: 'TransactionEvent';
  createdOn: Scalars['String'];
  id: Scalars['String'];
  type: Scalars['String'];
  updatedOn: Scalars['String'];
};

export enum TransactionFinancialStatus {
  NotApplicable = 'NOT_APPLICABLE',
  '0PendingVerification' = '_0_PENDING_VERIFICATION',
  '1PendingLoanDocumentSubmission' = '_1_PENDING_LOAN_DOCUMENT_SUBMISSION',
  '2PendingLoanApproval' = '_2_PENDING_LOAN_APPROVAL',
  '3LoanApproved' = '_3_LOAN_APPROVED',
  '4PendingArrangement' = '_4_PENDING_ARRANGEMENT',
  '5PendingSigning' = '_5_PENDING_SIGNING',
  '6Signed' = '_6_SIGNED',
  '7CashBuyer' = '_7_CASH_BUYER'
}

export type TransactionFormInfo = {
  __typename?: 'TransactionFormInfo';
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  files?: Maybe<Array<AttachedFile>>;
  key?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
  value?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Scalars['String']>>;
};

/**
 * Refer: src/graphql/definitions/object/transaction-loan-application-status-pending-document-submission.graphql
 * Refer: src/graphql/definitions/object/transaction-loan-application-status-pending-approval.graphql
 * Refer: src/graphql/definitions/object/transaction-loan-application-status-approved.graphql
 * Refer: src/graphql/definitions/object/transaction-loan-application-status-rejected.graphql
 * Refer: src/graphql/definitions/object/transaction-loan-application-status-selected.graphql
 */
export type TransactionLoanApplicationStatus = TransactionLoanApplicationStatusApproved | TransactionLoanApplicationStatusPendingApproval | TransactionLoanApplicationStatusPendingDocumentSubmission | TransactionLoanApplicationStatusRejected | TransactionLoanApplicationStatusSelected;

export type TransactionLoanApplicationStatusApproved = {
  __typename?: 'TransactionLoanApplicationStatusApproved';
  approvedOn: Scalars['Date'];
  documentSubmittedOn: Scalars['Date'];
  marginOfFinance: Scalars['Float'];
};

export type TransactionLoanApplicationStatusPendingApproval = {
  __typename?: 'TransactionLoanApplicationStatusPendingApproval';
  documentSubmittedOn: Scalars['Date'];
};

export type TransactionLoanApplicationStatusPendingDocumentSubmission = {
  __typename?: 'TransactionLoanApplicationStatusPendingDocumentSubmission';
  dummy?: Maybe<Scalars['String']>;
};

export type TransactionLoanApplicationStatusRejected = {
  __typename?: 'TransactionLoanApplicationStatusRejected';
  documentSubmittedOn: Scalars['Date'];
  reason: Scalars['String'];
  rejectedOn: Scalars['Date'];
};

export type TransactionLoanApplicationStatusSelected = {
  __typename?: 'TransactionLoanApplicationStatusSelected';
  approvedOn: Scalars['Date'];
  documentSubmittedOn: Scalars['Date'];
  marginOfFinance: Scalars['Float'];
  selectedOn: Scalars['Date'];
};

export type TransactionLoanInfo = {
  __typename?: 'TransactionLoanInfo';
  /** Refer: src/graphql/definitions/object/transaction-loan-rhb-application.graphql */
  activeRhbLoanApplication?: Maybe<TransactionLoanRhbApplication>;
  approvedOn?: Maybe<Scalars['String']>;
  assignedOn?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/banker.graphql */
  banker?: Maybe<Banker>;
  chosenOn?: Maybe<Scalars['String']>;
  detail?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/union/transaction-loan-info-handled-by.graphql */
  handledBy: TransactionLoanInfoHandledBy;
  id?: Maybe<Scalars['String']>;
  isPersonalBanker?: Maybe<Scalars['Boolean']>;
  loanPercentage?: Maybe<Scalars['Float']>;
  /** Refer: src/graphql/definitions/object/note.graphql */
  notes: Array<Note>;
  reason?: Maybe<Scalars['String']>;
  rejectedOn?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  submittedOn?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

/**
 * Refer: src/graphql/definitions/object/transaction-loan-info-handled-by-didian-sales-management.graphql
 * Refer: src/graphql/definitions/object/transaction-loan-info-handled-by-agent.graphql
 */
export type TransactionLoanInfoHandledBy = TransactionLoanInfoHandledByAgent | TransactionLoanInfoHandledByDidianSalesManagement;

export type TransactionLoanInfoHandledByAgent = {
  __typename?: 'TransactionLoanInfoHandledByAgent';
  /** Refer: src/graphql/definitions/object/user.graphql */
  user: User;
};

export type TransactionLoanInfoHandledByDidianSalesManagement = {
  __typename?: 'TransactionLoanInfoHandledByDidianSalesManagement';
  /** Refer: src/graphql/definitions/object/user.graphql */
  user: User;
};

export type TransactionLoanRhbApplication = {
  __typename?: 'TransactionLoanRhbApplication';
  date: Scalars['Date'];
  /** Returned by RHB API */
  receiptUrl: Scalars['String'];
};

export type TransactionOverviewStats = {
  __typename?: 'TransactionOverviewStats';
  allSalesCount: Scalars['Int'];
  loanByAgentSalesCount: Scalars['Int'];
  unverifiedSalesCount: Scalars['Int'];
};

export type TransactionPaymentInfo = {
  __typename?: 'TransactionPaymentInfo';
  amount: Scalars['Float'];
  detail?: Maybe<Scalars['String']>;
  method: Scalars['String'];
};

export type TransactionPivotTable = {
  __typename?: 'TransactionPivotTable';
  /** Refer: src/graphql/definitions/object/transaction-pivot-table-data.graphql */
  datum: Array<TransactionPivotTableData>;
  /** Refer: src/graphql/definitions/object/transaction-pivot-table-parameter.graphql */
  parameters: Array<TransactionPivotTableParameter>;
};

export type TransactionPivotTableData = {
  __typename?: 'TransactionPivotTableData';
  /** Refer: src/graphql/definitions/object/transaction-pivot-table-data-parameter.graphql */
  parameters?: Maybe<Array<TransactionPivotTableDataParameter>>;
};

export type TransactionPivotTableDataParameter = {
  __typename?: 'TransactionPivotTableDataParameter';
  property: Scalars['String'];
  value: Scalars['String'];
};

export type TransactionPivotTableParameter = {
  __typename?: 'TransactionPivotTableParameter';
  property: Scalars['String'];
  values: Array<Scalars['String']>;
};

export enum TransactionPriceType {
  SpaPrice = 'spaPrice'
}

export type TransactionServiceFeeSetting = {
  __typename?: 'TransactionServiceFeeSetting';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/service-fee-formula.graphql */
  formula: ServiceFeeFormula;
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/service-fee-billable-transaction.graphql */
  transaction: ServiceFeeBillableTransaction;
};

/**
 * Refer: src/graphql/definitions/object/transaction-source-of-finance-commercial-bank.graphql
 * Refer: src/graphql/definitions/object/transaction-source-of-finance-cash.graphql
 * Refer: src/graphql/definitions/object/transaction-source-of-finance-lppsa-staff-loan.graphql
 * Refer: src/graphql/definitions/object/transaction-source-of-finance-company-staff-loan.graphql
 */
export type TransactionSourceOfFinance = TransactionSourceOfFinanceCash | TransactionSourceOfFinanceCommercialBank | TransactionSourceOfFinanceCompanyStaffLoan | TransactionSourceOfFinanceLppsaStaffLoan;

export type TransactionSourceOfFinanceCash = {
  __typename?: 'TransactionSourceOfFinanceCash';
  bookingFormKey: Scalars['String'];
};

export type TransactionSourceOfFinanceCommercialBank = {
  __typename?: 'TransactionSourceOfFinanceCommercialBank';
  bookingFormKey: Scalars['String'];
  marginOfFinance: Scalars['Float'];
};

export type TransactionSourceOfFinanceCompanyStaffLoan = {
  __typename?: 'TransactionSourceOfFinanceCompanyStaffLoan';
  bookingFormKey: Scalars['String'];
  marginOfFinance: Scalars['Float'];
};

export type TransactionSourceOfFinanceLppsaStaffLoan = {
  __typename?: 'TransactionSourceOfFinanceLppsaStaffLoan';
  bookingFormKey: Scalars['String'];
  marginOfFinance: Scalars['Float'];
};

export enum TransactionSpaStatus {
  NotApplicable = 'NOT_APPLICABLE',
  '4PendingArrangement' = '_4_PENDING_ARRANGEMENT',
  '5PendingSigning' = '_5_PENDING_SIGNING',
  '6Signed' = '_6_SIGNED'
}

export type TransactionStatus = {
  __typename?: 'TransactionStatus';
  /** Refer: src/graphql/definitions/enum/transaction-cancellation-status.graphql */
  cancellation: TransactionCancellationStatus;
  /** Refer: src/graphql/definitions/enum/transaction-financial-status.graphql */
  financial: TransactionFinancialStatus;
  /** Refer: src/graphql/definitions/enum/transaction-spa-status.graphql */
  spa: TransactionSpaStatus;
};

export type TransactionStatusOverview = {
  __typename?: 'TransactionStatusOverview';
  childProjectName: Scalars['String'];
  developerUnit: Scalars['Int'];
  documentSignedForCashBuyer: Scalars['Int'];
  documentSignedForNonCashBuyer: Scalars['Int'];
  loanApproved: Scalars['Int'];
  loanRejected: Scalars['Int'];
  newSales: Scalars['Int'];
  pendingCancellation: Scalars['Int'];
  pendingDocumentArrangement: Scalars['Int'];
  pendingDocumentSigning: Scalars['Int'];
  pendingLoanApproval: Scalars['Int'];
  pendingLoanDocument: Scalars['Int'];
};

export type TransactionStatusSummary = {
  __typename?: 'TransactionStatusSummary';
  count: Scalars['Int'];
  status: Scalars['String'];
};

export type TransactionUnitChange = {
  __typename?: 'TransactionUnitChange';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  newUnit: ProjectUnit;
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  originalUnit: ProjectUnit;
  reason: Scalars['String'];
  /** Refer: src/graphql/definitions/object/transaction-unit-change-resolution.graphql */
  resolution?: Maybe<TransactionUnitChangeResolution>;
  /** Refer: src/graphql/definitions/object/postlaunch-transaction.graphql */
  transaction: PostlaunchTransaction;
};

export type TransactionUnitChangeResolution = {
  __typename?: 'TransactionUnitChangeResolution';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  id: Scalars['ID'];
};

export type TransactionVerification = {
  __typename?: 'TransactionVerification';
  /** Refer: src/graphql/definitions/object/user.graphql */
  createdBy: User;
  createdOn: Scalars['Date'];
  /** Refer: src/graphql/definitions/object/transaction-payment-info.graphql */
  payments: Array<TransactionPaymentInfo>;
};

export type TransactionWhoPayPreview = {
  __typename?: 'TransactionWhoPayPreview';
  /** Refer: src/graphql/definitions/object/transaction-who-pay-preview-applicant.graphql */
  applicants: Array<TransactionWhoPayPreviewApplicant>;
  loanPercentage?: Maybe<Scalars['Float']>;
  spaPrice?: Maybe<Scalars['Float']>;
};

export type TransactionWhoPayPreviewApplicant = {
  __typename?: 'TransactionWhoPayPreviewApplicant';
  fullName: Scalars['String'];
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  icCopiesBack: Array<UploadedFile>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  icCopiesFront: Array<UploadedFile>;
  icNumber?: Maybe<Scalars['String']>;
  income?: Maybe<Scalars['Float']>;
  mobileNumber?: Maybe<Scalars['String']>;
};

export type UUserFinancialReportsSummaryAgentGroup = {
  __typename?: 'UUserFinancialReportsSummaryAgentGroup';
  /** Refer: src/graphql/definitions/object/agent.graphql */
  agent: Agent;
  financialReportsCount: Scalars['Int'];
};

export type UnitMix = {
  /** Refer: src/graphql/definitions/input/input-attached-file.graphql */
  floorPlanFiles: Array<InputAttachedFile>;
  name: Scalars['String'];
  noOfBathrooms: Scalars['String'];
  noOfBedrooms: Scalars['String'];
  noOfCarParks: Scalars['String'];
  size: Scalars['String'];
  variants: Array<Scalars['String']>;
};

export type UnitStat = {
  __typename?: 'UnitStat';
  sold: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/project-unit.graphql */
  unitInfo: ProjectUnit;
};

export type UnitUpdate = {
  __typename?: 'UnitUpdate';
  address?: Maybe<Scalars['String']>;
  carParkUnitNums?: Maybe<Array<Scalars['String']>>;
  defaultLawyerId?: Maybe<Scalars['String']>;
  grossPrice?: Maybe<Scalars['Float']>;
  houseNum?: Maybe<Scalars['String']>;
  landSize?: Maybe<Scalars['String']>;
  staircase?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Update = {
  newFieldName: Scalars['String'];
  oldFieldName: Scalars['String'];
};

export enum UpdateBookingFormMode {
  Postlaunch = 'postlaunch',
  Prelaunch = 'prelaunch'
}

export type UpdateDdnCalculationVariables = {
  __typename?: 'UpdateDdnCalculationVariables';
  appreciationRates: Scalars['Boolean'];
  creditPointPercentage: Scalars['Boolean'];
  interestRate: Scalars['Boolean'];
  monthlyPaymentMultiplier: Scalars['Boolean'];
};


export type UpdateDdnCalculationVariablesAppreciationRatesArgs = {
  remark: Scalars['String'];
  values: Array<InputDdnAppreciationRate>;
};


export type UpdateDdnCalculationVariablesCreditPointPercentageArgs = {
  remark: Scalars['String'];
  value: Scalars['Float'];
};


export type UpdateDdnCalculationVariablesInterestRateArgs = {
  remark: Scalars['String'];
  value: Scalars['Float'];
};


export type UpdateDdnCalculationVariablesMonthlyPaymentMultiplierArgs = {
  remark: Scalars['String'];
  value: Scalars['Float'];
};

export type UpdateDdnPropertyStatus = {
  __typename?: 'UpdateDdnPropertyStatus';
  /** Refer: src/graphql/definitions/object/ddn-property.graphql */
  approve: DdnProperty;
  /** Refer: src/graphql/definitions/object/ddn-property.graphql */
  reject: DdnProperty;
};


export type UpdateDdnPropertyStatusApproveArgs = {
  date?: InputMaybe<Scalars['Date']>;
  waitBackgroundTasks?: InputMaybe<Scalars['Boolean']>;
};


export type UpdateDdnPropertyStatusRejectArgs = {
  date?: InputMaybe<Scalars['Date']>;
  reason: Scalars['String'];
  waitBackgroundTasks?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateDeveloperDashboardSetting = {
  __typename?: 'UpdateDeveloperDashboardSetting';
  /** Refer: src/graphql/definitions/object/developer-dashboard-setting.graphql */
  setShowTransactionAgency: DeveloperDashboardSetting;
};


export type UpdateDeveloperDashboardSettingSetShowTransactionAgencyArgs = {
  developerId: Scalars['ID'];
  showTransactionAgency: Scalars['Boolean'];
};

export enum UpdateJoinTeamRequestType {
  Approve = 'approve',
  Reject = 'reject'
}

export type UpdateLandedPriceChartLayout = {
  /** Refer: src/graphql/definitions/input/update-landed-price-chart-layout-child.graphql */
  child: UpdateLandedPriceChartLayoutChild;
  /** Refer: src/graphql/definitions/input/update-landed-price-chart-layout-parent.graphql */
  parent: UpdateLandedPriceChartLayoutParent;
  /** Refer: src/graphql/definitions/input/update-landed-price-chart-shape.graphql */
  shapes: Array<UpdateLandedPriceChartShape>;
  /** Refer: src/graphql/definitions/input/update-landed-price-chart-structure.graphql */
  structures: Array<UpdateLandedPriceChartStructure>;
  /** Refer: src/graphql/definitions/input/update-landed-price-chart-layout-zone.graphql */
  zone: UpdateLandedPriceChartLayoutZone;
};

export type UpdateLandedPriceChartLayoutChild = {
  height: Scalars['Float'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type UpdateLandedPriceChartLayoutParent = {
  height: Scalars['Float'];
  width: Scalars['Float'];
};

export type UpdateLandedPriceChartLayoutZone = {
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/input/update-landed-price-chart-shape.graphql */
  shapes: Array<UpdateLandedPriceChartShape>;
};

export type UpdateLandedPriceChartShape = {
  /** Refer: src/graphql/definitions/input/update-landed-price-chart-shape-path.graphql */
  path?: InputMaybe<UpdateLandedPriceChartShapePath>;
  /** Refer: src/graphql/definitions/input/update-landed-price-chart-shape-polygon.graphql */
  polygon?: InputMaybe<UpdateLandedPriceChartShapePolygon>;
  /** Refer: src/graphql/definitions/input/update-landed-price-chart-shape-rect.graphql */
  rect?: InputMaybe<UpdateLandedPriceChartShapeRect>;
  /** Refer: src/graphql/definitions/input/update-landed-price-chart-shape-text.graphql */
  text?: InputMaybe<UpdateLandedPriceChartShapeText>;
};

export type UpdateLandedPriceChartShapePath = {
  path: Scalars['String'];
};

export type UpdateLandedPriceChartShapePolygon = {
  points: Array<Scalars['Float']>;
};

export type UpdateLandedPriceChartShapeRect = {
  height: Scalars['Float'];
  width: Scalars['Float'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type UpdateLandedPriceChartShapeText = {
  /** Refer: src/graphql/definitions/enum/update-landed-price-chart-shape-text-anchor.graphql */
  anchor: UpdateLandedPriceChartShapeTextAnchor;
  rotation?: InputMaybe<Scalars['Float']>;
  scale?: InputMaybe<Scalars['Float']>;
  text: Scalars['String'];
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export enum UpdateLandedPriceChartShapeTextAnchor {
  End = 'END',
  Middle = 'MIDDLE',
  Start = 'START'
}

export type UpdateLandedPriceChartStructure = {
  rotation?: InputMaybe<Scalars['Float']>;
  /** Refer: src/graphql/definitions/input/update-landed-price-chart-shape.graphql */
  shapes: Array<UpdateLandedPriceChartShape>;
  unitId?: InputMaybe<Scalars['String']>;
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type UpdatePostlaunchBookingDraft = {
  __typename?: 'UpdatePostlaunchBookingDraft';
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  addAgent: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  addBuyer: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  bankerAssignmentPreference: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  customField: PostlaunchBookingDraftProgress;
  deletePaymentProof: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  epfContribution: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  financeSource: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  firstTimeHomeBuyer: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  howDoYouKnowAboutUs: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  marginOfFinance: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  paymentProof: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  removeAgent: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  removeBuyer: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  repeatBuyer: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/update-postlaunch-booking-draft-agent.graphql */
  updateAgent: UpdatePostlaunchBookingDraftAgent;
  /** Refer: src/graphql/definitions/object/update-postlaunch-booking-draft-buyer.graphql */
  updateBuyer: UpdatePostlaunchBookingDraftBuyer;
};


export type UpdatePostlaunchBookingDraftBankerAssignmentPreferenceArgs = {
  value: TransactionBankerAssignmentPreference;
};


export type UpdatePostlaunchBookingDraftCustomFieldArgs = {
  answers: Array<Scalars['String']>;
  question: Scalars['String'];
};


export type UpdatePostlaunchBookingDraftDeletePaymentProofArgs = {
  fileId: Scalars['ID'];
};


export type UpdatePostlaunchBookingDraftEpfContributionArgs = {
  value: Scalars['Boolean'];
};


export type UpdatePostlaunchBookingDraftFinanceSourceArgs = {
  value: BookingDraftFinanceSource;
};


export type UpdatePostlaunchBookingDraftFirstTimeHomeBuyerArgs = {
  value: Scalars['Boolean'];
};


export type UpdatePostlaunchBookingDraftHowDoYouKnowAboutUsArgs = {
  value: Array<Scalars['String']>;
};


export type UpdatePostlaunchBookingDraftMarginOfFinanceArgs = {
  value: Scalars['Float'];
};


export type UpdatePostlaunchBookingDraftPaymentProofArgs = {
  value: Upload;
};


export type UpdatePostlaunchBookingDraftRemoveAgentArgs = {
  agentId: Scalars['ID'];
};


export type UpdatePostlaunchBookingDraftRemoveBuyerArgs = {
  buyerId: Scalars['ID'];
};


export type UpdatePostlaunchBookingDraftRepeatBuyerArgs = {
  value: Scalars['Boolean'];
};


export type UpdatePostlaunchBookingDraftUpdateAgentArgs = {
  agentId: Scalars['ID'];
};


export type UpdatePostlaunchBookingDraftUpdateBuyerArgs = {
  buyerId: Scalars['ID'];
};

export type UpdatePostlaunchBookingDraftAgent = {
  __typename?: 'UpdatePostlaunchBookingDraftAgent';
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  agentUserId: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  hasNextAgent: PostlaunchBookingDraftProgress;
};


export type UpdatePostlaunchBookingDraftAgentAgentUserIdArgs = {
  value: Scalars['ID'];
};


export type UpdatePostlaunchBookingDraftAgentHasNextAgentArgs = {
  value: Scalars['Boolean'];
};

export type UpdatePostlaunchBookingDraftBuyer = {
  __typename?: 'UpdatePostlaunchBookingDraftBuyer';
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  addressDetails: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  addressPlaceId: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  companyAddressDetails: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  companyAddressPlaceId: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  companyName: PostlaunchBookingDraftProgress;
  deleteNricCopyBack: Scalars['Boolean'];
  deleteNricCopyFront: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  email: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  fullName: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  gender: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  grossMonthlyIncome: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  hasNextBuyer: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  incomeType: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  industry: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  isBumi: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  maritalStatus: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  mobileNum: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  nric: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  nricCopyBack: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  nricCopyFront: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  occupation: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  race: PostlaunchBookingDraftProgress;
  /** Refer: src/graphql/definitions/object/postlaunch-booking-draft-progress.graphql */
  signature: PostlaunchBookingDraftProgress;
};


export type UpdatePostlaunchBookingDraftBuyerAddressDetailsArgs = {
  value: Scalars['String'];
};


export type UpdatePostlaunchBookingDraftBuyerAddressPlaceIdArgs = {
  value: Scalars['String'];
};


export type UpdatePostlaunchBookingDraftBuyerCompanyAddressDetailsArgs = {
  value: Scalars['String'];
};


export type UpdatePostlaunchBookingDraftBuyerCompanyAddressPlaceIdArgs = {
  value: Scalars['String'];
};


export type UpdatePostlaunchBookingDraftBuyerCompanyNameArgs = {
  value: Scalars['String'];
};


export type UpdatePostlaunchBookingDraftBuyerDeleteNricCopyBackArgs = {
  fileId: Scalars['ID'];
};


export type UpdatePostlaunchBookingDraftBuyerDeleteNricCopyFrontArgs = {
  fileId: Scalars['ID'];
};


export type UpdatePostlaunchBookingDraftBuyerEmailArgs = {
  value: Scalars['String'];
};


export type UpdatePostlaunchBookingDraftBuyerFullNameArgs = {
  value: Scalars['String'];
};


export type UpdatePostlaunchBookingDraftBuyerGenderArgs = {
  value: Gender;
};


export type UpdatePostlaunchBookingDraftBuyerGrossMonthlyIncomeArgs = {
  value: Scalars['Float'];
};


export type UpdatePostlaunchBookingDraftBuyerHasNextBuyerArgs = {
  value: Scalars['Boolean'];
};


export type UpdatePostlaunchBookingDraftBuyerIncomeTypeArgs = {
  value: BookingDraftBuyerIncomeType;
};


export type UpdatePostlaunchBookingDraftBuyerIndustryArgs = {
  industryId: Scalars['ID'];
};


export type UpdatePostlaunchBookingDraftBuyerIsBumiArgs = {
  value: Scalars['Boolean'];
};


export type UpdatePostlaunchBookingDraftBuyerMaritalStatusArgs = {
  value: MaritalStatus;
};


export type UpdatePostlaunchBookingDraftBuyerMobileNumArgs = {
  value: Scalars['String'];
};


export type UpdatePostlaunchBookingDraftBuyerNricArgs = {
  value: Scalars['String'];
};


export type UpdatePostlaunchBookingDraftBuyerNricCopyBackArgs = {
  value: Upload;
};


export type UpdatePostlaunchBookingDraftBuyerNricCopyFrontArgs = {
  value: Upload;
};


export type UpdatePostlaunchBookingDraftBuyerOccupationArgs = {
  occupationId: Scalars['ID'];
};


export type UpdatePostlaunchBookingDraftBuyerRaceArgs = {
  value: Race;
};


export type UpdatePostlaunchBookingDraftBuyerSignatureArgs = {
  value: Upload;
};

export enum UpdateProjectHandlerMode {
  Assign = 'ASSIGN',
  Unassign = 'UNASSIGN'
}

export type UpdateProjectInquiryStatus = {
  __typename?: 'UpdateProjectInquiryStatus';
  /** Refer: src/graphql/definitions/object/project-inquiry.graphql */
  updateToFollowUpRequired: Array<ProjectInquiry>;
  /** Refer: src/graphql/definitions/object/project-inquiry.graphql */
  updateToNoActionRequired: Array<ProjectInquiry>;
};


export type UpdateProjectInquiryStatusUpdateToFollowUpRequiredArgs = {
  remark: Scalars['String'];
};


export type UpdateProjectInquiryStatusUpdateToNoActionRequiredArgs = {
  remark: Scalars['String'];
};

export type UpdatedDiscount = {
  amount?: InputMaybe<Scalars['Float']>;
  /**
   * If undefined means applicable indefinitely
   * Refer: src/graphql/definitions/input/applicable-period.graphql
   */
  applicablePeriods?: InputMaybe<Array<ApplicablePeriod>>;
  /** Refer: src/graphql/definitions/input/discount-dependency.graphql */
  dependsOn?: InputMaybe<DiscountDependency>;
  description: Scalars['String'];
  displayOnEstore?: InputMaybe<Scalars['Boolean']>;
  displayOnPriceChart?: InputMaybe<Scalars['Boolean']>;
  /** Unit IDs */
  exclusive?: InputMaybe<Array<Scalars['String']>>;
  expression?: InputMaybe<Scalars['String']>;
  forBumiOnly: Scalars['Boolean'];
  id?: InputMaybe<Scalars['String']>;
  isOptional: Scalars['Boolean'];
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/transaction-price-type.graphql */
  remainingAmountPriceType?: InputMaybe<TransactionPriceType>;
  /** Refer: src/graphql/definitions/enum/discount-status.graphql */
  status: DiscountStatus;
  /** Refer: src/graphql/definitions/input/discount-toggle-key-value.graphql */
  toggleKeyValues?: InputMaybe<Array<DiscountToggleKeyValue>>;
  /** Refer: src/graphql/definitions/enum/discount-type.graphql */
  type: DiscountType;
};

export type Upload = {
  fieldName: Scalars['String'];
  /** Refer: src/graphql/definitions/input/upload-header.graphql */
  headers: UploadHeader;
  originalFilename: Scalars['String'];
  path: Scalars['String'];
  size: Scalars['Int'];
};

export type UploadFdbFileReport = {
  __typename?: 'UploadFdbFileReport';
  /** Refer: src/graphql/definitions/object/upload-fdb-file-report-task.graphql */
  tasks: Array<UploadFdbFileReportTask>;
};

export type UploadFdbFileReportTask = {
  __typename?: 'UploadFdbFileReportTask';
  errors: Array<Scalars['String']>;
  title: Scalars['String'];
};

export enum UploadFileVisibility {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type UploadHeader = {
  contentDisposition?: InputMaybe<Scalars['String']>;
  contentType: Scalars['String'];
  filename?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
};

export type UploadedFile = {
  __typename?: 'UploadedFile';
  _id: Scalars['ID'];
  fileSize: Scalars['Float'];
  id: Scalars['String'];
  /**
   * Refer: src/graphql/definitions/object/file-modification-history.graphql
   * @deprecated Not tracked anymore, since the only modification is renaming, which is insignificant to the business.
   */
  modificationHistories: Array<FileModificationHistory>;
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  previewThumbnail?: Maybe<AttachedFile>;
  /** signedURL is generated by S3 and is meant to be a temporary URL for downloading this file */
  signedURL: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/uploaded-file-tag.graphql */
  tags: Array<UploadedFileTag>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  uploadedBy?: Maybe<User>;
  uploadedOn: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/upload-file-visibility.graphql */
  visibility: UploadFileVisibility;
};

export enum UploadedFileTag {
  BankStatement = 'BANK_STATEMENT',
  BookingForm = 'BOOKING_FORM',
  CtosReport = 'CTOS_REPORT',
  EpfStatement = 'EPF_STATEMENT',
  NricCopyBack = 'NRIC_COPY_BACK',
  NricCopyFront = 'NRIC_COPY_FRONT',
  OtherSupportingDocument = 'OTHER_SUPPORTING_DOCUMENT',
  Payslip = 'PAYSLIP',
  WhopayReport = 'WHOPAY_REPORT'
}

export type User = {
  __typename?: 'User';
  /**
   * Indicates if there is any active booking verification that the agent
   * needs to take note of.
   * Refer: src/graphql/definitions/object/active-booking-verification.graphql
   * @deprecated Use `bookingVerification.active` instead
   */
  activeBookingVerification?: Maybe<ActiveBookingVerification>;
  /** Refer: src/graphql/definitions/object/popup-ad.graphql */
  activePopupAds: Array<PopupAd>;
  /** Refer: src/graphql/definitions/object/user-address.graphql */
  addresses?: Maybe<Array<UserAddress>>;
  /** Refer: src/graphql/definitions/object/user-agent-info.graphql */
  agentInfo?: Maybe<UserAgentInfo>;
  /** Refer: src/graphql/definitions/object/buyer-lead.graphql */
  assignedBuyerLeads: Array<BuyerLead>;
  /** Refer: src/graphql/definitions/object/user-banker-info.graphql */
  bankerInfo?: Maybe<UserBankerInfo>;
  /** Refer: src/graphql/definitions/object/user-booking.graphql */
  booking: UserBooking;
  /** Refer: src/graphql/definitions/object/user-buyer-info.graphql */
  buyerInfo?: Maybe<UserBuyerInfo>;
  /** @deprecated This property is moved to `Buyer`. */
  citizenship: Scalars['String'];
  /**
   * Refer: src/graphql/definitions/object/user-contact.graphql
   * @deprecated use mobileNum, email, emailIsVerified instead.
   */
  contacts?: Maybe<Array<UserContact>>;
  createdOn: Scalars['String'];
  /** Refer: src/graphql/definitions/object/ddn-enable-on-app.graphql */
  ddnEnabledOnApp?: Maybe<DdnEnableOnApp>;
  /** Refer: src/graphql/definitions/object/user-developer-info.graphql */
  developerInfo?: Maybe<UserDeveloperInfo>;
  displayName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  emailIsVerified?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/object/user-employee-info.graphql */
  employeeInfo?: Maybe<UserEmployeeInfo>;
  /** @deprecated This property is moved to `Buyer`. */
  employerAddress: Scalars['String'];
  /** @deprecated This property is moved to `Buyer`. */
  employerName: Scalars['String'];
  /** Refer: src/graphql/definitions/object/estore-stats.graphql */
  estoreStats?: Maybe<EstoreStats>;
  estoreUrlSuffix?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  /** @deprecated This property is moved to `Buyer`. */
  gender?: Maybe<Scalars['String']>;
  /**
   * Return projects that are handled by this user.
   * Only applicable for ARMs.
   * Refer: src/graphql/definitions/object/handling-projects.graphql
   */
  handlingProjects: HandlingProjects;
  /** @deprecated This property is moved to `Buyer`. */
  houseNum: Scalars['String'];
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/user-lawyer-info.graphql */
  lawyerInfo?: Maybe<UserLawyerInfo>;
  /** @deprecated This property is moved to `Buyer`. */
  maritalStatus: Scalars['String'];
  mobileNum?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/money-info.graphql */
  moneyInfo?: Maybe<MoneyInfo>;
  /** @deprecated This property is moved to `Buyer`. */
  monthlyIncome: Scalars['String'];
  nric?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  nricCopiesBack: Array<UploadedFile>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  nricCopiesFront: Array<UploadedFile>;
  /** @deprecated This property is moved to `Buyer`. */
  occupation: Scalars['String'];
  /** @deprecated This property is moved to `Buyer`. */
  officeNum: Scalars['String'];
  permissions: Array<Scalars['String']>;
  /** @deprecated Use profilePicture instead. */
  photoUrl?: Maybe<Scalars['String']>;
  profilePicture?: Maybe<Scalars['String']>;
  /**
   * Return projects that the user submitted interest.
   * Only applicable for agents.
   * Refer: src/graphql/definitions/object/project-interest.graphql
   */
  projectInterests: Array<ProjectInterest>;
  /** @deprecated This property is moved to `Buyer`. */
  race: Scalars['String'];
  /** Refer: src/graphql/definitions/object/reward.graphql */
  redeemedRewards?: Maybe<Array<Reward>>;
  /**
   * Refer: src/graphql/definitions/object/reengagement-notification.graphql
   * @deprecated For testing purposes only. Do not use in production.
   */
  reengagementNotifications: Array<ReengagementNotification>;
  referralCode?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/referral.graphql */
  referrals: Array<Referral>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  referrer?: Maybe<User>;
  /**
   * Buyer leads that has the same mobileNum as this user
   * Refer: src/graphql/definitions/object/buyer-lead.graphql
   */
  relatedBuyerLeads: Array<BuyerLead>;
  /** Refer: src/graphql/definitions/object/role.graphql */
  roles: Array<Role>;
  /** @deprecated No longer in used. */
  sendBirdToken?: Maybe<Scalars['String']>;
  types: Array<Scalars['String']>;
  /**
   * Returns a list of project interests that is not being whitelisted.
   * Refer: src/graphql/definitions/object/project-interest.graphql
   */
  unwhitelistedProjectInterests: Array<ProjectInterest>;
};


export type UserActivePopupAdsArgs = {
  date?: InputMaybe<Scalars['String']>;
  excludePopupAdIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UserAchievementMedal = {
  __typename?: 'UserAchievementMedal';
  area?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** Millisecond */
  duration?: Maybe<Scalars['Float']>;
  instruction?: Maybe<Scalars['String']>;
  level: Scalars['String'];
  levelRange?: Maybe<Array<Scalars['Float']>>;
  name: Scalars['String'];
  /** @deprecated Use numberOfUnitsSold instead. */
  numberOfSales?: Maybe<Scalars['Int']>;
  numberOfUnitsSold?: Maybe<Scalars['Int']>;
  projectName?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UserAcnResult = {
  __typename?: 'UserAcnResult';
  /** Refer: src/graphql/definitions/object/user-acn-result-filtered.graphql */
  filter: UserAcnResultFiltered;
  /**
   * Search by buyer's name.
   * Refer: src/graphql/definitions/object/user-acn-result-filtered.graphql
   */
  search: UserAcnResultFiltered;
  /** Refer: src/graphql/definitions/object/user-acn-result-summary.graphql */
  summary: UserAcnResultSummary;
};


export type UserAcnResultFilterArgs = {
  filter: DisplayUserAcnFilter;
};


export type UserAcnResultSearchArgs = {
  searchString: Scalars['String'];
};

export type UserAcnResultFiltered = {
  __typename?: 'UserAcnResultFiltered';
  /** Refer: src/graphql/definitions/object/agent-cooperation.graphql */
  paginate: Array<AgentCooperation>;
  totalCount: Scalars['Int'];
};


export type UserAcnResultFilteredPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type UserAcnResultSummary = {
  __typename?: 'UserAcnResultSummary';
  followUpRequired: Scalars['Int'];
  mine: Scalars['Int'];
  new: Scalars['Int'];
  /** Not team leader, but ACN assigned to team members of the requesting user. */
  team: Scalars['Int'];
};

export type UserAcnSummary = {
  __typename?: 'UserAcnSummary';
  /**
   * Group ACN by agent.
   * Refer: src/graphql/definitions/object/user-acn-summary-agent-group.graphql
   */
  agentGroups: Array<UserAcnSummaryAgentGroup>;
  /**
   * Group ACN by project.
   * Refer: src/graphql/definitions/object/user-acn-summary-project-group.graphql
   */
  projectGroups: Array<UserAcnSummaryProjectGroup>;
};

export type UserAcnSummaryAgentGroup = {
  __typename?: 'UserAcnSummaryAgentGroup';
  activeCount: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/agent.graphql */
  agent: Agent;
};

export type UserAcnSummaryProjectGroup = {
  __typename?: 'UserAcnSummaryProjectGroup';
  activeCount: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/project.graphql */
  project: Project;
};

export type UserAddress = {
  __typename?: 'UserAddress';
  city: Scalars['String'];
  country: Scalars['String'];
  postCode: Scalars['String'];
  state: Scalars['String'];
  streetName: Scalars['String'];
  /** Refer: src/graphql/definitions/enum/user-address-type.graphql */
  type: UserAddressType;
};

export enum UserAddressType {
  Correspondence = 'correspondence',
  Nric = 'nric'
}

export type UserAgentAgency = {
  __typename?: 'UserAgentAgency';
  address?: Maybe<Scalars['String']>;
  /**
   * Refer: src/graphql/definitions/object/agency-contact.graphql
   * @deprecated use officeNum, email instead.
   */
  contacts?: Maybe<Array<AgencyContact>>;
  email?: Maybe<Scalars['String']>;
  /**
   * This is a convenient shortcut that combines `name` and `registrationNum` together,
   * so that client do not need to keep joining both of these together manually.
   */
  fullName: Scalars['String'];
  id: Scalars['ID'];
  isPreferredPartner?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  logoFile?: Maybe<AttachedFile>;
  name: Scalars['String'];
  officeNum?: Maybe<Scalars['String']>;
  registrationNum?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/agency.graphql */
  siblingAgencies?: Maybe<Array<Maybe<Agency>>>;
  /** Refer: src/graphql/definitions/object/agency-team.graphql */
  team?: Maybe<AgencyTeam>;
  /** Refer: src/graphql/definitions/object/agency-team.graphql */
  teams?: Maybe<Array<AgencyTeam>>;
  /** Refer: src/graphql/definitions/enum/agency-type.graphql */
  type: AgencyType;
};

export type UserAgentInfo = {
  __typename?: 'UserAgentInfo';
  /** Refer: src/graphql/definitions/object/user-agent-agency.graphql */
  agency?: Maybe<UserAgentAgency>;
  isVerified?: Maybe<Scalars['Boolean']>;
  /** Refer: src/graphql/definitions/object/join-team-request.graphql */
  joinTeamRequests: Array<JoinTeamRequest>;
  /** Refer: src/graphql/definitions/object/agent-lead.graphql */
  leadInfo?: Maybe<AgentLead>;
  /** Refer: src/graphql/definitions/object/user-achievement-medal.graphql */
  medals: Array<UserAchievementMedal>;
  /**
   * number of all transactions made by agent
   * @deprecated Use `numOfTransactions` instead.
   */
  numOfSales: Scalars['Int'];
  /**
   * number of transactions made by agent in current team
   * @deprecated Use `numOfTeamTransactions` instead.
   */
  numOfTeamSales: Scalars['Int'];
  /** number of transactions made by agent in current team */
  numOfTeamTransactions: Scalars['Int'];
  /** number of all transactions made by agent */
  numOfTransactions: Scalars['Int'];
  onboardProgress?: Maybe<Scalars['String']>;
  /**
   * - If the agent has a team, this field will return all the projects that are
   * related to the team i.e. any team member has sales for the project
   * - If the agent has no team, this field will return the projects that the agent
   * involved in i.e. agent has sales for the project
   * Refer: src/graphql/definitions/object/project.graphql
   */
  projectsInvolved: Array<Project>;
  renTag?: Maybe<Scalars['String']>;
  role: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user-public-transaction.graphql */
  sales: Array<UserPublicTransaction>;
  /** Refer: src/graphql/definitions/object/whitelist-item.graphql */
  whitelistItems: Array<WhitelistItem>;
};

export type UserBankerInfo = {
  __typename?: 'UserBankerInfo';
  /** Refer: src/graphql/definitions/object/project.graphql */
  assignedProjects: Array<Project>;
  /** @deprecated Use financer instead */
  bankName?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/financer.graphql */
  financer?: Maybe<Financer>;
  rhbStaffId?: Maybe<Scalars['String']>;
};

export type UserBooking = {
  __typename?: 'UserBooking';
  /**
   * Incomplete booking can be:
   * 1. An active ongoing booking with/without booking verification step.
   * 2. A booking that is expired due to unit lock timeout but already has a
   * booking verification created.
   * Refer: src/graphql/definitions/union/user-booking-incomplete.graphql
   */
  incomplete?: Maybe<UserBookingIncomplete>;
};

/**
 * Refer: src/graphql/definitions/object/user-booking-incomplete-active.graphql
 * Refer: src/graphql/definitions/object/user-booking-incomplete-expired.graphql
 */
export type UserBookingIncomplete = UserBookingIncompleteActive | UserBookingIncompleteExpired;

export type UserBookingIncompleteActive = {
  __typename?: 'UserBookingIncompleteActive';
  /** Refer: src/graphql/definitions/object/booking-verification.graphql */
  bookingVerification?: Maybe<BookingVerification>;
  /** Refer: src/graphql/definitions/object/project-unit-lock.graphql */
  unitLock: ProjectUnitLock;
};

export type UserBookingIncompleteExpired = {
  __typename?: 'UserBookingIncompleteExpired';
  /** Refer: src/graphql/definitions/object/booking-verification.graphql */
  bookingVerification: BookingVerification;
};

export type UserBuyerInfo = {
  __typename?: 'UserBuyerInfo';
  isCompany: Scalars['Boolean'];
  source: Scalars['String'];
};

export type UserBuyerLeadsResult = {
  __typename?: 'UserBuyerLeadsResult';
  /** Refer: src/graphql/definitions/object/user-buyer-leads-result-filtered.graphql */
  filter: UserBuyerLeadsResultFiltered;
  /**
   * Search by buyer's name.
   * Refer: src/graphql/definitions/object/user-buyer-leads-result-filtered.graphql
   */
  search: UserBuyerLeadsResultFiltered;
  /** Refer: src/graphql/definitions/object/user-buyer-leads-result-summary.graphql */
  summary: UserBuyerLeadsResultSummary;
};


export type UserBuyerLeadsResultFilterArgs = {
  filter: DisplayUserBuyerLeadsFilter;
};


export type UserBuyerLeadsResultSearchArgs = {
  searchString: Scalars['String'];
};

export type UserBuyerLeadsResultFiltered = {
  __typename?: 'UserBuyerLeadsResultFiltered';
  /** Refer: src/graphql/definitions/object/buyer-lead.graphql */
  paginate: Array<BuyerLead>;
  totalCount: Scalars['Int'];
};


export type UserBuyerLeadsResultFilteredPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type UserBuyerLeadsResultSummary = {
  __typename?: 'UserBuyerLeadsResultSummary';
  followUpRequired: Scalars['Int'];
  myLeads: Scalars['Int'];
  newLead: Scalars['Int'];
  /** Not team leader, but buyer leads assigned to team members of the requesting user. */
  teamLeads: Scalars['Int'];
};

export type UserBuyerLeadsSummary = {
  __typename?: 'UserBuyerLeadsSummary';
  /**
   * Group buyer leads by agent.
   * Refer: src/graphql/definitions/object/user-buyer-leads-summary-agent-group.graphql
   */
  agentGroups: Array<UserBuyerLeadsSummaryAgentGroup>;
  /**
   * Group buyer leads by project.
   * Refer: src/graphql/definitions/object/user-buyer-leads-summary-project-group.graphql
   */
  projectGroups: Array<UserBuyerLeadsSummaryProjectGroup>;
};

export type UserBuyerLeadsSummaryAgentGroup = {
  __typename?: 'UserBuyerLeadsSummaryAgentGroup';
  activeLeadsCount: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/agent.graphql */
  agent: Agent;
};

export type UserBuyerLeadsSummaryProjectGroup = {
  __typename?: 'UserBuyerLeadsSummaryProjectGroup';
  activeLeadsCount: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/project.graphql */
  project: Project;
};

export type UserContact = {
  __typename?: 'UserContact';
  email?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  mobileNum?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/enum/user-contact-type.graphql */
  type: UserContactType;
};

export enum UserContactType {
  Primary = 'primary',
  Secondary = 'secondary'
}

export type UserDeveloperInfo = {
  __typename?: 'UserDeveloperInfo';
  /** Refer: src/graphql/definitions/object/agency.graphql */
  developer?: Maybe<Agency>;
  developerId: Scalars['String'];
  role: Scalars['String'];
};

export type UserEmployeeInfo = {
  __typename?: 'UserEmployeeInfo';
  /**
   * Defined if this user was, is, or will be a Head of ARM for some projects.
   * Refer: src/graphql/definitions/object/user-employee-info-harm-info.graphql
   */
  harmInfo?: Maybe<UserEmployeeInfoHarmInfo>;
  roles?: Maybe<Array<Scalars['String']>>;
};

export type UserEmployeeInfoHarmInfo = {
  __typename?: 'UserEmployeeInfoHarmInfo';
  /** Refer: src/graphql/definitions/object/project-harm.graphql */
  projects: Array<ProjectHarm>;
};

export type UserFinancialReportsResult = {
  __typename?: 'UserFinancialReportsResult';
  /** Refer: src/graphql/definitions/object/user-financial-reports-result-filtered.graphql */
  filter: UserFinancialReportsResultFiltered;
  /**
   * Search by buyer name.
   * Refer: src/graphql/definitions/object/user-financial-reports-result-filtered.graphql
   */
  search: UserFinancialReportsResultFiltered;
  /** Refer: src/graphql/definitions/object/user-financial-reports-result-summary.graphql */
  summary: UserFinancialReportsResultSummary;
};


export type UserFinancialReportsResultFilterArgs = {
  filter: DisplayUserFinancialReportsFilter;
};


export type UserFinancialReportsResultSearchArgs = {
  searchString: Scalars['String'];
};

export type UserFinancialReportsResultFiltered = {
  __typename?: 'UserFinancialReportsResultFiltered';
  /** Refer: src/graphql/definitions/union/financial-report.graphql */
  paginate: Array<FinancialReport>;
  totalCount: Scalars['Int'];
};


export type UserFinancialReportsResultFilteredPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type UserFinancialReportsResultSummary = {
  __typename?: 'UserFinancialReportsResultSummary';
  financialReport: Scalars['Int'];
  important: Scalars['Int'];
};

export type UserFinancialReportsSummary = {
  __typename?: 'UserFinancialReportsSummary';
  /**
   * Group financial reports by agent.
   * Note: Agent can only view financial reports created by him/her,
   * thus, only one agent group will be returned i.e. agent self
   * Refer: src/graphql/definitions/object/u-user-financial-reports-summary-agent-group.graphql
   */
  agentGroups: Array<UUserFinancialReportsSummaryAgentGroup>;
  /**
   * Group financial reports by project.
   * Refer: src/graphql/definitions/object/user-financial-reports-summary-project-group.graphql
   */
  projectGroups: Array<UserFinancialReportsSummaryProjectGroup>;
};

export type UserFinancialReportsSummaryProjectGroup = {
  __typename?: 'UserFinancialReportsSummaryProjectGroup';
  financialReportsCount: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/project.graphql */
  project: Project;
};

export type UserLawyerInfo = {
  __typename?: 'UserLawyerInfo';
  lawyerFirm?: Maybe<Scalars['String']>;
  personInCharge?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/project.graphql */
  projects: Array<Project>;
};

export type UserMission = {
  __typename?: 'UserMission';
  amount: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  done: Scalars['Boolean'];
  expiryDate?: Maybe<Scalars['Float']>;
  /** Refer: src/graphql/definitions/object/uploaded-file.graphql */
  icon?: Maybe<UploadedFile>;
  key?: Maybe<Scalars['String']>;
  /** Refer: src/graphql/definitions/object/user-mission-limited-slot.graphql */
  limitedSlot?: Maybe<UserMissionLimitedSlot>;
  /** Refer: src/graphql/definitions/object/user-mission-limited-time.graphql */
  limitedTime?: Maybe<UserMissionLimitedTime>;
  name: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user-mission-progress.graphql */
  progress?: Maybe<UserMissionProgress>;
  repeatable: Scalars['Boolean'];
  /** Refer: src/graphql/definitions/object/user-mission-step.graphql */
  steps: Array<UserMissionStep>;
};

export type UserMissionLimitedSlot = {
  __typename?: 'UserMissionLimitedSlot';
  amount: Scalars['Float'];
  availableSlots: Scalars['Int'];
  totalSlots: Scalars['Int'];
};

export type UserMissionLimitedTime = {
  __typename?: 'UserMissionLimitedTime';
  amount: Scalars['Float'];
  toDate: Scalars['String'];
};

export type UserMissionProgress = {
  __typename?: 'UserMissionProgress';
  currentAmount: Scalars['Float'];
  totalAmount: Scalars['Float'];
};

export type UserMissionStep = {
  __typename?: 'UserMissionStep';
  /** Refer: src/graphql/definitions/union/app-screen.graphql */
  appScreen?: Maybe<AppScreen>;
  description: Scalars['String'];
  done: Scalars['Boolean'];
  /** @deprecated Use appScreen instead */
  screen?: Maybe<Scalars['String']>;
};

export type UserPublicTransaction = {
  __typename?: 'UserPublicTransaction';
  bookingDate: Scalars['String'];
  completionDate: Scalars['String'];
  grossPrice: Scalars['Float'];
  id: Scalars['String'];
  mosaicedUnitNumber: Scalars['String'];
  /** Refer: src/graphql/definitions/object/user-public-transaction-project.graphql */
  project?: Maybe<UserPublicTransactionProject>;
};

export type UserPublicTransactionProject = {
  __typename?: 'UserPublicTransactionProject';
  area?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UserSchedulesSummary = {
  __typename?: 'UserSchedulesSummary';
  /**
   * Group schedules by agent.
   * Refer: src/graphql/definitions/object/user-schedules-summary-agent-group.graphql
   */
  agentGroups: Array<UserSchedulesSummaryAgentGroup>;
  /**
   * Group schedules by project.
   * Refer: src/graphql/definitions/object/user-schedules-summary-project-group.graphql
   */
  projectGroups: Array<UserSchedulesSummaryProjectGroup>;
};

export type UserSchedulesSummaryAgentGroup = {
  __typename?: 'UserSchedulesSummaryAgentGroup';
  /** Refer: src/graphql/definitions/object/agent.graphql */
  agent: Agent;
  upcomingSchedulesCount: Scalars['Int'];
};

export type UserSchedulesSummaryProjectGroup = {
  __typename?: 'UserSchedulesSummaryProjectGroup';
  /** Refer: src/graphql/definitions/object/project.graphql */
  project: Project;
  upcomingSchedulesCount: Scalars['Int'];
};

export type UserTransactionsResult = {
  __typename?: 'UserTransactionsResult';
  /** Refer: src/graphql/definitions/object/user-transactions-result-filtered.graphql */
  filter: UserTransactionsResultFiltered;
  /**
   * Search by unit number / buyer's name.
   * Refer: src/graphql/definitions/object/user-transactions-result-filtered.graphql
   */
  search: UserTransactionsResultFiltered;
  /** Refer: src/graphql/definitions/object/user-transactions-result-summary.graphql */
  summary: UserTransactionsResultSummary;
};


export type UserTransactionsResultFilterArgs = {
  filter: DisplayUserTransactionsFilter;
};


export type UserTransactionsResultSearchArgs = {
  searchString: Scalars['String'];
};

export type UserTransactionsResultFiltered = {
  __typename?: 'UserTransactionsResultFiltered';
  /** Refer: src/graphql/definitions/object/transaction.graphql */
  paginate: Array<Transaction>;
  totalCount: Scalars['Int'];
};


export type UserTransactionsResultFilteredPaginateArgs = {
  pagingOptions: PagingOptions;
};

export type UserTransactionsResultSummary = {
  __typename?: 'UserTransactionsResultSummary';
  commissionPayment: Scalars['Int'];
  documentSigning: Scalars['Int'];
  important: Scalars['Int'];
  loanApplication: Scalars['Int'];
  mySales: Scalars['Int'];
  teamSales: Scalars['Int'];
};

export type UserTransactionsSummary = {
  __typename?: 'UserTransactionsSummary';
  /**
   * Group transactions by agent.
   * Refer: src/graphql/definitions/object/user-transactions-summary-agent-group.graphql
   */
  agentGroups: Array<UserTransactionsSummaryAgentGroup>;
  /**
   * Group transactions by project.
   * Refer: src/graphql/definitions/object/user-transactions-summary-project-group.graphql
   */
  projectGroups: Array<UserTransactionsSummaryProjectGroup>;
};

export type UserTransactionsSummaryAgentGroup = {
  __typename?: 'UserTransactionsSummaryAgentGroup';
  activeSalesLastWeek: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/agent.graphql */
  agent: Agent;
  transactionsCount: Scalars['Int'];
  transactionsGrossPriceSum: Scalars['Float'];
};

export type UserTransactionsSummaryProjectGroup = {
  __typename?: 'UserTransactionsSummaryProjectGroup';
  activeSalesLastWeek: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/project.graphql */
  project: Project;
  transactionsCount: Scalars['Int'];
  transactionsGrossPriceSum: Scalars['Float'];
};

export type VerifyBookingDocumentCollectionMethodExpress = {
  dummy?: InputMaybe<Scalars['String']>;
};

export type VerifyBookingDocumentCollectionMethodManual = {
  dummy?: InputMaybe<Scalars['String']>;
};

export type VerifyBookingFormPayment = {
  amount: Scalars['Float'];
  detail?: InputMaybe<Scalars['String']>;
  method: Scalars['String'];
};

export type ViceTeamLeader = {
  __typename?: 'ViceTeamLeader';
  restrictedToProjectIds?: Maybe<Array<Scalars['String']>>;
  /** Refer: src/graphql/definitions/object/agent.graphql */
  user: Agent;
};

export type WeeklyFrequency = {
  __typename?: 'WeeklyFrequency';
  frequency: Scalars['Int'];
  weekPeriod: Scalars['String'];
};

export type WeeklySignupVerificationStat = {
  __typename?: 'WeeklySignupVerificationStat';
  numberOfAgents: Scalars['Int'];
  verificationStatus: Scalars['String'];
};

export type WeeklyWhitelistStats = {
  __typename?: 'WeeklyWhitelistStats';
  /**
   * 0 means current week.
   * 1 means next week and so on.
   */
  week: Scalars['Int'];
  /** Refer: src/graphql/definitions/object/whitelist-stats-arm.graphql */
  whitelistStatsArm: Array<WhitelistStatsArm>;
  /** Refer: src/graphql/definitions/object/whitelist-stats-source.graphql */
  whitelistStatsSource: Array<WhitelistStatsSource>;
};

export type WhitelistEvent = {
  __typename?: 'WhitelistEvent';
  /** Refer: src/graphql/definitions/object/user.graphql */
  author?: Maybe<User>;
  createdOn: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
};

/** Project whitelist created by ARM. */
export type WhitelistItem = {
  __typename?: 'WhitelistItem';
  /**
   * The value of this field is either a team leader or a vice team leader who
   * whitelisted the `whitelistedUser` for this `project`.
   * This is undefined if this whitelist item is created by ARM.
   * Refer: src/graphql/definitions/object/user.graphql
   */
  assistedBy?: Maybe<User>;
  /** Refer: src/graphql/definitions/object/user.graphql */
  by?: Maybe<User>;
  createdOn: Scalars['String'];
  /** Refer: src/graphql/definitions/object/whitelist-event.graphql */
  events: Array<WhitelistEvent>;
  id: Scalars['String'];
  on: Scalars['String'];
  /** Refer: src/graphql/definitions/object/project.graphql */
  project?: Maybe<Project>;
  remarks: Scalars['String'];
  /** Refer: src/graphql/definitions/object/schedule.graphql */
  schedule?: Maybe<Schedule>;
  /** @deprecated This is never used before, so we removed support for it. */
  teamId?: Maybe<Scalars['String']>;
  /** @deprecated It will always be 'individual', since we never use 'team' type. */
  type: Scalars['String'];
  /**
   * This is always an ARM regardless of whether this whitelist item is actually
   * created by an ARM or not.
   * If this whitelist item is created by a team leader, then `whitelistedBy`
   * will be the ARM who whitelisted the team leader for this `project`.
   * If this whitelist item is created by a vice team leader, then `whitelistedBy`
   * will be the ARM who whitelisted the team leader of the vice team leader for
   * this `project`.
   * Refer: src/graphql/definitions/object/user.graphql
   */
  whitelistedBy: User;
  /** Refer: src/graphql/definitions/object/agent.graphql */
  whitelistedUser?: Maybe<Agent>;
};

export type WhitelistStats = {
  __typename?: 'WhitelistStats';
  /** Refer: src/graphql/definitions/object/monthly-whitelist-stats.graphql */
  monthlyWhitelistStats: Array<MonthlyWhitelistStats>;
  /** Refer: src/graphql/definitions/object/monthly-whitelist-stats.graphql */
  monthlyWhitelistStatsUniqueByAgents: Array<MonthlyWhitelistStats>;
  /** Refer: src/graphql/definitions/object/weekly-whitelist-stats.graphql */
  weeklyWhitelistStats: Array<WeeklyWhitelistStats>;
  /** Refer: src/graphql/definitions/object/weekly-whitelist-stats.graphql */
  weeklyWhitelistStatsUniqueByAgents: Array<WeeklyWhitelistStats>;
};

export type WhitelistStatsArm = {
  __typename?: 'WhitelistStatsArm';
  /** Refer: src/graphql/definitions/object/user.graphql */
  arm: User;
  numberOfWhitelists: Scalars['Int'];
};

export type WhitelistStatsSource = {
  __typename?: 'WhitelistStatsSource';
  numberOfWhitelists: Scalars['Int'];
  source: Scalars['String'];
};

export type WhoPayFinancialReport = {
  __typename?: 'WhoPayFinancialReport';
  /** Refer: src/graphql/definitions/object/user.graphql */
  agents: Array<User>;
  /** Refer: src/graphql/definitions/object/attached-file.graphql */
  consent?: Maybe<AttachedFile>;
  /** Refer: src/graphql/definitions/object/who-pay-financial-report-content.graphql */
  content?: Maybe<WhoPayFinancialReportContent>;
  createdOn: Scalars['String'];
  id: Scalars['ID'];
  /** Refer: src/graphql/definitions/object/project.graphql */
  projects: Array<Project>;
  /** Refer: src/graphql/definitions/object/financial-report-user.graphql */
  users: Array<FinancialReportUser>;
};

export type WhoPayFinancialReportContent = {
  __typename?: 'WhoPayFinancialReportContent';
  advice: Scalars['String'];
  /** Refer: src/graphql/definitions/object/who-pay-loan-info.graphql */
  loanInfo: WhoPayLoanInfo;
  /** Refer: src/graphql/definitions/enum/who-pay-financial-report-profile-result.graphql */
  profileResult: WhoPayFinancialReportProfileResult;
  /** URL to the Whopay report on Whopay website */
  reportUrl: Scalars['String'];
  /** Request ID of the whopay report */
  requestId: Scalars['ID'];
};

export enum WhoPayFinancialReportProfileResult {
  Green = 'GREEN',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export type WhoPayLoanInfo = {
  __typename?: 'WhoPayLoanInfo';
  loanAmount: Scalars['Float'];
};

export type PaymentPortal_App_HomeQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type PaymentPortal_App_HomeQuery = { __typename?: 'Query', paymentPortal: { __typename?: 'PaymentPortal', expiryDate: string } };

export type PaymentPortal_LoginIndex_DisplayPaymentPortalTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentPortal_LoginIndex_DisplayPaymentPortalTokenQuery = { __typename?: 'Query', displayProfile?: { __typename?: 'User', id: string, fullName: string, mobileNum?: string | null } | null, displayPaymentPortalToken: { __typename?: 'Token', token: string } };

export type SignedCopyQueryFragment = { __typename?: 'GalSignedCopy', createdOn: string, file: { __typename?: 'UploadedFile', name: string, signedURL: string }, createdBy: { __typename?: 'User', fullName: string } };

export type GalAgencyGroupQueryFragment = { __typename?: 'GalAgencyGroup', id: string, agencyGroup: { __typename?: 'AgencyGroup', id: string, parentAgency: { __typename?: 'AgencyGroupParentAgency', agency: { __typename?: 'Agency', name: string, registrationNum?: string | null } } }, latestGal?: { __typename?: 'GalAgencyGroupGal', template: { __typename?: 'GalTemplate', id: string }, status: { __typename: 'GalAgencyGroupGalStatusApproved', on: string, signedCopy: { __typename?: 'GalSignedCopy', createdOn: string, file: { __typename?: 'UploadedFile', name: string, signedURL: string }, createdBy: { __typename?: 'User', fullName: string } } } | { __typename: 'GalAgencyGroupGalStatusPendingReupload', dummy?: string | null } | { __typename: 'GalAgencyGroupGalStatusPendingUpload', dummy?: string | null } | { __typename: 'GalAgencyGroupGalStatusRejected', reason: string, on: string } | { __typename: 'GalAgencyGroupGalStatusUploaded', signedCopy: { __typename?: 'GalSignedCopy', createdOn: string, file: { __typename?: 'UploadedFile', name: string, signedURL: string }, createdBy: { __typename?: 'User', fullName: string } } } | { __typename: 'GalAgencyGroupGalStatusVoided', on: string, reason: string } } | null };

export type PaymentPortal_GalAgencyGroupSectionQueryVariables = Exact<{
  token: Scalars['String'];
  pagingOptions: PagingOptions;
}>;


export type PaymentPortal_GalAgencyGroupSectionQuery = { __typename?: 'Query', paymentPortal: { __typename?: 'PaymentPortal', galAgencyGroups: { __typename?: 'PaymentPortalGalAgencyGroups', findMany: { __typename?: 'FilteredGalAgencyGroups', totalCount: number, paginate: Array<{ __typename?: 'GalAgencyGroup', id: string, agencyGroup: { __typename?: 'AgencyGroup', id: string, parentAgency: { __typename?: 'AgencyGroupParentAgency', agency: { __typename?: 'Agency', name: string, registrationNum?: string | null } } }, latestGal?: { __typename?: 'GalAgencyGroupGal', template: { __typename?: 'GalTemplate', id: string }, status: { __typename: 'GalAgencyGroupGalStatusApproved', on: string, signedCopy: { __typename?: 'GalSignedCopy', createdOn: string, file: { __typename?: 'UploadedFile', name: string, signedURL: string }, createdBy: { __typename?: 'User', fullName: string } } } | { __typename: 'GalAgencyGroupGalStatusPendingReupload', dummy?: string | null } | { __typename: 'GalAgencyGroupGalStatusPendingUpload', dummy?: string | null } | { __typename: 'GalAgencyGroupGalStatusRejected', reason: string, on: string } | { __typename: 'GalAgencyGroupGalStatusUploaded', signedCopy: { __typename?: 'GalSignedCopy', createdOn: string, file: { __typename?: 'UploadedFile', name: string, signedURL: string }, createdBy: { __typename?: 'User', fullName: string } } } | { __typename: 'GalAgencyGroupGalStatusVoided', on: string, reason: string } } | null }> } } } };

export type PaymentPortal_GalAgencyGroupSection_GenerateGalQueryVariables = Exact<{
  token: Scalars['String'];
  galTemplateId: Scalars['ID'];
  galAgencyGroupId: Scalars['ID'];
}>;


export type PaymentPortal_GalAgencyGroupSection_GenerateGalQuery = { __typename?: 'Query', paymentPortal: { __typename?: 'PaymentPortal', generateGal: { __typename?: 'GenerateGalResponse', generatedPdf: string } } };

export type PaymentPortal_GalAgencyGroupSection_UploadGalSignedCopyMutationVariables = Exact<{
  token: Scalars['String'];
  file: Upload;
  galAgencyGroupId: Scalars['ID'];
  galTemplateId: Scalars['ID'];
}>;


export type PaymentPortal_GalAgencyGroupSection_UploadGalSignedCopyMutation = { __typename?: 'Mutation', paymentPortalMutation: { __typename?: 'PaymentPortalMutation', uploadGalSignedCopy: { __typename?: 'GalSignedCopy', id: string } } };

export type ProjectCommissionTncVersionQueryFragment = { __typename?: 'ProjectCommissionTncVersion', id: string, createdOn: string, commencementDate: string, file: { __typename?: 'UploadedFile', name: string, signedURL: string }, endDate?: { __typename?: 'ProjectCommissionTncVersionEndDate', value: string } | null, commissionPortions: Array<{ __typename?: 'ProjectCommissionTncVersionCommissionPortion', type: string, percentage: number }>, commissionTiers: Array<{ __typename?: 'ProjectCommissionTncVersionCommissionTier', lowerBoundaryInclusive: number, upperBoundaryInclusive?: number | null, percentage: number }> };

export type ProjectAgencyGroupQueryFragment = { __typename?: 'ProjectAgencyGroup', id: string, agencyKind: { __typename?: 'ProjectAgencyKind', childProject: { __typename?: 'Project', name: string, parent?: { __typename?: 'Project', name: string } | null } }, agencyGroup: { __typename?: 'AgencyGroup', parentAgency: { __typename?: 'AgencyGroupParentAgency', agency: { __typename?: 'Agency', name: string, registrationNum?: string | null } } }, commissionTncs: Array<{ __typename?: 'ProjectAgencyGroupCommissionTnc', tnc: { __typename?: 'ProjectCommissionTnc', id: string, latestVersion: { __typename?: 'ProjectCommissionTncVersion', id: string, createdOn: string, commencementDate: string, file: { __typename?: 'UploadedFile', name: string, signedURL: string }, endDate?: { __typename?: 'ProjectCommissionTncVersionEndDate', value: string } | null, commissionPortions: Array<{ __typename?: 'ProjectCommissionTncVersionCommissionPortion', type: string, percentage: number }>, commissionTiers: Array<{ __typename?: 'ProjectCommissionTncVersionCommissionTier', lowerBoundaryInclusive: number, upperBoundaryInclusive?: number | null, percentage: number }> } }, status: { __typename: 'ProjectAgencyGroupCommissionTncStatusAgreed', agreement: { __typename?: 'ProjectCommissionTncVersionAgreement', createdOn: string, createdBy: { __typename?: 'User', fullName: string } } } | { __typename: 'ProjectAgencyGroupCommissionTncStatusPendingAgreement', dummy?: string | null } | { __typename: 'ProjectAgencyGroupCommissionTncStatusPendingReagreement', dummy?: string | null } | { __typename: 'ProjectAgencyGroupCommissionTncStatusTerminated', termination: { __typename?: 'ProjectCommissionTncVersionAgreementTermination', effectiveDate: string, reason: string } } }> };

export type PaymentPortal_ProjectAgencyGroupSectionQueryVariables = Exact<{
  token: Scalars['String'];
  pagingOptions: PagingOptions;
}>;


export type PaymentPortal_ProjectAgencyGroupSectionQuery = { __typename?: 'Query', paymentPortal: { __typename?: 'PaymentPortal', projectAgencyGroups: { __typename?: 'PaymentPortalProjectAgencyGroups', findMany: { __typename?: 'FilteredProjectAgencyGroups', totalCount: number, paginate: Array<{ __typename?: 'ProjectAgencyGroup', id: string, agencyKind: { __typename?: 'ProjectAgencyKind', childProject: { __typename?: 'Project', name: string, parent?: { __typename?: 'Project', name: string } | null } }, agencyGroup: { __typename?: 'AgencyGroup', parentAgency: { __typename?: 'AgencyGroupParentAgency', agency: { __typename?: 'Agency', name: string, registrationNum?: string | null } } }, commissionTncs: Array<{ __typename?: 'ProjectAgencyGroupCommissionTnc', tnc: { __typename?: 'ProjectCommissionTnc', id: string, latestVersion: { __typename?: 'ProjectCommissionTncVersion', id: string, createdOn: string, commencementDate: string, file: { __typename?: 'UploadedFile', name: string, signedURL: string }, endDate?: { __typename?: 'ProjectCommissionTncVersionEndDate', value: string } | null, commissionPortions: Array<{ __typename?: 'ProjectCommissionTncVersionCommissionPortion', type: string, percentage: number }>, commissionTiers: Array<{ __typename?: 'ProjectCommissionTncVersionCommissionTier', lowerBoundaryInclusive: number, upperBoundaryInclusive?: number | null, percentage: number }> } }, status: { __typename: 'ProjectAgencyGroupCommissionTncStatusAgreed', agreement: { __typename?: 'ProjectCommissionTncVersionAgreement', createdOn: string, createdBy: { __typename?: 'User', fullName: string } } } | { __typename: 'ProjectAgencyGroupCommissionTncStatusPendingAgreement', dummy?: string | null } | { __typename: 'ProjectAgencyGroupCommissionTncStatusPendingReagreement', dummy?: string | null } | { __typename: 'ProjectAgencyGroupCommissionTncStatusTerminated', termination: { __typename?: 'ProjectCommissionTncVersionAgreementTermination', effectiveDate: string, reason: string } } }> }> } } } };

export type PaymentPortal_TncDialog_AgreeTncMutationVariables = Exact<{
  token: Scalars['String'];
  tncVersionId: Scalars['ID'];
  projectAgencyGroupId: Scalars['ID'];
}>;


export type PaymentPortal_TncDialog_AgreeTncMutation = { __typename?: 'Mutation', paymentPortalMutation: { __typename?: 'PaymentPortalMutation', agreeProjectCommissionTnc: { __typename?: 'ProjectCommissionTncVersionAgreement', id: string } } };

export type EmailContentQueryFragment = { __typename?: 'EmailContent', htmlBody: string, templateModel: { __typename?: 'EmailContentTemplateModel', human_readable_id: string, project_name: string, unit_no: string, buyers: string, gross_price: string, nett_price: string, gross_commission_percentage: string, gross_commission_payable: string, nett_commission_percentage: string, tax_percentage: string, commission_type: string, commmission_portion: string, agency: string, agents: string } };

export type InvoiceRequestQueryFragment = { __typename?: 'TransactionCommissionInvoiceRequest', id: string, humanReadableId: string, commissionType: string, payableAmount: number, agency: { __typename?: 'Agency', id: string, name: string }, forAgents: Array<{ __typename?: 'User', fullName: string, agentInfo?: { __typename?: 'UserAgentInfo', agency?: { __typename?: 'UserAgentAgency', name: string } | null } | null }>, invoices: Array<{ __typename?: 'TransactionCommissionInvoice', createdOn: string, type: TransactionCommissionInvoiceType }>, transaction: { __typename?: 'Transaction', id: string, project?: { __typename?: 'Project', id: string, name: string, parent?: { __typename?: 'Project', id: string, name: string } | null, unit?: { __typename?: 'ProjectUnit', unitNum: string } | null } | null }, emailContent?: { __typename?: 'EmailContent', htmlBody: string, templateModel: { __typename?: 'EmailContentTemplateModel', human_readable_id: string, project_name: string, unit_no: string, buyers: string, gross_price: string, nett_price: string, gross_commission_percentage: string, gross_commission_payable: string, nett_commission_percentage: string, tax_percentage: string, commission_type: string, commmission_portion: string, agency: string, agents: string } } | null };

export type AttachedFileQueryFragment = { __typename?: 'AttachedFile', signedURL: string };

export type InvoiceQueryFragment = { __typename?: 'TransactionCommissionInvoice', id: string, createdOn: string, filename?: string | null, type: TransactionCommissionInvoiceType, invalidatedReason?: string | null, file?: { __typename?: 'AttachedFile', signedURL: string } | null, invoiceRequests: Array<{ __typename?: 'TransactionCommissionInvoiceRequest', id: string, humanReadableId: string, commissionType: string, payableAmount: number, agency: { __typename?: 'Agency', id: string, name: string }, forAgents: Array<{ __typename?: 'User', fullName: string, agentInfo?: { __typename?: 'UserAgentInfo', agency?: { __typename?: 'UserAgentAgency', name: string } | null } | null }>, invoices: Array<{ __typename?: 'TransactionCommissionInvoice', createdOn: string, type: TransactionCommissionInvoiceType }>, transaction: { __typename?: 'Transaction', id: string, project?: { __typename?: 'Project', id: string, name: string, parent?: { __typename?: 'Project', id: string, name: string } | null, unit?: { __typename?: 'ProjectUnit', unitNum: string } | null } | null }, emailContent?: { __typename?: 'EmailContent', htmlBody: string, templateModel: { __typename?: 'EmailContentTemplateModel', human_readable_id: string, project_name: string, unit_no: string, buyers: string, gross_price: string, nett_price: string, gross_commission_percentage: string, gross_commission_payable: string, nett_commission_percentage: string, tax_percentage: string, commission_type: string, commmission_portion: string, agency: string, agents: string } } | null }>, paymentSlip?: { __typename?: 'TransactionCommissionPaymentSlip', id: string } | null };

export type PaymentSlipQueryFragment = { __typename?: 'TransactionCommissionPaymentSlip', createdOn: string, voidedOn?: string | null, generatedFilename: string, file?: { __typename?: 'AttachedFile', signedURL: string } | null, commissionInvoices: Array<{ __typename?: 'TransactionCommissionInvoice', id: string, createdOn: string, filename?: string | null, type: TransactionCommissionInvoiceType, invalidatedReason?: string | null, file?: { __typename?: 'AttachedFile', signedURL: string } | null, invoiceRequests: Array<{ __typename?: 'TransactionCommissionInvoiceRequest', id: string, humanReadableId: string, commissionType: string, payableAmount: number, agency: { __typename?: 'Agency', id: string, name: string }, forAgents: Array<{ __typename?: 'User', fullName: string, agentInfo?: { __typename?: 'UserAgentInfo', agency?: { __typename?: 'UserAgentAgency', name: string } | null } | null }>, invoices: Array<{ __typename?: 'TransactionCommissionInvoice', createdOn: string, type: TransactionCommissionInvoiceType }>, transaction: { __typename?: 'Transaction', id: string, project?: { __typename?: 'Project', id: string, name: string, parent?: { __typename?: 'Project', id: string, name: string } | null, unit?: { __typename?: 'ProjectUnit', unitNum: string } | null } | null }, emailContent?: { __typename?: 'EmailContent', htmlBody: string, templateModel: { __typename?: 'EmailContentTemplateModel', human_readable_id: string, project_name: string, unit_no: string, buyers: string, gross_price: string, nett_price: string, gross_commission_percentage: string, gross_commission_payable: string, nett_commission_percentage: string, tax_percentage: string, commission_type: string, commmission_portion: string, agency: string, agents: string } } | null }>, paymentSlip?: { __typename?: 'TransactionCommissionPaymentSlip', id: string } | null }>, additionalPaymentSlips: Array<{ __typename?: 'TransactionCommissionPaymentSlip', createdOn: string, voidedOn?: string | null, generatedFilename: string, file?: { __typename?: 'AttachedFile', signedURL: string } | null, commissionInvoices: Array<{ __typename?: 'TransactionCommissionInvoice', id: string, createdOn: string, filename?: string | null, type: TransactionCommissionInvoiceType, invalidatedReason?: string | null, file?: { __typename?: 'AttachedFile', signedURL: string } | null, invoiceRequests: Array<{ __typename?: 'TransactionCommissionInvoiceRequest', id: string, humanReadableId: string, commissionType: string, payableAmount: number, agency: { __typename?: 'Agency', id: string, name: string }, forAgents: Array<{ __typename?: 'User', fullName: string, agentInfo?: { __typename?: 'UserAgentInfo', agency?: { __typename?: 'UserAgentAgency', name: string } | null } | null }>, invoices: Array<{ __typename?: 'TransactionCommissionInvoice', createdOn: string, type: TransactionCommissionInvoiceType }>, transaction: { __typename?: 'Transaction', id: string, project?: { __typename?: 'Project', id: string, name: string, parent?: { __typename?: 'Project', id: string, name: string } | null, unit?: { __typename?: 'ProjectUnit', unitNum: string } | null } | null }, emailContent?: { __typename?: 'EmailContent', htmlBody: string, templateModel: { __typename?: 'EmailContentTemplateModel', human_readable_id: string, project_name: string, unit_no: string, buyers: string, gross_price: string, nett_price: string, gross_commission_percentage: string, gross_commission_payable: string, nett_commission_percentage: string, tax_percentage: string, commission_type: string, commmission_portion: string, agency: string, agents: string } } | null }>, paymentSlip?: { __typename?: 'TransactionCommissionPaymentSlip', id: string } | null }> }> };

export type AppointmentLetterQueryFragment = { __typename?: 'AppointmentLetter', id: string, commencementDate: string, expiryDate: string, template?: { __typename?: 'AttachedFile', name: string, signedURL: string } | null, signedVersion?: { __typename?: 'AttachedFile', name: string, signedURL: string } | null, agency?: { __typename?: 'Agency', id: string, name: string } | null, parentProject?: { __typename?: 'Project', id: string, name: string } | null, childProject?: { __typename?: 'Project', id: string, name: string } | null, rejectedSignedVersions: Array<{ __typename?: 'AppointmentLetterRejectedSignedVersion', id: string, rejectedOn?: string | null, rejectionTitle: string, rejectionDescription: string, file?: { __typename?: 'AttachedFile', name: string, signedURL: string } | null, rejectedBy?: { __typename?: 'User', id: string, fullName: string } | null }> };

export type PaymentPortal_AppointmentLetterIndex_MainAppointmentLettersQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type PaymentPortal_AppointmentLetterIndex_MainAppointmentLettersQuery = { __typename?: 'Query', displayPaymentPortalData?: { __typename?: 'DisplayPaymentPortalDataResponse', expiryDate: string, appointmentLetters: Array<{ __typename?: 'AppointmentLetter', id: string, commencementDate: string, expiryDate: string, template?: { __typename?: 'AttachedFile', name: string, signedURL: string } | null, signedVersion?: { __typename?: 'AttachedFile', name: string, signedURL: string } | null, agency?: { __typename?: 'Agency', id: string, name: string } | null, parentProject?: { __typename?: 'Project', id: string, name: string } | null, childProject?: { __typename?: 'Project', id: string, name: string } | null, rejectedSignedVersions: Array<{ __typename?: 'AppointmentLetterRejectedSignedVersion', id: string, rejectedOn?: string | null, rejectionTitle: string, rejectionDescription: string, file?: { __typename?: 'AttachedFile', name: string, signedURL: string } | null, rejectedBy?: { __typename?: 'User', id: string, fullName: string } | null }> }> } | null };

export type PaymentPortal_AppointmentLetterIndex_MainCancelSignedAppointmentLetterMutationVariables = Exact<{
  token: Scalars['String'];
  appointmentLetterId: Scalars['String'];
}>;


export type PaymentPortal_AppointmentLetterIndex_MainCancelSignedAppointmentLetterMutation = { __typename?: 'Mutation', cancelSignedAppointmentLetter: boolean };

export type PaymentPortal_AppointmentLetterIndex_MainUploadSignedAppointmentLetterMutationVariables = Exact<{
  token: Scalars['String'];
  files: Array<Upload> | Upload;
  appointmentLetterId: Scalars['String'];
}>;


export type PaymentPortal_AppointmentLetterIndex_MainUploadSignedAppointmentLetterMutation = { __typename?: 'Mutation', uploadSignedAppointmentLetter: boolean };

export type PaymentPortal_MainIndexQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type PaymentPortal_MainIndexQuery = { __typename?: 'Query', paymentPortal: { __typename?: 'PaymentPortal', user: { __typename?: 'User', id: string, fullName: string, mobileNum?: string | null } } };

export type PaymentPortal_MainIndex_TabsQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type PaymentPortal_MainIndex_TabsQuery = { __typename?: 'Query', paymentPortal: { __typename?: 'PaymentPortal', invoiceRequests: { __typename?: 'PaymentPortalInvoiceRequests', actionNeededCount: number }, galAgencyGroups: { __typename?: 'PaymentPortalGalAgencyGroups', actionNeededCount: number }, projectAgencyGroups: { __typename?: 'PaymentPortalProjectAgencyGroups', actionNeededCount: number } } };

export type PaymentPortal_InvoiceRequestDialogQueryVariables = Exact<{
  token: Scalars['String'];
  invoiceRequestId: Scalars['ID'];
}>;


export type PaymentPortal_InvoiceRequestDialogQuery = { __typename?: 'Query', paymentPortal: { __typename?: 'PaymentPortal', invoiceRequests: { __typename?: 'PaymentPortalInvoiceRequests', findOne: { __typename?: 'TransactionCommissionInvoiceRequest', id: string, humanReadableId: string, commissionType: string, payableAmount: number, agency: { __typename?: 'Agency', id: string, name: string }, forAgents: Array<{ __typename?: 'User', fullName: string, agentInfo?: { __typename?: 'UserAgentInfo', agency?: { __typename?: 'UserAgentAgency', name: string } | null } | null }>, invoices: Array<{ __typename?: 'TransactionCommissionInvoice', createdOn: string, type: TransactionCommissionInvoiceType }>, transaction: { __typename?: 'Transaction', id: string, project?: { __typename?: 'Project', id: string, name: string, parent?: { __typename?: 'Project', id: string, name: string } | null, unit?: { __typename?: 'ProjectUnit', unitNum: string } | null } | null }, emailContent?: { __typename?: 'EmailContent', htmlBody: string, templateModel: { __typename?: 'EmailContentTemplateModel', human_readable_id: string, project_name: string, unit_no: string, buyers: string, gross_price: string, nett_price: string, gross_commission_percentage: string, gross_commission_payable: string, nett_commission_percentage: string, tax_percentage: string, commission_type: string, commmission_portion: string, agency: string, agents: string } } | null } } } };

export type PaymentPortal_InvoiceRequestTabQueryVariables = Exact<{
  token: Scalars['String'];
  pagingOptions: PagingOptions;
}>;


export type PaymentPortal_InvoiceRequestTabQuery = { __typename?: 'Query', paymentPortal: { __typename?: 'PaymentPortal', invoiceRequests: { __typename?: 'PaymentPortalInvoiceRequests', findMany: { __typename?: 'FilteredTransactionCommissionInvoiceRequests', totalCount: number, paginate: Array<{ __typename?: 'TransactionCommissionInvoiceRequest', id: string, humanReadableId: string, commissionType: string, payableAmount: number, agency: { __typename?: 'Agency', id: string, name: string }, forAgents: Array<{ __typename?: 'User', fullName: string, agentInfo?: { __typename?: 'UserAgentInfo', agency?: { __typename?: 'UserAgentAgency', name: string } | null } | null }>, invoices: Array<{ __typename?: 'TransactionCommissionInvoice', createdOn: string, type: TransactionCommissionInvoiceType }>, transaction: { __typename?: 'Transaction', id: string, project?: { __typename?: 'Project', id: string, name: string, parent?: { __typename?: 'Project', id: string, name: string } | null, unit?: { __typename?: 'ProjectUnit', unitNum: string } | null } | null }, emailContent?: { __typename?: 'EmailContent', htmlBody: string, templateModel: { __typename?: 'EmailContentTemplateModel', human_readable_id: string, project_name: string, unit_no: string, buyers: string, gross_price: string, nett_price: string, gross_commission_percentage: string, gross_commission_payable: string, nett_commission_percentage: string, tax_percentage: string, commission_type: string, commmission_portion: string, agency: string, agents: string } } | null }> } } } };

export type PaymentPortal_InvoiceRequestTab_MainUploadInvoiceMutationVariables = Exact<{
  token: Scalars['String'];
  invoiceRequestIds: Array<Scalars['String']> | Scalars['String'];
  files: Array<Upload> | Upload;
}>;


export type PaymentPortal_InvoiceRequestTab_MainUploadInvoiceMutation = { __typename?: 'Mutation', uploadTransactionCommissionInvoice: boolean };

export type PaymentPortal_InvoiceTabQueryVariables = Exact<{
  token: Scalars['String'];
  pagingOptions: PagingOptions;
}>;


export type PaymentPortal_InvoiceTabQuery = { __typename?: 'Query', paymentPortal: { __typename?: 'PaymentPortal', invoices: { __typename?: 'PaymentPortalInvoices', findMany: { __typename?: 'FilteredTransactionCommissionInvoices', totalCount: number, paginate: Array<{ __typename?: 'TransactionCommissionInvoice', id: string, createdOn: string, filename?: string | null, type: TransactionCommissionInvoiceType, invalidatedReason?: string | null, file?: { __typename?: 'AttachedFile', signedURL: string } | null, invoiceRequests: Array<{ __typename?: 'TransactionCommissionInvoiceRequest', id: string, humanReadableId: string, commissionType: string, payableAmount: number, agency: { __typename?: 'Agency', id: string, name: string }, forAgents: Array<{ __typename?: 'User', fullName: string, agentInfo?: { __typename?: 'UserAgentInfo', agency?: { __typename?: 'UserAgentAgency', name: string } | null } | null }>, invoices: Array<{ __typename?: 'TransactionCommissionInvoice', createdOn: string, type: TransactionCommissionInvoiceType }>, transaction: { __typename?: 'Transaction', id: string, project?: { __typename?: 'Project', id: string, name: string, parent?: { __typename?: 'Project', id: string, name: string } | null, unit?: { __typename?: 'ProjectUnit', unitNum: string } | null } | null }, emailContent?: { __typename?: 'EmailContent', htmlBody: string, templateModel: { __typename?: 'EmailContentTemplateModel', human_readable_id: string, project_name: string, unit_no: string, buyers: string, gross_price: string, nett_price: string, gross_commission_percentage: string, gross_commission_payable: string, nett_commission_percentage: string, tax_percentage: string, commission_type: string, commmission_portion: string, agency: string, agents: string } } | null }>, paymentSlip?: { __typename?: 'TransactionCommissionPaymentSlip', id: string } | null }> } } } };

export type PaymentPortal_InvoiceTab_MainCancelInvoiceMutationVariables = Exact<{
  token: Scalars['String'];
  transactionCommissionInvoiceId: Scalars['String'];
}>;


export type PaymentPortal_InvoiceTab_MainCancelInvoiceMutation = { __typename?: 'Mutation', cancelTransactionCommissionInvoice: boolean };

export type PaymentPortal_PaymentSlipTabQueryVariables = Exact<{
  token: Scalars['String'];
  pagingOptions: PagingOptions;
}>;


export type PaymentPortal_PaymentSlipTabQuery = { __typename?: 'Query', paymentPortal: { __typename?: 'PaymentPortal', paymentSlips: { __typename?: 'PaymentPortalPaymentSlips', findMany: { __typename?: 'FilteredTransactionCommissionPaymentSlips', totalCount: number, paginate: Array<{ __typename?: 'TransactionCommissionPaymentSlip', createdOn: string, voidedOn?: string | null, generatedFilename: string, file?: { __typename?: 'AttachedFile', signedURL: string } | null, commissionInvoices: Array<{ __typename?: 'TransactionCommissionInvoice', id: string, createdOn: string, filename?: string | null, type: TransactionCommissionInvoiceType, invalidatedReason?: string | null, file?: { __typename?: 'AttachedFile', signedURL: string } | null, invoiceRequests: Array<{ __typename?: 'TransactionCommissionInvoiceRequest', id: string, humanReadableId: string, commissionType: string, payableAmount: number, agency: { __typename?: 'Agency', id: string, name: string }, forAgents: Array<{ __typename?: 'User', fullName: string, agentInfo?: { __typename?: 'UserAgentInfo', agency?: { __typename?: 'UserAgentAgency', name: string } | null } | null }>, invoices: Array<{ __typename?: 'TransactionCommissionInvoice', createdOn: string, type: TransactionCommissionInvoiceType }>, transaction: { __typename?: 'Transaction', id: string, project?: { __typename?: 'Project', id: string, name: string, parent?: { __typename?: 'Project', id: string, name: string } | null, unit?: { __typename?: 'ProjectUnit', unitNum: string } | null } | null }, emailContent?: { __typename?: 'EmailContent', htmlBody: string, templateModel: { __typename?: 'EmailContentTemplateModel', human_readable_id: string, project_name: string, unit_no: string, buyers: string, gross_price: string, nett_price: string, gross_commission_percentage: string, gross_commission_payable: string, nett_commission_percentage: string, tax_percentage: string, commission_type: string, commmission_portion: string, agency: string, agents: string } } | null }>, paymentSlip?: { __typename?: 'TransactionCommissionPaymentSlip', id: string } | null }>, additionalPaymentSlips: Array<{ __typename?: 'TransactionCommissionPaymentSlip', createdOn: string, voidedOn?: string | null, generatedFilename: string, file?: { __typename?: 'AttachedFile', signedURL: string } | null, commissionInvoices: Array<{ __typename?: 'TransactionCommissionInvoice', id: string, createdOn: string, filename?: string | null, type: TransactionCommissionInvoiceType, invalidatedReason?: string | null, file?: { __typename?: 'AttachedFile', signedURL: string } | null, invoiceRequests: Array<{ __typename?: 'TransactionCommissionInvoiceRequest', id: string, humanReadableId: string, commissionType: string, payableAmount: number, agency: { __typename?: 'Agency', id: string, name: string }, forAgents: Array<{ __typename?: 'User', fullName: string, agentInfo?: { __typename?: 'UserAgentInfo', agency?: { __typename?: 'UserAgentAgency', name: string } | null } | null }>, invoices: Array<{ __typename?: 'TransactionCommissionInvoice', createdOn: string, type: TransactionCommissionInvoiceType }>, transaction: { __typename?: 'Transaction', id: string, project?: { __typename?: 'Project', id: string, name: string, parent?: { __typename?: 'Project', id: string, name: string } | null, unit?: { __typename?: 'ProjectUnit', unitNum: string } | null } | null }, emailContent?: { __typename?: 'EmailContent', htmlBody: string, templateModel: { __typename?: 'EmailContentTemplateModel', human_readable_id: string, project_name: string, unit_no: string, buyers: string, gross_price: string, nett_price: string, gross_commission_percentage: string, gross_commission_payable: string, nett_commission_percentage: string, tax_percentage: string, commission_type: string, commmission_portion: string, agency: string, agents: string } } | null }>, paymentSlip?: { __typename?: 'TransactionCommissionPaymentSlip', id: string } | null }> }> }> } } } };

export const SignedCopyQueryFragmentDoc = gql`
    fragment signedCopyQuery on GalSignedCopy {
  file {
    name
    signedURL
  }
  createdOn
  createdBy {
    fullName
  }
}
    `;
export const GalAgencyGroupQueryFragmentDoc = gql`
    fragment galAgencyGroupQuery on GalAgencyGroup {
  id
  agencyGroup {
    id
    parentAgency {
      agency {
        name
        registrationNum
      }
    }
  }
  latestGal {
    template {
      id
    }
    status {
      __typename
      ... on GalAgencyGroupGalStatusPendingUpload {
        dummy
      }
      ... on GalAgencyGroupGalStatusUploaded {
        signedCopy {
          ...signedCopyQuery
        }
      }
      ... on GalAgencyGroupGalStatusApproved {
        on
        signedCopy {
          ...signedCopyQuery
        }
      }
      ... on GalAgencyGroupGalStatusRejected {
        reason
        on
      }
      ... on GalAgencyGroupGalStatusPendingReupload {
        dummy
      }
      ... on GalAgencyGroupGalStatusVoided {
        on
        reason
      }
    }
  }
}
    ${SignedCopyQueryFragmentDoc}`;
export const ProjectCommissionTncVersionQueryFragmentDoc = gql`
    fragment projectCommissionTncVersionQuery on ProjectCommissionTncVersion {
  id
  createdOn
  file {
    name
    signedURL
  }
  commencementDate
  endDate {
    value
  }
  commissionPortions {
    type
    percentage
  }
  commissionTiers {
    lowerBoundaryInclusive
    upperBoundaryInclusive
    percentage
  }
}
    `;
export const ProjectAgencyGroupQueryFragmentDoc = gql`
    fragment projectAgencyGroupQuery on ProjectAgencyGroup {
  id
  agencyKind {
    childProject {
      name
      parent {
        name
      }
    }
  }
  agencyGroup {
    parentAgency {
      agency {
        name
        registrationNum
      }
    }
  }
  commissionTncs {
    tnc {
      id
      latestVersion {
        ...projectCommissionTncVersionQuery
      }
    }
    status {
      __typename
      ... on ProjectAgencyGroupCommissionTncStatusPendingAgreement {
        dummy
      }
      ... on ProjectAgencyGroupCommissionTncStatusAgreed {
        agreement {
          createdOn
          createdBy {
            fullName
          }
        }
      }
      ... on ProjectAgencyGroupCommissionTncStatusPendingReagreement {
        dummy
      }
      ... on ProjectAgencyGroupCommissionTncStatusTerminated {
        termination {
          effectiveDate
          reason
        }
      }
    }
  }
}
    ${ProjectCommissionTncVersionQueryFragmentDoc}`;
export const AttachedFileQueryFragmentDoc = gql`
    fragment attachedFileQuery on AttachedFile {
  signedURL
}
    `;
export const EmailContentQueryFragmentDoc = gql`
    fragment emailContentQuery on EmailContent {
  htmlBody
  templateModel {
    human_readable_id
    project_name
    unit_no
    buyers
    gross_price
    nett_price
    gross_commission_percentage
    gross_commission_payable
    nett_commission_percentage
    tax_percentage
    commission_type
    commmission_portion
    agency
    agents
  }
}
    `;
export const InvoiceRequestQueryFragmentDoc = gql`
    fragment invoiceRequestQuery on TransactionCommissionInvoiceRequest {
  id
  humanReadableId
  commissionType
  payableAmount
  agency {
    id
    name
  }
  forAgents {
    fullName
    agentInfo {
      agency {
        name
      }
    }
  }
  invoices {
    createdOn
    type
  }
  transaction {
    id
    project {
      id
      name
      parent {
        id
        name
      }
      unit {
        unitNum
      }
    }
  }
  emailContent {
    ...emailContentQuery
  }
}
    ${EmailContentQueryFragmentDoc}`;
export const InvoiceQueryFragmentDoc = gql`
    fragment invoiceQuery on TransactionCommissionInvoice {
  id
  createdOn
  filename
  file {
    ...attachedFileQuery
  }
  type
  invoiceRequests {
    ...invoiceRequestQuery
  }
  paymentSlip {
    id
  }
  invalidatedReason
}
    ${AttachedFileQueryFragmentDoc}
${InvoiceRequestQueryFragmentDoc}`;
export const PaymentSlipQueryFragmentDoc = gql`
    fragment paymentSlipQuery on TransactionCommissionPaymentSlip {
  createdOn
  voidedOn
  file {
    ...attachedFileQuery
  }
  generatedFilename
  commissionInvoices {
    ...invoiceQuery
  }
  additionalPaymentSlips {
    createdOn
    voidedOn
    file {
      ...attachedFileQuery
    }
    generatedFilename
    commissionInvoices {
      ...invoiceQuery
    }
  }
}
    ${AttachedFileQueryFragmentDoc}
${InvoiceQueryFragmentDoc}`;
export const AppointmentLetterQueryFragmentDoc = gql`
    fragment appointmentLetterQuery on AppointmentLetter {
  id
  template {
    name
    signedURL
  }
  signedVersion {
    name
    signedURL
  }
  agency {
    id
    name
  }
  commencementDate
  expiryDate
  parentProject {
    id
    name
  }
  childProject {
    id
    name
  }
  rejectedSignedVersions {
    id
    file {
      name
      signedURL
    }
    rejectedBy {
      id
      fullName
    }
    rejectedOn
    rejectionTitle
    rejectionDescription
  }
}
    `;
export const PaymentPortal_App_HomeDocument = gql`
    query PaymentPortal_App_Home($token: String!) {
  paymentPortal(token: $token) {
    expiryDate
  }
}
    `;
export const PaymentPortal_LoginIndex_DisplayPaymentPortalTokenDocument = gql`
    query PaymentPortal_LoginIndex_DisplayPaymentPortalToken {
  displayProfile {
    id
    fullName
    mobileNum
  }
  displayPaymentPortalToken {
    token
  }
}
    `;
export const PaymentPortal_GalAgencyGroupSectionDocument = gql`
    query PaymentPortal_GalAgencyGroupSection($token: String!, $pagingOptions: PagingOptions!) {
  paymentPortal(token: $token) {
    galAgencyGroups {
      findMany {
        totalCount
        paginate(pagingOptions: $pagingOptions) {
          ...galAgencyGroupQuery
        }
      }
    }
  }
}
    ${GalAgencyGroupQueryFragmentDoc}`;
export const PaymentPortal_GalAgencyGroupSection_GenerateGalDocument = gql`
    query PaymentPortal_GalAgencyGroupSection_GenerateGal($token: String!, $galTemplateId: ID!, $galAgencyGroupId: ID!) {
  paymentPortal(token: $token) {
    generateGal(galTemplateId: $galTemplateId, galAgencyGroupId: $galAgencyGroupId) {
      generatedPdf
    }
  }
}
    `;
export const PaymentPortal_GalAgencyGroupSection_UploadGalSignedCopyDocument = gql`
    mutation PaymentPortal_GalAgencyGroupSection_UploadGalSignedCopy($token: String!, $file: Upload!, $galAgencyGroupId: ID!, $galTemplateId: ID!) {
  paymentPortalMutation(token: $token) {
    uploadGalSignedCopy(
      file: $file
      galAgencyGroupId: $galAgencyGroupId
      galTemplateId: $galTemplateId
    ) {
      id
    }
  }
}
    `;
export const PaymentPortal_ProjectAgencyGroupSectionDocument = gql`
    query PaymentPortal_ProjectAgencyGroupSection($token: String!, $pagingOptions: PagingOptions!) {
  paymentPortal(token: $token) {
    projectAgencyGroups {
      findMany {
        totalCount
        paginate(pagingOptions: $pagingOptions) {
          ...projectAgencyGroupQuery
        }
      }
    }
  }
}
    ${ProjectAgencyGroupQueryFragmentDoc}`;
export const PaymentPortal_TncDialog_AgreeTncDocument = gql`
    mutation PaymentPortal_TncDialog_AgreeTnc($token: String!, $tncVersionId: ID!, $projectAgencyGroupId: ID!) {
  paymentPortalMutation(token: $token) {
    agreeProjectCommissionTnc(
      tncVersionId: $tncVersionId
      projectAgencyGroupId: $projectAgencyGroupId
    ) {
      id
    }
  }
}
    `;
export const PaymentPortal_AppointmentLetterIndex_MainAppointmentLettersDocument = gql`
    query PaymentPortal_AppointmentLetterIndex_MainAppointmentLetters($token: String!) {
  displayPaymentPortalData(token: $token) {
    expiryDate
    appointmentLetters {
      ...appointmentLetterQuery
    }
  }
}
    ${AppointmentLetterQueryFragmentDoc}`;
export const PaymentPortal_AppointmentLetterIndex_MainCancelSignedAppointmentLetterDocument = gql`
    mutation PaymentPortal_AppointmentLetterIndex_MainCancelSignedAppointmentLetter($token: String!, $appointmentLetterId: String!) {
  cancelSignedAppointmentLetter(
    token: $token
    appointmentLetterId: $appointmentLetterId
  )
}
    `;
export const PaymentPortal_AppointmentLetterIndex_MainUploadSignedAppointmentLetterDocument = gql`
    mutation PaymentPortal_AppointmentLetterIndex_MainUploadSignedAppointmentLetter($token: String!, $files: [Upload!]!, $appointmentLetterId: String!) {
  uploadSignedAppointmentLetter(
    token: $token
    appointmentLetterId: $appointmentLetterId
    signedAppointmentLetters: $files
  )
}
    `;
export const PaymentPortal_MainIndexDocument = gql`
    query PaymentPortal_MainIndex($token: String!) {
  paymentPortal(token: $token) {
    user {
      id
      fullName
      mobileNum
    }
  }
}
    `;
export const PaymentPortal_MainIndex_TabsDocument = gql`
    query PaymentPortal_MainIndex_Tabs($token: String!) {
  paymentPortal(token: $token) {
    invoiceRequests {
      actionNeededCount
    }
    galAgencyGroups {
      actionNeededCount
    }
    projectAgencyGroups {
      actionNeededCount
    }
  }
}
    `;
export const PaymentPortal_InvoiceRequestDialogDocument = gql`
    query PaymentPortal_InvoiceRequestDialog($token: String!, $invoiceRequestId: ID!) {
  paymentPortal(token: $token) {
    invoiceRequests {
      findOne(id: $invoiceRequestId) {
        ...invoiceRequestQuery
      }
    }
  }
}
    ${InvoiceRequestQueryFragmentDoc}`;
export const PaymentPortal_InvoiceRequestTabDocument = gql`
    query PaymentPortal_InvoiceRequestTab($token: String!, $pagingOptions: PagingOptions!) {
  paymentPortal(token: $token) {
    invoiceRequests {
      findMany(filter: PENDING_INVOICE) {
        totalCount
        paginate(pagingOptions: $pagingOptions) {
          ...invoiceRequestQuery
        }
      }
    }
  }
}
    ${InvoiceRequestQueryFragmentDoc}`;
export const PaymentPortal_InvoiceRequestTab_MainUploadInvoiceDocument = gql`
    mutation PaymentPortal_InvoiceRequestTab_MainUploadInvoice($token: String!, $invoiceRequestIds: [String!]!, $files: [Upload!]!) {
  uploadTransactionCommissionInvoice(
    token: $token
    invoiceRequestIds: $invoiceRequestIds
    invoice: $files
  )
}
    `;
export const PaymentPortal_InvoiceTabDocument = gql`
    query PaymentPortal_InvoiceTab($token: String!, $pagingOptions: PagingOptions!) {
  paymentPortal(token: $token) {
    invoices {
      findMany(filter: ALL) {
        totalCount
        paginate(pagingOptions: $pagingOptions) {
          ...invoiceQuery
        }
      }
    }
  }
}
    ${InvoiceQueryFragmentDoc}`;
export const PaymentPortal_InvoiceTab_MainCancelInvoiceDocument = gql`
    mutation PaymentPortal_InvoiceTab_MainCancelInvoice($token: String!, $transactionCommissionInvoiceId: String!) {
  cancelTransactionCommissionInvoice(
    token: $token
    transactionCommissionInvoiceId: $transactionCommissionInvoiceId
  )
}
    `;
export const PaymentPortal_PaymentSlipTabDocument = gql`
    query PaymentPortal_PaymentSlipTab($token: String!, $pagingOptions: PagingOptions!) {
  paymentPortal(token: $token) {
    paymentSlips {
      findMany(filter: NON_VOIDED) {
        totalCount
        paginate(pagingOptions: $pagingOptions) {
          ...paymentSlipQuery
        }
      }
    }
  }
}
    ${PaymentSlipQueryFragmentDoc}`;
export type Requester<C = {}, E = unknown> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R> | AsyncIterable<R>
export function getSdk<C, E>(requester: Requester<C, E>) {
  return {
    PaymentPortal_App_Home(variables: PaymentPortal_App_HomeQueryVariables, options?: C): Promise<PaymentPortal_App_HomeQuery> {
      return requester<PaymentPortal_App_HomeQuery, PaymentPortal_App_HomeQueryVariables>(PaymentPortal_App_HomeDocument, variables, options) as Promise<PaymentPortal_App_HomeQuery>;
    },
    PaymentPortal_LoginIndex_DisplayPaymentPortalToken(variables?: PaymentPortal_LoginIndex_DisplayPaymentPortalTokenQueryVariables, options?: C): Promise<PaymentPortal_LoginIndex_DisplayPaymentPortalTokenQuery> {
      return requester<PaymentPortal_LoginIndex_DisplayPaymentPortalTokenQuery, PaymentPortal_LoginIndex_DisplayPaymentPortalTokenQueryVariables>(PaymentPortal_LoginIndex_DisplayPaymentPortalTokenDocument, variables, options) as Promise<PaymentPortal_LoginIndex_DisplayPaymentPortalTokenQuery>;
    },
    PaymentPortal_GalAgencyGroupSection(variables: PaymentPortal_GalAgencyGroupSectionQueryVariables, options?: C): Promise<PaymentPortal_GalAgencyGroupSectionQuery> {
      return requester<PaymentPortal_GalAgencyGroupSectionQuery, PaymentPortal_GalAgencyGroupSectionQueryVariables>(PaymentPortal_GalAgencyGroupSectionDocument, variables, options) as Promise<PaymentPortal_GalAgencyGroupSectionQuery>;
    },
    PaymentPortal_GalAgencyGroupSection_GenerateGal(variables: PaymentPortal_GalAgencyGroupSection_GenerateGalQueryVariables, options?: C): Promise<PaymentPortal_GalAgencyGroupSection_GenerateGalQuery> {
      return requester<PaymentPortal_GalAgencyGroupSection_GenerateGalQuery, PaymentPortal_GalAgencyGroupSection_GenerateGalQueryVariables>(PaymentPortal_GalAgencyGroupSection_GenerateGalDocument, variables, options) as Promise<PaymentPortal_GalAgencyGroupSection_GenerateGalQuery>;
    },
    PaymentPortal_GalAgencyGroupSection_UploadGalSignedCopy(variables: PaymentPortal_GalAgencyGroupSection_UploadGalSignedCopyMutationVariables, options?: C): Promise<PaymentPortal_GalAgencyGroupSection_UploadGalSignedCopyMutation> {
      return requester<PaymentPortal_GalAgencyGroupSection_UploadGalSignedCopyMutation, PaymentPortal_GalAgencyGroupSection_UploadGalSignedCopyMutationVariables>(PaymentPortal_GalAgencyGroupSection_UploadGalSignedCopyDocument, variables, options) as Promise<PaymentPortal_GalAgencyGroupSection_UploadGalSignedCopyMutation>;
    },
    PaymentPortal_ProjectAgencyGroupSection(variables: PaymentPortal_ProjectAgencyGroupSectionQueryVariables, options?: C): Promise<PaymentPortal_ProjectAgencyGroupSectionQuery> {
      return requester<PaymentPortal_ProjectAgencyGroupSectionQuery, PaymentPortal_ProjectAgencyGroupSectionQueryVariables>(PaymentPortal_ProjectAgencyGroupSectionDocument, variables, options) as Promise<PaymentPortal_ProjectAgencyGroupSectionQuery>;
    },
    PaymentPortal_TncDialog_AgreeTnc(variables: PaymentPortal_TncDialog_AgreeTncMutationVariables, options?: C): Promise<PaymentPortal_TncDialog_AgreeTncMutation> {
      return requester<PaymentPortal_TncDialog_AgreeTncMutation, PaymentPortal_TncDialog_AgreeTncMutationVariables>(PaymentPortal_TncDialog_AgreeTncDocument, variables, options) as Promise<PaymentPortal_TncDialog_AgreeTncMutation>;
    },
    PaymentPortal_AppointmentLetterIndex_MainAppointmentLetters(variables: PaymentPortal_AppointmentLetterIndex_MainAppointmentLettersQueryVariables, options?: C): Promise<PaymentPortal_AppointmentLetterIndex_MainAppointmentLettersQuery> {
      return requester<PaymentPortal_AppointmentLetterIndex_MainAppointmentLettersQuery, PaymentPortal_AppointmentLetterIndex_MainAppointmentLettersQueryVariables>(PaymentPortal_AppointmentLetterIndex_MainAppointmentLettersDocument, variables, options) as Promise<PaymentPortal_AppointmentLetterIndex_MainAppointmentLettersQuery>;
    },
    PaymentPortal_AppointmentLetterIndex_MainCancelSignedAppointmentLetter(variables: PaymentPortal_AppointmentLetterIndex_MainCancelSignedAppointmentLetterMutationVariables, options?: C): Promise<PaymentPortal_AppointmentLetterIndex_MainCancelSignedAppointmentLetterMutation> {
      return requester<PaymentPortal_AppointmentLetterIndex_MainCancelSignedAppointmentLetterMutation, PaymentPortal_AppointmentLetterIndex_MainCancelSignedAppointmentLetterMutationVariables>(PaymentPortal_AppointmentLetterIndex_MainCancelSignedAppointmentLetterDocument, variables, options) as Promise<PaymentPortal_AppointmentLetterIndex_MainCancelSignedAppointmentLetterMutation>;
    },
    PaymentPortal_AppointmentLetterIndex_MainUploadSignedAppointmentLetter(variables: PaymentPortal_AppointmentLetterIndex_MainUploadSignedAppointmentLetterMutationVariables, options?: C): Promise<PaymentPortal_AppointmentLetterIndex_MainUploadSignedAppointmentLetterMutation> {
      return requester<PaymentPortal_AppointmentLetterIndex_MainUploadSignedAppointmentLetterMutation, PaymentPortal_AppointmentLetterIndex_MainUploadSignedAppointmentLetterMutationVariables>(PaymentPortal_AppointmentLetterIndex_MainUploadSignedAppointmentLetterDocument, variables, options) as Promise<PaymentPortal_AppointmentLetterIndex_MainUploadSignedAppointmentLetterMutation>;
    },
    PaymentPortal_MainIndex(variables: PaymentPortal_MainIndexQueryVariables, options?: C): Promise<PaymentPortal_MainIndexQuery> {
      return requester<PaymentPortal_MainIndexQuery, PaymentPortal_MainIndexQueryVariables>(PaymentPortal_MainIndexDocument, variables, options) as Promise<PaymentPortal_MainIndexQuery>;
    },
    PaymentPortal_MainIndex_Tabs(variables: PaymentPortal_MainIndex_TabsQueryVariables, options?: C): Promise<PaymentPortal_MainIndex_TabsQuery> {
      return requester<PaymentPortal_MainIndex_TabsQuery, PaymentPortal_MainIndex_TabsQueryVariables>(PaymentPortal_MainIndex_TabsDocument, variables, options) as Promise<PaymentPortal_MainIndex_TabsQuery>;
    },
    PaymentPortal_InvoiceRequestDialog(variables: PaymentPortal_InvoiceRequestDialogQueryVariables, options?: C): Promise<PaymentPortal_InvoiceRequestDialogQuery> {
      return requester<PaymentPortal_InvoiceRequestDialogQuery, PaymentPortal_InvoiceRequestDialogQueryVariables>(PaymentPortal_InvoiceRequestDialogDocument, variables, options) as Promise<PaymentPortal_InvoiceRequestDialogQuery>;
    },
    PaymentPortal_InvoiceRequestTab(variables: PaymentPortal_InvoiceRequestTabQueryVariables, options?: C): Promise<PaymentPortal_InvoiceRequestTabQuery> {
      return requester<PaymentPortal_InvoiceRequestTabQuery, PaymentPortal_InvoiceRequestTabQueryVariables>(PaymentPortal_InvoiceRequestTabDocument, variables, options) as Promise<PaymentPortal_InvoiceRequestTabQuery>;
    },
    PaymentPortal_InvoiceRequestTab_MainUploadInvoice(variables: PaymentPortal_InvoiceRequestTab_MainUploadInvoiceMutationVariables, options?: C): Promise<PaymentPortal_InvoiceRequestTab_MainUploadInvoiceMutation> {
      return requester<PaymentPortal_InvoiceRequestTab_MainUploadInvoiceMutation, PaymentPortal_InvoiceRequestTab_MainUploadInvoiceMutationVariables>(PaymentPortal_InvoiceRequestTab_MainUploadInvoiceDocument, variables, options) as Promise<PaymentPortal_InvoiceRequestTab_MainUploadInvoiceMutation>;
    },
    PaymentPortal_InvoiceTab(variables: PaymentPortal_InvoiceTabQueryVariables, options?: C): Promise<PaymentPortal_InvoiceTabQuery> {
      return requester<PaymentPortal_InvoiceTabQuery, PaymentPortal_InvoiceTabQueryVariables>(PaymentPortal_InvoiceTabDocument, variables, options) as Promise<PaymentPortal_InvoiceTabQuery>;
    },
    PaymentPortal_InvoiceTab_MainCancelInvoice(variables: PaymentPortal_InvoiceTab_MainCancelInvoiceMutationVariables, options?: C): Promise<PaymentPortal_InvoiceTab_MainCancelInvoiceMutation> {
      return requester<PaymentPortal_InvoiceTab_MainCancelInvoiceMutation, PaymentPortal_InvoiceTab_MainCancelInvoiceMutationVariables>(PaymentPortal_InvoiceTab_MainCancelInvoiceDocument, variables, options) as Promise<PaymentPortal_InvoiceTab_MainCancelInvoiceMutation>;
    },
    PaymentPortal_PaymentSlipTab(variables: PaymentPortal_PaymentSlipTabQueryVariables, options?: C): Promise<PaymentPortal_PaymentSlipTabQuery> {
      return requester<PaymentPortal_PaymentSlipTabQuery, PaymentPortal_PaymentSlipTabQueryVariables>(PaymentPortal_PaymentSlipTabDocument, variables, options) as Promise<PaymentPortal_PaymentSlipTabQuery>;
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;